// src/__generated__/types.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    iconSize: size\n    iconTheme: theme\n    title\n    withBackground\n    spotLight\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n\n    ... on Illustration {\n      ...IllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    text\n    badgeSize: size\n    badgeTheme: theme\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSRatingFragment on EGDSRating {\n    accessibility\n    rating\n    ... on EGDSIconRating {\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconRatingFragment on EGDSIconRating {\n    rating\n    icon {\n      size\n      theme\n      token\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    accessibility\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n      ... on Mark {\n        url {\n          ... on HttpURI {\n            value\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n    ... on EGDSGraphicText {\n      ...LodgingEGDSGraphicTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    sizeEGDSLink: size\n    text\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n    ...EGDSInlineLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    accessibilityTemplate\n    models {\n      key\n      source\n    }\n    text\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardGuestRatingFragment on LodgingCardPhrase {\n    accessibilityLabel\n    phraseParts {\n      ... on EGDSIconRating {\n        ...EGDSIconRatingFragment\n      }\n      ... on EGDSStylizedText {\n        ...EGDSStylizedTextFragment\n      }\n      ... on EGDSText {\n        ...LodgingEGDSTextFragment\n      }\n    }\n    parts {\n      text\n      ... on EGDSStylizedText {\n        ...EGDSStylizedTextFragment\n      }\n      ... on EGDSText {\n        ...LodgingEGDSTextFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyPriceFragment on PropertyPrice {\n    ...PriceSummaryFragment\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n      priceHeaderDialog {\n        title\n        content\n        primaryUIButton {\n          primary\n        }\n        trigger {\n          icon {\n            id\n            token\n            description\n          }\n          dialogTrigger {\n            dialogName\n          }\n          value\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment PriceHeaderDialogFragment on PropertyPriceOption {\n    priceHeaderDialog {\n      title\n      content\n      primaryUIButton {\n        primary\n      }\n      trigger {\n        icon {\n          id\n          token\n          description\n        }\n        dialogTrigger {\n          dialogName\n        }\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPriceSummaryFragment on Offer {\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n        ...PriceHeaderDialogFragment\n      }\n      priceMessaging {\n        value\n        theme\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetFooterFragment on ShoppingProductCardSheetPriceAndButtonFooter {\n    oldPriceSection {\n      ...PropertyPriceFragment\n    }\n    button {\n      accessibility\n      actionId\n      disabled\n      icon {\n        id\n        description\n        size\n      }\n      primary\n      buttonType\n    }\n    buttonV2 {\n      accessibility\n      actionId\n      disabled\n      icon {\n        id\n        description\n        size\n      }\n      primary\n      buttonType\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetListBodySectionFragment on ShoppingProductCardSheetListBodySection {\n    heading {\n      icon {\n        description\n        id\n        size\n      }\n      text\n      theme\n    }\n    items {\n      listItems {\n        style\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetListContentFragment on ShoppingProductCardSheetListContent {\n    title\n    subtitle\n    body {\n      ...ProductCardSheetListBodySectionFragment\n    }\n    footer {\n      ...ProductCardSheetFooterFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingButtonFragment on ShoppingButton {\n    accessibility\n    actionId\n    primary\n    buttonType\n    disabled\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    spotLight\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingPriceFragment on ShoppingPrice {\n    displayMessages {\n      lineItems {\n        ... on ShoppingDisplayPrice {\n          clickActionId\n          price {\n            accessibilityLabel\n            formatted\n          }\n          role\n        }\n        ... on ShoppingEnrichedMessage {\n          state\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetSectionFragment on ShoppingProductCardSheetSection {\n    lineItems {\n      ...ProductCardSheetSectionLineItemFragment\n    }\n  }\n\n  fragment ProductCardSheetSectionLineItemFragment on ShoppingProductCardSheetSectionLineItem {\n    icons {\n      ...LodgingEGDSIconFragment\n    }\n    price {\n      ...ShoppingPriceFragment\n    }\n    texts {\n      ...EGDSStylizedTextFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetSectionalContentFragment on ShoppingProductCardSheetSectionalContent {\n    __typename\n    header {\n      ...EGDSSpannableTextFragment\n    }\n    sections {\n      ...ProductCardSheetSectionFragment\n    }\n    button {\n      ...ShoppingButtonFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetTabListContentFragment on ShoppingProductCardSheetTabListContent {\n    content {\n      ...ProductCardSheetListBodySectionFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardSheetTabularContentFragment on ShoppingProductCardSheetTabularContent {\n    title\n    subtitle\n    tabularBody: body {\n      selectedTabId\n      tabs {\n        accessibility\n        label\n        tabId\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n        contentId\n      }\n    }\n    footer {\n      ...ProductCardSheetFooterFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardContentFragment on ShoppingProductCardContentContainer {\n    contentId\n    content {\n      __typename\n      ...ProductCardSheetListContentFragment\n      ...ProductCardSheetTabularContentFragment\n      ...ProductCardSheetTabListContentFragment\n      ...ProductCardSheetSectionalContentFragment\n      ... on ShoppingLoadSharedUI {\n        componentName\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingProductCardSheetFragment on EGDSSheet {\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    closeText\n    sheetType\n    sheetTypes {\n      sheetType\n      viewSize\n    }\n  }\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardLinkFragment on UILinkAction {\n    __typename\n    accessibility\n    resource {\n      __typename\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n      urls\n    }\n    useRelativePath\n    target\n  }\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardOverLayFragment on ShoppingOverlayContainer {\n    overlayId\n    contentId\n    overlay {\n      __typename\n      ... on EGDSSheet {\n        ...ShoppingProductCardSheetFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingBadgeFragment on EGDSStandardBadge {\n    text\n    theme\n    graphic {\n      __typename\n      ... on Icon {\n        description\n        id\n      }\n      ... on Mark {\n        description\n        id\n      }\n    }\n    size\n  }\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingButtonsFragment on AdTransparencyTrigger {\n    adTransparencyId\n    adTransparencyButton {\n      ...LodgingAdTransparencyButtonFragment\n    }\n    adTransparencyOverlaySkeleton {\n      ...LodgingTransparencyOverlaySkeletonFragment\n    }\n  }\n  fragment LodgingAdTransparencyButtonFragment on AdTransparencyButton {\n    primary\n    icon {\n      id\n    }\n  }\n  fragment LodgingTransparencyOverlaySkeletonFragment on TransparencyOverlaySkeleton {\n    title\n    error {\n      ...TransparencyOverlayErrorFragment\n    }\n  }\n  fragment TransparencyOverlayErrorFragment on TransparencyOverlayError {\n    icon {\n      id\n      size\n    }\n    description\n    button {\n      primary\n    }\n    allowedRetryAttempts\n    exceededAttemptsMessage\n  }\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingAdaptExAnalyticsEventFragment on LodgingAdaptExAnalyticsEvent {\n    campaignId\n    clientSideAnalytics {\n      referrerId\n      eventType\n      linkName\n    }\n    events {\n      eventType\n      eventTarget\n      banditDisplayed\n      payloadId\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSImageFragment on Image {\n    description\n    url\n    thumbnailClickAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingMediaItemFragment on LodgingMediaItem {\n    id\n    media {\n      ... on Image {\n        ...LodgingEGDSImageFragment\n      }\n    }\n    mediaFit\n    trackingId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingGalleryCarouselFragment on LodgingGalleryCarousel {\n    accessibilityHeadingText\n    navClickAnalytics {\n      referrerId\n      linkName\n    }\n    adaptExAnalyticsAttemptEvents {\n      ...LodgingAdaptExAnalyticsEventFragment\n    }\n    adaptExAnalyticsSuccessEvents {\n      ...LodgingAdaptExAnalyticsEventFragment\n    }\n    intersectionAnalytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    media {\n      ...LodgingMediaItemFragment\n    }\n    nextButtonText\n    previousButtonText\n    carouselScrimType\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {\n    campaignId\n    eventTarget\n  }\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n      ...TripsSaveCarOfferAttributesFragment\n      ...TripsSavePackageAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessCampaignIds {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    label\n    tooltip\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  fragment TripsSaveCarOfferAttributesFragment on TripsSaveCarOfferAttributes {\n    categoryCode\n    fuelAcCode\n    offerToken\n    searchCriteria {\n      dropOffDateTime {\n        ...DateTimeFragment\n      }\n      dropOffLocation {\n        ...CarRentalLocationFragment\n      }\n      pickUpDateTime {\n        ...DateTimeFragment\n      }\n      pickUpLocation {\n        ...CarRentalLocationFragment\n      }\n    }\n    transmissionDriveCode\n    typeCode\n    vendorCode\n  }\n\n  fragment TripsSavePackageAttributesFragment on TripsSavePackageAttributes {\n    packageOfferId\n    sessionId\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardSaveItemFragment on LodgingSaveItem {\n    items {\n      itemId\n    }\n    labels {\n      saveLabel\n      removeLabel\n    }\n    messages {\n      saveMessage\n      removeMessage\n    }\n    initialChecked\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMediaSectionFragment on LodgingCardMediaSection {\n    gallery {\n      ...LodgingGalleryCarouselFragment\n    }\n    saveItem {\n      ...LodgingCardSaveItemFragment\n    }\n    saveTripItem {\n      ...TripsSaveItemFragment\n    }\n    badges {\n      primaryBadge {\n        ...LodgingBadgeFragment\n      }\n      secondaryBadge {\n        ...LodgingBadgeFragment\n      }\n      tertiaryBadge {\n        ...LodgingBadgeFragment\n      }\n    }\n    buttons {\n      primaryButton {\n        ...LodgingButtonsFragment\n      }\n      secondaryButton {\n        ...LodgingButtonsFragment\n      }\n      tertiaryButton {\n        ...LodgingButtonsFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingUILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSButtonFragment on EGDSButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    ... on UIPrimaryButton {\n      egdsElementId\n    }\n    disabled\n    primary\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingActionButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    primary\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSSheetFragment on EGDSSheet {\n    closeText\n    closeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    models {\n      key\n      source\n    }\n    text\n    accessibilityText\n    templates {\n      category\n      template\n    }\n    accessibilityTemplates {\n      category\n      template\n    }\n  }\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...IconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSLocalThemeProviderFragment on EGDSThemeProvider {\n    isColorThemeContainer\n    lightMode {\n      isGradient\n      isThemeBase\n      themeProviderColor\n    }\n  }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    resource {\n      value\n      ... on HttpURI {\n        relativePath\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    message\n    heading\n    background\n    themes\n    dismiss {\n      accessibility\n      analytics {\n        ...ClientSideAnalyticsFragment\n      }\n      label\n    }\n    rightIcon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    buttons {\n      ...LodgingEGDSButtonFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n    themeProvider {\n      ...EGDSLocalThemeProviderFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardFeaturedMessageFragment on LodgingCardFeaturedMessage {\n    icon {\n      id\n      description\n      size\n    }\n    text\n  }\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingProductAmenityFragment on EGDSIconText {\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardHeadingSectionFragment on LodgingCardHeadingSection {\n    heading\n    productRating {\n      ...LodgingEGDSRatingFragment\n    }\n    featuredMessages {\n      ...LodgingCardFeaturedMessageFragment\n    }\n    messages {\n      ...LodgingEGDSTextFragment\n    }\n    amenities {\n      ...LodgingProductAmenityFragment\n    }\n    missingFilters {\n      ...LodgingEGDSTextFragment\n    }\n    standardBadges {\n      ...LodgingBadgeFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      icon {\n        description\n      }\n      analytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n    previousButton {\n      icon {\n        description\n      }\n      analytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingLinkFragment on ShoppingLink {\n    actionId\n    text\n    trailingIcon {\n      id\n    }\n  }\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment ProductCardFooterSectionContentFragment on ShoppingProductCardFooterSectionContent {\n    items {\n      ...EGDSStylizedTextFragment\n      ...ShoppingLinkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingStandardBadgeFragment on LodgingStandardBadge {\n    standardBadge {\n      text\n      theme\n      graphic {\n        __typename\n        ... on Icon {\n          description\n          id\n        }\n        ... on Mark {\n          description\n          id\n        }\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      size\n    }\n    impressionEventAnalytics {\n      referrerId\n      linkName\n      event\n    }\n  }\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardCompareSectionFragment on LodgingCardCompareSection {\n    __typename\n    compareAction {\n      ... on EGDSBasicCheckBox {\n        __typename\n        label {\n          text\n        }\n        checkedAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n        uncheckedAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardDateSectionFragment on LodgingCardDateSection {\n    date {\n      ...EGDSStylizedTextFragment\n    }\n    messages {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMarketingFeeDetailFragment on MarketingFeeDetails {\n    tierMessage {\n      accessibilityLabel\n      value\n      egdsMark {\n        id\n      }\n    }\n    marketingFeeMessageDialog {\n      content\n      dialog {\n        footer {\n          buttons {\n            primary\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingActionableIconFragment on ShoppingActionableIcon {\n    actionId\n    icon {\n      id\n      token\n      theme\n      size\n    }\n  }\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardBadgedRatingFragment on LodgingCardBadgedRating {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    phrases {\n      phraseParts {\n        ...EGDSStylizedTextFragment\n        ...ShoppingActionableIconFragment\n      }\n      parts {\n        ...LodgingEGDSGraphicTextFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMoreDetailsTriggerFragment on LodgingCardMoreDetailsTrigger {\n    accessibilityLabel\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    label\n  }\n\n  ",
        "\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardChangeUnitDialogActionFragment on LodgingCardChangeUnitDialogAction {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardChangeUnitSheetActionFragment on LodgingCardChangeUnitSheetAction {\n    sheet {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      closeText\n    }\n    trigger {\n      ...LodgingCardMoreDetailsTriggerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMoreDetailsLinkTriggerFragment on LodgingCardMoreDetailsTrigger {\n    accessibilityLabel\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    label\n  }\n\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardPropertyDetailsDialogActionFragment on LodgingCardPropertyDetailsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsLinkTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardUnitDetailsDialogActionFragment on LodgingCardUnitDetailsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsLinkTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardPropertyDialogActionFragment on LodgingCardDetailsAction {\n    __typename\n    ... on LodgingCardUnitDetailsDialog {\n      ...LodgingCardUnitDetailsDialogActionFragment\n    }\n    ... on LodgingCardPropertyDetailsDialog {\n      ...LodgingCardPropertyDetailsDialogActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardRatingFragment on LodgingCardRating {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    phrases {\n      accessibilityLabel\n      phraseParts {\n        ...EGDSPlainTextFragment\n        ...EGDSStylizedTextFragment\n        ...EGDSIconRatingFragment\n        ...ShoppingLinkFragment\n        ...ShoppingActionableIconFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardPropertyDescriptionSectionFragment on LodgingCardPropertyDescriptionSection {\n    heading {\n      text\n    }\n    description {\n      text\n    }\n    # Link is used for tracking purposes on the client, do not remove\n    link {\n      action {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingProductFooterMessagesFragment on EGDSTextWithMarkListItem {\n    mark {\n      description\n      id\n      url {\n        value\n      }\n    }\n    egdsElementId\n    style\n    text\n  }\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingProductSpannableFooterMessagesFragment on EarnMessageContainerListItem {\n    graphic {\n      ... on Mark {\n        description\n        id\n        token\n        url {\n          value\n          relativePath\n        }\n      }\n      ... on Icon {\n        description\n        id\n        size\n        theme\n        title\n      }\n      ... on Illustration {\n        id\n        description\n      }\n    }\n    style\n    text\n    stylizedText {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardProductSummarySectionFragment on LodgingCardProductSummarySection {\n    heading {\n      ...LodgingEGDSHeadingFragment\n    }\n    amenities {\n      ...LodgingProductAmenityFragment\n    }\n    messages {\n      ...LodgingEGDSTextFragment\n    }\n    descriptionSection {\n      ...LodgingCardPropertyDescriptionSectionFragment\n    }\n    changeActionDialog {\n      ...LodgingCardChangeUnitDialogActionFragment\n    }\n    changeActionSheet {\n      ...LodgingCardChangeUnitSheetActionFragment\n    }\n    detailsAction {\n      ...LodgingCardPropertyDialogActionFragment\n    }\n    detailsLink {\n      ...ShoppingLinkFragment\n    }\n    guestRatingSection {\n      __typename\n      ... on LodgingCardPhrase {\n        ...LodgingCardGuestRatingFragment\n      }\n      ... on LodgingCardBadgedRating {\n        ...LodgingCardBadgedRatingFragment\n      }\n    }\n    guestRatingSectionV2 {\n      __typename\n      ... on LodgingCardPhrase {\n        ...LodgingCardGuestRatingFragment\n      }\n      ... on LodgingCardRating {\n        ...LodgingCardRatingFragment\n      }\n    }\n    footerMessages {\n      listItems {\n        ...LodgingProductFooterMessagesFragment\n        ...LodgingProductSpannableFooterMessagesFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardContentSectionFragment on LodgingCard {\n    __typename\n    headingSection {\n      ...LodgingCardHeadingSectionFragment\n    }\n    summarySections {\n      ...LodgingCardProductSummarySectionFragment\n    }\n    priceSection {\n      priceSummary {\n        ...PropertyPriceFragment\n        marketingFeeDetails {\n          ...LodgingCardMarketingFeeDetailFragment\n        }\n      }\n      badge {\n        ...LodgingBadgeFragment\n      }\n      standardBadge {\n        ...LodgingStandardBadgeFragment\n      }\n      button {\n        accessibility\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n        disabled\n        icon {\n          description\n          id\n        }\n        primary\n        attemptEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        successEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        adaptexSuccessActionTracking {\n          ...AdaptexCampaignTrackingDetailFragment\n        }\n      }\n    }\n    compareSection {\n      ...LodgingCardCompareSectionFragment\n    }\n    dateSection {\n      ...LodgingCardDateSectionFragment\n    }\n    callOut {\n      ...LodgingEGDSTextFragment\n    }\n    id\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardLinkActionFragment on LodgingCardLinkAction {\n    __typename\n    link {\n      text\n      action {\n        target\n        resource {\n          ... on HttpURI {\n            value\n            relativePath\n          }\n        }\n        useRelativePath\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      egdsElementId\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardFooterActionFragment on LodgingCardFooterAction {\n    ...ShoppingButtonFragment\n    ...LodgingCardLinkActionFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardFragment on LodgingCard {\n    featuredHeader {\n      header {\n        text\n      }\n    }\n    cardLink {\n      ...LodgingCardLinkFragment\n    }\n    cardBackgroundTheme: backgroundTheme\n    footerActions {\n      ...LodgingCardFooterActionFragment\n    }\n    footer {\n      contents {\n        ...ProductCardFooterSectionContentFragment\n      }\n      actionId\n    }\n    mediaSection {\n      ...LodgingCardMediaSectionFragment\n    }\n    id\n    ...LodgingCardContentSectionFragment\n    clickstreamEvents {\n      productPresented {\n        ...ProductEventFragment\n      }\n      productSelected {\n        ...ProductEventFragment\n      }\n    }\n    impressionAnalytics {\n      url\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    renderAnalytics {\n      urls\n    }\n    adaptexSuccessActionTracking {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    clickActionId\n    shoppingJoinListContainer {\n      actions {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        actionId\n        ... on ShoppingNavigateToOverlay {\n          overlayId\n        }\n        ... on ShoppingNavigateToURI {\n          resource {\n            value\n            ... on HttpURI {\n              relativePath\n            }\n          }\n          target\n          useRelativePath\n        }\n        ... on ShoppingInvokeFunction {\n          name\n          paramsId\n          functionType\n        }\n        ... on ShoppingScrollsToView {\n          targetRef\n        }\n      }\n      overlays {\n        ...ProductCardOverLayFragment\n      }\n    }\n    contents {\n      ...ProductCardContentFragment\n    }\n    shoppingInvokeFunctionParams {\n      paramsId\n      keyValueParams {\n        key\n        value\n      }\n    }\n    dataAttributes {\n      ...DataAttributeFragment\n    }\n  }\n\n  fragment ProductEventFragment on LodgingProductEvent {\n    event {\n      ...ClickstreamEventFragment\n    }\n    product_list {\n      ...ProductListFragment\n    }\n    search_request {\n      ...RequestFragment\n    }\n  }\n\n  fragment ClickstreamEventFragment on EGClickstreamEvent {\n    eventCategory\n    eventName\n    eventType\n    eventVersion\n  }\n\n  fragment ProductListFragment on LodgingProduct {\n    product_id\n  }\n\n  fragment RequestFragment on LodgingSearchRequest {\n    search_id\n  }\n\n  fragment DataAttributeFragment on GraphQLPair {\n    key\n    value\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCarouselContainerFragment on LodgingCarouselContainer {\n    heading {\n      ... on EGDSStylizedText {\n        text\n      }\n    }\n    items {\n      ...LodgingCardFragment\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    carousel {\n      nextButton {\n        __typename\n        icon {\n          description\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n      previousButton {\n        __typename\n        icon {\n          description\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    seoRichContentMetaData\n  }\n\n  ",
        "\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingLinkMessageFragment on LodgingLinkMessage {\n    accessibilityLabel\n    icon {\n      id\n      description\n      token\n    }\n    link {\n      clientSideAnalytics {\n        referrerId\n        linkName\n      }\n      uri {\n        relativePath\n        value\n      }\n    }\n    value\n  }\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyImageFragment on PropertyImage {\n    alt\n    image {\n      url\n      description\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    lowResImage {\n      url\n    }\n    onClickAction {\n      ... on PropertyImageDetailDialogAction {\n        scrollPageToRef\n        trigger {\n          accessibility\n          analytics {\n            ...ClientSideAnalyticsFragment\n          }\n        }\n      }\n    }\n    trackingId\n    imageId\n  }\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingGraphicFragment on LodgingGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n    ... on Mark {\n      ...MarkFragment\n    }\n    ... on Illustration {\n      ...IllustrationFragment\n    }\n    ... on EGDSBadge {\n      ...EGDSBadgeFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemGraphicsFragment on PropertyContentItemGraphics {\n    graphics {\n      ...UIGraphicFragment\n    }\n    graphicsV2 {\n      ...LodgingGraphicFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemImagesFragment on PropertyContentItemImages {\n    contents {\n      image {\n        description\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemMarkupFragment on PropertyContentItemMarkup {\n    content {\n      text\n      markupType\n    }\n  }\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemTextFragment on PropertyContentItemText {\n    content {\n      primary {\n        value\n        icon {\n          iconId: id\n        }\n        egdsMark {\n          description\n          url {\n            value\n          }\n        }\n        state\n        subtexts\n      }\n      secondary {\n        value\n      }\n    }\n    expando {\n      expandedLabel\n      collapsedLabel\n    }\n  }\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemTextsFragment on PropertyContentItemTexts {\n    contents {\n      primary {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  fragment SectionHeaderFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      iconId: id\n      description\n    }\n    headerImage {\n      description\n      url\n    }\n    mark {\n      description\n      id\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentFragment on PropertyContent {\n    maxColumns\n    propertyContentRef\n    header {\n      ...SectionHeaderFragment\n    }\n    expando {\n      expandButton {\n        text\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      collapseButton {\n        text\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    expandoPeek {\n      expandedLabel\n      collapsedLabel\n      lines\n      items\n      expandAnalytics {\n        referrerId\n        linkName\n      }\n      collapseAnalytics {\n        referrerId\n        linkName\n      }\n    }\n    items {\n      __typename\n      ...LodgingLinkMessageFragment\n      ...PropertyContentItemGraphicsFragment\n      ...PropertyContentItemImagesFragment\n      ...PropertyContentItemMarkupFragment\n      ...PropertyContentItemTextFragment\n      ...PropertyContentItemTextsFragment\n    }\n    leadingGraphic {\n      ... on PropertyImage {\n        ...PropertyImageFragment\n      }\n      ... on LodgingGalleryCarousel {\n        ...LodgingGalleryCarouselFragment\n      }\n      ... on Video {\n        description\n        url {\n          value\n        }\n      }\n    }\n    structuredData {\n      itemprop\n      itemscope\n      itemtype\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionDetailedDialogFragment on PropertyContentSectionDetailedDialog {\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n          closeText\n        }\n        closeAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    trigger {\n      message\n      analytics {\n        linkName\n        referrerId\n      }\n      icon {\n        id\n        description\n        token\n      }\n    }\n  }\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionDialogFragment on PropertyContentSectionDialog {\n    trigger {\n      analytics {\n        linkName\n        referrerId\n      }\n      message\n    }\n    content {\n      contents {\n        ... on EGDSParagraph {\n          text\n        }\n        ... on EGDSPlainText {\n          text\n        }\n        ... on EGDSInlineLink {\n          text\n          action {\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n            target\n          }\n        }\n      }\n    }\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n        }\n      }\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentHeaderFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      id\n      description\n      size\n    }\n  }\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityReviewSummaryFragment on Highlights {\n    icon {\n      iconId: id\n      description\n      size\n    }\n    reviewSummaryHighlight {\n      __typename\n      header {\n        text\n        graphic {\n          ... on Icon {\n            id\n          }\n        }\n      }\n      content\n    }\n    clickAnalytics {\n      __typename\n      linkName\n      referrerId\n      eventType\n    }\n    impressionAnalytics {\n      __typename\n      event\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentItemFragment on PropertyInfoItem {\n    icon {\n      iconId: id\n      description\n      size\n    }\n    text\n    state\n    moreInfo\n    accessibilityLabel\n    highlights {\n      ...AmenityReviewSummaryFragment\n    }\n    subItems {\n      ... on EGDSTextIconList {\n        listItems {\n          ... on EGDSTextIconListItem {\n            text\n            icon {\n              id\n              description\n              token\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentItemsFragment on PropertyInfoContent {\n    items {\n      ...PropertyInfoContentItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentFragment on PropertyInfoContent {\n    header {\n      ...PropertyInfoContentHeaderFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    iconAnalytics {\n      linkName\n      referrerId\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n      event\n    }\n    adaptExAttemptEvents {\n      ...LodgingAdaptExAnalyticsEventFragment\n    }\n    ...PropertyInfoContentItemsFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionListTypeDialogFragment on PropertyContentSectionListTypeDialog {\n    trigger {\n      analytics {\n        linkName\n        referrerId\n      }\n      icon {\n        id\n        description\n      }\n      message\n    }\n    dialogData: content {\n      ... on PropertyInfoContent {\n        ...PropertyInfoContentFragment\n      }\n    }\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n        }\n      }\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionActionFragment on PropertyContentSectionAction {\n    ... on PropertyContentSectionDialog {\n      ...PropertyContentSectionDialogFragment\n    }\n    ... on PropertyContentSectionDetailedDialog {\n      ...PropertyContentSectionDetailedDialogFragment\n    }\n    ... on LodgingLinkMessage {\n      ...LodgingLinkMessageFragment\n    }\n    ... on PropertyContentSectionListTypeDialog {\n      ...PropertyContentSectionListTypeDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemCardFragment on EGDSStandardMessagingCard {\n    ...EGDSStandardMessagingCardFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentElementGroupFragment on PropertyContentElementGroup {\n    elements {\n      ... on PropertyContent {\n        ...PropertyContentFragment\n      }\n      ... on EGDSStandardMessagingCard {\n        ...EGDSStandardMessagingCardFragment\n      }\n    }\n    maxColumns\n  }\n  ",
        "\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSubSectionFragment on PropertyContentSubSection {\n    header {\n      ...SectionHeaderFragment\n    }\n    elementsV2 {\n      ...PropertyContentElementGroupFragment\n    }\n    actions {\n      ...PropertyContentSectionActionFragment\n    }\n    expando {\n      expandButton {\n        text\n        analytics {\n          eventType\n          referrerId\n          linkName\n        }\n      }\n      collapseButton {\n        text\n        analytics {\n          eventType\n          referrerId\n          linkName\n        }\n      }\n      lines\n    }\n    maxColumns\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionFragment on PropertyContentSection {\n    sectionName\n    header {\n      ...SectionHeaderFragment\n    }\n    bodySubSections {\n      ...PropertyContentSubSectionFragment\n    }\n    action {\n      ...PropertyContentSectionActionFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n    expando {\n      collapseButton {\n        text\n        accessibilityLabel\n        analytics {\n          eventType\n          referrerId\n          linkName\n        }\n      }\n      expandButton {\n        text\n        accessibilityLabel\n        analytics {\n          eventType\n          referrerId\n          linkName\n        }\n      }\n      items\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionGroupFragment on PropertyContentSectionGroup {\n    expando {\n      collapseButton {\n        text\n      }\n      expandButton {\n        text\n      }\n    }\n    sectionName\n    sections {\n      ...PropertyContentSectionFragment\n    }\n    action {\n      ...PropertyContentSectionActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  fragment CleanlinessFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria) {\n      cleanliness {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  fragment PoliciesFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      policies {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n  fragment SpecialFeaturesFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      specialFeatures {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n  fragment ImportantInfoFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      importantInfo {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  fragment AboutThisPropertyFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisProperty {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  fragment HostProfileFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisHost {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDetailedAmenitiesFragment on PropertyInfo {\n    amenitiesSummary: propertyContentSectionGroups(amenitiesPropertyContentType: SUMMARY) {\n      amenities {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n    detailedAmenitiesContent: propertyContentSectionGroups(amenitiesPropertyContentType: DETAILED) {\n      amenities {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingJumpLinkFragment on PropertyInfoJumpLink {\n    icon {\n      iconId: id\n    }\n    sectionName\n    localizedName\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSSwitchFragment on UIToggle {\n    checked\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    checkedLabel\n    enabled\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedLabel\n  }\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableListItemFragment on EGDSSpannableListItem {\n    graphic {\n      ...UIGraphicFragment\n    }\n    subText\n    text {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableListFragment on EGDSSpannableList {\n    items {\n      ...EGDSSpannableListItemFragment\n    }\n    listType\n  }\n\n  ",
        "\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    subText\n    subtexts\n    value\n    theme\n    state\n    accessibilityLabel\n    icon {\n      id\n      size\n      theme\n    }\n    mark {\n      id\n    }\n    egdsMark {\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        "\n  fragment RatingCountsFragment on PropertyReviewSummary {\n    ratingCounts {\n      count {\n        formatted\n      }\n      percent\n      rating\n      description\n      accessibilityLabel\n    }\n  }\n"
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewSummaryDetailsFragment on PropertyReviewSummary {\n    reviewSummaryDetails {\n      label\n      formattedRatingOutOfMaxA11y {\n        value\n        accessibilityLabel\n      }\n    }\n  }\n"
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingDialogTriggerMessageFragment on LodgingDialogTriggerMessage {\n    accessibilityLabel\n    value\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyFilteredReviewsDialogFragment on PropertyFilteredReviewsDialog {\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n    ratingPercentage {\n      closeAnalytics {\n        referrerId\n        linkName\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewDisclaimerFragment on PropertyReviewSummary {\n    reviewDisclaimer\n    reviewDisclaimerHeading\n    strategy\n    reviewDisclaimerValues {\n      text\n    }\n    reviewDisclaimerLabel\n    reviewDisclaimerAnalytics {\n      referrerId\n      linkName\n    }\n    reviewDisclaimerUrl {\n      value\n      accessibilityLabel\n      link {\n        url\n      }\n    }\n    reviewDisclaimerAccessibilityLabel\n  }\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyReviewsBreakdownFragment on PropertyReviewSummary {\n    averageOverallRatingValue {\n      formatted\n    }\n    averageOverallRatingSection {\n      ...LodgingEnrichedMessageFragment\n    }\n    superlative\n    strategy\n    propertyReviewCountDetails {\n      shortDescription\n    }\n    reviewDisclaimer\n    reviewDisclaimerLabel\n    ...ReviewDisclaimerFragment\n    totalCount {\n      raw\n    }\n    ...ReviewSummaryDetailsFragment\n    ...RatingCountsFragment\n    seeAllAction {\n      ...PropertyFilteredReviewsDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject131 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _tagged_template_literal([
        "\n  fragment MapTriggerFragment on LodgingMapTrigger {\n    icon {\n      id\n      title\n      token\n    }\n    labels {\n      ... on EGDSPlainText {\n        text\n      }\n      ... on EGDSInlineLink {\n        action {\n          analytics {\n            referrerId\n            linkName\n          }\n        }\n        text\n      }\n    }\n    small {\n      description\n      url\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    medium {\n      description\n      url\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    large {\n      description\n      url\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    label\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject132 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    label {\n      text\n    }\n    name\n    required\n    state\n  }\n"
    ]);
    _templateObject133 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSCheckboxFragment on EGDSBasicCheckBox {\n    ...LodgingEGDSBasicCheckBoxFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject134 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyOverfilteredCardFragment on PropertySearchListingsOverfilteredCard {\n    content {\n      heading\n      message\n      dismiss {\n        label\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n      impressionTracking {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject135 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingCarouselFormatFragment on ShoppingCarouselFormat {\n    nextButton {\n      ...ShoppingCarouselButtonFragment\n    }\n    previousButton {\n      ...ShoppingCarouselButtonFragment\n    }\n    itemsVisible\n  }\n\n  fragment ShoppingCarouselButtonFragment on ShoppingCarouselButton {\n    analytics {\n      linkName\n      referrerId\n    }\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject136 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingSelectableImageCardFragment on ShoppingSelectableImageCard {\n    id\n    state\n    title {\n      ...EGDSStylizedTextFragment\n    }\n    image {\n      ...LodgingEGDSImageFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject137 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingMoreInfoTriggerFragment on EGDSStandardLink {\n    __typename\n    text\n    icon {\n      description\n      id\n      size\n      title\n      token\n      withBackground\n    }\n    action {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n      resource {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n      target\n      useRelativePath\n    }\n    egdsElementId\n    disabled\n  }\n"
    ]);
    _templateObject138 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    accessibility\n    name\n    value\n    remove {\n      ... on Icon {\n        id\n        description\n        size\n      }\n    }\n    removeAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject139 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _tagged_template_literal([
        "\n  fragment SearchFilterPillsFragment on PropertySearchListingsOverfilteredCard {\n    filterPills {\n      ... on BasicShoppingAppliedFilter {\n        filter {\n          ...LodgingEGDSRemovablePillFragment\n        }\n        linkUrl {\n          ... on UILinkAction {\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n            target\n            useRelativePath\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject140 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _tagged_template_literal([
        "\n  fragment MessagingResultTitleMediaFragment on MessagingResultTitle {\n    icon {\n      id\n      description\n      size\n      spotLight\n    }\n    illustration {\n      assetUri {\n        value\n      }\n      description\n    }\n    egdsMark {\n      id\n      description\n      url {\n        ... on HttpURI {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject141 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _tagged_template_literal([
        "\n  fragment MessageResultFragment on MessageResult {\n    title {\n      text\n      ...MessagingResultTitleMediaFragment\n    }\n    subtitle {\n      text\n      ...MessagingResultTitleMediaFragment\n    }\n    action {\n      primary {\n        ...MessageActionContent\n      }\n      secondary {\n        ...MessageActionContent\n      }\n    }\n    type\n    footerText\n  }\n  fragment MessageActionContent on MessagingAction {\n    text\n    linkUrl\n    referrerId\n    actionDetails {\n      action\n      accessibilityLabel\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject142 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingHeadingFragment on LodgingHeading {\n    __typename\n    value\n  }\n"
    ]);
    _templateObject143 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingIntentButtonFragment on UIPrimaryButton {\n    primary\n    action {\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject144 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingIntentCardFragment on LodgingIntentCard {\n    headingTitle\n    cardMessage: message\n    gallery {\n      media {\n        ...LodgingMediaItemFragment\n      }\n    }\n    primaryButton {\n      ...LodgingIntentButtonFragment\n    }\n    impressionAnalyticsTracking: impressionTracking {\n      event\n      referrerId\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject145 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _tagged_template_literal([
        "\n  fragment SparkleBannerFragment on MessageResult {\n    __typename\n    title {\n      ...MessageTitleFields\n      ...MessagingResultTitleMediaFragment\n    }\n    subtitle {\n      ...MessageTitleFields\n    }\n    action {\n      primary {\n        ...MessagingActionFields\n      }\n      secondary {\n        ...MessagingActionFields\n      }\n    }\n    type\n  }\n  fragment MessageTitleFields on MessagingResultTitle {\n    text\n    icon {\n      description\n      id\n    }\n    illustration {\n      assetUri {\n        value\n      }\n      description\n    }\n  }\n  fragment MessagingActionFields on MessagingAction {\n    actionDetails {\n      action\n      accessibilityLabel\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    linkUrl\n    referrerId\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject146 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingHeaderFragment on LodgingHeader {\n    text\n    label\n    subText\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject147 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _tagged_template_literal([
        "\n  fragment PrimaryInfoFragment on PrimaryInfo {\n    heading {\n      text\n    }\n    subheading {\n      text\n    }\n  }\n"
    ]);
    _templateObject148 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _tagged_template_literal([
        "\n  fragment SecondaryInfoFragment on SecondaryInfo {\n    title {\n      text\n    }\n    message\n  }\n"
    ]);
    _templateObject149 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _tagged_template_literal([
        "\n  fragment MessageSectionsFragment on LodgingPolicy {\n    messageSections {\n      primaryInfo {\n        ...PrimaryInfoFragment\n      }\n      secondaryInfo {\n        ...SecondaryInfoFragment\n      }\n    }\n  }\n  ",
        ",\n  ",
        "\n"
    ]);
    _templateObject150 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingStepIndicatorFragment on LodgingStepIndicator {\n    accessibilityLabel\n    steppers {\n      text {\n        text\n      }\n      state\n      track {\n        text {\n          text\n          accessibility\n        }\n        position\n      }\n    }\n  }\n"
    ]);
    _templateObject151 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPolicyFragment on LodgingPolicy {\n    title {\n      text\n    }\n    stepIndicator {\n      ...LodgingStepIndicatorFragment\n    }\n    ...MessageSectionsFragment\n    policyClientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject152 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject153() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingDetailedTimelineFragment on LodgingDetailedTimeline {\n    title {\n      ... on EGDSStylizedText {\n        text\n      }\n      ... on EGDSGraphicText {\n        text\n      }\n    }\n    policies {\n      ...LodgingPolicyFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject153 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject154() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingMicroCardTextFragment on LodgingMicroCardText {\n    ...LodgingEGDSGraphicTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject154 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject155() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingMicroCardFragment on LodgingMicroCard {\n    heading\n    image {\n      url\n      description\n    }\n    contents {\n      ...LodgingMicroCardTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject155 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject156() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoCardFragment on EGDSExpandoCard {\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expandedLabel\n    expanded\n    subtitle\n  }\n"
    ]);
    _templateObject156 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject157() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSActionDialogFragment on EGDSActionDialog {\n    closeAnalytics {\n      referrerId\n      linkName\n    }\n    footer {\n      ... on EGDSStackedDialogFooter {\n        buttons {\n          ... on EGDSOverlayButton {\n            __typename\n          }\n        }\n      }\n      ... on EGDSInlineDialogFooter {\n        buttons {\n          ... on UIPrimaryButton {\n            accessibility\n            primary\n            disabled\n            action {\n              ... on UILinkAction {\n                resource {\n                  value\n                }\n                analytics {\n                  linkName\n                  referrerId\n                }\n              }\n            }\n          }\n          ... on UITertiaryButton {\n            accessibility\n            primary\n            action {\n              ... on UILinkAction {\n                resource {\n                  value\n                }\n              }\n            }\n            disabled\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject157 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject158() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDialogFragment on EGDSDialog {\n    ...EGDSActionDialogFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject158 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject159() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject159 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject160() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessageFragment on EGDSStandardMessage {\n    heading\n    message\n    graphic {\n      ...UIGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject160 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject161() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    enabled\n    label {\n      text\n    }\n    state\n  }\n"
    ]);
    _templateObject161 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject162() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicOptionFragment on EGDSOption {\n    label\n    selected\n    value\n  }\n"
    ]);
    _templateObject162 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject163() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerChildAgeSelectFragment on EGDSTravelerChildAgeSelect {\n    disabled\n    errorMessage\n    icon {\n      description\n      id\n      size\n      theme\n      title\n    }\n    label\n    options {\n      ...EGDSBasicOptionFragment\n    }\n    readOnly\n    value\n  }\n  ",
        "\n"
    ]);
    _templateObject163 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject164() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerStepInputFragment on EGDSStepInput {\n    increaseText\n    decreaseText\n    key\n    label\n    min\n    max\n    step\n    subLabel\n    value\n  }\n"
    ]);
    _templateObject164 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject165() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingUnitCardFragment on LodgingUnitCard {\n    unitId\n    header {\n      text\n    }\n    image {\n      description\n      url\n    }\n    trigger {\n      accessibilityLabel\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      secondaryValue\n      theme\n      value\n    }\n  }\n"
    ]);
    _templateObject165 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject166() {
    var data = _tagged_template_literal([
        "\n  fragment ShoppingRangeIndicatorCardDisclaimerFragment on LodgingPlainDialog {\n    title\n    content\n    primaryUIButton {\n      primary\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n    trigger {\n      icon {\n        id\n        title\n      }\n      clientSideAnalytics {\n        referrerId\n        linkName\n      }\n    }\n    toolbar {\n      icon {\n        id\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject166 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject167() {
    var data = _tagged_template_literal([
        "\n  fragment RangeIndicatorCardFragment on ShoppingRangeIndicatorCard {\n    rangeIndicator {\n      accessibility\n      milestones {\n        label {\n          size\n          text\n          weight\n        }\n      }\n      segments {\n        pins {\n          badge {\n            accessibility\n            text\n          }\n          percentage\n        }\n        style\n        theme\n      }\n    }\n    message\n    disclaimer {\n      ...ShoppingRangeIndicatorCardDisclaimerFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject167 = function _templateObject() {
        return data;
    };
    return data;
}
var ActionDetailsType = /* @__PURE__ */ function(ActionDetailsType2) {
    ActionDetailsType2["AUTHWINDOW"] = "AUTHWINDOW";
    ActionDetailsType2["CLOSE"] = "CLOSE";
    ActionDetailsType2["COPY"] = "COPY";
    ActionDetailsType2["DATEPICKER"] = "DATEPICKER";
    ActionDetailsType2["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    ActionDetailsType2["FREE_LX"] = "FREE_LX";
    ActionDetailsType2["OPEN"] = "OPEN";
    ActionDetailsType2["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    return ActionDetailsType2;
}(ActionDetailsType || {});
var AgencyBusinessModel = /* @__PURE__ */ function(AgencyBusinessModel2) {
    AgencyBusinessModel2["EXPEDIA_COLLECT"] = "EXPEDIA_COLLECT";
    AgencyBusinessModel2["HOTEL_COLLECT"] = "HOTEL_COLLECT";
    return AgencyBusinessModel2;
}(AgencyBusinessModel || {});
var AirportLocationType = /* @__PURE__ */ function(AirportLocationType2) {
    AirportLocationType2["AIRPORT"] = "AIRPORT";
    AirportLocationType2["METROCODE"] = "METROCODE";
    AirportLocationType2["UNSPECIFIED"] = "UNSPECIFIED";
    return AirportLocationType2;
}(AirportLocationType || {});
var AlterMode = /* @__PURE__ */ function(AlterMode2) {
    AlterMode2["DEBUG"] = "DEBUG";
    AlterMode2["NONE"] = "NONE";
    AlterMode2["PREVIEW"] = "PREVIEW";
    AlterMode2["RELEASED"] = "RELEASED";
    return AlterMode2;
}(AlterMode || {});
var AmenityCategory = /* @__PURE__ */ function(AmenityCategory2) {
    AmenityCategory2["ACCESSIBLE_ROLL_IN_SHOWER"] = "ACCESSIBLE_ROLL_IN_SHOWER";
    AmenityCategory2["AIR_CONDITIONING"] = "AIR_CONDITIONING";
    AmenityCategory2["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
    AmenityCategory2["ARCADE"] = "ARCADE";
    AmenityCategory2["BABYSITTING"] = "BABYSITTING";
    AmenityCategory2["BAR"] = "BAR";
    AmenityCategory2["BARBECUE"] = "BARBECUE";
    AmenityCategory2["BOWLING"] = "BOWLING";
    AmenityCategory2["BREAKFAST_AVAILABLE"] = "BREAKFAST_AVAILABLE";
    AmenityCategory2["BREAKFAST_INCLUDED"] = "BREAKFAST_INCLUDED";
    AmenityCategory2["BREAKFAST_NOT_AVAILABLE"] = "BREAKFAST_NOT_AVAILABLE";
    AmenityCategory2["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
    AmenityCategory2["CHILDREN_CLUB"] = "CHILDREN_CLUB";
    AmenityCategory2["DAILY_HOUSEKEEPING"] = "DAILY_HOUSEKEEPING";
    AmenityCategory2["EXTRA_BED"] = "EXTRA_BED";
    AmenityCategory2["FIRE_PLACE"] = "FIRE_PLACE";
    AmenityCategory2["FITNESS_EQUIPMENT"] = "FITNESS_EQUIPMENT";
    AmenityCategory2["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
    AmenityCategory2["FREE_BREAKFAST"] = "FREE_BREAKFAST";
    AmenityCategory2["FREE_CANCEL"] = "FREE_CANCEL";
    AmenityCategory2["FREE_PARKING"] = "FREE_PARKING";
    AmenityCategory2["FREE_WELCOME_DRINK"] = "FREE_WELCOME_DRINK";
    AmenityCategory2["FREE_WIRED_INTERNET"] = "FREE_WIRED_INTERNET";
    AmenityCategory2["FRONT_DESK_24_HOURS"] = "FRONT_DESK_24_HOURS";
    AmenityCategory2["GROCERY"] = "GROCERY";
    AmenityCategory2["HIGH_SPEED_INTERNET"] = "HIGH_SPEED_INTERNET";
    AmenityCategory2["HOT_TUB"] = "HOT_TUB";
    AmenityCategory2["INTERNET_NOT_AVAILABLE"] = "INTERNET_NOT_AVAILABLE";
    AmenityCategory2["IN_ROOM_INTERNET"] = "IN_ROOM_INTERNET";
    AmenityCategory2["KIDS_POOL"] = "KIDS_POOL";
    AmenityCategory2["KITCHEN"] = "KITCHEN";
    AmenityCategory2["LAUNDRY"] = "LAUNDRY";
    AmenityCategory2["LIVING_AREA"] = "LIVING_AREA";
    AmenityCategory2["MICROWAVE"] = "MICROWAVE";
    AmenityCategory2["MINI_GOLF"] = "MINI_GOLF";
    AmenityCategory2["NON_REFUNDABLE"] = "NON_REFUNDABLE";
    AmenityCategory2["ON_PRIVATE_BEACH"] = "ON_PRIVATE_BEACH";
    AmenityCategory2["ON_THE_BEACH"] = "ON_THE_BEACH";
    AmenityCategory2["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
    AmenityCategory2["PARKING"] = "PARKING";
    AmenityCategory2["PARTIAL_REFUND"] = "PARTIAL_REFUND";
    AmenityCategory2["PETS_ALLOWED"] = "PETS_ALLOWED";
    AmenityCategory2["PLAYGROUND"] = "PLAYGROUND";
    AmenityCategory2["POOL"] = "POOL";
    AmenityCategory2["RESERVE_NOW_PAY_DEPOSIT"] = "RESERVE_NOW_PAY_DEPOSIT";
    AmenityCategory2["RESERVE_NOW_PAY_LATER"] = "RESERVE_NOW_PAY_LATER";
    AmenityCategory2["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
    AmenityCategory2["ROOM_SERVICE"] = "ROOM_SERVICE";
    AmenityCategory2["SMOKE_FREE"] = "SMOKE_FREE";
    AmenityCategory2["SOUNDPROOF_ROOM"] = "SOUNDPROOF_ROOM";
    AmenityCategory2["SPA_SERVICES_ON_SITE"] = "SPA_SERVICES_ON_SITE";
    AmenityCategory2["SPECIAL_DEAL"] = "SPECIAL_DEAL";
    AmenityCategory2["TENNIS_COURT"] = "TENNIS_COURT";
    AmenityCategory2["TOYS"] = "TOYS";
    AmenityCategory2["WASHER"] = "WASHER";
    AmenityCategory2["WATERSLIDE"] = "WATERSLIDE";
    AmenityCategory2["WIFI_SURCHARGE"] = "WIFI_SURCHARGE";
    AmenityCategory2["WIRED_INTERNET_SURCHARGE"] = "WIRED_INTERNET_SURCHARGE";
    return AmenityCategory2;
}(AmenityCategory || {});
var AspectRatio = /* @__PURE__ */ function(AspectRatio2) {
    AspectRatio2["FOUR_ONE"] = "FOUR_ONE";
    AspectRatio2["FOUR_THREE"] = "FOUR_THREE";
    AspectRatio2["ONE_ONE"] = "ONE_ONE";
    AspectRatio2["SIXTEEN_NINE"] = "SIXTEEN_NINE";
    AspectRatio2["THREE_FOUR"] = "THREE_FOUR";
    AspectRatio2["THREE_TWO"] = "THREE_TWO";
    AspectRatio2["TWENTY_ONE_NINE"] = "TWENTY_ONE_NINE";
    return AspectRatio2;
}(AspectRatio || {});
var AuthenticationState = /* @__PURE__ */ function(AuthenticationState2) {
    AuthenticationState2["ANONYMOUS"] = "ANONYMOUS";
    AuthenticationState2["AUTHENTICATED"] = "AUTHENTICATED";
    AuthenticationState2["IDENTIFIED"] = "IDENTIFIED";
    return AuthenticationState2;
}(AuthenticationState || {});
var BadgeIcon = /* @__PURE__ */ function(BadgeIcon2) {
    BadgeIcon2["ACCESS_TIME"] = "ACCESS_TIME";
    BadgeIcon2["ADD"] = "ADD";
    BadgeIcon2["BUNDLED_SAVINGS_PLUS"] = "BUNDLED_SAVINGS_PLUS";
    BadgeIcon2["EXP29639_ORB"] = "EXP29639_ORB";
    BadgeIcon2["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
    BadgeIcon2["INFO_OUTLINE"] = "INFO_OUTLINE";
    BadgeIcon2["LOB_DEALS"] = "LOB_DEALS";
    BadgeIcon2["LOCAL_OFFER"] = "LOCAL_OFFER";
    BadgeIcon2["MOD"] = "MOD";
    BadgeIcon2["SMARTPHONE"] = "SMARTPHONE";
    return BadgeIcon2;
}(BadgeIcon || {});
var BusinessModelType = /* @__PURE__ */ function(BusinessModelType2) {
    BusinessModelType2["EXPEDIA_COLLECT"] = "EXPEDIA_COLLECT";
    BusinessModelType2["HOTEL_COLLECT"] = "HOTEL_COLLECT";
    return BusinessModelType2;
}(BusinessModelType || {});
var CarouselScrimType = /* @__PURE__ */ function(CarouselScrimType2) {
    CarouselScrimType2["INSET_PAGINATION_DOT"] = "INSET_PAGINATION_DOT";
    CarouselScrimType2["OFFSET_PAGINATION_DOT"] = "OFFSET_PAGINATION_DOT";
    return CarouselScrimType2;
}(CarouselScrimType || {});
var ChronoUnit = /* @__PURE__ */ function(ChronoUnit2) {
    ChronoUnit2["CENTURIES"] = "CENTURIES";
    ChronoUnit2["DAYS"] = "DAYS";
    ChronoUnit2["DECADES"] = "DECADES";
    ChronoUnit2["ERAS"] = "ERAS";
    ChronoUnit2["FOREVER"] = "FOREVER";
    ChronoUnit2["HALFDAYS"] = "HALFDAYS";
    ChronoUnit2["HOURS"] = "HOURS";
    ChronoUnit2["MICROS"] = "MICROS";
    ChronoUnit2["MILLENNIA"] = "MILLENNIA";
    ChronoUnit2["MILLIS"] = "MILLIS";
    ChronoUnit2["MINUTES"] = "MINUTES";
    ChronoUnit2["MONTHS"] = "MONTHS";
    ChronoUnit2["NANOS"] = "NANOS";
    ChronoUnit2["SECONDS"] = "SECONDS";
    ChronoUnit2["WEEKS"] = "WEEKS";
    ChronoUnit2["YEARS"] = "YEARS";
    return ChronoUnit2;
}(ChronoUnit || {});
var CleaningAndSafetyPractice = /* @__PURE__ */ function(CleaningAndSafetyPractice2) {
    CleaningAndSafetyPractice2["ENHANCED_CLEANING"] = "ENHANCED_CLEANING";
    return CleaningAndSafetyPractice2;
}(CleaningAndSafetyPractice || {});
var ClosedPeriodBounding = /* @__PURE__ */ function(ClosedPeriodBounding2) {
    ClosedPeriodBounding2["LOWER"] = "LOWER";
    ClosedPeriodBounding2["UPPER"] = "UPPER";
    return ClosedPeriodBounding2;
}(ClosedPeriodBounding || {});
var CommissionTier = /* @__PURE__ */ function(CommissionTier2) {
    CommissionTier2["BASIC"] = "BASIC";
    CommissionTier2["BASIC_PLUS"] = "BASIC_PLUS";
    CommissionTier2["PREMIUM"] = "PREMIUM";
    CommissionTier2["PREMIUM_PLUS"] = "PREMIUM_PLUS";
    return CommissionTier2;
}(CommissionTier || {});
var CompressionLevel = /* @__PURE__ */ function(CompressionLevel2) {
    CompressionLevel2["CAP"] = "CAP";
    CompressionLevel2["HIGH"] = "HIGH";
    CompressionLevel2["LOW"] = "LOW";
    CompressionLevel2["MEDIUM"] = "MEDIUM";
    CompressionLevel2["NA"] = "NA";
    return CompressionLevel2;
}(CompressionLevel || {});
var DatePeriodUnit = /* @__PURE__ */ function(DatePeriodUnit2) {
    DatePeriodUnit2["DAY"] = "DAY";
    DatePeriodUnit2["MONTH"] = "MONTH";
    DatePeriodUnit2["WEEK"] = "WEEK";
    DatePeriodUnit2["WEEKEND"] = "WEEKEND";
    return DatePeriodUnit2;
}(DatePeriodUnit || {});
var DealType = /* @__PURE__ */ function(DealType2) {
    DealType2["AARP"] = "AARP";
    DealType2["POINTS_PROMOTION"] = "POINTS_PROMOTION";
    return DealType2;
}(DealType || {});
var DeviceType = /* @__PURE__ */ function(DeviceType2) {
    DeviceType2["APP_PHONE"] = "APP_PHONE";
    DeviceType2["APP_TABLET"] = "APP_TABLET";
    DeviceType2["CHAT_APP"] = "CHAT_APP";
    DeviceType2["DESKTOP"] = "DESKTOP";
    DeviceType2["MOBILE_PHONE"] = "MOBILE_PHONE";
    DeviceType2["MOBILE_TABLET"] = "MOBILE_TABLET";
    DeviceType2["VOICE_APP"] = "VOICE_APP";
    return DeviceType2;
}(DeviceType || {});
var DirectFeedbackSheetType = /* @__PURE__ */ function(DirectFeedbackSheetType2) {
    DirectFeedbackSheetType2["BOTTOM_SHEET"] = "BOTTOM_SHEET";
    DirectFeedbackSheetType2["CENTERED_SHEET"] = "CENTERED_SHEET";
    DirectFeedbackSheetType2["FULL_SHEET"] = "FULL_SHEET";
    return DirectFeedbackSheetType2;
}(DirectFeedbackSheetType || {});
var DistanceUnit = /* @__PURE__ */ function(DistanceUnit2) {
    DistanceUnit2["KILOMETER"] = "KILOMETER";
    DistanceUnit2["MILE"] = "MILE";
    return DistanceUnit2;
}(DistanceUnit || {});
var EGDSCardBackgroundTheme = /* @__PURE__ */ function(EGDSCardBackgroundTheme4) {
    EGDSCardBackgroundTheme4["GLOBAL_LOYALTY_EXTRAHIGH"] = "GLOBAL_LOYALTY_EXTRAHIGH";
    EGDSCardBackgroundTheme4["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
    EGDSCardBackgroundTheme4["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
    EGDSCardBackgroundTheme4["GLOBAL_LOYALTY_MIDDLE"] = "GLOBAL_LOYALTY_MIDDLE";
    EGDSCardBackgroundTheme4["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
    EGDSCardBackgroundTheme4["HIGHLIGHT"] = "HIGHLIGHT";
    EGDSCardBackgroundTheme4["PRIMARY"] = "PRIMARY";
    EGDSCardBackgroundTheme4["SECONDARY"] = "SECONDARY";
    return EGDSCardBackgroundTheme4;
}(EGDSCardBackgroundTheme || {});
var EGDSCardThemes = /* @__PURE__ */ function(EGDSCardThemes2) {
    EGDSCardThemes2["BORDERED"] = "BORDERED";
    EGDSCardThemes2["PADDED"] = "PADDED";
    return EGDSCardThemes2;
}(EGDSCardThemes || {});
var EGDSCheckBoxState = /* @__PURE__ */ function(EGDSCheckBoxState2) {
    EGDSCheckBoxState2["CHECKED"] = "CHECKED";
    EGDSCheckBoxState2["INDETERMINATE"] = "INDETERMINATE";
    EGDSCheckBoxState2["UNCHECKED"] = "UNCHECKED";
    return EGDSCheckBoxState2;
}(EGDSCheckBoxState || {});
var EGDSDecorativeText = /* @__PURE__ */ function(EGDSDecorativeText2) {
    EGDSDecorativeText2["HIGHLIGHT"] = "HIGHLIGHT";
    EGDSDecorativeText2["LINE_THROUGH"] = "LINE_THROUGH";
    EGDSDecorativeText2["SUBSCRIPT"] = "SUBSCRIPT";
    EGDSDecorativeText2["SUPERSCRIPT"] = "SUPERSCRIPT";
    EGDSDecorativeText2["UNDERLINE"] = "UNDERLINE";
    return EGDSDecorativeText2;
}(EGDSDecorativeText || {});
var EGDSHeadingStyle = /* @__PURE__ */ function(EGDSHeadingStyle2) {
    EGDSHeadingStyle2["H1"] = "H1";
    EGDSHeadingStyle2["H2"] = "H2";
    EGDSHeadingStyle2["H3"] = "H3";
    EGDSHeadingStyle2["H4"] = "H4";
    EGDSHeadingStyle2["H5"] = "H5";
    EGDSHeadingStyle2["H6"] = "H6";
    EGDSHeadingStyle2["H7"] = "H7";
    EGDSHeadingStyle2["H8"] = "H8";
    return EGDSHeadingStyle2;
}(EGDSHeadingStyle || {});
var EGDSIconPosition = /* @__PURE__ */ function(EGDSIconPosition2) {
    EGDSIconPosition2["LEADING"] = "LEADING";
    EGDSIconPosition2["TRAILING"] = "TRAILING";
    return EGDSIconPosition2;
}(EGDSIconPosition || {});
var EGDSLinkSize = /* @__PURE__ */ function(EGDSLinkSize2) {
    EGDSLinkSize2["LARGE"] = "LARGE";
    EGDSLinkSize2["MEDIUM"] = "MEDIUM";
    EGDSLinkSize2["SMALL"] = "SMALL";
    return EGDSLinkSize2;
}(EGDSLinkSize || {});
var EGDSMapFeatureType = /* @__PURE__ */ function(EGDSMapFeatureType2) {
    EGDSMapFeatureType2["PLACE"] = "PLACE";
    EGDSMapFeatureType2["PRODUCT"] = "PRODUCT";
    EGDSMapFeatureType2["PROPERTY"] = "PROPERTY";
    return EGDSMapFeatureType2;
}(EGDSMapFeatureType || {});
var EGDSMapInitialViewport = /* @__PURE__ */ function(EGDSMapInitialViewport2) {
    EGDSMapInitialViewport2["BOUNDS"] = "BOUNDS";
    EGDSMapInitialViewport2["CENTERED_COMPUTED_BOUNDS"] = "CENTERED_COMPUTED_BOUNDS";
    EGDSMapInitialViewport2["CENTER_AND_ZOOM"] = "CENTER_AND_ZOOM";
    EGDSMapInitialViewport2["COMPUTED_BOUNDS"] = "COMPUTED_BOUNDS";
    EGDSMapInitialViewport2["FIT_MARKERS"] = "FIT_MARKERS";
    return EGDSMapInitialViewport2;
}(EGDSMapInitialViewport || {});
var EGDSMapMarkerStatus = /* @__PURE__ */ function(EGDSMapMarkerStatus2) {
    EGDSMapMarkerStatus2["AVAILABLE"] = "AVAILABLE";
    EGDSMapMarkerStatus2["FILTERED"] = "FILTERED";
    EGDSMapMarkerStatus2["SOLD_OUT"] = "SOLD_OUT";
    EGDSMapMarkerStatus2["UNKNOWN"] = "UNKNOWN";
    return EGDSMapMarkerStatus2;
}(EGDSMapMarkerStatus || {});
var EGDSMapProvider = /* @__PURE__ */ function(EGDSMapProvider2) {
    EGDSMapProvider2["GOOGLE"] = "GOOGLE";
    EGDSMapProvider2["MAPBOX"] = "MAPBOX";
    EGDSMapProvider2["MAPKIT"] = "MAPKIT";
    return EGDSMapProvider2;
}(EGDSMapProvider || {});
var EGDSParagraphStyle = /* @__PURE__ */ function(EGDSParagraphStyle2) {
    EGDSParagraphStyle2["P1"] = "P1";
    EGDSParagraphStyle2["P2"] = "P2";
    EGDSParagraphStyle2["P3"] = "P3";
    return EGDSParagraphStyle2;
}(EGDSParagraphStyle || {});
var EGDSPhotosphereCameraMovement = /* @__PURE__ */ function(EGDSPhotosphereCameraMovement2) {
    EGDSPhotosphereCameraMovement2["AUTO_PAN"] = "AUTO_PAN";
    EGDSPhotosphereCameraMovement2["DISABLED"] = "DISABLED";
    EGDSPhotosphereCameraMovement2["FULL_MOVE"] = "FULL_MOVE";
    return EGDSPhotosphereCameraMovement2;
}(EGDSPhotosphereCameraMovement || {});
var EGDSSheetType = /* @__PURE__ */ function(EGDSSheetType2) {
    EGDSSheetType2["BOTTOM"] = "BOTTOM";
    EGDSSheetType2["CENTERED"] = "CENTERED";
    EGDSSheetType2["FULLSCREEN"] = "FULLSCREEN";
    EGDSSheetType2["POPOVER"] = "POPOVER";
    EGDSSheetType2["SIDE"] = "SIDE";
    return EGDSSheetType2;
}(EGDSSheetType || {});
var EGDSSheetTypeViewSize = /* @__PURE__ */ function(EGDSSheetTypeViewSize2) {
    EGDSSheetTypeViewSize2["LARGE"] = "LARGE";
    EGDSSheetTypeViewSize2["MEDIUM"] = "MEDIUM";
    EGDSSheetTypeViewSize2["SMALL"] = "SMALL";
    return EGDSSheetTypeViewSize2;
}(EGDSSheetTypeViewSize || {});
var EGDSTextListItemStyle = /* @__PURE__ */ function(EGDSTextListItemStyle2) {
    EGDSTextListItemStyle2["DEFAULT"] = "DEFAULT";
    EGDSTextListItemStyle2["EMPHASIS"] = "EMPHASIS";
    EGDSTextListItemStyle2["LOYALTY"] = "LOYALTY";
    EGDSTextListItemStyle2["NEGATIVE"] = "NEGATIVE";
    EGDSTextListItemStyle2["POSITIVE"] = "POSITIVE";
    return EGDSTextListItemStyle2;
}(EGDSTextListItemStyle || {});
var EGDSTextListSize = /* @__PURE__ */ function(EGDSTextListSize2) {
    EGDSTextListSize2["LIST_1"] = "LIST_1";
    EGDSTextListSize2["LIST_2"] = "LIST_2";
    EGDSTextListSize2["LIST_3"] = "LIST_3";
    return EGDSTextListSize2;
}(EGDSTextListSize || {});
var EGDSTextListType = /* @__PURE__ */ function(EGDSTextListType2) {
    EGDSTextListType2["BULLET"] = "BULLET";
    EGDSTextListType2["ICON"] = "ICON";
    EGDSTextListType2["NO_BULLET"] = "NO_BULLET";
    EGDSTextListType2["NUMBER"] = "NUMBER";
    return EGDSTextListType2;
}(EGDSTextListType || {});
var EGDSThemeProviderColor = /* @__PURE__ */ function(EGDSThemeProviderColor2) {
    EGDSThemeProviderColor2["BRIGHT_1"] = "BRIGHT_1";
    EGDSThemeProviderColor2["DARK_1"] = "DARK_1";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_EXTRA_HIGH"] = "GLOBAL_LOYALTY_EXTRA_HIGH";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT"] = "GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_HIGH_BRIGHT"] = "GLOBAL_LOYALTY_HIGH_BRIGHT";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_LOW_BRIGHT"] = "GLOBAL_LOYALTY_LOW_BRIGHT";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_MID"] = "GLOBAL_LOYALTY_MID";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_MID_BRIGHT"] = "GLOBAL_LOYALTY_MID_BRIGHT";
    EGDSThemeProviderColor2["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
    EGDSThemeProviderColor2["LIGHT_1"] = "LIGHT_1";
    EGDSThemeProviderColor2["MARKETING_1"] = "MARKETING_1";
    EGDSThemeProviderColor2["MARKETING_2"] = "MARKETING_2";
    EGDSThemeProviderColor2["NONE"] = "NONE";
    EGDSThemeProviderColor2["STANDARD"] = "STANDARD";
    return EGDSThemeProviderColor2;
}(EGDSThemeProviderColor || {});
var EGDSTypeaheadRenderType = /* @__PURE__ */ function(EGDSTypeaheadRenderType2) {
    EGDSTypeaheadRenderType2["ADAPTIVE"] = "ADAPTIVE";
    EGDSTypeaheadRenderType2["DIALOG"] = "DIALOG";
    EGDSTypeaheadRenderType2["MENU"] = "MENU";
    return EGDSTypeaheadRenderType2;
}(EGDSTypeaheadRenderType || {});
var EGReferrerEventType = /* @__PURE__ */ function(EGReferrerEventType2) {
    EGReferrerEventType2["CLICK"] = "CLICK";
    EGReferrerEventType2["IMPRESSION"] = "IMPRESSION";
    return EGReferrerEventType2;
}(EGReferrerEventType || {});
var ExpandoTriggerPosition = /* @__PURE__ */ function(ExpandoTriggerPosition2) {
    ExpandoTriggerPosition2["LEADING"] = "LEADING";
    ExpandoTriggerPosition2["TRAILING"] = "TRAILING";
    return ExpandoTriggerPosition2;
}(ExpandoTriggerPosition || {});
var FeeType = /* @__PURE__ */ function(FeeType2) {
    FeeType2["CARD_ON_FILE_DAMAGE_LIABILITY"] = "CARD_ON_FILE_DAMAGE_LIABILITY";
    FeeType2["DEFAULT"] = "DEFAULT";
    FeeType2["DEFAULT_SUPPLIER_COLLECTED"] = "DEFAULT_SUPPLIER_COLLECTED";
    FeeType2["GROUPED_MANDATORY_FEES"] = "GROUPED_MANDATORY_FEES";
    FeeType2["L26_TAX_BREAKOUT"] = "L26_TAX_BREAKOUT";
    FeeType2["NORMAL"] = "NORMAL";
    FeeType2["OTHER"] = "OTHER";
    FeeType2["PER_PERSON_PER_NIGHT"] = "PER_PERSON_PER_NIGHT";
    FeeType2["PROPERTY"] = "PROPERTY";
    FeeType2["REFUNDABLE_DAMAGE_DEPOSIT"] = "REFUNDABLE_DAMAGE_DEPOSIT";
    FeeType2["RESORT"] = "RESORT";
    return FeeType2;
}(FeeType || {});
var FilterPlacement = /* @__PURE__ */ function(FilterPlacement2) {
    FilterPlacement2["OVERLAY_BOTTOM"] = "OVERLAY_BOTTOM";
    FilterPlacement2["OVERLAY_TOP"] = "OVERLAY_TOP";
    FilterPlacement2["TOOLBAR"] = "TOOLBAR";
    return FilterPlacement2;
}(FilterPlacement || {});
var FlexibleSearchTripDurationType = /* @__PURE__ */ function(FlexibleSearchTripDurationType2) {
    FlexibleSearchTripDurationType2["MONTH"] = "MONTH";
    FlexibleSearchTripDurationType2["WEEK"] = "WEEK";
    FlexibleSearchTripDurationType2["WEEKEND"] = "WEEKEND";
    return FlexibleSearchTripDurationType2;
}(FlexibleSearchTripDurationType || {});
var FlightsAdvancedFilterType = /* @__PURE__ */ function(FlightsAdvancedFilterType2) {
    FlightsAdvancedFilterType2["NONSTOP"] = "NONSTOP";
    FlightsAdvancedFilterType2["REFUNDABLE"] = "REFUNDABLE";
    return FlightsAdvancedFilterType2;
}(FlightsAdvancedFilterType || {});
var FlightsCabinClass = /* @__PURE__ */ function(FlightsCabinClass2) {
    FlightsCabinClass2["BUSINESS"] = "BUSINESS";
    FlightsCabinClass2["COACH"] = "COACH";
    FlightsCabinClass2["FIRST"] = "FIRST";
    FlightsCabinClass2["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
    return FlightsCabinClass2;
}(FlightsCabinClass || {});
var FlightsTripType = /* @__PURE__ */ function(FlightsTripType2) {
    FlightsTripType2["MULTI_DESTINATION"] = "MULTI_DESTINATION";
    FlightsTripType2["ONE_WAY"] = "ONE_WAY";
    FlightsTripType2["ROUND_TRIP"] = "ROUND_TRIP";
    return FlightsTripType2;
}(FlightsTripType || {});
var GeoType = /* @__PURE__ */ function(GeoType2) {
    GeoType2["AIRPORT"] = "AIRPORT";
    GeoType2["DESTINATION"] = "DESTINATION";
    GeoType2["PROPERTY"] = "PROPERTY";
    return GeoType2;
}(GeoType || {});
var GroundTransfersDirection = /* @__PURE__ */ function(GroundTransfersDirection2) {
    GroundTransfersDirection2["FROM_AIRPORT"] = "FROM_AIRPORT";
    GroundTransfersDirection2["ROUNDTRIP"] = "ROUNDTRIP";
    GroundTransfersDirection2["TO_AIRPORT"] = "TO_AIRPORT";
    return GroundTransfersDirection2;
}(GroundTransfersDirection || {});
var GroundTransfersTravelerDetailsType = /* @__PURE__ */ function(GroundTransfersTravelerDetailsType2) {
    GroundTransfersTravelerDetailsType2["ADULT"] = "ADULT";
    GroundTransfersTravelerDetailsType2["CHILD"] = "CHILD";
    GroundTransfersTravelerDetailsType2["INFANT"] = "INFANT";
    return GroundTransfersTravelerDetailsType2;
}(GroundTransfersTravelerDetailsType || {});
var IconSize = /* @__PURE__ */ function(IconSize2) {
    IconSize2["EXTRA_SMALL"] = "EXTRA_SMALL";
    IconSize2["LARGE"] = "LARGE";
    IconSize2["MEDIUM"] = "MEDIUM";
    IconSize2["MEDIUM_LARGE"] = "MEDIUM_LARGE";
    IconSize2["SMALL"] = "SMALL";
    IconSize2["XLARGE"] = "XLARGE";
    return IconSize2;
}(IconSize || {});
var IconSpotLight = /* @__PURE__ */ function(IconSpotLight2) {
    IconSpotLight2["INFO"] = "INFO";
    IconSpotLight2["POSITIVE"] = "POSITIVE";
    IconSpotLight2["STANDARD"] = "STANDARD";
    IconSpotLight2["WARNING"] = "WARNING";
    return IconSpotLight2;
}(IconSpotLight || {});
var IconTheme = /* @__PURE__ */ function(IconTheme2) {
    IconTheme2["default"] = "default";
    IconTheme2["emphasis"] = "emphasis";
    IconTheme2["inverse"] = "inverse";
    IconTheme2["negative"] = "negative";
    IconTheme2["positive"] = "positive";
    return IconTheme2;
}(IconTheme || {});
var InsurTechPagePlacementType = /* @__PURE__ */ function(InsurTechPagePlacementType2) {
    InsurTechPagePlacementType2["LISTING"] = "LISTING";
    InsurTechPagePlacementType2["LISTING_ONE_WAY"] = "LISTING_ONE_WAY";
    return InsurTechPagePlacementType2;
}(InsurTechPagePlacementType || {});
var InventoryType = /* @__PURE__ */ function(InventoryType2) {
    InventoryType2["AICTRAVELGROUP"] = "AICTRAVELGROUP";
    InventoryType2["AMOMA"] = "AMOMA";
    InventoryType2["ANA"] = "ANA";
    InventoryType2["BESTBUYHOTEL"] = "BESTBUYHOTEL";
    InventoryType2["BONOTEL"] = "BONOTEL";
    InventoryType2["CNTRAVEL"] = "CNTRAVEL";
    InventoryType2["CTRIP"] = "CTRIP";
    InventoryType2["DESPEGAR"] = "DESPEGAR";
    InventoryType2["DIDATRAVEL"] = "DIDATRAVEL";
    InventoryType2["DIRECT_AGENCY"] = "DIRECT_AGENCY";
    InventoryType2["EUROPLAYAS"] = "EUROPLAYAS";
    InventoryType2["EXCITEHOLIDAYS"] = "EXCITEHOLIDAYS";
    InventoryType2["EZZEGO_1"] = "EZZEGO_1";
    InventoryType2["GETAROOM"] = "GETAROOM";
    InventoryType2["HOME_AWAY"] = "HOME_AWAY";
    InventoryType2["HOTELDOBESTDAYTRAVEL"] = "HOTELDOBESTDAYTRAVEL";
    InventoryType2["HOTEL_BEDS"] = "HOTEL_BEDS";
    InventoryType2["HRS"] = "HRS";
    InventoryType2["JAC_TRAVEL"] = "JAC_TRAVEL";
    InventoryType2["JAL"] = "JAL";
    InventoryType2["JALAN"] = "JALAN";
    InventoryType2["JTB"] = "JTB";
    InventoryType2["JUMBOTOURS"] = "JUMBOTOURS";
    InventoryType2["MAGICROOMS"] = "MAGICROOMS";
    InventoryType2["MERCHANT"] = "MERCHANT";
    InventoryType2["MGBEDBANK"] = "MGBEDBANK";
    InventoryType2["MIKI"] = "MIKI";
    InventoryType2["MTS"] = "MTS";
    InventoryType2["NTA"] = "NTA";
    InventoryType2["NUITEE"] = "NUITEE";
    InventoryType2["OPAQUE"] = "OPAQUE";
    InventoryType2["OSTROVOK"] = "OSTROVOK";
    InventoryType2["PEGASUS"] = "PEGASUS";
    InventoryType2["RAKUTEN"] = "RAKUTEN";
    InventoryType2["RESTEL"] = "RESTEL";
    InventoryType2["ROOMER"] = "ROOMER";
    InventoryType2["SMYROOMS"] = "SMYROOMS";
    InventoryType2["SUNHOTELS"] = "SUNHOTELS";
    InventoryType2["THOMASCOOK_EUR"] = "THOMASCOOK_EUR";
    InventoryType2["THOMASCOOK_UK"] = "THOMASCOOK_UK";
    InventoryType2["TOURICO"] = "TOURICO";
    InventoryType2["TRAVELLANDA"] = "TRAVELLANDA";
    InventoryType2["TRAVELREPUBLIC"] = "TRAVELREPUBLIC";
    InventoryType2["TRIPCOM"] = "TRIPCOM";
    InventoryType2["VENERE"] = "VENERE";
    InventoryType2["VRBO"] = "VRBO";
    InventoryType2["VRBO_MUVR"] = "VRBO_MUVR";
    InventoryType2["WELCOME_BEDS"] = "WELCOME_BEDS";
    InventoryType2["WOORI"] = "WOORI";
    InventoryType2["WORLDHOTELLINK"] = "WORLDHOTELLINK";
    InventoryType2["WORLDSPAN"] = "WORLDSPAN";
    InventoryType2["WOTIF"] = "WOTIF";
    InventoryType2["YOUTRAVEL"] = "YOUTRAVEL";
    InventoryType2["ZUMATA"] = "ZUMATA";
    return InventoryType2;
}(InventoryType || {});
var LineOfBusinessDomain = /* @__PURE__ */ function(LineOfBusinessDomain2) {
    LineOfBusinessDomain2["ACTIVITIES"] = "ACTIVITIES";
    LineOfBusinessDomain2["CAR"] = "CAR";
    LineOfBusinessDomain2["CRUISES"] = "CRUISES";
    LineOfBusinessDomain2["FLIGHT"] = "FLIGHT";
    LineOfBusinessDomain2["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
    LineOfBusinessDomain2["LODGING"] = "LODGING";
    LineOfBusinessDomain2["PACKAGES"] = "PACKAGES";
    LineOfBusinessDomain2["RAILS"] = "RAILS";
    LineOfBusinessDomain2["UNCLASSIFIED"] = "UNCLASSIFIED";
    return LineOfBusinessDomain2;
}(LineOfBusinessDomain || {});
var Listings = /* @__PURE__ */ function(Listings2) {
    Listings2["ADS_ONLY"] = "ADS_ONLY";
    return Listings2;
}(Listings || {});
var LiveAnnouncePoliteness = /* @__PURE__ */ function(LiveAnnouncePoliteness2) {
    LiveAnnouncePoliteness2["ASSERTIVE"] = "ASSERTIVE";
    LiveAnnouncePoliteness2["OFF"] = "OFF";
    LiveAnnouncePoliteness2["POLITE"] = "POLITE";
    return LiveAnnouncePoliteness2;
}(LiveAnnouncePoliteness || {});
var LodgingCrossSellProductType = /* @__PURE__ */ function(LodgingCrossSellProductType2) {
    LodgingCrossSellProductType2["CAR"] = "CAR";
    return LodgingCrossSellProductType2;
}(LodgingCrossSellProductType || {});
var LodgingFormMethod = /* @__PURE__ */ function(LodgingFormMethod2) {
    LodgingFormMethod2["GET"] = "GET";
    LodgingFormMethod2["POST"] = "POST";
    return LodgingFormMethod2;
}(LodgingFormMethod || {});
var LodgingInputType = /* @__PURE__ */ function(LodgingInputType2) {
    LodgingInputType2["EMAIL"] = "EMAIL";
    LodgingInputType2["HIDDEN"] = "HIDDEN";
    LodgingInputType2["PASSWORD"] = "PASSWORD";
    LodgingInputType2["TEL"] = "TEL";
    LodgingInputType2["TEXT"] = "TEXT";
    LodgingInputType2["URL"] = "URL";
    return LodgingInputType2;
}(LodgingInputType || {});
var LodgingMessageTheme = /* @__PURE__ */ function(LodgingMessageTheme2) {
    LodgingMessageTheme2["AGGRESSIVE"] = "AGGRESSIVE";
    LodgingMessageTheme2["EMPHASIS"] = "EMPHASIS";
    LodgingMessageTheme2["HIGHLIGHT"] = "HIGHLIGHT";
    LodgingMessageTheme2["STRONG"] = "STRONG";
    return LodgingMessageTheme2;
}(LodgingMessageTheme || {});
var LodgingStepperState = /* @__PURE__ */ function(LodgingStepperState2) {
    LodgingStepperState2["COMPLETE"] = "COMPLETE";
    LodgingStepperState2["CURRENT"] = "CURRENT";
    LodgingStepperState2["INCOMPLETE"] = "INCOMPLETE";
    return LodgingStepperState2;
}(LodgingStepperState || {});
var LodgingTrackPosition = /* @__PURE__ */ function(LodgingTrackPosition2) {
    LodgingTrackPosition2["END"] = "END";
    LodgingTrackPosition2["STANDARD"] = "STANDARD";
    LodgingTrackPosition2["START"] = "START";
    return LodgingTrackPosition2;
}(LodgingTrackPosition || {});
var MapIconType = /* @__PURE__ */ function(MapIconType2) {
    MapIconType2["AIRPORT"] = "AIRPORT";
    MapIconType2["CIRCLE"] = "CIRCLE";
    MapIconType2["GROCERY"] = "GROCERY";
    MapIconType2["HOTEL"] = "HOTEL";
    MapIconType2["LANDMARK"] = "LANDMARK";
    MapIconType2["METRO"] = "METRO";
    MapIconType2["RESTAURANT"] = "RESTAURANT";
    MapIconType2["SOLD_OUT"] = "SOLD_OUT";
    MapIconType2["TRAIN"] = "TRAIN";
    MapIconType2["VACATION_RENTAL"] = "VACATION_RENTAL";
    return MapIconType2;
}(MapIconType || {});
var MapToolbarActionsType = /* @__PURE__ */ function(MapToolbarActionsType2) {
    MapToolbarActionsType2["FILTERS"] = "FILTERS";
    return MapToolbarActionsType2;
}(MapToolbarActionsType || {});
var MarkerType = /* @__PURE__ */ function(MarkerType2) {
    MarkerType2["HOTEL"] = "HOTEL";
    MarkerType2["POI"] = "POI";
    return MarkerType2;
}(MarkerType || {});
var MarkupTextType = /* @__PURE__ */ function(MarkupTextType2) {
    MarkupTextType2["HTML"] = "HTML";
    return MarkupTextType2;
}(MarkupTextType || {});
var MealPlanFilterAmenity = /* @__PURE__ */ function(MealPlanFilterAmenity2) {
    MealPlanFilterAmenity2["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
    MealPlanFilterAmenity2["FREE_BREAKFAST"] = "FREE_BREAKFAST";
    MealPlanFilterAmenity2["FULL_BOARD"] = "FULL_BOARD";
    MealPlanFilterAmenity2["HALF_BOARD"] = "HALF_BOARD";
    return MealPlanFilterAmenity2;
}(MealPlanFilterAmenity || {});
var MessageType = /* @__PURE__ */ function(MessageType2) {
    MessageType2["ADDON"] = "ADDON";
    MessageType2["BRANDED_THEME_ACCENT"] = "BRANDED_THEME_ACCENT";
    MessageType2["BRANDED_THEME_DARK"] = "BRANDED_THEME_DARK";
    MessageType2["BRANDED_THEME_LIGHT"] = "BRANDED_THEME_LIGHT";
    MessageType2["COMPRESSION"] = "COMPRESSION";
    MessageType2["COUPON"] = "COUPON";
    MessageType2["DOUBLE_POINTS"] = "DOUBLE_POINTS";
    MessageType2["FREE_CANCELLATION"] = "FREE_CANCELLATION";
    MessageType2["FREE_LX"] = "FREE_LX";
    MessageType2["HOTRATE"] = "HOTRATE";
    MessageType2["LEGAL"] = "LEGAL";
    MessageType2["LOGIN"] = "LOGIN";
    MessageType2["LOYALTY"] = "LOYALTY";
    MessageType2["NO_CC"] = "NO_CC";
    MessageType2["OVERFILTERED"] = "OVERFILTERED";
    MessageType2["PARTNER_LINKOFF"] = "PARTNER_LINKOFF";
    MessageType2["VACATION_RENTALS"] = "VACATION_RENTALS";
    return MessageType2;
}(MessageType || {});
var OfferAttributeType = /* @__PURE__ */ function(OfferAttributeType2) {
    OfferAttributeType2["FREE_BREAKFAST"] = "FREE_BREAKFAST";
    OfferAttributeType2["FREE_CANCELLATION"] = "FREE_CANCELLATION";
    OfferAttributeType2["NO_CC_REQUIRED"] = "NO_CC_REQUIRED";
    OfferAttributeType2["PAYMENT_CHOICE"] = "PAYMENT_CHOICE";
    OfferAttributeType2["VIP"] = "VIP";
    return OfferAttributeType2;
}(OfferAttributeType || {});
var Orientation = /* @__PURE__ */ function(Orientation2) {
    Orientation2["LANDSCAPE"] = "LANDSCAPE";
    Orientation2["PORTRAIT"] = "PORTRAIT";
    return Orientation2;
}(Orientation || {});
var PackageType = /* @__PURE__ */ function(PackageType2) {
    PackageType2["FLIGHT_CAR"] = "FLIGHT_CAR";
    PackageType2["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
    PackageType2["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
    PackageType2["HOTEL_ACTIVITY"] = "HOTEL_ACTIVITY";
    PackageType2["HOTEL_CAR"] = "HOTEL_CAR";
    return PackageType2;
}(PackageType || {});
var PageLocation = /* @__PURE__ */ function(PageLocation2) {
    PageLocation2["CFAR_DETAILS"] = "CFAR_DETAILS";
    PageLocation2["CHECKOUT"] = "CHECKOUT";
    PageLocation2["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
    PageLocation2["CONFIRMATION"] = "CONFIRMATION";
    PageLocation2["DETAILS"] = "DETAILS";
    PageLocation2["ENTRY"] = "ENTRY";
    PageLocation2["FEATURES"] = "FEATURES";
    PageLocation2["INSURANCE_DETAILS"] = "INSURANCE_DETAILS";
    PageLocation2["ITINERARY"] = "ITINERARY";
    PageLocation2["PAYMENT_ERROR"] = "PAYMENT_ERROR";
    PageLocation2["POST_BOOKING"] = "POST_BOOKING";
    PageLocation2["SEARCH_RESULTS"] = "SEARCH_RESULTS";
    PageLocation2["SYSTEM"] = "SYSTEM";
    PageLocation2["USER"] = "USER";
    return PageLocation2;
}(PageLocation || {});
var PaymentType = /* @__PURE__ */ function(PaymentType2) {
    PaymentType2["COUPON_ELIGIBLE"] = "COUPON_ELIGIBLE";
    PaymentType2["FREE_CANCELLATION"] = "FREE_CANCELLATION";
    PaymentType2["GIFT_CARD"] = "GIFT_CARD";
    PaymentType2["PAY_LATER"] = "PAY_LATER";
    PaymentType2["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
    PaymentType2["PAY_WITHOUT_CREDITCARD"] = "PAY_WITHOUT_CREDITCARD";
    PaymentType2["PAY_WITH_AFFIRM"] = "PAY_WITH_AFFIRM";
    PaymentType2["PAY_WITH_AFTERPAY"] = "PAY_WITH_AFTERPAY";
    PaymentType2["PAY_WITH_KLARNA"] = "PAY_WITH_KLARNA";
    return PaymentType2;
}(PaymentType || {});
var PluralCategory = /* @__PURE__ */ function(PluralCategory2) {
    PluralCategory2["FEW"] = "FEW";
    PluralCategory2["MANY"] = "MANY";
    PluralCategory2["ONE"] = "ONE";
    PluralCategory2["OTHER"] = "OTHER";
    PluralCategory2["TWO"] = "TWO";
    PluralCategory2["ZERO"] = "ZERO";
    return PluralCategory2;
}(PluralCategory || {});
var Points = /* @__PURE__ */ function(Points2) {
    Points2["SHOP_WITHOUT_POINTS"] = "SHOP_WITHOUT_POINTS";
    Points2["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
    return Points2;
}(Points || {});
var PricingSchemeType = /* @__PURE__ */ function(PricingSchemeType2) {
    PricingSchemeType2["DAILY_RATE"] = "DAILY_RATE";
    PricingSchemeType2["TOTAL_RATE"] = "TOTAL_RATE";
    return PricingSchemeType2;
}(PricingSchemeType || {});
var PrivacyTrackingState = /* @__PURE__ */ function(PrivacyTrackingState2) {
    PrivacyTrackingState2["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
    PrivacyTrackingState2["CAN_TRACK"] = "CAN_TRACK";
    return PrivacyTrackingState2;
}(PrivacyTrackingState || {});
var PropertyAmenityCategoryType = /* @__PURE__ */ function(PropertyAmenityCategoryType2) {
    PropertyAmenityCategoryType2["ACCESSIBLE_ROLL_IN_SHOWER"] = "ACCESSIBLE_ROLL_IN_SHOWER";
    PropertyAmenityCategoryType2["AIR_CONDITIONING"] = "AIR_CONDITIONING";
    PropertyAmenityCategoryType2["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
    PropertyAmenityCategoryType2["ARCADE"] = "ARCADE";
    PropertyAmenityCategoryType2["BABYSITTING"] = "BABYSITTING";
    PropertyAmenityCategoryType2["BAR"] = "BAR";
    PropertyAmenityCategoryType2["BOWLING"] = "BOWLING";
    PropertyAmenityCategoryType2["BREAKFAST_AVAILABLE"] = "BREAKFAST_AVAILABLE";
    PropertyAmenityCategoryType2["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
    PropertyAmenityCategoryType2["CHILDREN_CLUB"] = "CHILDREN_CLUB";
    PropertyAmenityCategoryType2["DAILY_HOUSEKEEPING"] = "DAILY_HOUSEKEEPING";
    PropertyAmenityCategoryType2["EXTRA_BED"] = "EXTRA_BED";
    PropertyAmenityCategoryType2["FITNESS_EQUIPMENT"] = "FITNESS_EQUIPMENT";
    PropertyAmenityCategoryType2["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
    PropertyAmenityCategoryType2["FREE_BREAKFAST"] = "FREE_BREAKFAST";
    PropertyAmenityCategoryType2["FREE_PARKING"] = "FREE_PARKING";
    PropertyAmenityCategoryType2["FREE_WELCOME_DRINK"] = "FREE_WELCOME_DRINK";
    PropertyAmenityCategoryType2["FRONT_DESK_24_HOURS"] = "FRONT_DESK_24_HOURS";
    PropertyAmenityCategoryType2["GROCERY"] = "GROCERY";
    PropertyAmenityCategoryType2["HIGH_SPEED_INTERNET"] = "HIGH_SPEED_INTERNET";
    PropertyAmenityCategoryType2["HOT_TUB"] = "HOT_TUB";
    PropertyAmenityCategoryType2["IN_ROOM_INTERNET"] = "IN_ROOM_INTERNET";
    PropertyAmenityCategoryType2["KIDS_POOL"] = "KIDS_POOL";
    PropertyAmenityCategoryType2["KITCHEN"] = "KITCHEN";
    PropertyAmenityCategoryType2["LAUNDRY"] = "LAUNDRY";
    PropertyAmenityCategoryType2["LIVING_AREA"] = "LIVING_AREA";
    PropertyAmenityCategoryType2["MICROWAVE"] = "MICROWAVE";
    PropertyAmenityCategoryType2["MINI_GOLF"] = "MINI_GOLF";
    PropertyAmenityCategoryType2["PARKING"] = "PARKING";
    PropertyAmenityCategoryType2["PETS_ALLOWED"] = "PETS_ALLOWED";
    PropertyAmenityCategoryType2["PLAYGROUND"] = "PLAYGROUND";
    PropertyAmenityCategoryType2["POOL"] = "POOL";
    PropertyAmenityCategoryType2["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
    PropertyAmenityCategoryType2["ROOM_SERVICE"] = "ROOM_SERVICE";
    PropertyAmenityCategoryType2["SMOKE_FREE"] = "SMOKE_FREE";
    PropertyAmenityCategoryType2["SOUNDPROOF_ROOM"] = "SOUNDPROOF_ROOM";
    PropertyAmenityCategoryType2["SPA_SERVICES_ON_SITE"] = "SPA_SERVICES_ON_SITE";
    PropertyAmenityCategoryType2["SPECIAL_DEAL"] = "SPECIAL_DEAL";
    PropertyAmenityCategoryType2["TENNIS_COURT"] = "TENNIS_COURT";
    PropertyAmenityCategoryType2["TOYS"] = "TOYS";
    PropertyAmenityCategoryType2["WATERSLIDE"] = "WATERSLIDE";
    return PropertyAmenityCategoryType2;
}(PropertyAmenityCategoryType || {});
var PropertyAmenityType = /* @__PURE__ */ function(PropertyAmenityType2) {
    PropertyAmenityType2["ACCESSIBILITY"] = "ACCESSIBILITY";
    PropertyAmenityType2["BATHROOM"] = "BATHROOM";
    PropertyAmenityType2["BEDROOM"] = "BEDROOM";
    PropertyAmenityType2["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
    PropertyAmenityType2["CONVENIENCES"] = "CONVENIENCES";
    PropertyAmenityType2["ENTERTAINMENT"] = "ENTERTAINMENT";
    PropertyAmenityType2["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
    PropertyAmenityType2["FOOD_DRINK"] = "FOOD_DRINK";
    PropertyAmenityType2["GUEST_SERVICES"] = "GUEST_SERVICES";
    PropertyAmenityType2["INTERNET"] = "INTERNET";
    PropertyAmenityType2["MORE"] = "MORE";
    PropertyAmenityType2["OUTDOOR"] = "OUTDOOR";
    PropertyAmenityType2["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
    PropertyAmenityType2["PARKING"] = "PARKING";
    PropertyAmenityType2["PROPERTY"] = "PROPERTY";
    PropertyAmenityType2["ROOM"] = "ROOM";
    PropertyAmenityType2["SPA"] = "SPA";
    PropertyAmenityType2["THINGS_TO_DO"] = "THINGS_TO_DO";
    return PropertyAmenityType2;
}(PropertyAmenityType || {});
var PropertyCancellationPolicyType = /* @__PURE__ */ function(PropertyCancellationPolicyType2) {
    PropertyCancellationPolicyType2["NON_REFUNDABLE"] = "NON_REFUNDABLE";
    PropertyCancellationPolicyType2["REFUNDABLE_WITH_NO_PENALTY"] = "REFUNDABLE_WITH_NO_PENALTY";
    PropertyCancellationPolicyType2["REFUNDABLE_WITH_PENALTY"] = "REFUNDABLE_WITH_PENALTY";
    return PropertyCancellationPolicyType2;
}(PropertyCancellationPolicyType || {});
var PropertyContentSectionRef = /* @__PURE__ */ function(PropertyContentSectionRef2) {
    PropertyContentSectionRef2["AVAILABILITY_CALENDAR_START_DATE"] = "AVAILABILITY_CALENDAR_START_DATE";
    PropertyContentSectionRef2["PRICE_DISPLAY_SERVICE_RESPONSE"] = "PRICE_DISPLAY_SERVICE_RESPONSE";
    PropertyContentSectionRef2["RECOMMENDED_OFFER"] = "RECOMMENDED_OFFER";
    PropertyContentSectionRef2["ROOMS_AND_RATES"] = "ROOMS_AND_RATES";
    return PropertyContentSectionRef2;
}(PropertyContentSectionRef || {});
var PropertyFilterAccessibility = /* @__PURE__ */ function(PropertyFilterAccessibility2) {
    PropertyFilterAccessibility2["ACCESSIBLE_BATHROOM"] = "ACCESSIBLE_BATHROOM";
    PropertyFilterAccessibility2["ACCESSIBLE_PARKING"] = "ACCESSIBLE_PARKING";
    PropertyFilterAccessibility2["ELEVATOR"] = "ELEVATOR";
    PropertyFilterAccessibility2["IN_ROOM_ACCESSIBLE"] = "IN_ROOM_ACCESSIBLE";
    PropertyFilterAccessibility2["ROLL_IN_SHOWER"] = "ROLL_IN_SHOWER";
    PropertyFilterAccessibility2["SERVICE_ANIMAL"] = "SERVICE_ANIMAL";
    PropertyFilterAccessibility2["SIGN_LANGUAGE_INTERPRETER"] = "SIGN_LANGUAGE_INTERPRETER";
    PropertyFilterAccessibility2["STAIR_FREE_PATH"] = "STAIR_FREE_PATH";
    return PropertyFilterAccessibility2;
}(PropertyFilterAccessibility || {});
var PropertyFilterAmenity = /* @__PURE__ */ function(PropertyFilterAmenity2) {
    PropertyFilterAmenity2["AIR_CONDITIONING"] = "AIR_CONDITIONING";
    PropertyFilterAmenity2["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
    PropertyFilterAmenity2["BALCONY_OR_TERRACE"] = "BALCONY_OR_TERRACE";
    PropertyFilterAmenity2["BAR"] = "BAR";
    PropertyFilterAmenity2["BEACH"] = "BEACH";
    PropertyFilterAmenity2["BEACH_FRONT"] = "BEACH_FRONT";
    PropertyFilterAmenity2["BED_LINENS"] = "BED_LINENS";
    PropertyFilterAmenity2["CASINO"] = "CASINO";
    PropertyFilterAmenity2["CRIB"] = "CRIB";
    PropertyFilterAmenity2["DISHWASHER"] = "DISHWASHER";
    PropertyFilterAmenity2["DRYER"] = "DRYER";
    PropertyFilterAmenity2["ELECTRIC_CAR"] = "ELECTRIC_CAR";
    PropertyFilterAmenity2["FIREPLACE"] = "FIREPLACE";
    PropertyFilterAmenity2["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
    PropertyFilterAmenity2["FREE_BREAKFAST"] = "FREE_BREAKFAST";
    PropertyFilterAmenity2["FREE_PARKING"] = "FREE_PARKING";
    PropertyFilterAmenity2["GOLF"] = "GOLF";
    PropertyFilterAmenity2["GOLF_COURSE"] = "GOLF_COURSE";
    PropertyFilterAmenity2["GYM"] = "GYM";
    PropertyFilterAmenity2["HOT_SPRING"] = "HOT_SPRING";
    PropertyFilterAmenity2["HOT_TUB"] = "HOT_TUB";
    PropertyFilterAmenity2["KITCHEN_KITCHEN"] = "KITCHEN_KITCHEN";
    PropertyFilterAmenity2["KITCHEN_KITCHENETTE"] = "KITCHEN_KITCHENETTE";
    PropertyFilterAmenity2["OCEAN_VIEW"] = "OCEAN_VIEW";
    PropertyFilterAmenity2["PARKING"] = "PARKING";
    PropertyFilterAmenity2["PETS"] = "PETS";
    PropertyFilterAmenity2["POOL"] = "POOL";
    PropertyFilterAmenity2["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
    PropertyFilterAmenity2["SPA_ON_SITE"] = "SPA_ON_SITE";
    PropertyFilterAmenity2["TELEVISION"] = "TELEVISION";
    PropertyFilterAmenity2["WASHER"] = "WASHER";
    PropertyFilterAmenity2["WASHER_DRYER"] = "WASHER_DRYER";
    PropertyFilterAmenity2["WATER_PARK"] = "WATER_PARK";
    PropertyFilterAmenity2["WIFI"] = "WIFI";
    return PropertyFilterAmenity2;
}(PropertyFilterAmenity || {});
var PropertyInfoOptions = /* @__PURE__ */ function(PropertyInfoOptions2) {
    PropertyInfoOptions2["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
    return PropertyInfoOptions2;
}(PropertyInfoOptions || {});
var PropertyPaymentFlags = /* @__PURE__ */ function(PropertyPaymentFlags2) {
    PropertyPaymentFlags2["ARTIFICIALLY_FENCED_RATE"] = "ARTIFICIALLY_FENCED_RATE";
    PropertyPaymentFlags2["MIXED_RATE_PLAN"] = "MIXED_RATE_PLAN";
    PropertyPaymentFlags2["NO_CREDIT_CARD"] = "NO_CREDIT_CARD";
    return PropertyPaymentFlags2;
}(PropertyPaymentFlags || {});
var PropertyPaymentModel = /* @__PURE__ */ function(PropertyPaymentModel2) {
    PropertyPaymentModel2["PAY_LATER"] = "PAY_LATER";
    PropertyPaymentModel2["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
    PropertyPaymentModel2["PAY_NOW"] = "PAY_NOW";
    return PropertyPaymentModel2;
}(PropertyPaymentModel || {});
var PropertyPaymentType = /* @__PURE__ */ function(PropertyPaymentType2) {
    PropertyPaymentType2["PAY_LATER"] = "PAY_LATER";
    PropertyPaymentType2["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
    PropertyPaymentType2["PAY_NOW"] = "PAY_NOW";
    return PropertyPaymentType2;
}(PropertyPaymentType || {});
var PropertySearchOptions = /* @__PURE__ */ function(PropertySearchOptions2) {
    PropertySearchOptions2["ADS_ONLY"] = "ADS_ONLY";
    PropertySearchOptions2["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
    return PropertySearchOptions2;
}(PropertySearchOptions || {});
var PropertySectionRef = /* @__PURE__ */ function(PropertySectionRef2) {
    PropertySectionRef2["AVAILABILITY_CALENDAR_START_DATE"] = "AVAILABILITY_CALENDAR_START_DATE";
    PropertySectionRef2["PRICE_DISPLAY_SERVICE_RESPONSE"] = "PRICE_DISPLAY_SERVICE_RESPONSE";
    PropertySectionRef2["RECOMMENDED_OFFER"] = "RECOMMENDED_OFFER";
    PropertySectionRef2["ROOMS_AND_RATES"] = "ROOMS_AND_RATES";
    return PropertySectionRef2;
}(PropertySectionRef || {});
var PropertySort = /* @__PURE__ */ function(PropertySort2) {
    PropertySort2["AARP_MEMBER_DISCOUNT"] = "AARP_MEMBER_DISCOUNT";
    PropertySort2["BEST_DEAL"] = "BEST_DEAL";
    PropertySort2["DEPARTURE_EARLY_TO_LATE"] = "DEPARTURE_EARLY_TO_LATE";
    PropertySort2["DEPARTURE_LATE_TO_EARLY"] = "DEPARTURE_LATE_TO_EARLY";
    PropertySort2["DISTANCE"] = "DISTANCE";
    PropertySort2["DURATION_LONG_TO_SHORT"] = "DURATION_LONG_TO_SHORT";
    PropertySort2["DURATION_SHORT_TO_LONG"] = "DURATION_SHORT_TO_LONG";
    PropertySort2["MAXIMUM_SAVINGS"] = "MAXIMUM_SAVINGS";
    PropertySort2["MAXIMUM_SAVINGS_PERCENT"] = "MAXIMUM_SAVINGS_PERCENT";
    PropertySort2["MEMBER_PRICING"] = "MEMBER_PRICING";
    PropertySort2["PACKAGE_SAVINGS"] = "PACKAGE_SAVINGS";
    PropertySort2["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
    PropertySort2["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
    PropertySort2["PRICE_RELEVANT"] = "PRICE_RELEVANT";
    PropertySort2["PROPERTY_CLASS"] = "PROPERTY_CLASS";
    PropertySort2["PROPERTY_NAME"] = "PROPERTY_NAME";
    PropertySort2["RECOMMENDED"] = "RECOMMENDED";
    PropertySort2["REVIEW"] = "REVIEW";
    PropertySort2["REVIEW_COUNT"] = "REVIEW_COUNT";
    PropertySort2["REVIEW_PRICE"] = "REVIEW_PRICE";
    PropertySort2["REVIEW_RELEVANT"] = "REVIEW_RELEVANT";
    PropertySort2["VACATION_RENTAL"] = "VACATION_RENTAL";
    return PropertySort2;
}(PropertySort || {});
var PropertyStyle = /* @__PURE__ */ function(PropertyStyle2) {
    PropertyStyle2["BOUTIQUE"] = "BOUTIQUE";
    PropertyStyle2["HOMES"] = "HOMES";
    PropertyStyle2["HOTELS"] = "HOTELS";
    PropertyStyle2["LGBT"] = "LGBT";
    PropertyStyle2["LUXURY"] = "LUXURY";
    PropertyStyle2["OUTDOOR"] = "OUTDOOR";
    PropertyStyle2["UNIQUE"] = "UNIQUE";
    return PropertyStyle2;
}(PropertyStyle || {});
var RangeIndicatorSegmentStyle = /* @__PURE__ */ function(RangeIndicatorSegmentStyle2) {
    RangeIndicatorSegmentStyle2["EMPHASIS"] = "EMPHASIS";
    return RangeIndicatorSegmentStyle2;
}(RangeIndicatorSegmentStyle || {});
var RangeIndicatorSegmentTheme = /* @__PURE__ */ function(RangeIndicatorSegmentTheme2) {
    RangeIndicatorSegmentTheme2["NEGATIVE"] = "NEGATIVE";
    RangeIndicatorSegmentTheme2["NEUTRAL"] = "NEUTRAL";
    RangeIndicatorSegmentTheme2["POSITIVE"] = "POSITIVE";
    RangeIndicatorSegmentTheme2["VERY_POSITIVE"] = "VERY_POSITIVE";
    return RangeIndicatorSegmentTheme2;
}(RangeIndicatorSegmentTheme || {});
var RateDiscountType = /* @__PURE__ */ function(RateDiscountType2) {
    RateDiscountType2["MEMBER_DEAL"] = "MEMBER_DEAL";
    RateDiscountType2["MOBILE_EXCLUSIVE"] = "MOBILE_EXCLUSIVE";
    RateDiscountType2["REGULAR"] = "REGULAR";
    RateDiscountType2["TONIGHT_ONLY"] = "TONIGHT_ONLY";
    return RateDiscountType2;
}(RateDiscountType || {});
var RegionType = /* @__PURE__ */ function(RegionType2) {
    RegionType2["ADDRESS"] = "ADDRESS";
    RegionType2["AIRPORT"] = "AIRPORT";
    RegionType2["CITY"] = "CITY";
    RegionType2["CONTINENT"] = "CONTINENT";
    RegionType2["COUNTRY"] = "COUNTRY";
    RegionType2["HIGH_LEVEL_REGION"] = "HIGH_LEVEL_REGION";
    RegionType2["METRO_STATION"] = "METRO_STATION";
    RegionType2["MULTI_CITY_VICINITY"] = "MULTI_CITY_VICINITY";
    RegionType2["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    RegionType2["POINT_OF_INTEREST"] = "POINT_OF_INTEREST";
    RegionType2["PROVINCE_STATE"] = "PROVINCE_STATE";
    RegionType2["TRAIN_STATION"] = "TRAIN_STATION";
    RegionType2["UNKNOWN"] = "UNKNOWN";
    return RegionType2;
}(RegionType || {});
var ReviewInteractionType = /* @__PURE__ */ function(ReviewInteractionType2) {
    ReviewInteractionType2["HELPFUL_REVIEW"] = "HELPFUL_REVIEW";
    ReviewInteractionType2["REVIEW_COLLAPSE_LABEL"] = "REVIEW_COLLAPSE_LABEL";
    ReviewInteractionType2["REVIEW_EXPAND_LABEL"] = "REVIEW_EXPAND_LABEL";
    ReviewInteractionType2["REVIEW_REPORT_FLAG"] = "REVIEW_REPORT_FLAG";
    return ReviewInteractionType2;
}(ReviewInteractionType || {});
var ReviewSource = /* @__PURE__ */ function(ReviewSource2) {
    ReviewSource2["EXTERNAL_REVIEWS"] = "EXTERNAL_REVIEWS";
    ReviewSource2["INTERNAL_REVIEWS"] = "INTERNAL_REVIEWS";
    return ReviewSource2;
}(ReviewSource || {});
var ShoppingButtonType = /* @__PURE__ */ function(ShoppingButtonType2) {
    ShoppingButtonType2["PRIMARY"] = "PRIMARY";
    ShoppingButtonType2["SECONDARY"] = "SECONDARY";
    ShoppingButtonType2["TERTIARY"] = "TERTIARY";
    return ShoppingButtonType2;
}(ShoppingButtonType || {});
var ShoppingFunctionType = /* @__PURE__ */ function(ShoppingFunctionType2) {
    ShoppingFunctionType2["CALLBACK"] = "CALLBACK";
    ShoppingFunctionType2["SHARED_UI"] = "SHARED_UI";
    return ShoppingFunctionType2;
}(ShoppingFunctionType || {});
var ShoppingPathType = /* @__PURE__ */ function(ShoppingPathType2) {
    ShoppingPathType2["ATTACH"] = "ATTACH";
    ShoppingPathType2["PACKAGE"] = "PACKAGE";
    ShoppingPathType2["STANDALONE"] = "STANDALONE";
    return ShoppingPathType2;
}(ShoppingPathType || {});
var ShoppingSelectableCardState = /* @__PURE__ */ function(ShoppingSelectableCardState2) {
    ShoppingSelectableCardState2["DISABLED"] = "DISABLED";
    ShoppingSelectableCardState2["SELECTED"] = "SELECTED";
    ShoppingSelectableCardState2["UNSELECTED"] = "UNSELECTED";
    return ShoppingSelectableCardState2;
}(ShoppingSelectableCardState || {});
var ShoppingTabsNavType = /* @__PURE__ */ function(ShoppingTabsNavType2) {
    ShoppingTabsNavType2["JUMPLINK"] = "JUMPLINK";
    ShoppingTabsNavType2["NATURAL"] = "NATURAL";
    return ShoppingTabsNavType2;
}(ShoppingTabsNavType || {});
var ShoppingTriggerType = /* @__PURE__ */ function(ShoppingTriggerType2) {
    ShoppingTriggerType2["CLICK"] = "CLICK";
    ShoppingTriggerType2["HOVER"] = "HOVER";
    ShoppingTriggerType2["LOAD"] = "LOAD";
    return ShoppingTriggerType2;
}(ShoppingTriggerType || {});
var SortAndFilterBasicFilterPayloadType = /* @__PURE__ */ function(SortAndFilterBasicFilterPayloadType2) {
    SortAndFilterBasicFilterPayloadType2["OPTION"] = "OPTION";
    SortAndFilterBasicFilterPayloadType2["REMOVE"] = "REMOVE";
    return SortAndFilterBasicFilterPayloadType2;
}(SortAndFilterBasicFilterPayloadType || {});
var SortAndFilterSignalCondition = /* @__PURE__ */ function(SortAndFilterSignalCondition2) {
    SortAndFilterSignalCondition2["DEFAULT_TO_NON_DEFAULT"] = "DEFAULT_TO_NON_DEFAULT";
    SortAndFilterSignalCondition2["NON_DEFAULT_TO_DEFAULT"] = "NON_DEFAULT_TO_DEFAULT";
    SortAndFilterSignalCondition2["NON_DEFAULT_TO_NON_DEFAULT"] = "NON_DEFAULT_TO_NON_DEFAULT";
    SortAndFilterSignalCondition2["SELECTED"] = "SELECTED";
    SortAndFilterSignalCondition2["UNSELECTED"] = "UNSELECTED";
    return SortAndFilterSignalCondition2;
}(SortAndFilterSignalCondition || {});
var SortAndFiltersViewType = /* @__PURE__ */ function(SortAndFiltersViewType2) {
    SortAndFiltersViewType2["APPLIED_FILTERS"] = "APPLIED_FILTERS";
    SortAndFiltersViewType2["FILTERS"] = "FILTERS";
    SortAndFiltersViewType2["FILTERS_PILLS"] = "FILTERS_PILLS";
    SortAndFiltersViewType2["FILTER_BAR"] = "FILTER_BAR";
    SortAndFiltersViewType2["FILTER_DIALOG"] = "FILTER_DIALOG";
    SortAndFiltersViewType2["SORT"] = "SORT";
    SortAndFiltersViewType2["SORT_AND_FILTERS"] = "SORT_AND_FILTERS";
    SortAndFiltersViewType2["SORT_TABS"] = "SORT_TABS";
    SortAndFiltersViewType2["USE_REWARDS"] = "USE_REWARDS";
    return SortAndFiltersViewType2;
}(SortAndFiltersViewType || {});
var SourceType = /* @__PURE__ */ function(SourceType2) {
    SourceType2["ESR"] = "ESR";
    SourceType2["GDS"] = "GDS";
    return SourceType2;
}(SourceType || {});
var SponsoredContentLocationResolver = /* @__PURE__ */ function(SponsoredContentLocationResolver2) {
    SponsoredContentLocationResolver2["GAIA"] = "GAIA";
    SponsoredContentLocationResolver2["TLA"] = "TLA";
    return SponsoredContentLocationResolver2;
}(SponsoredContentLocationResolver || {});
var SponsoredContentProductType = /* @__PURE__ */ function(SponsoredContentProductType2) {
    SponsoredContentProductType2["ALTERNATE_DESTINATIONS_CAROUSEL"] = "ALTERNATE_DESTINATIONS_CAROUSEL";
    SponsoredContentProductType2["BRAND_RESULT_LISTING"] = "BRAND_RESULT_LISTING";
    SponsoredContentProductType2["BRAND_RESULT_LISTING_CARS"] = "BRAND_RESULT_LISTING_CARS";
    SponsoredContentProductType2["BRAND_RESULT_LISTING_CRUISES"] = "BRAND_RESULT_LISTING_CRUISES";
    SponsoredContentProductType2["BRAND_RESULT_LISTING_FLIGHTS"] = "BRAND_RESULT_LISTING_FLIGHTS";
    SponsoredContentProductType2["BRAND_RESULT_LISTING_LODGING"] = "BRAND_RESULT_LISTING_LODGING";
    SponsoredContentProductType2["BRAND_RESULT_LISTING_LX"] = "BRAND_RESULT_LISTING_LX";
    SponsoredContentProductType2["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
    SponsoredContentProductType2["MULTI_LISTING_AD"] = "MULTI_LISTING_AD";
    SponsoredContentProductType2["SPONSORED_PROPERTIES_CAROUSEL"] = "SPONSORED_PROPERTIES_CAROUSEL";
    return SponsoredContentProductType2;
}(SponsoredContentProductType || {});
var StayType = /* @__PURE__ */ function(StayType2) {
    StayType2["CONVENTIONAL"] = "CONVENTIONAL";
    StayType2["VACATION_RENTALS"] = "VACATION_RENTALS";
    return StayType2;
}(StayType || {});
var StrikeOutType = /* @__PURE__ */ function(StrikeOutType2) {
    StrikeOutType2["ATTACH"] = "ATTACH";
    StrikeOutType2["INVALID"] = "INVALID";
    StrikeOutType2["LOYALTY"] = "LOYALTY";
    StrikeOutType2["PACKAGE"] = "PACKAGE";
    StrikeOutType2["PRICE_SURVEY"] = "PRICE_SURVEY";
    StrikeOutType2["STANDALONE"] = "STANDALONE";
    return StrikeOutType2;
}(StrikeOutType || {});
var StructureType = /* @__PURE__ */ function(StructureType2) {
    StructureType2["AGRITOURISM"] = "AGRITOURISM";
    StructureType2["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
    StructureType2["APARTMENT"] = "APARTMENT";
    StructureType2["APART_HOTEL"] = "APART_HOTEL";
    StructureType2["BED_AND_BREAKFAST"] = "BED_AND_BREAKFAST";
    StructureType2["CABIN"] = "CABIN";
    StructureType2["CAPSULE_HOTEL"] = "CAPSULE_HOTEL";
    StructureType2["CARAVAN_PARK"] = "CARAVAN_PARK";
    StructureType2["CASTLE"] = "CASTLE";
    StructureType2["CHALET"] = "CHALET";
    StructureType2["CONDO"] = "CONDO";
    StructureType2["CONDO_RESORT"] = "CONDO_RESORT";
    StructureType2["COTTAGE"] = "COTTAGE";
    StructureType2["COUNTRY_HOUSE"] = "COUNTRY_HOUSE";
    StructureType2["CRUISE"] = "CRUISE";
    StructureType2["ECO_HOTEL"] = "ECO_HOTEL";
    StructureType2["GUEST_HOUSE"] = "GUEST_HOUSE";
    StructureType2["HOLIDAY_PARK"] = "HOLIDAY_PARK";
    StructureType2["HOSTAL"] = "HOSTAL";
    StructureType2["HOSTEL"] = "HOSTEL";
    StructureType2["HOTEL"] = "HOTEL";
    StructureType2["HOTEL_RESORT"] = "HOTEL_RESORT";
    StructureType2["HOUSE_BOAT"] = "HOUSE_BOAT";
    StructureType2["INN"] = "INN";
    StructureType2["LODGE"] = "LODGE";
    StructureType2["LONGHOUSE"] = "LONGHOUSE";
    StructureType2["MOBILE_HOME"] = "MOBILE_HOME";
    StructureType2["MOTEL"] = "MOTEL";
    StructureType2["OVERWATER"] = "OVERWATER";
    StructureType2["PALACE"] = "PALACE";
    StructureType2["PENSION"] = "PENSION";
    StructureType2["POUSADA_BRAZIL"] = "POUSADA_BRAZIL";
    StructureType2["POUSADA_PORTUGAL"] = "POUSADA_PORTUGAL";
    StructureType2["RANCH"] = "RANCH";
    StructureType2["RESIDENCE"] = "RESIDENCE";
    StructureType2["RIAD"] = "RIAD";
    StructureType2["RYOKAN"] = "RYOKAN";
    StructureType2["SAFARI"] = "SAFARI";
    StructureType2["SERVICED_APARTMENT"] = "SERVICED_APARTMENT";
    StructureType2["TOWNHOUSE"] = "TOWNHOUSE";
    StructureType2["TRADITIONAL_BUILDING"] = "TRADITIONAL_BUILDING";
    StructureType2["TREE_HOUSE"] = "TREE_HOUSE";
    StructureType2["UNKNOWN"] = "UNKNOWN";
    StructureType2["VACATION_HOME"] = "VACATION_HOME";
    StructureType2["VACATION_RENTAL"] = "VACATION_RENTAL";
    StructureType2["VACATION_RENTALS"] = "VACATION_RENTALS";
    StructureType2["VILLA"] = "VILLA";
    StructureType2["VIP"] = "VIP";
    return StructureType2;
}(StructureType || {});
var TextTheme = /* @__PURE__ */ function(TextTheme2) {
    TextTheme2["EMPHASIS"] = "EMPHASIS";
    TextTheme2["INVERSE"] = "INVERSE";
    TextTheme2["LOYALTY"] = "LOYALTY";
    TextTheme2["NEGATIVE"] = "NEGATIVE";
    TextTheme2["POSITIVE"] = "POSITIVE";
    TextTheme2["PRIMARY"] = "PRIMARY";
    TextTheme2["SECONDARY"] = "SECONDARY";
    return TextTheme2;
}(TextTheme || {});
var TextWeight = /* @__PURE__ */ function(TextWeight2) {
    TextWeight2["BOLD"] = "BOLD";
    TextWeight2["MEDIUM"] = "MEDIUM";
    TextWeight2["REGULAR"] = "REGULAR";
    return TextWeight2;
}(TextWeight || {});
var Theme = /* @__PURE__ */ function(Theme2) {
    Theme2["BRAND"] = "BRAND";
    Theme2["BRANDED_DEAL"] = "BRANDED_DEAL";
    Theme2["DEAL_ADD_ON"] = "DEAL_ADD_ON";
    Theme2["DEAL_BUNDLED"] = "DEAL_BUNDLED";
    Theme2["DEAL_GENERIC"] = "DEAL_GENERIC";
    Theme2["DEAL_MEMBER"] = "DEAL_MEMBER";
    Theme2["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
    Theme2["INFO"] = "INFO";
    Theme2["LINK"] = "LINK";
    Theme2["LOYALTY"] = "LOYALTY";
    Theme2["LOYALTY_EXTRA_HIGH_TIER"] = "LOYALTY_EXTRA_HIGH_TIER";
    Theme2["LOYALTY_GLOBAL_EXTRA_HIGH_TIER"] = "LOYALTY_GLOBAL_EXTRA_HIGH_TIER";
    Theme2["LOYALTY_GLOBAL_HIGH_TIER"] = "LOYALTY_GLOBAL_HIGH_TIER";
    Theme2["LOYALTY_GLOBAL_LOW_TIER"] = "LOYALTY_GLOBAL_LOW_TIER";
    Theme2["LOYALTY_GLOBAL_MIDDLE_TIER"] = "LOYALTY_GLOBAL_MIDDLE_TIER";
    Theme2["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
    Theme2["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
    Theme2["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
    Theme2["NOTIFICATION"] = "NOTIFICATION";
    Theme2["PROMOTED"] = "PROMOTED";
    Theme2["SAVED"] = "SAVED";
    Theme2["SPONSORED"] = "SPONSORED";
    Theme2["STANDARD"] = "STANDARD";
    Theme2["SUCCESS"] = "SUCCESS";
    Theme2["SUCCESS_MEDIUM"] = "SUCCESS_MEDIUM";
    Theme2["SUPPLIER_PROMO"] = "SUPPLIER_PROMO";
    Theme2["URGENT"] = "URGENT";
    Theme2["VIEWED"] = "VIEWED";
    Theme2["VIP"] = "VIP";
    Theme2["VIP_ACCESS"] = "VIP_ACCESS";
    return Theme2;
}(Theme || {});
var TravelerDetailsType = /* @__PURE__ */ function(TravelerDetailsType2) {
    TravelerDetailsType2["ADULT"] = "ADULT";
    TravelerDetailsType2["CHILD"] = "CHILD";
    TravelerDetailsType2["INFANT_IN_LAP"] = "INFANT_IN_LAP";
    TravelerDetailsType2["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
    return TravelerDetailsType2;
}(TravelerDetailsType || {});
var TravelerType = /* @__PURE__ */ function(TravelerType2) {
    TravelerType2["ADULTS_ONLY"] = "ADULTS_ONLY";
    TravelerType2["BUSINESS"] = "BUSINESS";
    TravelerType2["ECO_CERTIFIED"] = "ECO_CERTIFIED";
    TravelerType2["FAMILY"] = "FAMILY";
    TravelerType2["LGBT"] = "LGBT";
    TravelerType2["ROMANTIC"] = "ROMANTIC";
    return TravelerType2;
}(TravelerType || {});
var UILinkTarget = /* @__PURE__ */ function(UILinkTarget2) {
    UILinkTarget2["EXTERNAL"] = "EXTERNAL";
    UILinkTarget2["INTERNAL"] = "INTERNAL";
    return UILinkTarget2;
}(UILinkTarget || {});
// src/components/common/client-side-analytics/client-side-analytics.ts
import { useCallback } from "react";
import { gql } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql(_templateObject());
var referrerMap = {
    CLICK: "click",
    IMPRESSION: "impression"
};
var trackAnalyticsList = function(clickstreamAnalytics, analytics) {
    if (analytics) {
        var track = clickstreamAnalytics.track;
        var referrerId = analytics.referrerId, linkName = analytics.linkName, uisPrimeMessages = analytics.uisPrimeMessages;
        var _analytics_eventType;
        var eventType = referrerMap[(_analytics_eventType = analytics.eventType) !== null && _analytics_eventType !== void 0 ? _analytics_eventType : "CLICK"];
        var message = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: eventType
            }
        };
        var data = !(uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.length) ? message : [
            message
        ].concat(_to_consumable_array(uisPrimeMessages.map(function(param) {
            var schemaName = param.schemaName, messageContent = param.messageContent;
            return {
                schemaName: schemaName,
                messageContent: JSON.parse(messageContent)
            };
        })));
        track(ITrackType.EVENT, {
            data: data
        });
    }
};
var useTrackClientSideAnalytics = function(analytics) {
    var clickstreamAnalytics = useClickstreamAnalytics();
    return useCallback(function() {
        if (analytics) {
            trackAnalyticsList(clickstreamAnalytics, analytics);
        }
    }, [
        analytics,
        clickstreamAnalytics
    ]);
};
// src/components/common/ui-graphic.tsx
import React4 from "react";
import { gql as gql5 } from "@apollo/client";
// src/components/common/icon.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var fragment = gql2(_templateObject1());
var _obj;
var SPOTLIGHT_MAP = (_obj = {}, _define_property(_obj, "INFO" /* INFO */ , "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "STANDARD" /* STANDARD */ , "standard"), _define_property(_obj, "WARNING" /* WARNING */ , "warning"), _obj);
var Icon = function(param) /* @__PURE__ */ {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    var _data_title, _data_iconTheme, _data_spotLight;
    return React.createElement(EGDSIcon, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.iconSize ? EGDSIconSize[data.iconSize] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_iconTheme = data.iconTheme) !== null && _data_iconTheme !== void 0 ? _data_iconTheme : void 0,
        shadow: Boolean(data.withBackground),
        spotlight: spotlight !== null && spotlight !== void 0 ? spotlight : SPOTLIGHT_MAP[(_data_spotLight = data.spotLight) !== null && _data_spotLight !== void 0 ? _data_spotLight : ""]
    });
};
Icon.displayName = "EGDSIcon";
Icon.fragment = fragment;
// src/components/common/illustration.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
var fragment2 = gql3(_templateObject2());
var Illustration = function(param) {
    var className = param.className, data = param.data;
    return /* @__PURE__ */ React2.createElement(EGDSIllustrations, {
        alt: data.description,
        url: data.link,
        className: className
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = fragment2;
// src/components/common/mark.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
var fragment3 = gql4(_templateObject3());
var Mark = function(param) /* @__PURE__ */ {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    var _EGDSMarkSize_data_markSize;
    return React3.createElement(EGDSMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize !== null && markSize !== void 0 ? markSize : data.markSize ? (_EGDSMarkSize_data_markSize = EGDSMarkSize[data.markSize]) !== null && _EGDSMarkSize_data_markSize !== void 0 ? _EGDSMarkSize_data_markSize : Number(data.markSize) : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment3;
// src/components/common/ui-graphic.tsx
var __UIGraphicFragment = gql5(_templateObject4(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React4.createElement(Mark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React4.createElement(Illustration, {
                data: data,
                className: className
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// src/components/egds/egds-badge/egds-badge.tsx
import React5 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSBadgeSize, EGDSBadgeStandard } from "@egds/react-core/badge";
// src/components/egds/egds-badge/__private/egds-standard-badge-theme.ts
var standardBadgeThemes = {
    standard: "standard",
    emphasis: "emphasis",
    info: "info",
    featured: "featured",
    brand: "brand",
    warning: "warning",
    positive: "positive"
};
// src/components/egds/egds-badge/egds-badge.tsx
var fragment4 = gql6(_templateObject5());
var SharedUIBadge = function(param) {
    var data = param.data;
    var accessibility = data.accessibility, text = data.text, badgeSize = data.badgeSize, badgeTheme = data.badgeTheme;
    var _ref;
    var size = (_ref = badgeSize && EGDSBadgeSize[badgeSize.toUpperCase()]) !== null && _ref !== void 0 ? _ref : EGDSBadgeSize.LARGE;
    if (!text) {
        return null;
    }
    var _badgeTheme_toLowerCase;
    var theme = standardBadgeThemes[(_badgeTheme_toLowerCase = badgeTheme === null || badgeTheme === void 0 ? void 0 : badgeTheme.toLowerCase()) !== null && _badgeTheme_toLowerCase !== void 0 ? _badgeTheme_toLowerCase : "standard"];
    return /* @__PURE__ */ React5.createElement(EGDSBadgeStandard, {
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        text: text,
        size: size,
        theme: theme
    });
};
SharedUIBadge.fragment = fragment4;
SharedUIBadge.displayName = "EGDSBadge";
// src/components/lodging-card/__private/lodging-card-guest-rating.tsx
import React19 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSIcon as EGDSIcon3, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
// src/components/lodging-egds-rating/lodging-egds-rating.tsx
import React6 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSRating } from "@egds/react-core/rating";
var fragment5 = gql7(_templateObject6());
var EGDSIconRating = gql7(_templateObject7());
var LodgingEGDSRating = function(param) {
    var data = param.data;
    var icon = data.icon;
    var _data_accessibility;
    return /* @__PURE__ */ React6.createElement(EGDSRating, {
        icon: icon === null || icon === void 0 ? void 0 : icon.id,
        rating: String(data.rating),
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
LodgingEGDSRating.fragment = fragment5;
LodgingEGDSRating.displayName = "LodgingEGDSRating";
// src/components/lodging-egds-text/lodging-egds-text.tsx
import React11 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
// src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React7 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark2, UitkMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
var fragment6 = gql8(_templateObject8());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize, customPadding = param.customPadding, flexLayout = param.flexLayout, _param_flexAlignItems = param.flexAlignItems, flexAlignItems = _param_flexAlignItems === void 0 ? "center" : _param_flexAlignItems, _param_flexSpacing = param.flexSpacing, flexSpacing = _param_flexSpacing === void 0 ? "two" : _param_flexSpacing, className = param.className;
    var _graphic_url, _graphic_url1;
    var text = data.text, graphic = data.graphic, accessibility = data.accessibility;
    return /* @__PURE__ */ React7.createElement("div", {
        className: className
    }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphic.id && !flexLayout && /* @__PURE__ */ React7.createElement(EGDSSpacing, {
        padding: customPadding !== null && customPadding !== void 0 ? customPadding : {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React7.createElement(EGDSIcon2, {
        "aria-hidden": Boolean(accessibility),
        name: graphic.id,
        size: graphic.size ? EGDSIconSize2[graphic.size] : EGDSIconSize2.EXTRA_SMALL
    })), (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Mark" && ((_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value) && !flexLayout && /* @__PURE__ */ React7.createElement(EGDSSpacing, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React7.createElement(EGDSMark2, {
        "aria-hidden": Boolean(accessibility),
        url: graphic.url.value,
        size: UitkMarkSize.SMALL
    })), flexLayout ? /* @__PURE__ */ React7.createElement(EGDSLayoutFlex, {
        alignItems: flexAlignItems,
        space: flexSpacing
    }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && /* @__PURE__ */ React7.createElement(EGDSIcon2, {
        "aria-hidden": Boolean(accessibility),
        name: graphic.id,
        size: graphic.size ? EGDSIconSize2[graphic.size] : EGDSIconSize2.EXTRA_SMALL
    }), (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Mark" && ((_graphic_url1 = graphic.url) === null || _graphic_url1 === void 0 ? void 0 : _graphic_url1.value) && /* @__PURE__ */ React7.createElement(EGDSMark2, {
        "aria-hidden": Boolean(accessibility),
        url: graphic.url.value,
        size: UitkMarkSize.SMALL
    }), /* @__PURE__ */ React7.createElement(EGDSText, _object_spread({
        "aria-hidden": Boolean(accessibility),
        size: customTextSize || 200
    }, textProps), text)) : /* @__PURE__ */ React7.createElement(EGDSText, _object_spread_props(_object_spread({
        "aria-hidden": Boolean(accessibility),
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text), accessibility && /* @__PURE__ */ React7.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
LodgingEGDSGraphicText.fragment = fragment6;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React8 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var _obj1;
// src/components/__private/link-map.ts
var linkSizeMapper = (_obj1 = {}, _define_property(_obj1, "SMALL" /* SMALL */ , "small"), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj1, "LARGE" /* LARGE */ , "large"), _obj1);
var _obj2;
var UILinkTargetMap = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj2, "INTERNAL" /* INTERNAL */ , "_self"), _obj2);
// src/components/lodging-egds-text/lodging-egds-inline-link.tsx
var fragment7 = gql9(_templateObject9());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker();
    var onClick = React8.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React8.createElement(EGDSLink, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React8.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap[target]
    }, text, accessibility && /* @__PURE__ */ React8.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment7;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React9 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
var fragment8 = gql10(_templateObject10());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React9.createElement(EGDSParagraph, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment8;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React10 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var _obj3;
// src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _obj3);
var _obj4;
// src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */ , "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment9 = gql11(_templateObject11());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    HIGHLIGHT: "mark",
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, theme = _param.theme, weight = _param.weight, size = _param.size, props = _object_without_properties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    var decorative = data.decorative, accessibility = data.accessibility;
    var inline = props.inline;
    var textProps = _object_spread({
        theme: data.theme ? textThemeMapper[data.theme] : theme,
        weight: data.weight ? textWeightMapper[data.weight] : weight,
        size: data.size ? sizeMap[data.size] : size
    }, props);
    var Decorative = decorative && decorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React10.createElement(Decorative, null, data.text) : data.text;
    var Tag = inline ? "span" : "div";
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(EGDSText2, _object_spread_props(_object_spread({}, textProps), {
        "aria-hidden": Boolean(accessibility)
    }), content), accessibility && /* @__PURE__ */ React10.createElement(Tag, {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment9;
EGDSStylizedText.displayName = "EGDSStylizedText";
// src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment10 = gql12(_templateObject12(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment, LodgingEGDSGraphicText.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React11.createElement(EGDSText3, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React11.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React11.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React11.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React11.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment10;
LodgingEGDSText.displayName = "LodgingEGDSText";
// src/components/lodging-egds-text/lodging-egds-heading.tsx
import React12 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSHeading } from "@egds/react-core/text";
var fragment11 = gql13(_templateObject13());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, overflow = param.overflow, data = param.data;
    return /* @__PURE__ */ React12.createElement(EGDSHeading, {
        tag: tag,
        size: size,
        overflow: overflow
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment11;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// src/components/lodging-egds-text/egds-spannable-text.tsx
import React16 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
// src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React15 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// src/components/lodging-egds-text/egds-inline-link.tsx
import React13 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var _obj5;
// src/components/lodging-egds-text/__private/link-map.ts
var linkSizeMapper2 = (_obj5 = {}, _define_property(_obj5, "SMALL" /* SMALL */ , "small"), _define_property(_obj5, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj5, "LARGE" /* LARGE */ , "medium"), _obj5);
var _obj6;
var UILinkTargetMap2 = (_obj6 = {}, _define_property(_obj6, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj6, "INTERNAL" /* INTERNAL */ , "_self"), _obj6);
// src/components/lodging-egds-text/egds-inline-link.tsx
var fragment12 = gql14(_templateObject14());
var EGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, action = _param_data.action, disabled = _param_data.disabled, sizeEGDSLink = _param_data.sizeEGDSLink, text = _param_data.text;
    var clickTracker = useClickTracker2();
    var onClick = React13.useCallback(function() {
        if (action.analytics) {
            clickTracker(action.analytics.referrerId, action.analytics.linkName);
        }
    }, [
        clickTracker,
        action
    ]);
    return action && /* @__PURE__ */ React13.createElement(EGDSLink2, {
        className: className,
        size: linkSizeMapper2[sizeEGDSLink],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React13.createElement("a", {
        href: action.resource.value,
        target: UILinkTargetMap2[action.target]
    }, text, action.accessibility && /* @__PURE__ */ React13.createElement("span", {
        className: "is-visually-hidden"
    }, action.accessibility)));
};
EGDSInlineLink.fragment = fragment12;
EGDSInlineLink.displayName = "EGDSInlineLink";
// src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React14 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var fragment13 = gql15(_templateObject15());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React14.createElement(EGDSText4, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment13;
EGDSPlainText.displayName = "EGDSPlainText";
// src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment14 = gql16(_templateObject16(), EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSInlineLink.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data, handleInlineLinkClick = param.handleInlineLinkClick, triggerRef = param.triggerRef, trackingPrefix = param.trackingPrefix;
    var _data_action;
    var track = useClickTracker3();
    var analytics = data.__typename === "EGDSInlineLink" ? (_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.analytics : null;
    var handleClick = function() {
        if ((analytics === null || analytics === void 0 ? void 0 : analytics.referrerId) && (analytics === null || analytics === void 0 ? void 0 : analytics.linkName)) {
            track(trackingPrefix ? "".concat(trackingPrefix, ".").concat(analytics.referrerId) : analytics.referrerId, analytics.linkName);
        }
        handleInlineLinkClick === null || handleInlineLinkClick === void 0 ? void 0 : handleInlineLinkClick();
    };
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React15.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React15.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React15.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        case "EGDSInlineLink":
            return handleInlineLinkClick ? /* @__PURE__ */ React15.createElement(EGDSLink3, {
                inline: true,
                onClick: handleClick,
                domRef: triggerRef,
                size: "medium"
            }, /* @__PURE__ */ React15.createElement("button", {
                type: "button",
                "data-stid": "reviews-link",
                style: {
                    zIndex: 200
                }
            }, data.text)) : /* @__PURE__ */ React15.createElement(EGDSInlineLink, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment14;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment15 = gql17(_templateObject17(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data_inlineContent, _data_inlineContent1;
    var align = props.align, data = props.data, styleProps = _object_without_properties(props, [
        "align",
        "data"
    ]);
    if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React16.createElement(EGDSText5, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React16.createElement(React16.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React16.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            }));
        }));
    }
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React16.createElement(React16.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React16.createElement(EGDSSpannableTextContent, _object_spread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment15;
EGDSSpannableText.displayName = "EGDSSpannableText";
// src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React17 from "react";
import { gql as gql18 } from "@apollo/client";
var fragment16 = gql18(_templateObject18());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment16;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// src/components/lodging-egds-text/lodging-egds-basic-localized-text.tsx
import React18, { useMemo } from "react";
import { gql as gql19 } from "@apollo/client";
var fragment17 = gql19(_templateObject19());
var interpolate = function(template, mappedModels) {
    return mappedModels.reduce(function(accumulator, param) {
        var key = param.key, value = param.value;
        return accumulator.replaceAll("${".concat(key, "}"), value);
    }, template);
};
var useInterpolateBasicLocalizedText = function(data, values) {
    return useMemo(function() {
        var template = data.template, accessibilityTemplate = data.accessibilityTemplate, models = data.models, text = data.text;
        var mappedModels = models.reduce(function(accumulator, param) {
            var key = param.key, source = param.source;
            if (!accumulator) {
                return null;
            }
            var value = values[source];
            if (value === void 0) {
                return null;
            }
            return _to_consumable_array(accumulator).concat([
                {
                    key: key,
                    value: value
                }
            ]);
        }, []);
        var interpolatedText = mappedModels && interpolate(template, mappedModels);
        var interpolatedAccessibilityText = mappedModels && accessibilityTemplate && interpolate(accessibilityTemplate, mappedModels);
        return [
            interpolatedText !== null && interpolatedText !== void 0 ? interpolatedText : text,
            interpolatedAccessibilityText
        ];
    }, [
        data,
        values
    ]);
};
var LodgingEGDSBasicLocalizedText = function(param) {
    var data = param.data, values = param.values, tmp = param.tag, Tag = tmp === void 0 ? "span" : tmp;
    var _useInterpolateBasicLocalizedText = _sliced_to_array(useInterpolateBasicLocalizedText(data, values), 2), text = _useInterpolateBasicLocalizedText[0], accessibilityText = _useInterpolateBasicLocalizedText[1];
    return /* @__PURE__ */ React18.createElement(React18.Fragment, null, accessibilityText && /* @__PURE__ */ React18.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityText), /* @__PURE__ */ React18.createElement(Tag, {
        "aria-hidden": Boolean(accessibilityText)
    }, text));
};
LodgingEGDSBasicLocalizedText.fragment = fragment17;
LodgingEGDSBasicLocalizedText.displayName = "LodgingEGDSBasicLocalizedText";
// src/components/lodging-card/__private/lodging-card-guest-rating.tsx
var fragment18 = gql20(_templateObject20(), LodgingEGDSText.fragment, EGDSStylizedText.fragment, EGDSIconRating);
var GuestReviewRating = function(param) {
    var part = param.part, index = param.index, isReview = param.isReview, size = param.size;
    return /* @__PURE__ */ React19.createElement(EGDSLayoutFlexItem, null, isReview ? /* @__PURE__ */ React19.createElement(EGDSSpacing2, {
        margin: index === 1 ? {
            inlineend: "two"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React19.createElement("span", null, /* @__PURE__ */ React19.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))) : /* @__PURE__ */ React19.createElement(EGDSSpacing2, {
        padding: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React19.createElement("span", null, /* @__PURE__ */ React19.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))));
};
var LodgingCardGuestRating = function(param) {
    var data = param.data, size = param.size, isReview = param.isReview;
    var parts = data.parts, accessibilityLabel = data.accessibilityLabel, phraseParts = data.phraseParts;
    var ratingPart = phraseParts === null || phraseParts === void 0 ? void 0 : phraseParts.find(function(part) {
        return part.__typename === "EGDSIconRating";
    });
    var PartsComponent = React19.useMemo(function() {
        if (parts.length) {
            return parts.map(function(part, index) {
                return /* @__PURE__ */ React19.createElement(GuestReviewRating, {
                    key: "guest-rate-parts-".concat(index),
                    part: part,
                    index: index,
                    isReview: isReview,
                    size: size
                });
            });
        }
        return phraseParts.filter(function(phrasePart) {
            return phrasePart !== ratingPart;
        }).map(function(part, index) {
            return /* @__PURE__ */ React19.createElement(GuestReviewRating, {
                key: "guest-rate-phrase-parts-".concat(index),
                part: part,
                index: index,
                isReview: isReview,
                size: size
            });
        });
    }, [
        isReview,
        parts,
        phraseParts,
        ratingPart,
        size
    ]);
    var RatingPartComponent = React19.useMemo(function() {
        if (!ratingPart) {
            return null;
        }
        var _ratingPart_icon = ratingPart.icon, token = _ratingPart_icon.token, theme = _ratingPart_icon.theme, iconSize = _ratingPart_icon.size;
        return /* @__PURE__ */ React19.createElement(EGDSLayoutFlexItem, {
            alignSelf: "center"
        }, /* @__PURE__ */ React19.createElement(EGDSIcon3, {
            name: token !== null && token !== void 0 ? token : "star",
            theme: theme !== null && theme !== void 0 ? theme : "default",
            size: iconSize ? EGDSIconSize3[iconSize] : EGDSIconSize3.EXTRA_SMALL
        }));
    }, [
        ratingPart
    ]);
    return /* @__PURE__ */ React19.createElement(EGDSLayoutFlex2, {
        alignItems: "start",
        space: "one"
    }, RatingPartComponent, /* @__PURE__ */ React19.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React19.createElement("div", {
        "aria-hidden": !!accessibilityLabel
    }, /* @__PURE__ */ React19.createElement(EGDSLayoutFlex2, {
        wrap: "wrap"
    }, PartsComponent))), accessibilityLabel && /* @__PURE__ */ React19.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
LodgingCardGuestRating.fragment = fragment18;
LodgingCardGuestRating.displayName = "LodgingCardGuestRating";
// src/components/lodging-card/__private/lodging-card-media-section.tsx
import React62 from "react";
import { gql as gql49 } from "@apollo/client";
import { EGDSFigure as EGDSFigure5, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType5, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex9 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { ProductType as ProductType4, useProductType as useProductType3 } from "@shared-ui/retail-product-type-providers";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/lodging-card/lodging-card-utils.ts
import { useHistory as useHistory2 } from "react-router-dom";
import { UitkCardBackgroundThemes } from "@egds/react-core/cards";
import { ITrackType as ITrackType2 } from "@shared-ui/clickstream-analytics-context";
import { useLodgingCompare as useLodgingCompare2 } from "@shared-ui/retail-compare-providers";
// src/utils/analytics.ts
var parseLodgingCardImpressionSchema = function(uisPrimeMessages) {
    var _uisPrimeMessages_;
    if ((uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : (_uisPrimeMessages_ = uisPrimeMessages[0]) === null || _uisPrimeMessages_ === void 0 ? void 0 : _uisPrimeMessages_.schemaName) && uisPrimeMessages[0].messageContent) {
        return [
            {
                // we are parsing data here since additionalUisPrimeMicroMessages in intersection tracker takes message content as json object
                // mean while we are returning this data from the API as string.
                messageContent: JSON.parse(uisPrimeMessages[0].messageContent),
                schemaName: uisPrimeMessages[0].schemaName
            }
        ];
    }
};
var lightweightAdaptExMicroMessage = function(param) {
    var campaignId = param.campaignId, payloadId = param.payloadId, eventType = param.eventType, eventTarget = param.eventTarget, _param_banditDisplayed = param.banditDisplayed, banditDisplayed = _param_banditDisplayed === void 0 ? true : _param_banditDisplayed;
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: [
                {
                    payloadId: payloadId,
                    eventType: eventType,
                    eventTarget: eventTarget,
                    banditDisplayed: banditDisplayed
                }
            ]
        }
    };
};
var createAdaptExMicroMessage = function(campaignId, events) {
    var allEvents = events === null || events === void 0 ? void 0 : events.reduce(function(acc, curr) {
        return _to_consumable_array(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: (eventType === null || eventType === void 0 ? void 0 : eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (campaignId && events) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events));
    }
    return mappedMessages;
};
var microMessageToFragment = function(param) {
    var schemaName = param.schemaName, messageContent = param.messageContent;
    return {
        __typename: "EGUisMicroMessage",
        schemaName: schemaName,
        messageContent: JSON.stringify(messageContent)
    };
};
var safeBuildMicroMessage = function(schemaName, messageContent) {
    try {
        return {
            schemaName: schemaName,
            messageContent: JSON.parse(messageContent)
        };
    } catch (e) {
        return {
            schemaName: schemaName,
            messageContent: {}
        };
    }
};
var _obj7;
// src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap3 = (_obj7 = {}, _define_property(_obj7, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj7, "INTERNAL" /* INTERNAL */ , "_self"), _obj7);
// src/components/lodging-card-view.tsx
var LodgingCardView = /* @__PURE__ */ function(LodgingCardView2) {
    LodgingCardView2["RESPONSIVE"] = "RESPONSIVE";
    LodgingCardView2["COMPACT"] = "COMPACT";
    LodgingCardView2["COMPACT_HORIZONTAL"] = "COMPACT_HORIZONTAL";
    LodgingCardView2["GRID"] = "GRID";
    return LodgingCardView2;
}(LodgingCardView || {});
// src/components/product-card/product-card-sheet.tsx
import React47 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSSheet, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/product-card/product-card-content.tsx
import React46 from "react";
import { gql as gql34 } from "@apollo/client";
// src/components/product-card/offer-details.tsx
import React21 from "react";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
// src/components/lodging-card/lodging-card-content-provider.tsx
import React20 from "react";
var LodgingCardContentContext = React20.createContext(void 0);
var useLodgingCardContentContext = function() {
    var context = React20.useContext(LodgingCardContentContext);
    if (context === void 0) {
        throw new Error("useLodgingCardContentContext must be used with a ILodgingCardContentContext.Provider");
    }
    return context;
};
// src/components/product-card/offer-details.tsx
var OfferDetails = function() {
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React21.createElement(EGDSSheetContent, {
        padded: false
    }, /* @__PURE__ */ React21.createElement(EGDSSpacing3, {
        padding: "three"
    }, /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(ChangeUnitContent, null))));
};
// src/components/product-card/product-card-sheet-list-content.tsx
import React32 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
// src/components/product-card/product-card-context.tsx
import React23, { createContext, useCallback as useCallback2, useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { liveAnnounce } from "@egds/react-core/utils";
import { useClickstreamAnalytics as useClickstreamAnalytics2, useClickTracker as useClickTracker4, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { useRefTargetScroll } from "@shared-ui/ref-context";
// src/components/product-card/product-card-utils.tsx
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var STORE_EVENTS = {
    CREATE_TRIP_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "CREATE_TRIP_FAILURE"),
    TRIP_ID_NOT_RETURNED: new SystemEvent(SystemEventLevel.ERROR, "TRIP_ID_NOT_RETURNED")
};
var getProductCardAction = function(actions, actionId) {
    if (!actionId) {
        return null;
    }
    var _actions_find;
    return (_actions_find = actions === null || actions === void 0 ? void 0 : actions.find(function(action) {
        return action.actionId === actionId;
    })) !== null && _actions_find !== void 0 ? _actions_find : null;
};
var getProductCardContent = function(contentId, contentContainers) {
    var contentContainer = contentContainers === null || contentContainers === void 0 ? void 0 : contentContainers.find(function(item) {
        return item.contentId === contentId;
    });
    return contentContainer !== null && contentContainer !== void 0 ? contentContainer : null;
};
var getProductCardParamsContainer = function(paramsId, shoppingInvokeFunctionParams) {
    if (!paramsId) {
        return null;
    }
    var paramsContainer = shoppingInvokeFunctionParams === null || shoppingInvokeFunctionParams === void 0 ? void 0 : shoppingInvokeFunctionParams.find(function(item) {
        return item.paramsId === paramsId;
    });
    return paramsContainer !== null && paramsContainer !== void 0 ? paramsContainer : null;
};
var getProductCardOverlayContainer = function(overlayId, overlays) {
    var overlayContainer = overlays === null || overlays === void 0 ? void 0 : overlays.find(function(item) {
        return item.overlayId === overlayId;
    });
    return overlayContainer !== null && overlayContainer !== void 0 ? overlayContainer : null;
};
var getActionUrl = function(productCardActions) {
    var navigateToUriAction = productCardActions === null || productCardActions === void 0 ? void 0 : productCardActions.find(function(action) {
        return action.__typename === "ShoppingNavigateToURI";
    });
    if ((navigateToUriAction === null || navigateToUriAction === void 0 ? void 0 : navigateToUriAction.resource.__typename) === "HttpURI") {
        return navigateToUriAction === null || navigateToUriAction === void 0 ? void 0 : navigateToUriAction.resource.relativePath;
    }
    var _navigateToUriAction_resource_value;
    return (_navigateToUriAction_resource_value = navigateToUriAction === null || navigateToUriAction === void 0 ? void 0 : navigateToUriAction.resource.value) !== null && _navigateToUriAction_resource_value !== void 0 ? _navigateToUriAction_resource_value : null;
};
var createTrip = function(actionUrl, search, loggerEvents) {
    return function() {
        if (!actionUrl) {
            return;
        }
        var urlParams = new URLSearchParams(search);
        var swpParam = urlParams.get("swp");
        fetch(actionUrl, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(function(response) {
            return response.json();
        }).then(function(responseData) {
            if (responseData === null || responseData === void 0 ? void 0 : responseData.tripid) {
                var appendSwp = swpParam === null ? "" : "&swpApplied=".concat(swpParam);
                window.location.href = "/MultiItemCheckout?tripid=".concat(responseData.tripid).concat(appendSwp);
            } else {
                loggerEvents.TRIP_ID_NOT_RETURNED.log({
                    actionUrl: actionUrl
                });
            }
        }).catch(function() {
            loggerEvents.CREATE_TRIP_FAILURE.log({
                actionUrl: actionUrl
            });
        });
    };
};
var _obj8;
var textThemeMapper2 = (_obj8 = {}, _define_property(_obj8, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj8, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj8, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj8, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj8, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj8, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj8, "SECONDARY" /* SECONDARY */ , "default"), _obj8);
// src/components/common/adaptex/adaptex-analytics-events.tsx
import React22 from "react";
// src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents === null || adaptExEvents === void 0 ? void 0 : adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if ((filteredEvents === null || filteredEvents === void 0 ? void 0 : filteredEvents.length) > 0) {
                    results.push(_object_spread_props(_object_spread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React22.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React22.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
var AdaptExEventsProvider = function(param) {
    var children = param.children, value = param.value;
    return /* @__PURE__ */ React22.createElement(AdaptExEventsContext.Provider, {
        value: value
    }, children);
};
// src/components/product-card/product-card-context.tsx
var ProductCardContext = createContext(null);
var ProductCardProvider = function(param) {
    var children = param.children, data = param.data, onClickCallback = param.onClickCallback, shoppingInvokeFunctionCallBack2 = param.shoppingInvokeFunctionCallBack, placement = param.placement, onClickScrollToView = param.onClickScrollToView;
    var _mediaSection_gallery;
    var clickstreamEvents = data.clickstreamEvents, adaptexSuccessActionTracking = data.adaptexSuccessActionTracking, contents = data.contents, shoppingInvokeFunctionParams = data.shoppingInvokeFunctionParams, shoppingJoinListContainer = data.shoppingJoinListContainer, id = data.id, clickActionId = data.clickActionId, mediaSection = data.mediaSection;
    var location = useLocation();
    var track = useEgClickstream();
    var _useClickstreamAnalytics2 = useClickstreamAnalytics2(), adaptexTrack = _useClickstreamAnalytics2.track;
    var loggerEvents = useLoggerEvents(STORE_EVENTS);
    var adaptExSuccessEvents = useAdaptExEvents(adaptexSuccessActionTracking !== null && adaptexSuccessActionTracking !== void 0 ? adaptexSuccessActionTracking : []).adaptExSuccessEvents;
    var _mediaSection_gallery_adaptExAnalyticsSuccessEvents;
    var imageGalleryAdaptExSuccessEvents = (_mediaSection_gallery_adaptExAnalyticsSuccessEvents = mediaSection === null || mediaSection === void 0 ? void 0 : (_mediaSection_gallery = mediaSection.gallery) === null || _mediaSection_gallery === void 0 ? void 0 : _mediaSection_gallery.adaptExAnalyticsSuccessEvents) !== null && _mediaSection_gallery_adaptExAnalyticsSuccessEvents !== void 0 ? _mediaSection_gallery_adaptExAnalyticsSuccessEvents : [];
    var consolidatedAdaptExSuccessEvents = consolidateAdaptExEvents(adaptExSuccessEvents, imageGalleryAdaptExSuccessEvents);
    var dialogId = "product-card-overlay-".concat(id);
    var _useState = _sliced_to_array(useState({
        productCardId: id,
        dialogId: dialogId,
        clickActionId: clickActionId,
        actions: shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.actions,
        overlays: shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.overlays,
        contents: contents,
        shoppingInvokeFunctionParams: shoppingInvokeFunctionParams,
        createTrip: createTrip(getActionUrl(shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.actions), location.search, loggerEvents),
        onProductCardClick: consolidateOnclick(track, clickstreamEvents.productSelected, adaptexTrack, consolidatedAdaptExSuccessEvents, onClickCallback),
        shoppingInvokeFunctionCallBack: shoppingInvokeFunctionCallBack2,
        placement: placement,
        onClickScrollToView: onClickScrollToView
    }), 2), productCardActionData = _useState[0], setProductCardActionData = _useState[1];
    useEffect(function() {
        setProductCardActionData({
            productCardId: id,
            dialogId: dialogId,
            clickActionId: clickActionId,
            actions: shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.actions,
            overlays: shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.overlays,
            contents: contents,
            shoppingInvokeFunctionParams: shoppingInvokeFunctionParams,
            createTrip: createTrip(getActionUrl(shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.actions), location.search, loggerEvents),
            onProductCardClick: consolidateOnclick(track, clickstreamEvents.productSelected, adaptexTrack, consolidatedAdaptExSuccessEvents, onClickCallback),
            shoppingInvokeFunctionCallBack: shoppingInvokeFunctionCallBack2,
            placement: placement,
            onClickScrollToView: onClickScrollToView
        });
    }, [
        clickActionId,
        clickstreamEvents.productSelected,
        contents,
        shoppingInvokeFunctionParams,
        dialogId,
        id,
        location.search,
        onClickCallback,
        shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.actions,
        shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.overlays,
        track,
        shoppingInvokeFunctionCallBack2,
        placement,
        onClickScrollToView
    ]);
    return /* @__PURE__ */ React23.createElement(ProductCardContext.Provider, {
        value: productCardActionData
    }, children);
};
var useProductCardClickCallback = function() {
    var productCardData = useContext(ProductCardContext);
    return productCardData === null || productCardData === void 0 ? void 0 : productCardData.onProductCardClick;
};
var useClickActionId = function() {
    var productCardData = useContext(ProductCardContext);
    return productCardData === null || productCardData === void 0 ? void 0 : productCardData.clickActionId;
};
var useCreateTrip = function() {
    var productCardData = useContext(ProductCardContext);
    return productCardData === null || productCardData === void 0 ? void 0 : productCardData.createTrip;
};
var useProductCardAction = function(actionId) {
    var productCardData = useContext(ProductCardContext);
    return getProductCardAction(productCardData === null || productCardData === void 0 ? void 0 : productCardData.actions, actionId);
};
var useProductCardUtils = function() {
    var productCardData = useContext(ProductCardContext);
    if (!productCardData) {
        return null;
    }
    return {
        getOverlayContainer: function(overlayId) {
            return getProductCardOverlayContainer(overlayId, productCardData.overlays);
        },
        getContentContainer: function(contentId) {
            return getProductCardContent(contentId, productCardData.contents);
        }
    };
};
var useProductCardDialog = function(actionId) {
    var productCardData = useContext(ProductCardContext);
    var dialogId = productCardData && actionId ? "".concat(productCardData.dialogId, "-").concat(actionId) : "";
    return useDialog(dialogId);
};
var useProductCardActionCallback = function(actionId) {
    var _productCardData_actions;
    var productCardData = useContext(ProductCardContext);
    var dialogId = productCardData ? "".concat(productCardData.dialogId, "-").concat(actionId) : "";
    var track = useClickTracker4();
    var history = useHistory();
    var _useDialog = _sliced_to_array(useDialog(dialogId), 2), dialogActions = _useDialog[1];
    var productCardAction = actionId && (productCardData === null || productCardData === void 0 ? void 0 : (_productCardData_actions = productCardData.actions) === null || _productCardData_actions === void 0 ? void 0 : _productCardData_actions.find(function(item) {
        return item.actionId === actionId;
    }));
    var scrollTo = useRefTargetScroll().scrollTo;
    var SCROLL_TIMEOUT = 1e3;
    return useCallback2(function() {
        if (!productCardAction) {
            return;
        }
        switch(productCardAction.__typename){
            case "ShoppingNavigateToOverlay":
                dialogActions.openDialog();
                track(productCardAction.analytics.referrerId, productCardAction.analytics.linkName);
                var _productCardAction_accessibility;
                liveAnnounce((_productCardAction_accessibility = productCardAction.accessibility) !== null && _productCardAction_accessibility !== void 0 ? _productCardAction_accessibility : "");
                break;
            case "ShoppingNavigateToURI":
                track(productCardAction.analytics.referrerId, productCardAction.analytics.linkName);
                var _productCardAction_accessibility1;
                liveAnnounce((_productCardAction_accessibility1 = productCardAction.accessibility) !== null && _productCardAction_accessibility1 !== void 0 ? _productCardAction_accessibility1 : "");
                if (productCardAction.resource.__typename === "HttpURI") {
                    var path = productCardAction.useRelativePath ? productCardAction.resource.relativePath : productCardAction.resource.value;
                    var doesWindowExist = typeof window !== "undefined" && typeof window.open === "function";
                    if (productCardAction.useRelativePath && productCardAction.target === "INTERNAL" /* INTERNAL */ ) {
                        history.push(path);
                    } else if (doesWindowExist && productCardAction.useRelativePath && productCardAction.target === "EXTERNAL" /* EXTERNAL */ ) {
                        var propertyFullURL = new URL(productCardAction.resource.value);
                        var propertyDomainlessURL = "".concat(propertyFullURL.pathname).concat(propertyFullURL.search);
                        window.open(propertyDomainlessURL, UILinkTargetMap[productCardAction.target]);
                    } else if (doesWindowExist) {
                        var finalPath = path !== null && path !== void 0 ? path : productCardAction.resource.value;
                        window.open(finalPath, UILinkTargetMap[productCardAction.target]);
                    }
                }
                break;
            case "ShoppingInvokeFunction":
                track(productCardAction.analytics.referrerId, productCardAction.analytics.linkName);
                var _productCardAction_accessibility2;
                liveAnnounce((_productCardAction_accessibility2 = productCardAction.accessibility) !== null && _productCardAction_accessibility2 !== void 0 ? _productCardAction_accessibility2 : "");
                if (productCardData === null || productCardData === void 0 ? void 0 : productCardData.shoppingInvokeFunctionCallBack) {
                    var paramsContainer = getProductCardParamsContainer(productCardAction.paramsId, productCardData === null || productCardData === void 0 ? void 0 : productCardData.shoppingInvokeFunctionParams);
                    productCardData.shoppingInvokeFunctionCallBack(productCardAction.actionId, productCardAction.name, paramsContainer === null || paramsContainer === void 0 ? void 0 : paramsContainer.keyValueParams);
                }
                break;
            case "ShoppingScrollsToView":
                track(productCardAction.analytics.referrerId, productCardAction.analytics.linkName);
                var _productCardAction_accessibility3;
                liveAnnounce((_productCardAction_accessibility3 = productCardAction.accessibility) !== null && _productCardAction_accessibility3 !== void 0 ? _productCardAction_accessibility3 : "");
                if (productCardAction.targetRef) {
                    if (productCardData === null || productCardData === void 0 ? void 0 : productCardData.onClickScrollToView) {
                        productCardData.onClickScrollToView();
                    }
                    setTimeout(function() {
                        scrollTo(productCardAction.targetRef, []);
                    }, SCROLL_TIMEOUT);
                }
                break;
            default:
                break;
        }
    }, [
        track,
        dialogActions,
        history,
        productCardAction
    ]);
};
var useProductCardId = function() {
    var productCardData = useContext(ProductCardContext);
    if (!productCardData) {
        throw new Error("useProductCardId hook can only be used in a component surrounded by <ProductCardProvider>");
    }
    return productCardData.productCardId;
};
var useProductCardPlacement = function() {
    var _useContext;
    return (_useContext = useContext(ProductCardContext)) === null || _useContext === void 0 ? void 0 : _useContext.placement;
};
// src/components/product-card/product-card-sheet-footer.tsx
import React30 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSButtonSize, EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkPriceLockupAlign as EGDSPriceLockupAlign3 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
// src/components/common/pricing-fragments.ts
import { gql as gql21 } from "@apollo/client";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
var PropertyPriceDocumentNode = gql21(_templateObject21(), PriceSummary.fragment);
// src/components/lodging-card/lodging-card-price-section-price-summary.tsx
import React29 from "react";
import { UitkPriceLockupAlign as EGDSPriceLockupAlign2 } from "@egds/react-core/price-lockup";
import { PriceSummary as PriceSummary2 } from "@shared-ui/pricing-price-summary";
// src/components/lodging-price-summary.tsx
import React28 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSDialog as EGDSDialog2, EGDSDialogContent as EGDSDialogContent2, EGDSDialogFooter as EGDSDialogFooter2 } from "@egds/react-core/dialog";
import { UitkPriceLockup as EGDSPriceLockup, UitkPriceLockupAlign as EGDSPriceLockupAlign } from "@egds/react-core/price-lockup";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
// src/utils/use-dialog-id.ts
import React24 from "react";
var useDialogId = function() {
    return React24.useMemo(function() {
        return Math.random().toString(36).slice(2, 7);
    }, []);
};
// src/components/common/price-header-dialog/price-header-dialog.tsx
import React27 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSDialog } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon5, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3 } from "@egds/react-core/layout-flex";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/common/price-header-dialog/price-header-dialog-content.tsx
import React25 from "react";
import { EGDSDialogContent, EGDSDialogFooter } from "@egds/react-core/dialog";
import { EGDSSpacingHr } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText6 } from "@egds/react-core/text";
var getDialogContent = function(param) {
    var content = param.content, title = param.title, primaryUIButton = param.primaryUIButton;
    var dividerIndex = 2;
    var dialogContent = content.map(function(text, idx) {
        return /* @__PURE__ */ React25.createElement(React25.Fragment, null, idx === dividerIndex && /* @__PURE__ */ React25.createElement(EGDSSpacingHr, null), /* @__PURE__ */ React25.createElement(EGDSText6, null, text));
    });
    return {
        dialogTitle: title,
        dialogContent: dialogContent,
        buttonText: (primaryUIButton === null || primaryUIButton === void 0 ? void 0 : primaryUIButton.primary) || ""
    };
};
var PriceHeaderDialogContent = function(param) {
    var data = param.data, closeAction = param.closeAction;
    var _getDialogContent = getDialogContent(data), dialogTitle = _getDialogContent.dialogTitle, buttonText = _getDialogContent.buttonText, dialogContent = _getDialogContent.dialogContent;
    return /* @__PURE__ */ React25.createElement(EGDSDialogContent, null, /* @__PURE__ */ React25.createElement(EGDSHeading2, null, dialogTitle), dialogContent, /* @__PURE__ */ React25.createElement(EGDSDialogFooter, {
        buttonOne: {
            onClick: closeAction,
            text: buttonText,
            type: "tertiary"
        }
    }));
};
// src/components/common/price-header-dialog/price-header-dialog-trigger.tsx
import React26 from "react";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
var PriceHeaderDialogTrigger = function(param) {
    var data = param.data, action = param.action;
    var icon = data.icon, value = data.value;
    return /* @__PURE__ */ React26.createElement("button", {
        onClick: action,
        type: "button",
        className: "uitk-more-info-trigger"
    }, /* @__PURE__ */ React26.createElement(EGDSIcon4, {
        id: icon.id,
        name: icon.id.toLowerCase(),
        description: icon.description,
        size: EGDSIconSize4.SMALL
    }), value);
};
// src/components/common/price-header-dialog/price-header-dialog.tsx
var fragment19 = gql22(_templateObject22());
var PriceHeaderDialog = function(param) {
    var data = param.data, direction = param.direction, justifyContent = param.justifyContent;
    var clickTracker = useClickTracker5();
    var priceHeaderDialogPostfix = useDialogId();
    var _useDialog2 = _sliced_to_array(useDialog2("property-price-messaging-dialog-".concat(priceHeaderDialogPostfix), "pwaDialogNested"), 3), isPriceHeaderDialogOpen = _useDialog2[0], priceHeaderDialogActions = _useDialog2[1], PriceHeaderDialogComponent = _useDialog2[2];
    if (!data || !data.priceHeaderDialog) {
        return null;
    }
    var priceHeaderDialog = data.priceHeaderDialog;
    var openPriceHeaderDialog = function() {
        priceHeaderDialogActions.openDialog();
        clickTracker("HOT.HIS.Price.ApproximatePrice.DisclaimerDialog", "Approximate Price Header Dialog");
    };
    return /* @__PURE__ */ React27.createElement(EGDSLayoutFlex3, {
        direction: direction,
        justifyContent: justifyContent
    }, /* @__PURE__ */ React27.createElement(PriceHeaderDialogTrigger, {
        data: priceHeaderDialog.trigger,
        action: openPriceHeaderDialog
    }), /* @__PURE__ */ React27.createElement(EGDSSheetTransition, {
        isVisible: isPriceHeaderDialogOpen
    }, /* @__PURE__ */ React27.createElement(PriceHeaderDialogComponent, null, /* @__PURE__ */ React27.createElement(EGDSDialog, {
        dialogShow: isPriceHeaderDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React27.createElement(PriceHeaderDialogContent, {
        data: priceHeaderDialog,
        closeAction: priceHeaderDialogActions.closeDialog
    })))));
};
PriceHeaderDialog.displayName = "PriceHeaderDialog";
PriceHeaderDialog.fragment = fragment19;
// src/components/lodging-price-summary.tsx
var fragment20 = gql23(_templateObject23(), PriceHeaderDialog.fragment);
var formatStrikeOutText = function(price, points, unit, leadingCaption, isPointsFirst) {
    if (!price && !points) {
        return void 0;
    }
    if (!points) {
        return price === null || price === void 0 ? void 0 : price.formatted;
    }
    if (!price) {
        return "".concat(points.formatted, " ").concat(unit);
    }
    if (isPointsFirst) {
        return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
    }
    return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildEGDSPriceLockupProps = function(options) {
    var _loyaltyPoints_amount, _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger;
    var _options = _sliced_to_array(options, 3), leadOption = _options[0], otherOption = _options[1], disclaimerForPoints = _options[2];
    var _ref = leadOption !== null && leadOption !== void 0 ? leadOption : {}, leadingCaption = _ref.leadingCaption, loyaltyPrice = _ref.loyaltyPrice, displayPrice = _ref.displayPrice, accessibilityLabel = _ref.accessibilityLabel, priceDisclaimer = _ref.priceDisclaimer, strikeOut = _ref.strikeOut;
    if (options.length === 1 && loyaltyPrice) {
        var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
        var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
        return {
            isStrikeThroughFirst: true,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
            strikeThroughPrice: strikeThroughPoints,
            a11yPrice: accessibilityLabel || ""
        };
    }
    if (loyaltyPrice) {
        var _otherOption_displayPrice, _loyaltyPrice_amount1, _disclaimerForPoints_priceDisclaimer_trigger_icon, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer;
        var moneyPrice = "".concat(otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption, " ").concat(otherOption === null || otherOption === void 0 ? void 0 : (_otherOption_displayPrice = otherOption.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
        var _disclaimerForPoints_strikeOut, _otherOption_leadingCaption;
        return {
            isStrikeThroughFirst: true,
            isPointsFirst: true,
            lockupPrice: moneyPrice,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
            a11yPrice: (otherOption === null || otherOption === void 0 ? void 0 : otherOption.accessibilityLabel) || "",
            strikeThroughPrice: formatStrikeOutText((_disclaimerForPoints_strikeOut = disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : disclaimerForPoints.strikeOut) !== null && _disclaimerForPoints_strikeOut !== void 0 ? _disclaimerForPoints_strikeOut : null, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, (_otherOption_leadingCaption = otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption) !== null && _otherOption_leadingCaption !== void 0 ? _otherOption_leadingCaption : null, true),
            a11yStrikeThroughDialogTrigger: disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = disclaimerForPoints.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
        };
    }
    var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat(displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted) : displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted;
    if (options.length === 1) {
        var _priceDisclaimer_trigger_icon1, _priceDisclaimer_trigger1;
        return {
            lockupPrice: leadPrice,
            a11yPrice: accessibilityLabel || "",
            strikeThroughPrice: strikeOut === null || strikeOut === void 0 ? void 0 : strikeOut.formatted,
            a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger1 = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
        };
    }
    var loyaltyPoints = otherOption === null || otherOption === void 0 ? void 0 : otherOption.loyaltyPrice;
    var _otherOption_leadingCaption1;
    return {
        isStrikeThroughFirst: true,
        isPointsFirst: false,
        strikeThroughPrice: formatStrikeOutText(strikeOut !== null && strikeOut !== void 0 ? strikeOut : null, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.totalStrikeOutPoints, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit, (_otherOption_leadingCaption1 = otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption) !== null && _otherOption_leadingCaption1 !== void 0 ? _otherOption_leadingCaption1 : null, false),
        lockupPrice: leadPrice,
        lockupFormattedPoints: "".concat(otherOption === null || otherOption === void 0 ? void 0 : otherOption.leadingCaption, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : (_loyaltyPoints_amount = loyaltyPoints.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit),
        a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
        a11yPrice: accessibilityLabel || ""
    };
};
var getPriceDisclaimer = function(options) {
    var _options_, _options_1;
    return ((_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.priceDisclaimer) || ((_options_1 = options[2]) === null || _options_1 === void 0 ? void 0 : _options_1.priceDisclaimer);
};
var LodgingPriceSummary = function(param) {
    var _param_showPriceDetails = param.showPriceDetails, showPriceDetails = _param_showPriceDetails === void 0 ? true : _param_showPriceDetails, _param_align = param.align, align = _param_align === void 0 ? EGDSPriceLockupAlign.LEFT : _param_align, data = param.data;
    var _priceMessaging_, _priceMessaging_priceSubtextBoldIndex, _priceDisclaimer_primaryButton;
    var price = data.price;
    var trackClick = useClickTracker6();
    var dialogPostfix = useDialogId();
    var _useDialog3 = _sliced_to_array(useDialog3("property-price-messaging-dialog-".concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog3[0], dialogActions = _useDialog3[1], DialogComponent = _useDialog3[2];
    if (!(price === null || price === void 0 ? void 0 : price.options) || price.options.length === 0) {
        return null;
    }
    var priceMessaging = price.priceMessaging, options = price.options;
    var priceSubtextBoldIndex = (priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.findIndex(function(msg) {
        return msg.theme === "STRONG" /* STRONG */ ;
    })) || -1;
    var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1) : priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1).splice(priceSubtextBoldIndex, 1);
    var priceSubtextStandard = priceSubtextStandardRawData === null || priceSubtextStandardRawData === void 0 ? void 0 : priceSubtextStandardRawData.map(function(msg) {
        return msg.value;
    });
    var openStrikeThroughPriceDialog = function() {
        dialogActions.openDialog();
        trackClick("HOT.HIS.Price.DisclaimerDialog", "Price Disclaimer Dialog");
    };
    var priceProps = buildEGDSPriceLockupProps(options);
    var priceDisclaimer = getPriceDisclaimer(options);
    var priceHeaderOption = options.find(function(opt) {
        return opt.priceHeaderDialog;
    });
    return /* @__PURE__ */ React28.createElement("div", null, priceHeaderOption && /* @__PURE__ */ React28.createElement(PriceHeaderDialog, {
        data: priceHeaderOption,
        direction: "row",
        justifyContent: "end"
    }), /* @__PURE__ */ React28.createElement(EGDSPriceLockup, _object_spread_props(_object_spread({}, priceProps), {
        align: align,
        priceSubtextFirst: showPriceDetails && priceMessaging ? (_priceMessaging_ = priceMessaging[0]) === null || _priceMessaging_ === void 0 ? void 0 : _priceMessaging_.value : "",
        priceSubtextStandard: showPriceDetails ? priceSubtextStandard : void 0,
        priceSubtextBold: showPriceDetails && priceMessaging && priceSubtextBoldIndex !== -1 ? (_priceMessaging_priceSubtextBoldIndex = priceMessaging[priceSubtextBoldIndex]) === null || _priceMessaging_priceSubtextBoldIndex === void 0 ? void 0 : _priceMessaging_priceSubtextBoldIndex.value : "",
        strikeThroughTrigger: !!priceDisclaimer && /* @__PURE__ */ React28.createElement("button", {
            onClick: openStrikeThroughPriceDialog,
            type: "button",
            className: "uitk-more-info-trigger"
        }),
        stids: {
            lockupId: "price-lockup-text",
            subtextBoldId: "price-lockup-bold-subtext",
            wrapperId: "price-lockup-wrapper"
        }
    })), !!priceDisclaimer && /* @__PURE__ */ React28.createElement(EGDSSheetTransition2, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React28.createElement(DialogComponent, null, /* @__PURE__ */ React28.createElement(EGDSDialog2, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React28.createElement(EGDSDialogContent2, null, priceDisclaimer.content[0], /* @__PURE__ */ React28.createElement(EGDSDialogFooter2, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_priceDisclaimer_primaryButton = priceDisclaimer.primaryButton) === null || _priceDisclaimer_primaryButton === void 0 ? void 0 : _priceDisclaimer_primaryButton.text) || "",
            type: "tertiary"
        }
    }))))));
};
LodgingPriceSummary.fragment = fragment20;
LodgingPriceSummary.displayName = "LodgingPriceSummary";
// src/components/lodging-card/lodging-card-price-section-price-summary.tsx
var mapPriceSummary = function(priceSummary) {
    var price = {
        __typename: "Offer",
        price: priceSummary
    };
    return price;
};
var PriceSectionPriceSummary = function(param) {
    var priceSummary = param.priceSummary, flexAlignment = param.flexAlignment, flexDirection = param.flexDirection, _param_align = param.align, align = _param_align === void 0 ? EGDSPriceLockupAlign2.RIGHT : _param_align, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _priceSummary_displayMessages;
    if (priceSummary == null) {
        return null;
    }
    return ((_priceSummary_displayMessages = priceSummary.displayMessages) === null || _priceSummary_displayMessages === void 0 ? void 0 : _priceSummary_displayMessages.length) ? /* @__PURE__ */ React29.createElement(PriceSummary2, {
        data: priceSummary,
        flexAlignment: flexAlignment,
        messageLineFlexDirection: flexDirection,
        enableInlineLink: enableInlineLink
    }) : /* @__PURE__ */ React29.createElement(LodgingPriceSummary, {
        align: align,
        data: mapPriceSummary(priceSummary)
    });
};
// src/components/product-card/product-card-sheet-footer.tsx
var fragment21 = gql24(_templateObject24(), PropertyPriceDocumentNode);
var ProductCardSheetFooter = function(param) {
    var data = param.data;
    var createTrip2 = useCreateTrip();
    var oldPriceSection = data.oldPriceSection, buttonV2 = data.buttonV2;
    return /* @__PURE__ */ React30.createElement(EGDSSpacing4, {
        margin: "three"
    }, /* @__PURE__ */ React30.createElement(EGDSLayoutFlex4, {
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React30.createElement(PriceSectionPriceSummary, {
        priceSummary: oldPriceSection,
        flexAlignment: "start",
        align: EGDSPriceLockupAlign3.LEFT,
        enableInlineLink: true
    })), createTrip2 && buttonV2 ? /* @__PURE__ */ React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React30.createElement(EGDSPrimaryButton, {
        type: "button",
        onClick: createTrip2,
        size: EGDSButtonSize.LARGE,
        "data-stid": "product-card-book-button"
    }, buttonV2.primary)) : null));
};
ProductCardSheetFooter.fragment = fragment21;
ProductCardSheetFooter.displayName = "ProductCardSheetFooter";
// src/components/product-card/product-card-sheet-list-body-section.tsx
import React31 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSIcon as EGDSIcon6, EGDSIconSize as EGDSIconSize6 } from "@egds/react-core/icons";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText7 } from "@egds/react-core/text";
import { EGDSUnformattedHtml } from "@egds/react-core/unformatted-html";
var fragment22 = gql25(_templateObject25());
var ProductCardSheetListBodySection = function(param) {
    var data = param.data;
    var heading = React31.useMemo(function() {
        if (!data.heading) {
            return null;
        }
        var _data_heading = data.heading, icon = _data_heading.icon, text = _data_heading.text, theme = _data_heading.theme;
        var iconSize = icon.size ? EGDSIconSize6[icon.size] : void 0;
        return /* @__PURE__ */ React31.createElement(EGDSHeading3, {
            tag: "h2",
            size: 5
        }, /* @__PURE__ */ React31.createElement(EGDSText7, {
            theme: textThemeMapper2[theme]
        }, /* @__PURE__ */ React31.createElement(EGDSIcon6, {
            name: icon.id,
            description: icon.description,
            size: iconSize
        }), text));
    }, [
        data.heading
    ]);
    var listProps = React31.useMemo(function() {
        var _data_items = data.items, type = _data_items.__typename;
        switch(type){
            case "EGDSTextIconList":
                return {
                    type: "unordered",
                    bullet: "icon-alternate"
                };
            case "EGDSBulletedList":
                return {
                    type: "unordered",
                    bullet: void 0
                };
            case "EGDSOrderedList":
                return {
                    type: "ordered",
                    bullet: void 0
                };
            case "EGDSUnorderedList":
                return {
                    type: "unordered",
                    bullet: "no-bullet"
                };
            default:
                return {};
        }
    }, [
        data.items
    ]);
    return /* @__PURE__ */ React31.createElement(React31.Fragment, null, heading, /* @__PURE__ */ React31.createElement(EGDSSpacing5, null, /* @__PURE__ */ React31.createElement(EGDSList, _object_spread_props(_object_spread({}, listProps), {
        spacing: false
    }), data.items.listItems.map(function(listItem, index) {
        return /* @__PURE__ */ React31.createElement(EGDSListItem, {
            key: "product-card-sheet-list-".concat(index),
            theme: listItem.style
        }, /* @__PURE__ */ React31.createElement(EGDSUnformattedHtml, {
            htmlToParse: listItem.text
        }));
    }))));
};
ProductCardSheetListBodySection.fragment = fragment22;
ProductCardSheetListBodySection.displayName = "ProductCardSheetListBodySection";
// src/components/product-card/product-card-sheet-list-content.tsx
var fragment23 = gql26(_templateObject26(), ProductCardSheetFooter.fragment, ProductCardSheetListBodySection.fragment);
var ProductCardSheetListContent = function(param) {
    var data = param.data;
    var _data_body;
    var productCardId = useProductCardId();
    return /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement(EGDSSheetContent2, null, (_data_body = data.body) === null || _data_body === void 0 ? void 0 : _data_body.map(function(bodyItem, index) {
        return /* @__PURE__ */ React32.createElement(ProductCardSheetListBodySection, {
            data: bodyItem,
            key: "product-card-sheet-list-body-section-".concat(productCardId, "-").concat(index)
        });
    })), data.footer && /* @__PURE__ */ React32.createElement(ProductCardSheetFooter, {
        data: data.footer
    }));
};
ProductCardSheetListContent.fragment = fragment23;
ProductCardSheetListContent.displayName = "ProductCardSheetListContent";
// src/components/product-card/product-card-sheet-sectional-content/index.tsx
import React41 from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing8, EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
// src/components/shopping-button/shopping-button.tsx
import React35 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton2, EGDSSecondaryButton } from "@egds/react-core/button";
import { usePackageOperations } from "@shared-ui/multi-item-operations-providers";
// src/components/product-card-carousel/product-card-carousel-hooks.ts
import React34, { useMemo as useMemo2 } from "react";
import { useLocation as useLocation2 } from "react-router-dom";
import { parse } from "query-string";
// src/components/product-card-carousel/product-card-carousel-context.tsx
import React33 from "react";
var ProductShoppingInvokeFunctionContext = React33.createContext({
    productShoppingInvokeFunctionData: void 0
});
// src/components/product-card-carousel/product-card-carousel-hooks.ts
function useQueryParams() {
    var location = useLocation2();
    return useMemo2(function() {
        return parse(location.search);
    }, [
        location.search
    ]);
}
function useMultiItemSessionId() {
    return useQueryParams().misId;
}
var useShoppingInvokeFunctionCallBack = function() {
    var _shoppingInvokeFunctionData_productShoppingInvokeFunctionData;
    var shoppingInvokeFunctionData = React34.useContext(ProductShoppingInvokeFunctionContext);
    if (!shoppingInvokeFunctionData) {
        throw new Error("useProductShoppingInvokeFunctionDispatch hook can only be used inside < ProductShoppingInvokeFunctionProvider />");
    }
    return (_shoppingInvokeFunctionData_productShoppingInvokeFunctionData = shoppingInvokeFunctionData.productShoppingInvokeFunctionData) === null || _shoppingInvokeFunctionData_productShoppingInvokeFunctionData === void 0 ? void 0 : _shoppingInvokeFunctionData_productShoppingInvokeFunctionData.shoppingInvokeFunctionCallBack;
};
var useProductShoppingInvokeFunctionToastData = function() {
    var _shoppingInvokeFunctionData_productShoppingInvokeFunctionData;
    var shoppingInvokeFunctionData = React34.useContext(ProductShoppingInvokeFunctionContext);
    if (!shoppingInvokeFunctionData) {
        throw new Error("useProductShoppingInvokeFunctionDispatch hook can only be used inside < ProductShoppingInvokeFunctionProvider />");
    }
    return (_shoppingInvokeFunctionData_productShoppingInvokeFunctionData = shoppingInvokeFunctionData.productShoppingInvokeFunctionData) === null || _shoppingInvokeFunctionData_productShoppingInvokeFunctionData === void 0 ? void 0 : _shoppingInvokeFunctionData_productShoppingInvokeFunctionData.toastData;
};
var useProductShoppingInvokeFunctionDispatch = function() {
    var shoppingInvokeFunctionData = React34.useContext(ProductShoppingInvokeFunctionContext);
    if (!shoppingInvokeFunctionData) {
        throw new Error("useProductShoppingInvokeFunctionDispatch hook can only be used inside < ProductShoppingInvokeFunctionProvider />");
    }
    return shoppingInvokeFunctionData.dispatch;
};
// src/components/shopping-button/shopping-button.tsx
var fragment24 = gql27(_templateObject27());
var ShoppingButton = function(param) {
    var data = param.data, size = param.size, isFullWidth = param.isFullWidth;
    var accessibility = data.accessibility, actionId = data.actionId, primary = data.primary, buttonType = data.buttonType;
    var productCardActionCallback = useProductCardActionCallback(actionId);
    var state = usePackageOperations().state;
    var _useProductCardDialog = _sliced_to_array(useProductCardDialog(actionId), 2), isDialogOpen = _useProductCardDialog[0], dialogActions = _useProductCardDialog[1];
    var triggerRef = React35.useRef(null);
    var toastData = useProductShoppingInvokeFunctionToastData();
    var disableButton = (toastData === null || toastData === void 0 ? void 0 : toastData.disabled) || Boolean((toastData === null || toastData === void 0 ? void 0 : toastData.actionId) && (toastData === null || toastData === void 0 ? void 0 : toastData.actionId) !== actionId);
    React35.useEffect(function() {
        if (actionId === "changeRoomActionId" && (state.selectPackage.status === "SUCCESS" || state.selectPackage.status === "FAILURE")) {
            if (isDialogOpen) {
                dialogActions.closeDialog();
            }
        }
    }, [
        state.selectPackage.status
    ]);
    var _obj;
    var buttonComponentMap = (_obj = {}, _define_property(_obj, "PRIMARY" /* PRIMARY */ , EGDSPrimaryButton2), _define_property(_obj, "SECONDARY" /* SECONDARY */ , EGDSSecondaryButton), _obj);
    var ButtonComponent = buttonComponentMap[buttonType];
    if (buttonType === "PRIMARY" /* PRIMARY */  || buttonType === "SECONDARY" /* SECONDARY */ ) {
        return /* @__PURE__ */ React35.createElement(ProductCardActionWrapper, {
            actionId: actionId,
            ref: triggerRef,
            triggerComponent: /* @__PURE__ */ React35.createElement(ButtonComponent, {
                "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
                size: size,
                onClick: productCardActionCallback,
                isFullWidth: isFullWidth,
                domRef: triggerRef,
                disabled: disableButton
            }, primary)
        });
    }
    return null;
};
ShoppingButton.fragment = fragment24;
ShoppingButton.displayName = "ShoppingButton";
// src/components/product-card/product-card-sheet-sectional-content/product-card-sheet-section.tsx
import React40 from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
// src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React36 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSIcon as EGDSIcon7, EGDSIconSize as EGDSIconSize7 } from "@egds/react-core/icons";
var _obj9;
// src/components/lodging-egds-icon/spotlight-mapper.ts
var spotlightMapper = (_obj9 = {}, _define_property(_obj9, "INFO" /* INFO */ , "info"), _define_property(_obj9, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj9, "WARNING" /* WARNING */ , "warning"), _define_property(_obj9, "STANDARD" /* STANDARD */ , "standard"), _obj9);
// src/components/lodging-egds-icon/lodging-egds-icon.tsx
var fragment25 = gql28(_templateObject28());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme, spotLight = data.spotLight;
    var spotLightValue = spotLight ? spotlightMapper[spotLight] : void 0;
    var _ref;
    return /* @__PURE__ */ React36.createElement(EGDSIcon7, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && EGDSIconSize7[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0,
        spotlight: spotLightValue
    });
};
LodgingEGDSIcon.fragment = fragment25;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// src/components/product-card/shopping-price.tsx
import React37 from "react";
import { gql as gql29 } from "@apollo/client";
import { PriceSummary as PriceSummary3 } from "@shared-ui/pricing-price-summary";
var fragment26 = gql29(_templateObject29());
var ShoppingPrice = function(param) {
    var data = param.data, _param_flexAlignment = param.flexAlignment, flexAlignment = _param_flexAlignment === void 0 ? "start" : _param_flexAlignment;
    var _data_displayMessages;
    var priceSummaryFragment = {
        __typename: "PropertyPrice",
        options: [],
        priceMessaging: [],
        displayMessages: (_data_displayMessages = data.displayMessages) === null || _data_displayMessages === void 0 ? void 0 : _data_displayMessages.map(function(displayMessage) {
            return {
                __typename: "PriceDisplayMessage",
                lineItems: displayMessage.lineItems.map(function(lineItem) {
                    if (lineItem.__typename === "ShoppingDisplayPrice") {
                        return {
                            __typename: "DisplayPrice",
                            price: {
                                __typename: "FormattedMoney",
                                formatted: lineItem.price.formatted,
                                accessibilityLabel: lineItem.price.accessibilityLabel
                            },
                            role: lineItem.role
                        };
                    }
                    return {
                        __typename: "LodgingEnrichedMessage",
                        state: lineItem.state,
                        value: lineItem.value
                    };
                })
            };
        })
    };
    return /* @__PURE__ */ React37.createElement(PriceSummary3, {
        data: priceSummaryFragment,
        flexAlignment: flexAlignment
    });
};
ShoppingPrice.fragment = fragment26;
ShoppingPrice.displayName = "ShoppingPrice";
// src/components/product-card/product-card-sheet-sectional-content/product-card-sheet-section-icons.tsx
import React38 from "react";
import { EGDSIcon as EGDSIcon8, EGDSIconSize as EGDSIconSize8 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
var ProductCardSheetSectionIcons = function(param) {
    var icons = param.icons;
    if (!(icons === null || icons === void 0 ? void 0 : icons.length)) {
        return null;
    }
    return /* @__PURE__ */ React38.createElement(EGDSSpacing6, {
        margin: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React38.createElement(EGDSLayoutFlex5, null, icons.map(function(icon, idx) {
        return /* @__PURE__ */ React38.createElement(React38.Fragment, {
            key: idx
        }, idx > 0 && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem3, {
            alignSelf: "center"
        }, /* @__PURE__ */ React38.createElement(EGDSIcon8, {
            name: "add_circle",
            size: EGDSIconSize8.EXTRA_SMALL
        })), /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React38.createElement(LodgingEGDSIcon, {
            data: icon
        })));
    })));
};
// src/components/product-card/product-card-sheet-sectional-content/product-card-sheet-section-texts.tsx
import React39 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { UitkSpacing } from "@egds/react-core/spacing";
var ProductCardSheetSectionTexts = function(param) {
    var texts = param.texts;
    return (texts === null || texts === void 0 ? void 0 : texts.length) ? /* @__PURE__ */ React39.createElement(EGDSLayoutFlex6, {
        wrap: "wrap",
        direction: "column",
        alignItems: "center"
    }, texts.map(function(text, idx) {
        return /* @__PURE__ */ React39.createElement(EGDSLayoutFlexItem4, {
            key: idx
        }, /* @__PURE__ */ React39.createElement(UitkSpacing, {
            padding: {
                inlineend: "four"
            }
        }, /* @__PURE__ */ React39.createElement(EGDSStylizedText, {
            data: text
        })));
    })) : null;
};
// src/components/product-card/product-card-sheet-sectional-content/product-card-sheet-section.tsx
var fragment27 = gql30(_templateObject30(), ShoppingPrice.fragment, EGDSStylizedText.fragment, LodgingEGDSIcon.fragment);
var ProductCardSheetSection = function(param) {
    var data = param.data;
    var _data_lineItems;
    return /* @__PURE__ */ React40.createElement(React40.Fragment, null, (_data_lineItems = data.lineItems) === null || _data_lineItems === void 0 ? void 0 : _data_lineItems.map(function(item, idx) {
        var _item_icons, _item_texts;
        return /* @__PURE__ */ React40.createElement(EGDSSpacing7, {
            key: "product-card-sheet-section-line-item-".concat(idx),
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React40.createElement(EGDSLayoutFlex7, {
            direction: "row",
            justifyContent: "space-between"
        }, /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(EGDSLayoutFlex7, {
            direction: "row",
            alignItems: "center"
        }, /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(ProductCardSheetSectionIcons, {
            icons: (_item_icons = item.icons) !== null && _item_icons !== void 0 ? _item_icons : void 0
        })), /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(ProductCardSheetSectionTexts, {
            texts: (_item_texts = item.texts) !== null && _item_texts !== void 0 ? _item_texts : void 0
        })))), item.price && /* @__PURE__ */ React40.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(ShoppingPrice, {
            data: item.price,
            flexAlignment: "end"
        }), ";")));
    }));
};
ProductCardSheetSection.fragment = fragment27;
ProductCardSheetSection.displayName = "ProductCardSheetSection";
// src/components/product-card/product-card-sheet-sectional-content/index.tsx
var fragment28 = gql31(_templateObject31(), EGDSSpannableText.fragment, ProductCardSheetSection.fragment);
var ProductCardSheetSectionalContent = function(param) {
    var data = param.data;
    var _data_header, _data_sections;
    return data && (data.header || data.sections) && /* @__PURE__ */ React41.createElement(EGDSSpacing8, {
        padding: {
            blockstart: "three",
            blockend: "six",
            inlinestart: "six",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React41.createElement(EGDSSheetContent3, null, /* @__PURE__ */ React41.createElement(EGDSLayoutFlex8, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */ React41.createElement("div", null, (_data_header = data.header) === null || _data_header === void 0 ? void 0 : _data_header.map(function(text, idx) {
        return /* @__PURE__ */ React41.createElement(EGDSSpacing8, {
            margin: {
                blockend: "three"
            },
            key: idx
        }, /* @__PURE__ */ React41.createElement(EGDSSpannableText, {
            data: text,
            size: 400
        }));
    }), (_data_sections = data.sections) === null || _data_sections === void 0 ? void 0 : _data_sections.map(function(section, idx) {
        return /* @__PURE__ */ React41.createElement(React41.Fragment, {
            key: "product-card-sheet-line-item-".concat(idx)
        }, idx > 0 && /* @__PURE__ */ React41.createElement(EGDSSpacingHr2, null), /* @__PURE__ */ React41.createElement(ProductCardSheetSection, {
            data: section,
            key: "product-card-sheet-section-".concat(idx)
        }));
    }))), /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(EGDSSpacing8, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlex8, {
        justifyContent: "center"
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlexItem6, null, (data === null || data === void 0 ? void 0 : data.button) && /* @__PURE__ */ React41.createElement(ShoppingButton, {
        data: data.button,
        isFullWidth: true
    })))))))));
};
ProductCardSheetSectionalContent.fragment = fragment28;
ProductCardSheetSectionalContent.displayName = "ProductCardSheetSectionalContent";
// src/components/product-card/product-card-sheet-tab-list-content.tsx
import React42 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
var fragment29 = gql32(_templateObject32(), ProductCardSheetListBodySection.fragment);
var ProductCardSheetTabListContent = function(param) {
    var data = param.data;
    var productCardId = useProductCardId();
    var content = data.content;
    return /* @__PURE__ */ React42.createElement(EGDSSpacing9, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React42.createElement("div", null, content === null || content === void 0 ? void 0 : content.map(function(contentItem, index) {
        return /* @__PURE__ */ React42.createElement(ProductCardSheetListBodySection, {
            data: contentItem,
            key: "product-card-sheet-list-body-section-".concat(productCardId, "-").concat(index)
        });
    })));
};
ProductCardSheetTabListContent.fragment = fragment29;
ProductCardSheetTabListContent.displayName = "ProductCardSheetTabularContent";
// src/components/product-card/product-card-sheet-tabular-content.tsx
import React43 from "react";
import { gql as gql33 } from "@apollo/client";
import { EGDSSheetContent as EGDSSheetContent4 } from "@egds/react-core/sheet";
import { EGDSTab, EGDSTabs } from "@egds/react-core/tabs";
var fragment30 = gql33(_templateObject33(), ProductCardSheetFooter.fragment);
var ProductCardSheetTabularContent = function(param) {
    var data = param.data;
    var _data_tabularBody_tabs, _data_tabularBody;
    var _React43_useState = _sliced_to_array(React43.useState(0), 2), selectedTab = _React43_useState[0], setSelectedTab = _React43_useState[1];
    var productCardUtils = useProductCardUtils();
    return /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(EGDSSheetContent4, null, /* @__PURE__ */ React43.createElement(EGDSTabs, {
        selectedTab: selectedTab,
        onTabSelect: setSelectedTab
    }, data === null || data === void 0 ? void 0 : (_data_tabularBody = data.tabularBody) === null || _data_tabularBody === void 0 ? void 0 : (_data_tabularBody_tabs = _data_tabularBody.tabs) === null || _data_tabularBody_tabs === void 0 ? void 0 : _data_tabularBody_tabs.map(function(tab) {
        var contentData = tab && (productCardUtils === null || productCardUtils === void 0 ? void 0 : productCardUtils.getContentContainer(tab.contentId));
        return contentData && /* @__PURE__ */ React43.createElement(EGDSTab, {
            name: tab === null || tab === void 0 ? void 0 : tab.label,
            id: tab === null || tab === void 0 ? void 0 : tab.tabId,
            key: tab === null || tab === void 0 ? void 0 : tab.tabId
        }, /* @__PURE__ */ React43.createElement(ProductCardContent, {
            data: contentData
        }));
    }))), data.footer && /* @__PURE__ */ React43.createElement(ProductCardSheetFooter, {
        data: data.footer
    }));
};
ProductCardSheetTabularContent.fragment = fragment30;
ProductCardSheetTabularContent.displayName = "ProductCardSheetTabularContent";
// src/components/product-card/property-filtered-reviews.tsx
import React45 from "react";
import { EGDSSheetContent as EGDSSheetContent5 } from "@egds/react-core/sheet";
// src/components/property-review-summary/__private/providers/property-filtered-reviews-dialog-provider.tsx
import React44 from "react";
var PropertyFilteredReviewsDialogContext = React44.createContext(void 0);
var usePropertyFilteredReviewsDialogContext = function() {
    var context = React44.useContext(PropertyFilteredReviewsDialogContext);
    if (context === void 0) {
        throw new Error("usePropertyFilteredReviewsDialogContext must be used with a PropertyFilteredReviewsDialogContext.Provider");
    }
    return context;
};
// src/components/product-card/property-filtered-reviews.tsx
var PropertyFilteredReviews = function() {
    var PropertyFilteredReviewsDialogContent = usePropertyFilteredReviewsDialogContext().PropertyFilteredReviewsDialogContent;
    return /* @__PURE__ */ React45.createElement(EGDSSheetContent5, {
        padded: true
    }, /* @__PURE__ */ React45.createElement(PropertyFilteredReviewsDialogContent, null));
};
// src/components/product-card/product-card-content.tsx
var fragment31 = gql34(_templateObject34(), ProductCardSheetListContent.fragment, ProductCardSheetTabListContent.fragment, ProductCardSheetTabularContent.fragment);
var ProductCardContent = function(param) {
    var data = param.data;
    var content = data.content;
    switch(content.__typename){
        case "ShoppingProductCardSheetListContent":
            return /* @__PURE__ */ React46.createElement(ProductCardSheetListContent, {
                data: content
            });
        case "ShoppingLoadSharedUI":
            {
                if (content.componentName === "SharedUIOfferDetails") {
                    return /* @__PURE__ */ React46.createElement(OfferDetails, null);
                }
                if (content.componentName === "SharedUIPropertyFilteredReviews") {
                    return /* @__PURE__ */ React46.createElement(PropertyFilteredReviews, null);
                }
                return null;
            }
        case "ShoppingProductCardSheetTabularContent":
            return /* @__PURE__ */ React46.createElement(ProductCardSheetTabularContent, {
                data: content
            });
        case "ShoppingProductCardSheetTabListContent":
            return /* @__PURE__ */ React46.createElement(ProductCardSheetTabListContent, {
                data: content
            });
        case "ShoppingProductCardSheetSectionalContent":
            return /* @__PURE__ */ React46.createElement(ProductCardSheetSectionalContent, {
                data: content
            });
        default:
            return null;
    }
};
ProductCardContent.fragment = fragment31;
ProductCardContent.displayName = "ProductCardContent";
// src/components/product-card/product-card-sheet.tsx
var fragment32 = gql35(_templateObject35());
var _obj10;
var EGDSSheetTypeMap = (_obj10 = {}, _define_property(_obj10, "BOTTOM" /* BOTTOM */ , "bottom"), _define_property(_obj10, "SIDE" /* SIDE */ , "side"), _define_property(_obj10, "CENTERED" /* CENTERED */ , "centered"), _define_property(_obj10, "POPOVER" /* POPOVER */ , "popover"), _define_property(_obj10, "FULLSCREEN" /* FULLSCREEN */ , "full"), _obj10);
var ProductCardSheet = React47.forwardRef(function(param, triggerRef) {
    var actionId = param.actionId, contentContainer = param.contentContainer, data = param.data;
    var track = useClickTracker7();
    var _useProductCardDialog = _sliced_to_array(useProductCardDialog(actionId), 3), isDialogOpen = _useProductCardDialog[0], dialogActions = _useProductCardDialog[1], DialogComponent = _useProductCardDialog[2];
    var content = contentContainer.content;
    var _data_sheetType;
    var sheetType = (_data_sheetType = data.sheetType) !== null && _data_sheetType !== void 0 ? _data_sheetType : "CENTERED" /* CENTERED */ ;
    var closeDialog = React47.useCallback(function() {
        track(data.closeAnalytics.linkName, data.closeAnalytics.referrerId);
        dialogActions.closeDialog();
    }, [
        data,
        track,
        dialogActions
    ]);
    var renderToolbar = function() {
        var _data_closeText;
        var toolbarProps = {
            navigationContent: {
                onClick: closeDialog,
                navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : "close"
            }
        };
        if (content.__typename === "ShoppingProductCardSheetListContent" || content.__typename === "ShoppingProductCardSheetTabularContent") {
            var _content_title;
            toolbarProps.toolbarTitle = (_content_title = content.title) !== null && _content_title !== void 0 ? _content_title : "";
            toolbarProps.toolbarSubtitle = content.subtitle;
        }
        return /* @__PURE__ */ React47.createElement(EGDSToolbar, _object_spread({}, toolbarProps));
    };
    var commonEGDSSheetProps = React47.useMemo(function() {
        return {
            isVisible: isDialogOpen,
            type: EGDSSheetTypeMap[sheetType],
            triggerRef: triggerRef
        };
    }, [
        isDialogOpen,
        data,
        triggerRef
    ]);
    var smallView = /* @__PURE__ */ React47.createElement(EGDSSheetTransition3, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React47.createElement(DialogComponent, null, /* @__PURE__ */ React47.createElement(EGDSSheet, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, renderToolbar(), /* @__PURE__ */ React47.createElement(ProductCardContent, {
        data: contentContainer
    }))));
    if (sheetType === "SIDE" /* SIDE */ ) {
        var renderSideSheet = function(sideSheetLayout) {
            return /* @__PURE__ */ React47.createElement(EGDSSheetTransition3, {
                isVisible: isDialogOpen
            }, /* @__PURE__ */ React47.createElement(EGDSSheet, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
                sideSheetLayout: sideSheetLayout
            }), renderToolbar(), /* @__PURE__ */ React47.createElement(ProductCardContent, {
                data: contentContainer
            })));
        };
        return /* @__PURE__ */ React47.createElement(Viewport, null, /* @__PURE__ */ React47.createElement(ViewSmall, null, smallView), /* @__PURE__ */ React47.createElement(ViewMedium, null, renderSideSheet({
            position: "trailing",
            columns: 6
        })), /* @__PURE__ */ React47.createElement(ViewLarge, null, renderSideSheet({
            position: "trailing",
            columns: 4
        })));
    }
    if (sheetType === "CENTERED" /* CENTERED */ ) {
        var centerSheet = /* @__PURE__ */ React47.createElement(DialogComponent, null, /* @__PURE__ */ React47.createElement(EGDSSheet, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
            centeredSheetSize: "small"
        }), renderToolbar(), /* @__PURE__ */ React47.createElement(ProductCardContent, {
            data: contentContainer
        })));
        return /* @__PURE__ */ React47.createElement(Viewport, null, /* @__PURE__ */ React47.createElement(ViewSmall, null, smallView), /* @__PURE__ */ React47.createElement(ViewMedium, null, centerSheet), /* @__PURE__ */ React47.createElement(ViewLarge, null, centerSheet));
    }
    if (data.sheetType === "FULLSCREEN" /* FULLSCREEN */ ) {
        return /* @__PURE__ */ React47.createElement(React47.Fragment, null, smallView);
    }
    if (data.sheetType === "BOTTOM" /* BOTTOM */ ) {
        return /* @__PURE__ */ React47.createElement(EGDSSheetTransition3, {
            isVisible: isDialogOpen
        }, /* @__PURE__ */ React47.createElement(DialogComponent, null, /* @__PURE__ */ React47.createElement(EGDSSheet, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
            hasModal: true
        }), renderToolbar(), /* @__PURE__ */ React47.createElement(ProductCardContent, {
            data: contentContainer
        }))));
    }
    return null;
});
ProductCardSheet.fragment = fragment32;
ProductCardSheet.displayName = "ProductCardDetailsSheet";
// src/components/product-card/product-card-link.tsx
import React52 from "react";
// src/components/common/link-semantic-element.tsx
import React48 from "react";
import { EGDSCardLink } from "@egds/react-core/cards";
import { EGDSImageLink } from "@egds/react-core/images";
var LinkSemanticElement = React48.forwardRef(function(_param, triggerRef) {
    var actionId = _param.actionId, cardLink = _param.cardLink, accessibilityText = _param.accessibilityText, onClick = _param.onClick, _param_useImageLink = _param.useImageLink, useImageLink = _param_useImageLink === void 0 ? false : _param_useImageLink, props = _object_without_properties(_param, [
        "actionId",
        "cardLink",
        "accessibilityText",
        "onClick",
        "useImageLink"
    ]);
    var action = useProductCardAction(actionId);
    var data = action !== null && action !== void 0 ? action : cardLink;
    if (!data) {
        return null;
    }
    var onClickCapture = function(e) {
        e.preventDefault();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var _data_accessibility, _ref;
    var a11yText = (_ref = (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : accessibilityText) !== null && _ref !== void 0 ? _ref : "";
    var isLink = (data.__typename === "ShoppingNavigateToURI" || data.__typename === "UILinkAction") && "value" in data.resource;
    var Tag = isLink ? "a" : "button";
    var attributes = isLink ? {
        href: data.resource.value
    } : {
        type: "button"
    };
    var Wrapper = useImageLink ? EGDSImageLink : EGDSCardLink;
    return /* @__PURE__ */ React48.createElement(Wrapper, null, /* @__PURE__ */ React48.createElement(Tag, _object_spread({
        onClickCapture: onClickCapture,
        ref: triggerRef
    }, attributes, props), a11yText));
});
LinkSemanticElement.displayName = "LinkSemanticElement";
// src/components/lodging-card/__private/lodging-card-link.tsx
import React49 from "react";
import { Link } from "react-router-dom";
import { gql as gql36 } from "@apollo/client";
import { EGDSCardLink as EGDSCardLink2 } from "@egds/react-core/cards";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLodgingCompare } from "@shared-ui/retail-compare-providers";
var fragment33 = gql36(_templateObject36());
var LINK_REL = "noopener";
var LINK_DATA_STID = "open-hotel-information";
var LodgingCardLink = function(param) {
    var data = param.data, onClickCallback = param.onClickCallback, _param_appendAdditionalQueryParamCb = param.appendAdditionalQueryParamCb, appendAdditionalQueryParamCb = _param_appendAdditionalQueryParamCb === void 0 ? function(link) {
        return link;
    } : _param_appendAdditionalQueryParamCb, _param_alternateURLDetails = param.alternateURLDetails, alternateURLDetails = _param_alternateURLDetails === void 0 ? null : _param_alternateURLDetails, tmp = param.isAd, isAd2 = tmp === void 0 ? null : tmp, _param_isSRPListingCard = param.isSRPListingCard, isSRPListingCard = _param_isSRPListingCard === void 0 ? true : _param_isSRPListingCard;
    var _alternateURLDetails_shoppingJoinListContainer_actions, _alternateURLDetails_shoppingJoinListContainer;
    var resource = data.resource, useRelativePath = data.useRelativePath, analytics = data.analytics, target = data.target, accessibility = data.accessibility;
    var _alternateURLDetails_shoppingJoinListContainer_actions_;
    var alternateURL = (_alternateURLDetails_shoppingJoinListContainer_actions_ = alternateURLDetails === null || alternateURLDetails === void 0 ? void 0 : (_alternateURLDetails_shoppingJoinListContainer = alternateURLDetails.shoppingJoinListContainer) === null || _alternateURLDetails_shoppingJoinListContainer === void 0 ? void 0 : (_alternateURLDetails_shoppingJoinListContainer_actions = _alternateURLDetails_shoppingJoinListContainer.actions) === null || _alternateURLDetails_shoppingJoinListContainer_actions === void 0 ? void 0 : _alternateURLDetails_shoppingJoinListContainer_actions[0]) !== null && _alternateURLDetails_shoppingJoinListContainer_actions_ !== void 0 ? _alternateURLDetails_shoppingJoinListContainer_actions_ : null;
    var track = useClickTracker8();
    var _useLodgingCompare = _sliced_to_array(useLodgingCompare(), 1), comparePropertyIds = _useLodgingCompare[0].comparePropertyIds;
    var path;
    var anchorRef = React49.createRef();
    if (resource.__typename === "HttpURI") {
        path = useRelativePath ? resource.relativePath : resource.value;
        if (comparePropertyIds.length) {
            path = path.concat("&comparePropertyIds=".concat(comparePropertyIds.toString()));
        }
    }
    path = appendAdditionalQueryParamCb(path);
    var _useExperiment = useExperiment("Split_View_Side_by_side_BEXG_H"), bexSplitViewExposure = _useExperiment.exposure;
    var cardAnalytics = !isSRPListingCard && bexSplitViewExposure.bucket === 1 && (analytics.referrerId.match(/HOT\.SR:HotelModule:\d+$/) !== null || analytics.referrerId.match(/HOT\.SR:TravelAd\.Clicked:\d+$/) !== null) ? _object_spread_props(_object_spread({}, analytics), {
        referrerId: isAd2 ? "HOT.SR:TravelAd.Clicked:Map" : "HOT.SR:HotelModule:Map"
    }) : analytics;
    var onClick = function() {
        if (analytics) {
            sendProductSchemaTracking(_object_spread_props(_object_spread({}, cardAnalytics), {
                uisPrimeMessages: analytics.uisPrimeMessages
            }), track);
        }
        if (onClickCallback) {
            onClickCallback();
        }
    };
    var routeLink = function(e) {
        e.preventDefault();
        if (alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.analytics) {
            track(alternateURL.analytics.referrerId, alternateURL.analytics.linkName);
        }
        if ((alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.__typename) === "ShoppingNavigateToURI") {
            if (alternateURL.target === "INTERNAL" /* INTERNAL */  && (alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.useRelativePath)) {
                var _alternateURL_resource;
                window.location.href = (alternateURL === null || alternateURL === void 0 ? void 0 : (_alternateURL_resource = alternateURL.resource) === null || _alternateURL_resource === void 0 ? void 0 : _alternateURL_resource.__typename) === "HttpURI" ? alternateURL.resource.relativePath : path;
            } else {
                var _alternateURL_resource1, _alternateURL_resource2;
                var routePath = (alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.useRelativePath) && (alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.resource.__typename) === "HttpURI" ? (_alternateURL_resource1 = alternateURL.resource) === null || _alternateURL_resource1 === void 0 ? void 0 : _alternateURL_resource1.relativePath : (_alternateURL_resource2 = alternateURL.resource) === null || _alternateURL_resource2 === void 0 ? void 0 : _alternateURL_resource2.value;
                window.open(routePath, UILinkTargetMap3[alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.target]);
            }
        } else {
            window.location.href = path;
        }
    };
    var routeLinkOnRightClick = function() {
        var anc = anchorRef.current;
        if (anc) {
            anc.href = (alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.__typename) === "ShoppingNavigateToURI" ? alternateURL.resource.value : path;
        }
    };
    if (alternateURL !== null) {
        return /* @__PURE__ */ React49.createElement(EGDSCardLink2, null, /* @__PURE__ */ React49.createElement("a", {
            ref: anchorRef,
            rel: LINK_REL,
            target: UILinkTargetMap3[target],
            onClick: routeLink,
            href: path,
            onContextMenu: routeLinkOnRightClick
        }, alternateURL === null || alternateURL === void 0 ? void 0 : alternateURL.accessibility));
    }
    var linkProps = {
        rel: LINK_REL,
        "data-stid": LINK_DATA_STID,
        target: target && UILinkTargetMap3[target],
        onClickCapture: onClick
    };
    return /* @__PURE__ */ React49.createElement(EGDSCardLink2, null, target === "INTERNAL" /* INTERNAL */  && useRelativePath ? /* @__PURE__ */ React49.createElement(Link, _object_spread_props(_object_spread({}, linkProps), {
        to: path || ""
    }), accessibility) : /* @__PURE__ */ React49.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
        href: path
    }), accessibility));
};
LodgingCardLink.fragment = fragment33;
LodgingCardLink.displayName = "LodgingCardLink";
// src/components/lodging-compare/index.ts
var isAd = function(mediaSection) {
    var _mediaSection_badges_secondaryBadge, _mediaSection_badges;
    return ((_mediaSection_badges = mediaSection.badges) === null || _mediaSection_badges === void 0 ? void 0 : (_mediaSection_badges_secondaryBadge = _mediaSection_badges.secondaryBadge) === null || _mediaSection_badges_secondaryBadge === void 0 ? void 0 : _mediaSection_badges_secondaryBadge.theme) === "sponsored";
};
// src/components/product-card/product-card-action-wrapper.tsx
import React51 from "react";
// src/components/product-card/product-card-overlay.tsx
import React50 from "react";
import { gql as gql37 } from "@apollo/client";
var fragment34 = gql37(_templateObject37(), ProductCardSheet.fragment);
var ProductCardOverlay = React50.forwardRef(function(param, triggerRef) {
    var data = param.data, actionId = param.actionId, contentContainer = param.contentContainer;
    var overlay = data.overlay;
    switch(overlay.__typename){
        case "EGDSSheet":
            return /* @__PURE__ */ React50.createElement(ProductCardSheet, {
                data: overlay,
                contentContainer: contentContainer,
                ref: triggerRef,
                actionId: actionId
            });
        default:
            return null;
    }
});
ProductCardOverlay.fragment = fragment34;
ProductCardOverlay.displayName = "ProductCardOverLay";
// src/components/product-card/product-card-action-wrapper.tsx
var ProductCardActionWrapper = React51.forwardRef(function(param, triggerRef) {
    var actionId = param.actionId, triggerComponent = param.triggerComponent;
    var productCardAction = useProductCardAction(actionId);
    var productCardUtils = useProductCardUtils();
    if ((productCardAction === null || productCardAction === void 0 ? void 0 : productCardAction.__typename) === "ShoppingNavigateToOverlay") {
        var overlayContainer = productCardUtils === null || productCardUtils === void 0 ? void 0 : productCardUtils.getOverlayContainer(productCardAction.overlayId);
        var contentContainer = overlayContainer && (productCardUtils === null || productCardUtils === void 0 ? void 0 : productCardUtils.getContentContainer(overlayContainer.contentId));
        if (!overlayContainer || !contentContainer) {
            return triggerComponent;
        }
        return /* @__PURE__ */ React51.createElement(React51.Fragment, null, triggerComponent, /* @__PURE__ */ React51.createElement(ProductCardOverlay, {
            data: overlayContainer,
            actionId: actionId,
            contentContainer: contentContainer,
            ref: triggerRef
        }));
    }
    return triggerComponent;
});
ProductCardActionWrapper.displayName = "ProductCardActionWrapper";
// src/components/product-card/product-card-link.tsx
var ProductCardLink = function(param) {
    var data = param.data, isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, appendAdditionalQueryParamCb = param.appendAdditionalQueryParamCb, isSRPListingCard = param.isSRPListingCard;
    var _data_headingSection;
    var clickActionId = data.clickActionId, cardLink = data.cardLink;
    var onProductCardClick = useProductCardClickCallback();
    var productCardActionCallback = useProductCardActionCallback(clickActionId);
    var triggerRef = React52.useRef(null);
    if (!clickActionId || isRouteAndHoverDifferent) {
        return cardLink && /* @__PURE__ */ React52.createElement(LodgingCardLink, {
            data: cardLink,
            onClickCallback: onProductCardClick,
            alternateURLDetails: isRouteAndHoverDifferent ? data : void 0,
            appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
            isAd: isAd(data.mediaSection),
            isSRPListingCard: isSRPListingCard
        });
    }
    var productCardLinkTrigger = /* @__PURE__ */ React52.createElement(LinkSemanticElement, {
        actionId: clickActionId,
        cardLink: cardLink,
        "data-stid": "open-product-information",
        ref: triggerRef,
        onClick: function() {
            productCardActionCallback();
            onProductCardClick === null || onProductCardClick === void 0 ? void 0 : onProductCardClick();
        },
        accessibilityText: (_data_headingSection = data.headingSection) === null || _data_headingSection === void 0 ? void 0 : _data_headingSection.heading
    });
    return /* @__PURE__ */ React52.createElement(ProductCardActionWrapper, {
        actionId: clickActionId,
        triggerComponent: productCardLinkTrigger,
        ref: triggerRef
    });
};
ProductCardLink.displayName = "ProductCardLink";
// src/components/lodging-card/lodging-card-utils.ts
var isCompactView = function(view) {
    return view === "COMPACT" /* COMPACT */ ;
};
var isCompactHorizontalView = function(view) {
    return view === "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ ;
};
function sendProductSchemaTracking(analytics, track, imageItemId, imageIndex, additionalUisPrimeMicroMessages2) {
    var _analytics_uisPrimeMessages;
    var backendUisMessages = ((_analytics_uisPrimeMessages = analytics.uisPrimeMessages) === null || _analytics_uisPrimeMessages === void 0 ? void 0 : _analytics_uisPrimeMessages.length) > 0 ? analytics.uisPrimeMessages.map(function(param) {
        var schemaName = param.schemaName, messageContent = param.messageContent;
        return {
            schemaName: schemaName,
            messageContent: JSON.parse(messageContent)
        };
    }) : void 0;
    var messages = additionalUisPrimeMicroMessages2 && imageItemId ? additionalUisPrimeMicroMessages2([
        {
            trackingId: imageItemId,
            galleryPosition: imageIndex
        }
    ], backendUisMessages) : backendUisMessages;
    track(analytics.referrerId, analytics.linkName, true, messages);
}
function adaptProductEvent(productEvent) {
    return _object_spread_props(_object_spread({}, productEvent), {
        event: {
            event_name: productEvent.event.eventName,
            event_type: productEvent.event.eventType,
            event_version: productEvent.event.eventVersion
        }
    });
}
function consolidateOnclick(track, event, adaptexTrack, consolidatedAdaptExSuccessEvents, onClick) {
    return function() {
        if (onClick) {
            onClick();
        }
        if (event) {
            track(adaptProductEvent(event));
        }
        if (consolidatedAdaptExSuccessEvents.length) {
            consolidatedAdaptExSuccessEvents.forEach(function(adaptExEvent) {
                adaptexTrack(ITrackType2.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    };
}
var consolidateAdaptExEvents = function(adaptExSuccessEvents, imageGalleryAdaptExSuccessEvents) {
    return Array.prototype.concat.apply(adaptExSuccessEvents, imageGalleryAdaptExSuccessEvents);
};
var formatDataAttributes = function(dataAttributes) {
    var formattedDataAttrs = {};
    dataAttributes === null || dataAttributes === void 0 ? void 0 : dataAttributes.forEach(function(pair) {
        formattedDataAttrs[pair.key] = pair.value;
    });
    return formattedDataAttrs;
};
var useLodgingCardImageClickCallback = function(cardLink, alternateRouteLink) {
    var history = useHistory2();
    var clickActionId = useClickActionId();
    var productCardClickAction = useProductCardAction(clickActionId);
    var onProductCardClick = useProductCardClickCallback();
    var _useProductCardDialog = _sliced_to_array(useProductCardDialog(clickActionId), 2), dialogActions = _useProductCardDialog[1];
    var _useLodgingCompare2 = _sliced_to_array(useLodgingCompare2(), 1), comparePropertyIds = _useLodgingCompare2[0].comparePropertyIds;
    return function() {
        if ((productCardClickAction === null || productCardClickAction === void 0 ? void 0 : productCardClickAction.__typename) === "ShoppingNavigateToOverlay") {
            dialogActions.openDialog();
            if (onProductCardClick) {
                onProductCardClick();
            }
            return;
        }
        if (!cardLink) {
            return;
        }
        if (alternateRouteLink !== null) {
            if ((alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.target) === "INTERNAL" /* INTERNAL */  && alternateRouteLink.useRelativePath) {
                window.location.href = alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.resource.relativePath;
            } else {
                var _alternateRouteLink_resource;
                var path = (alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.useRelativePath) ? (_alternateRouteLink_resource = alternateRouteLink.resource) === null || _alternateRouteLink_resource === void 0 ? void 0 : _alternateRouteLink_resource.relativePath : alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.resource.value;
                window.open(path, UILinkTargetMap3[alternateRouteLink.target]);
            }
        } else if (cardLink.resource.__typename === "HttpURI") {
            var comparePropertyIdsStringToAppend = comparePropertyIds.length ? "&comparePropertyIds=".concat(comparePropertyIds.toString()) : "";
            if (cardLink.target === "INTERNAL" /* INTERNAL */  && cardLink.useRelativePath) {
                history.push(cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend));
            } else {
                var path1 = cardLink.useRelativePath ? cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend) : cardLink.resource.value.concat(comparePropertyIdsStringToAppend);
                window.open(path1, UILinkTargetMap3[cardLink.target]);
            }
        }
        if (onProductCardClick) {
            onProductCardClick();
        }
    };
};
var BACKGROUND_CARD_THEME_DICTIONARY = {
    PRIMARY: UitkCardBackgroundThemes.PRIMARY,
    SECONDARY: UitkCardBackgroundThemes.SECONDARY,
    HIGHLIGHT: UitkCardBackgroundThemes.HIGHLIGHT,
    GLOBAL_LOYALTY_STANDARD: UitkCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD,
    GLOBAL_LOYALTY_LOW: UitkCardBackgroundThemes.GLOBAL_LOYALTY_LOW,
    GLOBAL_LOYALTY_HIGH: UitkCardBackgroundThemes.GLOBAL_LOYALTY_HIGH,
    GLOBAL_LOYALTY_EXTRAHIGH: UitkCardBackgroundThemes.GLOBAL_LOYALTY_EXTRAHIGH,
    GLOBAL_LOYALTY_MIDDLE: UitkCardBackgroundThemes.GLOBAL_LOYALTY_MIDDLE
};
var getBackgroundCardTheme = function(cardTheme) {
    var _BACKGROUND_CARD_THEME_DICTIONARY_;
    return (_BACKGROUND_CARD_THEME_DICTIONARY_ = BACKGROUND_CARD_THEME_DICTIONARY["".concat(cardTheme)]) !== null && _BACKGROUND_CARD_THEME_DICTIONARY_ !== void 0 ? _BACKGROUND_CARD_THEME_DICTIONARY_ : void 0;
};
// src/components/lodging-badge/lodging-badge.tsx
import React53 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSBadge, EGDSBadgeLoyalty, EGDSBadgeStandard as EGDSBadgeStandard2, EGDSBadgeStandardThemes } from "@egds/react-core/badge";
import { EGDSIcon as EGDSIcon9, EGDSIconSize as EGDSIconSize9 } from "@egds/react-core/icons";
import { EGDSMark as EGDSMark3, EGDSMarkSize as EGDSMarkSize2 } from "@egds/react-core/mark";
// src/components/uitk-badge-size-mapper.tsx
import { EGDSBadgeSize as EGDSBadgeSize2 } from "@egds/react-core/badge";
var _obj11;
var EGDSBadgeSizeMapper = (_obj11 = {}, _define_property(_obj11, EGDSBadgeSize2.SMALL, "small"), _define_property(_obj11, EGDSBadgeSize2.LARGE, "large"), _obj11);
// src/components/uitk-badge-theme-mapper.tsx
import { EGDSBadgeLoyaltyThemes, EGDSBadgeTheme } from "@egds/react-core/badge";
var LOYALTY_GLOBAL_LOW_TIER = "loyalty-global-low-tier";
var LOYALTY_GLOBAL_MIDDLE_TIER = "loyalty-global-middle-tier";
var LOYALTY_GLOBAL_HIGH_TIER = "loyalty-global-high-tier";
var LOYALTY_GLOBAL_EXTRA_HIGH_TIER = "loyalty-global-extra-high-tier";
var _obj12;
var EGDSBadgeThemeMapper = (_obj12 = {}, _define_property(_obj12, EGDSBadgeTheme.DEAL_BUNDLED, "deal-bundled"), _define_property(_obj12, EGDSBadgeTheme.DEAL_GENERIC, "deal-generic"), _define_property(_obj12, EGDSBadgeTheme.DEAL_MEMBER, "deal-member"), _define_property(_obj12, EGDSBadgeTheme.NOTIFICATION_1, "notification-1"), _define_property(_obj12, EGDSBadgeTheme.NOTIFICATION_2, "notification-2"), _define_property(_obj12, EGDSBadgeTheme.VIP, "vip"), _define_property(_obj12, EGDSBadgeTheme.LOYALTY_EXTRA_HIGH_TIER, "loyalty-extra-high-tier"), _define_property(_obj12, EGDSBadgeTheme.LOYALTY_HIGH_TIER, "loyalty-high-tier"), _define_property(_obj12, EGDSBadgeTheme.LOYALTY_MIDDLE_TIER, "loyalty-middle-tier"), _define_property(_obj12, EGDSBadgeTheme.LOYALTY_LOW_TIER, "loyalty-low-tier"), _define_property(_obj12, EGDSBadgeTheme.SPONSORED, "sponsored"), _define_property(_obj12, EGDSBadgeTheme.VIEWED, "viewed"), _define_property(_obj12, EGDSBadgeTheme.SAVED, "saved"), _define_property(_obj12, EGDSBadgeTheme.FAMILY_FRIENDLY, "family-friendly"), _define_property(_obj12, EGDSBadgeTheme.SUPPLIER_PROMO, "supplier-promo"), _define_property(_obj12, EGDSBadgeTheme.PROMOTED, "promoted"), _obj12);
var _obj13;
var EGDSBadgeLoyaltyThemeMapper = (_obj13 = {}, _define_property(_obj13, EGDSBadgeTheme.LOYALTY_EXTRA_HIGH_TIER, EGDSBadgeLoyaltyThemes.EXTRAHIGH), _define_property(_obj13, EGDSBadgeTheme.LOYALTY_HIGH_TIER, EGDSBadgeLoyaltyThemes.HIGH), _define_property(_obj13, EGDSBadgeTheme.LOYALTY_MIDDLE_TIER, EGDSBadgeLoyaltyThemes.MID), _define_property(_obj13, EGDSBadgeTheme.LOYALTY_LOW_TIER, EGDSBadgeLoyaltyThemes.LOW), _define_property(_obj13, LOYALTY_GLOBAL_LOW_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_LOW), _define_property(_obj13, LOYALTY_GLOBAL_MIDDLE_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_MIDDLE), _define_property(_obj13, LOYALTY_GLOBAL_HIGH_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_HIGH), _define_property(_obj13, LOYALTY_GLOBAL_EXTRA_HIGH_TIER, EGDSBadgeLoyaltyThemes.GLOBAL_EXTRAHIGH), _obj13);
var EGDSBadgeLoyaltyThemePerksMessageMapper = {
    LOYALTY_EXTRA_HIGH_TIER: EGDSBadgeLoyaltyThemes.EXTRAHIGH,
    LOYALTY_HIGH_TIER: EGDSBadgeLoyaltyThemes.HIGH,
    LOYALTY_MIDDLE_TIER: EGDSBadgeLoyaltyThemes.MID,
    LOYALTY_LOW_TIER: EGDSBadgeLoyaltyThemes.LOW,
    VIP: EGDSBadgeLoyaltyThemes.VIP,
    LOYALTY_GLOBAL_LOW_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_LOW,
    LOYALTY_GLOBAL_MIDDLE_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_MIDDLE,
    LOYALTY_GLOBAL_HIGH_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_HIGH,
    LOYALTY_GLOBAL_EXTRA_HIGH_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_EXTRAHIGH
};
// src/components/lodging-badge/lodging-badge.tsx
var fragment35 = gql38(_templateObject38());
var LodgingBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, isSRPListingCard = param.isSRPListingCard, data = param.data;
    if (!data || !data.text && !data.graphic) {
        return null;
    }
    var text = data.text, theme = data.theme, graphic = data.graphic, size = data.size;
    var graphics = function() {
        switch(graphic === null || graphic === void 0 ? void 0 : graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React53.createElement(EGDSIcon9, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    size: EGDSIconSize9.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React53.createElement(EGDSMark3, {
                    name: graphic.id,
                    description: graphic.description,
                    size: EGDSMarkSize2.SMALL
                });
            default:
                return null;
        }
    };
    var DefaultEGDSBadge = // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ React53.createElement(EGDSBadge, {
        className: className,
        text: text || void 0,
        theme: theme ? EGDSBadgeThemeMapper[theme] : void 0,
        size: size ? EGDSBadgeSizeMapper[size] : void 0
    }, graphics());
    if (theme && EGDSBadgeLoyaltyThemeMapper[theme]) {
        return /* @__PURE__ */ React53.createElement(EGDSBadgeLoyalty, {
            className: className,
            text: text || void 0,
            theme: theme ? EGDSBadgeLoyaltyThemeMapper[theme] : void 0,
            size: size ? EGDSBadgeSizeMapper[size] : void 0
        }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphics());
    }
    if (theme === EGDSBadgeThemeMapper.sponsored) {
        return isSRPListingCard ? /* @__PURE__ */ React53.createElement(EGDSBadgeStandard2, {
            className: className,
            text: text || void 0,
            size: size ? EGDSBadgeSizeMapper[size] : void 0
        }) : DefaultEGDSBadge;
    }
    if (theme && EGDSBadgeStandardThemes[theme]) {
        return /* @__PURE__ */ React53.createElement(EGDSBadgeStandard2, {
            className: className,
            text: text || void 0,
            size: size ? EGDSBadgeSizeMapper[size] : void 0,
            theme: theme ? EGDSBadgeStandardThemes[theme] : void 0
        });
    }
    return DefaultEGDSBadge;
};
LodgingBadge.fragment = fragment35;
LodgingBadge.displayName = "LodgingBadge";
// src/components/lodging-buttons/lodging-buttons.tsx
import React54 from "react";
import { gql as gql39 } from "@apollo/client";
import { Transparency, TransparencyTriggerType } from "@shared-ui/retail-sponsored-content-transparency";
var fragment36 = gql39(_templateObject39());
var LodgingButtons = function(param) {
    var data = param.data, _param_type = param.type, type = _param_type === void 0 ? TransparencyTriggerType.NATIVE_AD : _param_type, className = param.className;
    if (!(data === null || data === void 0 ? void 0 : data.adTransparencyButton)) {
        return null;
    }
    var lodgingButtonsProps = {
        type: type,
        className: className
    };
    return /* @__PURE__ */ React54.createElement(Transparency, _object_spread({
        data: data
    }, lodgingButtonsProps));
};
LodgingButtons.fragment = fragment36;
LodgingButtons.displayName = "LodgingButtons";
// src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
import React58, { useEffect as useEffect2 } from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSButtonTheme } from "@egds/react-core/button";
import { UitkGalleryCarousel as EGDSGalleryCarousel } from "@egds/react-core/gallery-carousel";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { IntersectionTracker, ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics3, useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, useProductType } from "@shared-ui/retail-product-type-providers";
import { useInView } from "react-intersection-observer";
// src/components/lodging-gallery-carousel/lodging-media-item-mappers.tsx
import React55 from "react";
import { EGDSFigure, EGDSImage, EGDSImageLink as EGDSImageLink2 } from "@egds/react-core/images";
var lodgingMediaItemToEGDSMediaMapper = function(mediaItem) {
    switch(mediaItem.media.__typename){
        case "Image":
            return {
                src: mediaItem.media.url,
                alt: mediaItem.media.description
            };
        default:
            return {};
    }
};
var mediaItemToGridItem = function(mediaItem, mediaIndex, imageRatio, onImageClick, fetchPriority) {
    var _mediaItem_media, _mediaItem_media1;
    var _mediaItem_media_description, _mediaItem_media_description1;
    return (mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.media.__typename) === "Image" ? /* @__PURE__ */ React55.createElement(EGDSFigure, {
        key: mediaItem.id,
        ratio: imageRatio
    }, /* @__PURE__ */ React55.createElement(EGDSImage, {
        additionalProps: {
            fetchPriority: fetchPriority
        },
        placeholderImage: true,
        alt: (_mediaItem_media_description = (_mediaItem_media = mediaItem.media) === null || _mediaItem_media === void 0 ? void 0 : _mediaItem_media.description) !== null && _mediaItem_media_description !== void 0 ? _mediaItem_media_description : "",
        src: (_mediaItem_media1 = mediaItem.media) === null || _mediaItem_media1 === void 0 ? void 0 : _mediaItem_media1.url
    }), /* @__PURE__ */ React55.createElement(EGDSImageLink2, null, /* @__PURE__ */ React55.createElement("button", {
        type: "button",
        onClick: function() {
            return onImageClick(mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.trackingId, mediaIndex);
        },
        "data-testid": "lodging-card-image-grid-item"
    }, (_mediaItem_media_description1 = mediaItem.media.description) !== null && _mediaItem_media_description1 !== void 0 ? _mediaItem_media_description1 : ""))) : null;
};
// src/components/common/adaptex/adaptex-analytics-event-fragment.ts
import { gql as gql40 } from "@apollo/client";
var AdaptExAnalyticsEventFragment = gql40(_templateObject40());
// src/components/lodging-media-item/lodging-media-item.tsx
import React57 from "react";
import { gql as gql42 } from "@apollo/client";
// src/components/lodging-egds-image/lodging-egds-image.tsx
import React56 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
var fragment37 = gql41(_templateObject41());
var LodgingEGDSImage = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio, placeholderImage = param.placeholderImage, lazyLoad = param.lazyLoad, fetchPriority = param.fetchPriority;
    var figureProps = {};
    if (ratio) {
        figureProps.ratio = ratio;
    }
    if (imageFit) {
        figureProps.imageFit = imageFit;
    }
    return /* @__PURE__ */ React56.createElement(EGDSFigure2, _object_spread({}, figureProps), /* @__PURE__ */ React56.createElement(EGDSImage2, {
        placeholderImage: placeholderImage,
        src: data.url,
        alt: data.description,
        lazyLoading: lazyLoad,
        additionalProps: {
            fetchPriority: fetchPriority
        }
    }));
};
LodgingEGDSImage.fragment = fragment37;
LodgingEGDSImage.displayName = "LodgingEGDSImage";
// src/components/lodging-media-item/lodging-media-item.tsx
var fragment38 = gql42(_templateObject42(), LodgingEGDSImage.fragment);
var LodgingMediaItem = function(param) {
    var imageFit = param.imageFit, ratio = param.ratio, data = param.data, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg;
    switch(data.media.__typename){
        case "Image":
            return /* @__PURE__ */ React57.createElement(LodgingEGDSImage, {
                imageFit: imageFit,
                ratio: ratio,
                placeholderImage: true,
                data: data.media,
                lazyLoad: lazyLoadImg ? "lazy" : "off"
            });
        default:
            return null;
    }
};
LodgingMediaItem.fragment = fragment38;
LodgingMediaItem.displayName = "LodgingProductMediaItem";
// src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
var fragment39 = gql43(_templateObject43(), LodgingMediaItem.fragment, AdaptExAnalyticsEventFragment);
var LodgingGalleryCarousel = function(param) {
    var data = param.data, carouselId = param.carouselId, allyHeadingLevel = param.allyHeadingLevel, cardLink = param.cardLink, propertyId = param.propertyId, _param_alternateRouteLink = param.alternateRouteLink, alternateRouteLink = _param_alternateRouteLink === void 0 ? null : _param_alternateRouteLink, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? EGDSFigureAspectRatioType3.R21_9 : _param_imageRatio, propertySortIndex = param.propertySortIndex, fetchPriority = param.fetchPriority, lazyLoadImg = param.lazyLoadImg;
    var media = data.media, accessibilityHeadingText = data.accessibilityHeadingText, navClickAnalytics = data.navClickAnalytics, intersectionAnalytics = data.intersectionAnalytics, adaptExAnalyticsAttemptEvents = data.adaptExAnalyticsAttemptEvents;
    var track = useClickTracker9();
    var _useClickstreamAnalytics3 = useClickstreamAnalytics3(), clickStreamTrack = _useClickstreamAnalytics3.track;
    var _useInView = useInView({
        triggerOnce: true,
        threshold: 0.8
    }), ref = _useInView.ref, inView = _useInView.inView;
    var _React58_useState = _sliced_to_array(React58.useState(0), 2), currentMediaIndex = _React58_useState[0], setCurrentMediaIndex = _React58_useState[1];
    var clickActionId = useClickActionId();
    var productCardClickAction = useProductCardAction(clickActionId);
    var productLine = useProductType();
    var onImageClickWithoutTracking = useLodgingCardImageClickCallback(cardLink, alternateRouteLink);
    React58.useEffect(function() {
        setCurrentMediaIndex(0);
    }, [
        carouselId
    ]);
    useEffect2(function() {
        if (inView && (adaptExAnalyticsAttemptEvents === null || adaptExAnalyticsAttemptEvents === void 0 ? void 0 : adaptExAnalyticsAttemptEvents.length)) {
            adaptExAnalyticsAttemptEvents.forEach(function(adaptExEvent) {
                clickStreamTrack(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        adaptExAnalyticsAttemptEvents,
        inView,
        clickStreamTrack
    ]);
    var additionalUisPrimeMicroMessages2 = function(mediaIndex, buildForIntersectionAnalytics) {
        var _media_mediaIndex, _media_mediaIndex1, _intersectionAnalytics_uisPrimeMessages;
        var iId = (_media_mediaIndex = media[mediaIndex]) === null || _media_mediaIndex === void 0 ? void 0 : _media_mediaIndex.id;
        var trackingId = (_media_mediaIndex1 = media[mediaIndex]) === null || _media_mediaIndex1 === void 0 ? void 0 : _media_mediaIndex1.trackingId;
        var imageTracking = {
            schemaName: "imageTracking",
            messageContent: {
                galleryName: "SRP_PROPERTY_CARD_CAROUSEL",
                galleryType: "GALLERY_TYPE_SINGLE",
                galleryMaxPosition: media === null || media === void 0 ? void 0 : media.length,
                galleryPosition: mediaIndex,
                repeatedGalleryIndex: null,
                images: [
                    {
                        id: trackingId,
                        galleryPosition: mediaIndex
                    }
                ],
                imageGalleryMetaTagList: [
                    {
                        imageGalleryMetaTagType: "DEVICE_TIME_STAMP",
                        imageGalleryMetaTagValue: Date.now().toString()
                    }
                ]
            }
        };
        var _intersectionAnalytics_uisPrimeMessages_reduce;
        var _ref = _sliced_to_array((_intersectionAnalytics_uisPrimeMessages_reduce = intersectionAnalytics === null || intersectionAnalytics === void 0 ? void 0 : (_intersectionAnalytics_uisPrimeMessages = intersectionAnalytics.uisPrimeMessages) === null || _intersectionAnalytics_uisPrimeMessages === void 0 ? void 0 : _intersectionAnalytics_uisPrimeMessages.reduce(function(acc, message) {
            if (message.schemaName === "allHotelProducts") {
                var _acc_;
                (_acc_ = acc[0]) === null || _acc_ === void 0 ? void 0 : _acc_.push(safeBuildMicroMessage(message.schemaName, message.messageContent));
            } else if (buildForIntersectionAnalytics) {
                var _acc_1;
                (_acc_1 = acc[1]) === null || _acc_1 === void 0 ? void 0 : _acc_1.push(safeBuildMicroMessage(message.schemaName, message.messageContent));
            }
            return acc;
        }, [
            [],
            []
        ])) !== null && _intersectionAnalytics_uisPrimeMessages_reduce !== void 0 ? _intersectionAnalytics_uisPrimeMessages_reduce : [
            [],
            []
        ], 2), partialAllHotelProductsFromBackend = _ref[0], backendUisMessagesExcludingAllHotelProducts = _ref[1];
        if (productLine === ProductType.Cruise) {
            return _to_consumable_array(backendUisMessagesExcludingAllHotelProducts !== null && backendUisMessagesExcludingAllHotelProducts !== void 0 ? backendUisMessagesExcludingAllHotelProducts : []).concat([
                imageTracking
            ]);
        }
        var _ref1 = _sliced_to_array((partialAllHotelProductsFromBackend === null || partialAllHotelProductsFromBackend === void 0 ? void 0 : partialAllHotelProductsFromBackend[0]) ? [
            partialAllHotelProductsFromBackend[0].messageContent.badges,
            !!partialAllHotelProductsFromBackend[0].messageContent.sponsored
        ] : [
            null,
            false
        ], 2), badges = _ref1[0], sponsored = _ref1[1];
        return _to_consumable_array(backendUisMessagesExcludingAllHotelProducts !== null && backendUisMessagesExcludingAllHotelProducts !== void 0 ? backendUisMessagesExcludingAllHotelProducts : []).concat([
            {
                schemaName: "allHotelProducts",
                messageContent: {
                    numOfProducts: 1,
                    hotelProducts: [
                        {
                            productId: propertyId && parseInt(propertyId, 10),
                            imageId: iId && parseInt(iId, 10),
                            imageGalleryAlgorithm: {
                                name: "heroaesthetics.v20190411-hsc.v20190223"
                            },
                            badges: badges,
                            algoMediaGuid: trackingId,
                            sortPosition: propertySortIndex,
                            sponsored: sponsored
                        }
                    ]
                }
            },
            imageTracking
        ]);
    };
    var onImageClick = function() {
        var _media_currentMediaIndex;
        onImageClickWithoutTracking();
        if ((productCardClickAction === null || productCardClickAction === void 0 ? void 0 : productCardClickAction.__typename) === "ShoppingNavigateToOverlay" || !cardLink) {
            return;
        }
        if (alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.analytics) {
            sendProductSchemaTracking(alternateRouteLink.analytics, track);
        } else if (cardLink.resource.__typename === "HttpURI" && cardLink.analytics) {
            sendProductSchemaTracking(cardLink.analytics, track);
        }
        var currentMedia = (_media_currentMediaIndex = media[currentMediaIndex]) === null || _media_currentMediaIndex === void 0 ? void 0 : _media_currentMediaIndex.media;
        if ((currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.__typename) === "Image" && currentMedia.thumbnailClickAnalytics) {
            track(currentMedia.thumbnailClickAnalytics.referrerId, currentMedia.thumbnailClickAnalytics.linkName, true, additionalUisPrimeMicroMessages2(currentMediaIndex));
        }
    };
    var getCarouselNextIndex = function(currentIndex, mediaLength, carouselActionId) {
        if (carouselActionId.includes("clickRight")) {
            return currentIndex < mediaLength - 1 ? currentIndex + 1 : 0;
        }
        if (carouselActionId.includes("clickLeft")) {
            return currentIndex > 0 ? currentIndex - 1 : mediaLength - 1;
        }
        return currentIndex;
    };
    var navButtonAnalytics = navClickAnalytics ? {
        id: navClickAnalytics.referrerId,
        description: navClickAnalytics.linkName,
        callback: function(id, description) {
            return track(id, description, true, additionalUisPrimeMicroMessages2(getCarouselNextIndex(currentMediaIndex, media.length, id)));
        }
    } : void 0;
    var galleryCarouselButtonText = data.nextButtonText && data.previousButtonText ? {
        nextButton: data.nextButtonText,
        prevButton: data.previousButtonText
    } : void 0;
    var mediaMap = media.map(function(mediaItem) {
        return lodgingMediaItemToEGDSMediaMapper(mediaItem);
    });
    var _cardLink_accessibility;
    var galleryCarousel = media.length > 0 && /* @__PURE__ */ React58.createElement("span", {
        ref: ref
    }, /* @__PURE__ */ React58.createElement(EGDSGalleryCarousel, {
        allyHeadingText: accessibilityHeadingText,
        allyHeadingLevel: allyHeadingLevel !== null && allyHeadingLevel !== void 0 ? allyHeadingLevel : void 0,
        carouselId: carouselId,
        carouselName: carouselId,
        currentIndex: currentMediaIndex,
        buttonText: galleryCarouselButtonText,
        images: mediaMap,
        onImageClick: onImageClick,
        onIndexChange: setCurrentMediaIndex,
        ratio: imageRatio,
        navTheme: EGDSButtonTheme.TRANSPARENT,
        showGalleryButton: false,
        analytics: navButtonAnalytics,
        enablePreload: true,
        placeholderImage: true,
        fetchPriority: fetchPriority,
        triggerA11yText: (_cardLink_accessibility = cardLink === null || cardLink === void 0 ? void 0 : cardLink.accessibility) !== null && _cardLink_accessibility !== void 0 ? _cardLink_accessibility : ""
    }));
    switch(media.length){
        case 0:
            return /* @__PURE__ */ React58.createElement(EGDSLayoutPosition, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React58.createElement(EGDSFigure3, {
                imageFit: "cover",
                ratio: imageRatio
            }, /* @__PURE__ */ React58.createElement(EGDSImage3, {
                placeholderImage: true,
                alt: ""
            })));
        case 1:
            {
                var _mediaItem_media, _mediaItem_media1, _mediaItem_media2, _media_, _media_1, _media_2;
                var mediaItem = media[0];
                if ((mediaItem === null || mediaItem === void 0 ? void 0 : (_mediaItem_media = mediaItem.media) === null || _mediaItem_media === void 0 ? void 0 : _mediaItem_media.__typename) !== "Image") {
                    return /* @__PURE__ */ React58.createElement(EGDSLayoutPosition, {
                        position: {
                            zindex: "layer2"
                        },
                        cloneElement: true
                    }, /* @__PURE__ */ React58.createElement(EGDSFigure3, {
                        imageFit: "cover",
                        ratio: imageRatio
                    }, /* @__PURE__ */ React58.createElement(EGDSImage3, {
                        placeholderImage: true,
                        alt: ""
                    })));
                }
                var additionalImageProps = {
                    "data-testid": "egds-carousel-item-image",
                    fetchPriority: fetchPriority
                };
                var _mediaItem_media_description;
                var image = /* @__PURE__ */ React58.createElement(React58.Fragment, null, /* @__PURE__ */ React58.createElement(EGDSImage3, {
                    additionalProps: additionalImageProps,
                    lazyLoading: lazyLoadImg ? "lazy" : "off",
                    placeholderImage: true,
                    alt: (_mediaItem_media_description = (_mediaItem_media1 = mediaItem.media) === null || _mediaItem_media1 === void 0 ? void 0 : _mediaItem_media1.description) !== null && _mediaItem_media_description !== void 0 ? _mediaItem_media_description : "",
                    src: (_mediaItem_media2 = mediaItem.media) === null || _mediaItem_media2 === void 0 ? void 0 : _mediaItem_media2.url
                }), /* @__PURE__ */ React58.createElement(LinkSemanticElement, {
                    actionId: clickActionId,
                    cardLink: cardLink,
                    "data-testid": "uitk-gallery-item-current-trigger",
                    tabIndex: -1,
                    onClick: onImageClick,
                    useImageLink: true,
                    "aria-hidden": true
                }));
                var validatedImageFitData = ((_media_ = media[0]) === null || _media_ === void 0 ? void 0 : _media_.mediaFit) === "cover" || ((_media_1 = media[0]) === null || _media_1 === void 0 ? void 0 : _media_1.mediaFit) === "contain" ? (_media_2 = media[0]) === null || _media_2 === void 0 ? void 0 : _media_2.mediaFit : void 0;
                return /* @__PURE__ */ React58.createElement(EGDSLayoutPosition, {
                    position: {
                        zindex: "layer2"
                    },
                    cloneElement: true
                }, /* @__PURE__ */ React58.createElement(EGDSFigure3, {
                    imageFit: validatedImageFitData || "cover",
                    ratio: imageRatio
                }, intersectionAnalytics ? /* @__PURE__ */ React58.createElement(IntersectionTracker, {
                    tag: "span",
                    referrerId: intersectionAnalytics.referrerId,
                    linkName: intersectionAnalytics.linkName,
                    additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages2(currentMediaIndex, true)
                }, image) : image));
            }
        default:
            return /* @__PURE__ */ React58.createElement(EGDSLayoutPosition, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React58.createElement(EGDSFigure3, {
                imageFit: "cover",
                ratio: imageRatio
            }, intersectionAnalytics ? /* @__PURE__ */ React58.createElement(IntersectionTracker, {
                tag: "span",
                referrerId: intersectionAnalytics.referrerId,
                linkName: intersectionAnalytics.linkName,
                additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages2(currentMediaIndex, true)
            }, galleryCarousel) : galleryCarousel));
    }
};
LodgingGalleryCarousel.fragment = fragment39;
LodgingGalleryCarousel.displayName = "LodgingGalleryCarousel";
// src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
import React59 from "react";
import { gql as gql47 } from "@apollo/client";
import { ITrackType as ITrackType4, useClickstreamAnalytics as useClickstreamAnalytics4 } from "@shared-ui/clickstream-analytics-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// src/components/common/adaptex/adaptex-success-action-tracking-fragment.ts
import { gql as gql44 } from "@apollo/client";
var AdaptexTrackingFragment = gql44(_templateObject44());
// src/components/common/car-rental-location.ts
import { gql as gql45 } from "@apollo/client";
var __CarRentalLocation = gql45(_templateObject45());
// src/components/common/date-time.ts
import { gql as gql46 } from "@apollo/client";
var __DateTime = gql46(_templateObject46());
// src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
var fragment40 = gql47(_templateObject47(), __DateTime, __CarRentalLocation, AdaptexTrackingFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var LodgingTripsSaveItemAdapter = function(param) {
    var data = param.data;
    var save = data.save, remove = data.remove;
    var track = useClickstreamAnalytics4().track;
    var _save_adaptexSuccessCampaignIds;
    var _useAdaptExEvents = useAdaptExEvents((_save_adaptexSuccessCampaignIds = save.adaptexSuccessCampaignIds) !== null && _save_adaptexSuccessCampaignIds !== void 0 ? _save_adaptexSuccessCampaignIds : []), saveAdaptexSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var _remove_adaptexSuccessCampaignIds;
    var _useAdaptExEvents1 = useAdaptExEvents((_remove_adaptexSuccessCampaignIds = remove.adaptexSuccessCampaignIds) !== null && _remove_adaptexSuccessCampaignIds !== void 0 ? _remove_adaptexSuccessCampaignIds : []), removeAdaptexSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
    var saveItemAdaptexTracking = React59.useCallback(function() {
        if (saveAdaptexSuccessEvents.length) {
            saveAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType4.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        saveAdaptexSuccessEvents,
        track
    ]);
    var removeItemAdaptexTracking = React59.useCallback(function() {
        if (removeAdaptexSuccessEvents.length) {
            removeAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType4.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        removeAdaptexSuccessEvents,
        track
    ]);
    return data && /* @__PURE__ */ React59.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React59.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer2"
            }
        },
        saveItemCallback: saveItemAdaptexTracking,
        removeItemCallback: removeItemAdaptexTracking
    }));
};
LodgingTripsSaveItemAdapter.fragment = fragment40;
LodgingTripsSaveItemAdapter.displayName = "LodgingTripsSaveItemAdapter";
// src/components/lodging-card/__private/lodging-card-image-grid.tsx
import React60 from "react";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4 } from "@egds/react-core/images";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { ProductType as ProductType2, useProductType as useProductType2 } from "@shared-ui/retail-product-type-providers";
var LodgingCardImageGrid = function(param) {
    var media = param.media, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? EGDSFigureAspectRatioType4.R21_9 : _param_imageRatio, intersectionAnalytics = param.intersectionAnalytics, cardLink = param.cardLink, alternateRouteLink = param.alternateRouteLink, fetchPriority = param.fetchPriority, propertyId = param.propertyId, propertySortIndex = param.propertySortIndex, sponsored = param.sponsored;
    var clickActionId = useClickActionId();
    var productCardClickAction = useProductCardAction(clickActionId);
    var onImageClickWithoutTracking = useLodgingCardImageClickCallback(cardLink, alternateRouteLink);
    var track = useClickTracker10();
    var productType = useProductType2();
    var isCruise = productType === ProductType2.Cruise;
    var additionalUisPrimeMicroMessages2 = React60.useMemo(function() {
        return function(mediaItems, backendUisMessages, allHotelProductsData) {
            var images = mediaItems.map(function(item, index) {
                var _item_galleryPosition;
                return {
                    id: item.trackingId,
                    galleryPosition: (_item_galleryPosition = item.galleryPosition) !== null && _item_galleryPosition !== void 0 ? _item_galleryPosition : index
                };
            });
            var imageTracking = {
                schemaName: "imageTracking",
                messageContent: {
                    galleryName: "SRP_PROPERTY_CARD_MULTI_IMAGE_GRID",
                    galleryType: "GALLERY_TYPE_SINGLE",
                    images: images,
                    imageGalleryMetaTagList: [
                        {
                            imageGalleryMetaTagType: "DEVICE_TIME_STAMP",
                            imageGalleryMetaTagValue: Date.now().toString()
                        }
                    ]
                }
            };
            if (isCruise) {
                return _to_consumable_array(backendUisMessages !== null && backendUisMessages !== void 0 ? backendUisMessages : []).concat([
                    imageTracking
                ]);
            }
            var productId = (allHotelProductsData === null || allHotelProductsData === void 0 ? void 0 : allHotelProductsData.propertyId) && parseInt(allHotelProductsData.propertyId, 10);
            return _to_consumable_array(backendUisMessages !== null && backendUisMessages !== void 0 ? backendUisMessages : []).concat(_to_consumable_array(allHotelProductsData ? [
                {
                    schemaName: "allHotelProducts",
                    messageContent: {
                        numOfProducts: 1,
                        hotelProducts: [
                            {
                                productId: productId,
                                sortPosition: allHotelProductsData.propertySortIndex,
                                sponsored: Boolean(allHotelProductsData.sponsored)
                            }
                        ]
                    }
                }
            ] : []), [
                imageTracking
            ]);
        };
    }, [
        isCruise
    ]);
    var onImageClick = function(imageItemId, imageIndex) {
        onImageClickWithoutTracking();
        if ((productCardClickAction === null || productCardClickAction === void 0 ? void 0 : productCardClickAction.__typename) === "ShoppingNavigateToOverlay" || !cardLink) {
            return;
        }
        if (alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.analytics) {
            sendProductSchemaTracking(alternateRouteLink.analytics, track, imageItemId, imageIndex, additionalUisPrimeMicroMessages2);
        } else if (cardLink.resource.__typename === "HttpURI" && cardLink.analytics) {
            sendProductSchemaTracking(cardLink.analytics, track, imageItemId, imageIndex, additionalUisPrimeMicroMessages2);
        }
    };
    var imageGrid = /* @__PURE__ */ React60.createElement(EGDSLayoutGrid, {
        rows: 3,
        columns: 2,
        space: "one",
        blockSize: "full_size"
    }, media.slice(0, 3).map(function(mediaItem, index) {
        var colAndRowSpan = index === 0 ? 2 : 1;
        return /* @__PURE__ */ React60.createElement(EGDSLayoutGridItem, {
            key: mediaItem.id,
            colSpan: colAndRowSpan,
            rowSpan: colAndRowSpan
        }, mediaItemToGridItem(mediaItem, index, imageRatio, onImageClick, fetchPriority));
    }));
    return /* @__PURE__ */ React60.createElement(EGDSLayoutPosition2, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React60.createElement(EGDSFigure4, {
        imageFit: "cover",
        ratio: imageRatio
    }, intersectionAnalytics ? /* @__PURE__ */ React60.createElement(IntersectionTracker2, {
        tag: "span",
        referrerId: intersectionAnalytics.referrerId,
        linkName: intersectionAnalytics.linkName,
        additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages2(media.map(function(item, index) {
            return {
                trackingId: item.trackingId,
                galleryPosition: index
            };
        }), void 0, {
            propertyId: propertyId,
            propertySortIndex: propertySortIndex,
            sponsored: sponsored
        })
    }, imageGrid) : imageGrid));
};
// src/components/lodging-card/__private/lodging-card-save-item.tsx
import React61 from "react";
import { gql as gql48 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { ProductType as ProductType3, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var fragment41 = gql48(_templateObject48());
var LodgingCardSaveItem = function(param) {
    var data = param.data;
    var _items_;
    var trackClick = useClickTracker11();
    var _React61_useState = _sliced_to_array(React61.useState(data.initialChecked), 2), isChecked = _React61_useState[0], setIsChecked = _React61_useState[1];
    var items = data.items, labels = data.labels, messages = data.messages, initialChecked = data.initialChecked, analytics = data.analytics;
    var label = isChecked ? labels === null || labels === void 0 ? void 0 : labels.removeLabel : labels === null || labels === void 0 ? void 0 : labels.saveLabel;
    var _items__itemId;
    var inputs = {
        productId: (_items__itemId = (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.itemId) !== null && _items__itemId !== void 0 ? _items__itemId : "",
        productType: ProductType3.PROPERTY_DETAILS
    };
    var handleChange = function(_previousChecked, currentChecked, dispatch) {
        setIsChecked(currentChecked);
        var referrerId = currentChecked ? "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.linkName, ".Add to favorite lists") : "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.linkName, ".Remove from favorite lists");
        var linkName = currentChecked ? "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".SaveFavorite") : "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".RemoveFavorite");
        trackClick(linkName, referrerId);
        var message = currentChecked ? messages === null || messages === void 0 ? void 0 : messages.saveMessage : messages === null || messages === void 0 ? void 0 : messages.removeMessage;
        if (message) {
            dispatch({
                message: message
            });
        }
    };
    return /* @__PURE__ */ React61.createElement(ShortlistToggle, {
        inputs: inputs,
        initialChecked: initialChecked,
        label: label || void 0,
        onChange: handleChange
    });
};
LodgingCardSaveItem.fragment = fragment41;
LodgingCardSaveItem.displayName = "LodgingCardSaveItem";
// src/components/lodging-card/__private/lodging-card-media-section.tsx
var fragment42 = gql49(_templateObject49(), LodgingBadge.fragment, LodgingGalleryCarousel.fragment, LodgingCardSaveItem.fragment, LodgingTripsSaveItemAdapter.fragment, LodgingButtons.fragment);
var VRBO_SITE_ID = 9001001;
var ImageContainer = function(param) {
    var gallery = param.gallery, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? EGDSFigureAspectRatioType5.R21_9 : _param_imageRatio, propertyId = param.propertyId, index = param.index, cardLink = param.cardLink, alternateRouteLink = param.alternateRouteLink, fetchPriority = param.fetchPriority, sponsored = param.sponsored, lazyLoadImg = param.lazyLoadImg;
    var _context_device;
    var context = useBexApi().context;
    var productType = useProductType3();
    var _useExperiment2 = useExperiment2("Multi_image_SRP_cards_mWeb"), _useExperiment2_exposure = _useExperiment2.exposure, multiImagesSrpCardsBucket = _useExperiment2_exposure.bucket;
    var _useExperiment21 = useExperiment2("Multi_image_SRP_cards"), _useExperiment2_exposure1 = _useExperiment21.exposure, multiImagesSrpCardsNativeBucket = _useExperiment2_exposure1.bucket;
    var _useExperiment22 = useExperiment2("Multi_image_SRP_cards_mWeb_vrbo"), _useExperiment2_exposure2 = _useExperiment22.exposure, multiImagesSrpCardsVrboBucket = _useExperiment2_exposure2.bucket;
    var _useExperiment23 = useExperiment2("Enabling_multi_image_on_Cruise_mweb"), _useExperiment2_exposure3 = _useExperiment23.exposure, multiImagesCruiseMwebBucket = _useExperiment2_exposure3.bucket;
    var isMultiImageExperiment = productType === ProductType4.Lodging && (multiImagesSrpCardsBucket === 1 || multiImagesSrpCardsNativeBucket === 1 || multiImagesSrpCardsVrboBucket === 1) || productType === ProductType4.Cruise && multiImagesCruiseMwebBucket === 1;
    if (!gallery) {
        return /* @__PURE__ */ React62.createElement(EGDSFigure5, {
            additionalProps: {
                "data-stid": "lodging-card-media-section-placeholder-image"
            }
        }, /* @__PURE__ */ React62.createElement(EGDSImage4, {
            placeholderImage: true,
            alt: ""
        }));
    }
    var deviceType = context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type;
    if (isMultiImageExperiment && deviceType === "MOBILE_PHONE" /* MOBILE_PHONE */  && gallery.media.length >= 3) {
        return /* @__PURE__ */ React62.createElement(LodgingCardImageGrid, {
            media: gallery.media,
            intersectionAnalytics: gallery.intersectionAnalytics,
            imageRatio: imageRatio,
            cardLink: cardLink,
            alternateRouteLink: alternateRouteLink,
            fetchPriority: fetchPriority,
            propertyId: propertyId,
            propertySortIndex: index,
            sponsored: sponsored
        });
    }
    return /* @__PURE__ */ React62.createElement(LodgingGalleryCarousel, {
        data: gallery,
        carouselId: "lodging-card-gallery-carousel-".concat(propertyId, "-").concat(index),
        allyHeadingLevel: "h3",
        cardLink: cardLink,
        alternateRouteLink: alternateRouteLink,
        propertyId: propertyId,
        imageRatio: imageRatio,
        propertySortIndex: index,
        fetchPriority: fetchPriority,
        lazyLoadImg: lazyLoadImg
    });
};
var LodgingCardMediaSection = function(param) {
    var cardLink = param.cardLink, _param_alternateRouteLink = param.alternateRouteLink, alternateRouteLink = _param_alternateRouteLink === void 0 ? null : _param_alternateRouteLink, propertyId = param.propertyId, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, data = param.data, imageRatio = param.imageRatio, index = param.index, isSRPListingCard = param.isSRPListingCard, fetchPriority = param.fetchPriority, lazyLoadImg = param.lazyLoadImg;
    var _context_device, _buttons_tertiaryButton, _buttons_primaryButton, _buttons_primaryButton1, _buttons_secondaryButton, _buttons_secondaryButton1;
    var badges = data.badges, gallery = data.gallery, saveItem = data.saveItem, saveTripItem = data.saveTripItem, buttons = data.buttons;
    var context = useBexApi().context;
    var deviceType = context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type;
    var isDesktopOrTablet = deviceType === "DESKTOP" /* DESKTOP */  || deviceType === "MOBILE_TABLET" /* MOBILE_TABLET */ ;
    var isVrbo = (context === null || context === void 0 ? void 0 : context.siteId) === VRBO_SITE_ID;
    var isSwitchBadgesEnabled = isSRPListingCard && isDesktopOrTablet && isVrbo;
    var images = /* @__PURE__ */ React62.createElement(ImageContainer, {
        gallery: gallery,
        cardLink: cardLink,
        alternateRouteLink: alternateRouteLink,
        propertyId: propertyId,
        imageRatio: imageRatio,
        fetchPriority: fetchPriority,
        index: index,
        sponsored: isAd(data),
        lazyLoadImg: lazyLoadImg
    });
    var tertiaryLodgingElement;
    if ((buttons === null || buttons === void 0 ? void 0 : (_buttons_tertiaryButton = buttons.tertiaryButton) === null || _buttons_tertiaryButton === void 0 ? void 0 : _buttons_tertiaryButton.adTransparencyButton) || (badges === null || badges === void 0 ? void 0 : badges.tertiaryBadge)) {
        var _buttons_tertiaryButton1;
        var tertiaryContent = /* @__PURE__ */ React62.createElement(EGDSLayoutPosition3, {
            type: "absolute",
            position: {
                right: "three",
                bottom: "minus-three",
                zindex: "layer2"
            },
            cloneElement: true
        }, (buttons === null || buttons === void 0 ? void 0 : (_buttons_tertiaryButton1 = buttons.tertiaryButton) === null || _buttons_tertiaryButton1 === void 0 ? void 0 : _buttons_tertiaryButton1.adTransparencyButton) ? /* @__PURE__ */ React62.createElement(LodgingButtons, {
            data: buttons.tertiaryButton
        }) : (badges === null || badges === void 0 ? void 0 : badges.tertiaryBadge) && /* @__PURE__ */ React62.createElement(LodgingBadge, {
            data: badges.tertiaryBadge,
            propertyId: propertyId
        }));
        if (!isCompactHorizontalView(view)) {
            tertiaryLodgingElement = isCompactView(view) ? tertiaryContent : /* @__PURE__ */ React62.createElement(Viewport2, null, /* @__PURE__ */ React62.createElement(ViewSmall2, null, tertiaryContent), /* @__PURE__ */ React62.createElement(ViewMedium2, null));
        }
    }
    var shortlistToggle = saveItem && !isCompactHorizontalView(view) && /* @__PURE__ */ React62.createElement(EGDSLayoutPosition3, {
        type: "absolute",
        position: {
            top: "zero",
            right: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React62.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var compactViewShortlistToggle = saveItem && isCompactHorizontalView(view) && /* @__PURE__ */ React62.createElement(EGDSLayoutPosition3, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React62.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var saveTripItemHeart = saveTripItem && /* @__PURE__ */ React62.createElement(LodgingTripsSaveItemAdapter, {
        data: saveTripItem
    });
    var primaryBadge = !isSwitchBadgesEnabled ? badges === null || badges === void 0 ? void 0 : badges.primaryBadge : badges === null || badges === void 0 ? void 0 : badges.secondaryBadge;
    var secondaryBadge = !isSwitchBadgesEnabled ? badges === null || badges === void 0 ? void 0 : badges.secondaryBadge : badges === null || badges === void 0 ? void 0 : badges.primaryBadge;
    var isBEXGSplitViewExperimentEnabled = useExperiment2("Split_View_Side_by_side_BEXG_H").exposure.bucket === 1;
    var shouldHidePrimaryBadge = isBEXGSplitViewExperimentEnabled && !isSRPListingCard;
    var primaryLodgingElement = ((buttons === null || buttons === void 0 ? void 0 : (_buttons_primaryButton = buttons.primaryButton) === null || _buttons_primaryButton === void 0 ? void 0 : _buttons_primaryButton.adTransparencyButton) || primaryBadge) && /* @__PURE__ */ React62.createElement(EGDSLayoutPosition3, {
        type: "absolute",
        position: {
            left: "three",
            top: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, (buttons === null || buttons === void 0 ? void 0 : (_buttons_primaryButton1 = buttons.primaryButton) === null || _buttons_primaryButton1 === void 0 ? void 0 : _buttons_primaryButton1.adTransparencyButton) ? /* @__PURE__ */ React62.createElement(LodgingButtons, {
        data: buttons.primaryButton
    }) : primaryBadge && !shouldHidePrimaryBadge && /* @__PURE__ */ React62.createElement(LodgingBadge, {
        data: primaryBadge
    }));
    var secondaryLodgingElement = ((buttons === null || buttons === void 0 ? void 0 : (_buttons_secondaryButton = buttons.secondaryButton) === null || _buttons_secondaryButton === void 0 ? void 0 : _buttons_secondaryButton.adTransparencyButton) || secondaryBadge) && /* @__PURE__ */ React62.createElement(EGDSLayoutPosition3, {
        type: "absolute",
        position: {
            bottom: "three",
            left: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, (buttons === null || buttons === void 0 ? void 0 : (_buttons_secondaryButton1 = buttons.secondaryButton) === null || _buttons_secondaryButton1 === void 0 ? void 0 : _buttons_secondaryButton1.adTransparencyButton) ? /* @__PURE__ */ React62.createElement(LodgingButtons, {
        data: buttons.secondaryButton
    }) : secondaryBadge && /* @__PURE__ */ React62.createElement(LodgingBadge, {
        isSRPListingCard: isSRPListingCard,
        data: secondaryBadge
    }));
    return /* @__PURE__ */ React62.createElement(EGDSLayoutPosition3, {
        type: "relative",
        position: {
            top: "zero",
            left: "zero"
        },
        cloneElement: true
    }, /* @__PURE__ */ React62.createElement(EGDSLayoutFlex9, {
        blockSize: "full_size"
    }, images, shortlistToggle, compactViewShortlistToggle, saveTripItemHeart, primaryLodgingElement, secondaryLodgingElement, tertiaryLodgingElement));
};
LodgingCardMediaSection.fragment = fragment42;
LodgingCardMediaSection.displayName = "LodgingCardMediaSection";
// src/components/lodging-egds-button/lodging-egds-button.tsx
import React63 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSOverlayButton, EGDSPrimaryButton as EGDSPrimaryButton3, EGDSSecondaryButton as EGDSSecondaryButton2, EGDSTertiaryButton } from "@egds/react-core/button";
// src/components/lodging-ui-link-action/lodging-ui-link-action.ts
import { gql as gql50 } from "@apollo/client";
var fragment43 = gql50(_templateObject50());
var getLodgingUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLodgingUILinkActionTarget = function(action) {
    return UILinkTargetMap3[action.target];
};
// src/components/lodging-egds-button/lodging-egds-button.tsx
var fragment44 = gql51(_templateObject51(), clientSideAnalyticsFragment, fragment43, LodgingEGDSIcon.fragment);
var deriveLinkProps = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: EGDSPrimaryButton3,
    UISecondaryButton: EGDSSecondaryButton2,
    UITertiaryButton: EGDSTertiaryButton,
    EGDSOverlayButton: EGDSOverlayButton
};
var LodgingEGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, dataStid = _param.dataStid, props = _object_without_properties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps(action);
    var handleClick = React63.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React63.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "data-stid": dataStid
        }), icon ? /* @__PURE__ */ React63.createElement(LodgingEGDSIcon, {
            data: icon
        }) : null, primary);
    }
    return null;
};
LodgingEGDSButton.fragment = fragment44;
LodgingEGDSButton.displayName = "EGDSButton";
// src/components/lodging-egds-button/lodging-egds-floating-action-button.tsx
import React64 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSFloatingActionButton } from "@egds/react-core/button";
var fragment45 = gql52(_templateObject52());
var deriveLinkProps2 = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingActionButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps2(action);
    var handleClick = React64.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return icon ? /* @__PURE__ */ React64.createElement(EGDSFloatingActionButton, _object_spread({}, buttonProps), /* @__PURE__ */ React64.createElement(LodgingEGDSIcon, {
        data: icon
    })) : null;
};
LodgingEGDSFloatingActionButton.fragment = fragment45;
LodgingEGDSFloatingActionButton.displayName = "EGDSFloatingActionButton";
// src/components/lodging-egds-button/lodging-egds-floating-button.tsx
import React65 from "react";
import { gql as gql53 } from "@apollo/client";
import { EGDSFloatingButton } from "@egds/react-core/button";
var fragment46 = gql53(_templateObject53());
var deriveLinkProps3 = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps3(action);
    var handleClick = React65.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return /* @__PURE__ */ React65.createElement(EGDSFloatingButton, _object_spread({}, buttonProps), icon ? /* @__PURE__ */ React65.createElement(LodgingEGDSIcon, {
        data: icon
    }) : null, primary);
};
LodgingEGDSFloatingButton.fragment = fragment46;
LodgingEGDSFloatingButton.displayName = "EGDSFloatingButton";
// src/components/lodging-egds-sheet/lodging-egds-sheet.tsx
import React66, { useCallback as useCallback3 } from "react";
import { gql as gql54 } from "@apollo/client";
import { EGDSSheet as EGDSSheet2, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
var fragment47 = gql54(_templateObject54());
var LodgingEGDSSheet = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var trackClose = useTrackClientSideAnalytics(data.closeAnalytics);
    var isVisible = props.isVisible, closeCallback = props.closeCallback, openCallback = props.openCallback, sheetComponentProps = _object_without_properties(props, [
        "isVisible",
        "closeCallback",
        "openCallback"
    ]);
    var handleClose = useCallback3(function() {
        trackClose();
        closeCallback === null || closeCallback === void 0 ? void 0 : closeCallback();
    }, [
        trackClose,
        closeCallback
    ]);
    var sheetTranstionsProps = {
        isVisible: isVisible,
        openCallback: openCallback,
        closeCallback: handleClose
    };
    var sheetProps = _object_spread({
        isVisible: isVisible
    }, sheetComponentProps);
    return /* @__PURE__ */ React66.createElement(EGDSSheetTransition4, _object_spread({}, sheetTranstionsProps), /* @__PURE__ */ React66.createElement(EGDSSheet2, _object_spread({}, sheetProps)));
};
LodgingEGDSSheet.displayName = "LodgingEGDSSheet";
LodgingEGDSSheet.fragment = fragment47;
// src/components/lodging-egds-cardinal-localized-text/lodging-egds-cardinal-localized-text.tsx
import React67, { useMemo as useMemo3 } from "react";
import { gql as gql55 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
var fragment48 = gql55(_templateObject55());
var interpolate2 = function(template, models, replacements, locale) {
    return models.reduce(function(accumulator, param) {
        var key = param.key;
        var _replacements_get;
        var replacementValue = (_replacements_get = replacements.get(key)) !== null && _replacements_get !== void 0 ? _replacements_get : "";
        var replacement = typeof replacementValue === "number" ? new Intl.NumberFormat(locale).format(replacementValue) : replacementValue;
        return accumulator.replaceAll("${".concat(key, "}"), replacement);
    }, template.template);
};
var useInterpolateCardinalLocalizedText = function(data, values) {
    var context = useBexApi2().context;
    return useMemo3(function() {
        var _models_;
        if (data === null) {
            return [
                void 0,
                void 0
            ];
        }
        var models = data.models, templates = data.templates, accessibilityTemplates = data.accessibilityTemplates, text = data.text, accessibilityText = data.accessibilityText;
        var locale = context.locale.replace("_", "-");
        var replacements = new Map(models.map(function(param) {
            var key = param.key, source = param.source;
            var _values_source;
            return [
                key,
                (_values_source = values[source]) !== null && _values_source !== void 0 ? _values_source : ""
            ];
        }));
        var _models__key;
        var amount = replacements.get((_models__key = (_models_ = models[0]) === null || _models_ === void 0 ? void 0 : _models_.key) !== null && _models__key !== void 0 ? _models__key : "");
        var pluralCategory = new Intl.PluralRules(locale).select(Number(amount)).toUpperCase();
        var predicate = function(param) {
            var category = param.category;
            return category === pluralCategory;
        };
        var template = templates.find(predicate);
        var accessibilityTemplate = accessibilityTemplates === null || accessibilityTemplates === void 0 ? void 0 : accessibilityTemplates.find(predicate);
        var interpolatedText = template && interpolate2(template, models, replacements, locale);
        var interpolatedAccessibilityText = accessibilityTemplate && interpolate2(accessibilityTemplate, models, replacements, locale);
        var _ref;
        return [
            interpolatedText !== null && interpolatedText !== void 0 ? interpolatedText : text,
            (_ref = interpolatedAccessibilityText !== null && interpolatedAccessibilityText !== void 0 ? interpolatedAccessibilityText : accessibilityText) !== null && _ref !== void 0 ? _ref : void 0
        ];
    }, [
        data,
        values
    ]);
};
var LodgingEGDSCardinalLocalizedText = function(param) {
    var data = param.data, values = param.values, tmp = param.tag, Tag = tmp === void 0 ? "span" : tmp;
    var _useInterpolateCardinalLocalizedText = _sliced_to_array(useInterpolateCardinalLocalizedText(data, values), 2), text = _useInterpolateCardinalLocalizedText[0], accessibilityText = _useInterpolateCardinalLocalizedText[1];
    return /* @__PURE__ */ React67.createElement(React67.Fragment, null, accessibilityText && /* @__PURE__ */ React67.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityText), /* @__PURE__ */ React67.createElement(Tag, {
        "aria-hidden": Boolean(accessibilityText)
    }, text));
};
LodgingEGDSCardinalLocalizedText.fragment = fragment48;
LodgingEGDSCardinalLocalizedText.displayName = "LodgingEGDSCardinalLocalizedText";
// src/components/hocs/error-boundary.tsx
import React68, { Component } from "react";
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2, useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
var RENDER_ERROR = new SystemEvent2(SystemEventLevel2.ERROR, "RENDER_ERROR");
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    var _super = _create_super(ErrorBoundary);
    function ErrorBoundary(props) {
        _class_call_check(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    _create_class(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(param, errorInfo) {
                var name = param.name, message = param.message, stack = param.stack;
                var _this_props = this.props, logger = _this_props.logger, label = _this_props.label;
                logger.RENDER_ERROR.log({
                    error: {
                        name: name,
                        message: message,
                        stack: stack
                    },
                    errorInfo: errorInfo,
                    label: label
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var hasError = this.state.hasError;
                return hasError ? null : children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}(Component);
var errorBoundary = function(param) {
    var label = param.label;
    return function(WrappedComponent, fields) {
        var Wrapper = function(props) {
            var logger = useLoggerEvents2({
                RENDER_ERROR: RENDER_ERROR
            });
            return /* @__PURE__ */ React68.createElement(ErrorBoundary, {
                logger: logger,
                label: label
            }, /* @__PURE__ */ React68.createElement(WrappedComponent, _object_spread({}, props)));
        };
        Wrapper.displayName = "errorBoundary(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
        return Object.assign(Wrapper, fields);
    };
};
// src/components/hocs/gate.tsx
import React69 from "react";
var gate = function(param) {
    var predicate = param.predicate, _param_name = param.name, name = _param_name === void 0 ? "gate" : _param_name;
    return function(Component2, fields) {
        var Gate = function(props) {
            return predicate(props) ? /* @__PURE__ */ React69.createElement(Component2, _object_spread({}, props)) : null;
        };
        Gate.displayName = "".concat(name, "(").concat(Component2.displayName || Component2.name || "Component", ")");
        return Object.assign(Gate, fields);
    };
};
var gated = gate;
// src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React73 from "react";
import { gql as gql59 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSCard, EGDSCardBackgroundThemes, EGDSCardContentSection, EGDSCardLink as EGDSCardLink3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText9 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
// src/components/egds/egds-standard-link/egds-standard-link.tsx
import React70 from "react";
import { gql as gql56 } from "@apollo/client";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
var fragment49 = gql56(_templateObject56(), Icon.fragment);
var EGDSStandardLink = function(_param) {
    var _param_data = _param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, useRelativePath = _param_data_action.useRelativePath, disabled = _param_data.disabled, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text, dataStid = _param.dataStid, uitkLinkProps = _object_without_properties(_param, [
        "data",
        "dataStid"
    ]);
    var clickTracker = useClickTracker12();
    var onClick = React70.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    var path = React70.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React70.createElement(EGDSLink4, _object_spread({
        "data-stid": dataStid,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        disabled: disabled
    }, uitkLinkProps), /* @__PURE__ */ React70.createElement("a", {
        target: UILinkTargetMap[target],
        href: path
    }, standardLinkIcon ? /* @__PURE__ */ React70.createElement(React70.Fragment, null, iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React70.createElement(Icon, {
        data: standardLinkIcon
    }), text, iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React70.createElement(Icon, {
        data: standardLinkIcon
    })) : text, accessibility && /* @__PURE__ */ React70.createElement(EGDSText8, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment49;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/egds/egds-theme-provider/egds-theme-provider.tsx
import React71 from "react";
import { gql as gql57 } from "@apollo/client";
import { EGDSThemeProvider } from "@egds/react-core/utils";
var _obj14;
// src/components/egds/egds-theme-provider/egds-theme-provider-mapper.ts
var themeProviderMapper = (_obj14 = {}, _define_property(_obj14, "NONE" /* NONE */ , "none"), _define_property(_obj14, "LIGHT_1" /* LIGHT_1 */ , "light-1"), _define_property(_obj14, "DARK_1" /* DARK_1 */ , "dark-1"), _define_property(_obj14, "BRIGHT_1" /* BRIGHT_1 */ , "bright-1"), _define_property(_obj14, "GLOBAL_LOYALTY_STANDARD" /* GLOBAL_LOYALTY_STANDARD */ , "global-loyalty-standard"), _define_property(_obj14, "GLOBAL_LOYALTY_LOW" /* GLOBAL_LOYALTY_LOW */ , "global-loyalty-low"), _define_property(_obj14, "GLOBAL_LOYALTY_LOW_BRIGHT" /* GLOBAL_LOYALTY_LOW_BRIGHT */ , "global-loyalty-low-bright"), _define_property(_obj14, "GLOBAL_LOYALTY_MID" /* GLOBAL_LOYALTY_MID */ , "global-loyalty-mid"), _define_property(_obj14, "GLOBAL_LOYALTY_MID_BRIGHT" /* GLOBAL_LOYALTY_MID_BRIGHT */ , "global-loyalty-mid-bright"), _define_property(_obj14, "GLOBAL_LOYALTY_HIGH" /* GLOBAL_LOYALTY_HIGH */ , "global-loyalty-high"), _define_property(_obj14, "GLOBAL_LOYALTY_HIGH_BRIGHT" /* GLOBAL_LOYALTY_HIGH_BRIGHT */ , "global-loyalty-high-bright"), _define_property(_obj14, "GLOBAL_LOYALTY_EXTRA_HIGH" /* GLOBAL_LOYALTY_EXTRA_HIGH */ , "global-loyalty-extra-high"), _define_property(_obj14, "GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT" /* GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT */ , "global-loyalty-extra-high-bright"), _define_property(_obj14, "STANDARD" /* STANDARD */ , "standard"), _define_property(_obj14, "MARKETING_1" /* MARKETING_1 */ , "marketing-1"), _define_property(_obj14, "MARKETING_2" /* MARKETING_2 */ , "marketing-2"), _obj14);
// src/components/egds/egds-theme-provider/egds-theme-provider.tsx
var fragment50 = gql57(_templateObject57());
var EGDSLocalThemeProvider = function(param) {
    var children = param.children, data = param.data;
    if (!data.lightMode) {
        return /* @__PURE__ */ React71.createElement(React71.Fragment, null, children);
    }
    var isColorThemeContainer = data.isColorThemeContainer, lightMode = data.lightMode;
    var _lightMode_themeProviderColor;
    var themeProviderColor = (_lightMode_themeProviderColor = lightMode.themeProviderColor) !== null && _lightMode_themeProviderColor !== void 0 ? _lightMode_themeProviderColor : "none";
    var isGradient = Boolean(lightMode.isGradient);
    var isThemeBase = Boolean(lightMode.isThemeBase);
    var mappedColor = themeProviderMapper[themeProviderColor];
    return /* @__PURE__ */ React71.createElement(EGDSThemeProvider, {
        config: {
            lightMode: {
                colorTheme: mappedColor,
                isGradient: isGradient,
                isThemeBase: isThemeBase
            }
        },
        isColorThemeContainer: isColorThemeContainer,
        "data-stid": "theme-provider"
    }, children);
};
EGDSLocalThemeProvider.fragment = fragment50;
EGDSLocalThemeProvider.displayName = "EGDSLocalThemeProvider";
// src/components/egds/egds-ui-link-action/egds-ui-link-action.tsx
import React72 from "react";
import { gql as gql58 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
var __fragment = gql58(_templateObject58());
var EGDSUILinkAction = function(param) {
    var data = param.data;
    var resource = data.resource, target = data.target, analytics = data.analytics, accessibility = data.accessibility, useRelativePath = data.useRelativePath;
    var navigationTarget = target === "INTERNAL" /* INTERNAL */  ? "_self" : "_blank";
    var clickTracker = useClickTracker13();
    var onClickCapture = React72.useCallback(function() {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        analytics,
        clickTracker
    ]);
    var path = React72.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React72.createElement("a", {
        href: path,
        target: navigationTarget,
        rel: "noopener noreferrer",
        onClickCapture: onClickCapture,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
    }, accessibility);
};
EGDSUILinkAction.fragment = __fragment;
EGDSUILinkAction.displayName = "EGDSUILinkAction";
// src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
var fragment51 = gql59(_templateObject59(), Icon.fragment, UiGraphic.fragment, EGDSStandardLink.fragment, LodgingEGDSButton.fragment, clientSideAnalyticsFragment, EGDSLocalThemeProvider.fragment);
var EGDSStandardMessagingCard = function(param) {
    var data = param.data, dataStid = param.dataStid, markSize = param.markSize, className = param.className, actionProps = param.actionProps, _param_showBorder = param.showBorder, showBorder = _param_showBorder === void 0 ? true : _param_showBorder, onDismiss = param.onDismiss, _param_markNoInlineStart = param.markNoInlineStart, markNoInlineStart = _param_markNoInlineStart === void 0 ? false : _param_markNoInlineStart;
    var message = data.message, _data_background = data.background, background = _data_background === void 0 ? EGDSCardBackgroundThemes.PRIMARY : _data_background, links = data.links, graphic = data.graphic, heading = data.heading, rightIcon = data.rightIcon, buttons = data.buttons, themes = data.themes, themeProvider = data.themeProvider, impressionTracking = data.impressionTracking, dismiss = data.dismiss;
    var hasMultipleButtons = buttons && buttons.length > 1;
    var cardPadding = background === EGDSCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD ? {
        inline: hasMultipleButtons ? "half" : "three",
        block: "three"
    } : {
        inline: "one",
        block: "one"
    };
    var isBgColored = background !== null && background !== EGDSCardBackgroundThemes.PRIMARY && background !== EGDSCardBackgroundThemes.SECONDARY;
    var isIconSpotlighted = (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphic.spotLight;
    var isBordered = (themes === null || themes === void 0 ? void 0 : themes.includes("BORDERED" /* BORDERED */ )) || showBorder;
    var isPadding = themes ? themes.includes("PADDED" /* PADDED */ ) : true;
    var cardPaddingTheme = isPadding ? cardPadding : {};
    var clickTracker = useClickTracker14();
    var handleDismiss = function() {
        if (dismiss === null || dismiss === void 0 ? void 0 : dismiss.analytics) {
            var _dismiss_analytics, _dismiss_analytics1;
            var _dismiss_analytics_referrerId, _dismiss_analytics_linkName;
            clickTracker((_dismiss_analytics_referrerId = (_dismiss_analytics = dismiss.analytics) === null || _dismiss_analytics === void 0 ? void 0 : _dismiss_analytics.referrerId) !== null && _dismiss_analytics_referrerId !== void 0 ? _dismiss_analytics_referrerId : "", (_dismiss_analytics_linkName = (_dismiss_analytics1 = dismiss.analytics) === null || _dismiss_analytics1 === void 0 ? void 0 : _dismiss_analytics1.linkName) !== null && _dismiss_analytics_linkName !== void 0 ? _dismiss_analytics_linkName : "");
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    var egdsLinksMemo = React73.useMemo(function() {
        return /* @__PURE__ */ React73.createElement(EGDSSpacing10, null, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex10, null, links === null || links === void 0 ? void 0 : links.map(function(linkData, linkIndex) {
            return /* @__PURE__ */ React73.createElement(EGDSSpacing10, {
                margin: {
                    inlinestart: linkIndex === 0 ? "unset" : "two"
                },
                key: linkIndex
            }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(EGDSStandardLink, {
                data: linkData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(linkData.__typename) : void 0,
                theme: isBgColored ? "inverse" : "default"
            }))));
        })));
    }, [
        links,
        isBgColored
    ]);
    var egdsButtonsMemo = React73.useMemo(function() {
        return /* @__PURE__ */ React73.createElement(EGDSSpacing10, null, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex10, null, buttons === null || buttons === void 0 ? void 0 : buttons.map(function(buttonData, buttonIndex) {
            return /* @__PURE__ */ React73.createElement(EGDSSpacing10, {
                margin: {
                    inlinestart: buttonIndex === 0 ? "unset" : "two"
                },
                key: buttonIndex
            }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement(LodgingEGDSButton, {
                data: buttonData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(buttonData.__typename) : void 0,
                size: EGDSButtonSize2.SMALL,
                inverse: isBgColored && buttonData.__typename === "UITertiaryButton"
            })));
        })));
    }, [
        buttons,
        isBgColored
    ]);
    var graphicComponent = graphic && /* @__PURE__ */ React73.createElement(EGDSSpacing10, {
        margin: markNoInlineStart && graphic.__typename === "Mark" ? {
            inlineend: "three"
        } : {
            small: hasMultipleButtons ? {
                inlinestart: "one",
                inlineend: "four"
            } : {
                inline: "three"
            },
            medium: hasMultipleButtons ? {
                inlinestart: "half",
                inlineend: isBgColored || isIconSpotlighted ? "four" : "three"
            } : {
                inline: isBgColored || isIconSpotlighted ? "four" : "three"
            }
        }
    }, /* @__PURE__ */ React73.createElement(UiGraphic, {
        data: graphic,
        markSize: markSize
    }));
    var messageOrHeader = React73.useMemo(function() {
        if (!message) {
            return null;
        }
        if (heading) {
            return /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement(EGDSSpacing10, {
                margin: {
                    blockstart: "".concat(heading ? "half" : "unset")
                }
            }, /* @__PURE__ */ React73.createElement(EGDSText9, {
                theme: isBgColored ? "inverse" : "default"
            }, message)));
        }
        return /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement(EGDSHeading4, {
            className: isBgColored ? "uitk-text-inverse-theme" : ""
        }, message));
    }, [
        message,
        heading,
        isBgColored
    ]);
    var EgdsStandardMessagingCard = /* @__PURE__ */ React73.createElement(EGDSCard, {
        className: className,
        border: isBordered,
        padded: true,
        backgroundTheme: background
    }, /* @__PURE__ */ React73.createElement(EGDSCardContentSection, {
        "data-stid": dataStid
    }, /* @__PURE__ */ React73.createElement(EGDSSpacing10, {
        padding: cardPaddingTheme
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex10, {
        alignItems: "center"
    }, graphicComponent, /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, {
        grow: 1
    }, /* @__PURE__ */ React73.createElement(EGDSCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex10, {
        direction: "row",
        alignItems: "center",
        justifyContent: dismiss ? void 0 : "space-between",
        space: dismiss ? void 0 : "two",
        wrap: rightIcon ? "nowrap" : "wrap"
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, {
        grow: 1,
        minWidth: "88x"
    }, /* @__PURE__ */ React73.createElement(EGDSSpacing10, {
        margin: {
            inlinestart: isIconSpotlighted ? "two" : void 0
        }
    }, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex10, {
        direction: "column"
    }, heading && /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement(EGDSHeading4, {
        className: isBgColored ? "uitk-text-inverse-theme" : ""
    }, heading)), messageOrHeader))), /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement(EGDSLayoutFlex10, {
        alignItems: "center",
        space: "four",
        justifyContent: "end"
    }, buttons && buttons.length > 0 && /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, egdsButtonsMemo), links && links.length > 0 && /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, egdsLinksMemo))), rightIcon && /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(Icon, {
        data: rightIcon
    }))), (dismiss === null || dismiss === void 0 ? void 0 : dismiss.label) && /* @__PURE__ */ React73.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(EGDSTertiaryButton2, {
        type: "button",
        size: EGDSButtonSize2.MEDIUM,
        onClick: handleDismiss
    }, dismiss.label)))))))), actionProps && /* @__PURE__ */ React73.createElement(EGDSCardLink3, null, /* @__PURE__ */ React73.createElement(EGDSUILinkAction, {
        data: actionProps
    }))));
    var card = themeProvider ? /* @__PURE__ */ React73.createElement(EGDSLocalThemeProvider, {
        data: themeProvider
    }, EgdsStandardMessagingCard) : EgdsStandardMessagingCard;
    if (impressionTracking) {
        var referrerId = impressionTracking.referrerId, linkName = impressionTracking.linkName;
        return /* @__PURE__ */ React73.createElement(IntersectionTracker3, {
            referrerId: referrerId,
            linkName: linkName,
            intersectionOptions: {
                threshold: 0.5
            }
        }, card);
    }
    return /* @__PURE__ */ React73.createElement(React73.Fragment, null, card);
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment51;
// src/components/lodging-card/__private/lodging-card-heading-section.tsx
import React76 from "react";
import { gql as gql62 } from "@apollo/client";
import { EGDSIcon as EGDSIcon11, EGDSIconSize as EGDSIconSize11 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition4 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText12 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar2, EGDSToolbarButton } from "@egds/react-core/toolbar";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { useHeadingLevelContext } from "@shared-ui/heading-level-context";
import { ProductType as ProductType5, useProductType as useProductType4 } from "@shared-ui/retail-product-type-providers";
// src/components/lodging-card/__private/lodging-card-featured-message.tsx
import React74 from "react";
import { gql as gql60 } from "@apollo/client";
import { EGDSIcon as EGDSIcon10, EGDSIconSize as EGDSIconSize10 } from "@egds/react-core/icons";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
var fragment52 = gql60(_templateObject60());
var LodgingCardFeaturedMessage = function(param) {
    var data = param.data, index = param.index, size = param.size;
    var icon = data.icon, text = data.text;
    return /* @__PURE__ */ React74.createElement(React74.Fragment, null, index > 0 && /* @__PURE__ */ React74.createElement(EGDSText10, {
        "aria-hidden": "true",
        weight: "bold",
        size: size !== null && size !== void 0 ? size : 300
    }, "\xB7"), icon && /* @__PURE__ */ React74.createElement(EGDSIcon10, {
        name: icon.id || "visibility",
        description: icon.description || "",
        size: icon.size ? EGDSIconSize10[icon.size] : EGDSIconSize10.SMALL,
        "data-stid": "uitk-icon"
    }), /* @__PURE__ */ React74.createElement(EGDSText10, {
        size: size
    }, text));
};
LodgingCardFeaturedMessage.fragment = fragment52;
LodgingCardFeaturedMessage.displayName = "LodgingCardFeaturedMessage";
// src/components/lodging-card/__private/lodging-product-amenity.tsx
import React75 from "react";
import { gql as gql61 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex11 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
var fragment53 = gql61(_templateObject61(), LodgingEGDSIcon.fragment);
var LodgingProductAmenity = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React75.createElement(EGDSSpacing11, {
        padding: {
            inlineend: "three",
            block: "one"
        }
    }, /* @__PURE__ */ React75.createElement(EGDSLayoutFlex11, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React75.createElement(LodgingEGDSIcon, {
        ariaHidden: true,
        data: data.icon
    }), /* @__PURE__ */ React75.createElement(EGDSText11, {
        size: 200,
        overflow: "truncate-2-lines"
    }, data.text)));
};
LodgingProductAmenity.fragment = fragment53;
LodgingProductAmenity.displayName = "LodgingProductAmenity";
// src/components/lodging-card/__private/lodging-card-heading-section.tsx
var fragment54 = gql62(_templateObject62(), LodgingEGDSRating.fragment, LodgingCardFeaturedMessage.fragment, LodgingEGDSText.fragment, LodgingProductAmenity.fragment, LodgingBadge.fragment);
var LodgingCardHeadingSection = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? {} : _param_size, headingOverflowProp = param.headingOverflow, showDismissButton = param.showDismissButton, // TODO: To remove this property when the test is a winner; and depend on the server response for the Icon
    onCardDismiss = param.onCardDismiss, isReview = param.isReview, isOptimizedView = param.isOptimizedView;
    var _context_device;
    var heading = data.heading, productRating = data.productRating, featuredMessages = data.featuredMessages, messages = data.messages, amenities = data.amenities, missingFilters = data.missingFilters, standardBadges = data.standardBadges;
    var headingLevel = useHeadingLevelContext(1).headingLevel;
    var productType = useProductType4();
    var dismissButtonProps = {
        id: "close",
        name: "close",
        size: EGDSIconSize11.MEDIUM,
        title: "close"
    };
    var _useExperiment3 = useExperiment3("Multi_image_SRP_cards_mWeb"), multiImageExposure = _useExperiment3.exposure;
    var _useExperiment31 = useExperiment3("Multi_image_SRP_cards"), multiImageNativeExposure = _useExperiment31.exposure;
    var _useExperiment32 = useExperiment3("Multi_image_SRP_cards_mWeb_vrbo"), _useExperiment3_exposure = _useExperiment32.exposure, multiImagesSrpCardsVrboBucket = _useExperiment3_exposure.bucket;
    var _useExperiment33 = useExperiment3("Enabling_multi_image_on_Cruise_mweb"), _useExperiment3_exposure1 = _useExperiment33.exposure, multiImagesCruiseMwebBucket = _useExperiment3_exposure1.bucket;
    var subHeadingSize = size.subHeading, headingSizeProp = size.heading;
    var context = useBexApi3().context;
    var deviceType = context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type;
    var isMobile = deviceType === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var isMultiImageEnabled = productType === ProductType5.Lodging && (multiImageExposure.bucket === 1 || multiImageNativeExposure.bucket === 1 || multiImagesSrpCardsVrboBucket === 1) || productType === ProductType5.Cruise && multiImagesCruiseMwebBucket === 1;
    var headingOverflow = React76.useMemo(function() {
        if (headingOverflowProp) {
            return headingOverflowProp;
        }
        if (isMobile) {
            return "truncate-2-lines";
        }
        return "wrap";
    }, [
        headingOverflowProp,
        isMobile
    ]);
    var headingSize = React76.useMemo(function() {
        if (headingSizeProp) {
            return headingSizeProp;
        }
        if (isMultiImageEnabled && isMobile) {
            return 6;
        }
        return 5;
    }, [
        isMobile,
        headingSizeProp,
        isMultiImageEnabled
    ]);
    return /* @__PURE__ */ React76.createElement(React76.Fragment, null, /* @__PURE__ */ React76.createElement(EGDSLayoutFlex12, {
        justifyContent: "space-between",
        space: "two"
    }, /* @__PURE__ */ React76.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React76.createElement(EGDSLayoutGrid2, {
        rows: [
            "min-content"
        ]
    }, /* @__PURE__ */ React76.createElement(EGDSLayoutGridItem2, {
        rowSpan: 1
    }, featuredMessages.length > 0 && /* @__PURE__ */ React76.createElement(EGDSLayoutFlex12, {
        space: "one",
        alignItems: "center"
    }, featuredMessages.map(function(featuredMessage, index) {
        return /* @__PURE__ */ React76.createElement(LodgingCardFeaturedMessage, {
            data: featuredMessage,
            key: "featuredMessage-".concat(index),
            index: index,
            size: subHeadingSize !== null && subHeadingSize !== void 0 ? subHeadingSize : 300
        });
    }))), /* @__PURE__ */ React76.createElement(EGDSLayoutGridItem2, {
        rowSpan: 1
    }, /* @__PURE__ */ React76.createElement(EGDSHeading5, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: headingSize,
        overflow: headingOverflow
    }, heading)))), /* @__PURE__ */ React76.createElement(EGDSLayoutFlexItem8, null, showDismissButton && onCardDismiss && /* @__PURE__ */ React76.createElement(EGDSText12, null, /* @__PURE__ */ React76.createElement(EGDSLayoutPosition4, {
        type: "absolute",
        position: {
            right: "minus-two",
            top: "zero"
        }
    }, /* @__PURE__ */ React76.createElement(EGDSToolbar2, {
        elevation: "flat",
        toolbarActionContent: /* @__PURE__ */ React76.createElement(EGDSToolbarButton, {
            buttonId: "close-map-card",
            onClick: onCardDismiss
        }, /* @__PURE__ */ React76.createElement(EGDSIcon11, _object_spread({}, dismissButtonProps)))
    }))))), productRating && /* @__PURE__ */ React76.createElement(LodgingEGDSRating, {
        data: productRating
    }), !isReview && (messages === null || messages === void 0 ? void 0 : messages.map(function(message, messageIndex) {
        if (message.__typename === "EGDSGraphicText" && message.graphic.__typename === "Icon") {
            return /* @__PURE__ */ React76.createElement(EGDSSpacing12, {
                key: "message-".concat(messageIndex),
                margin: {
                    blockstart: "two",
                    small: {
                        blockend: "two"
                    },
                    medium: {
                        blockend: "unset"
                    }
                }
            }, /* @__PURE__ */ React76.createElement(LodgingEGDSGraphicText, {
                data: message,
                flexLayout: true,
                flexSpacing: "one",
                textProps: {
                    spacing: "half"
                }
            }));
        }
        return /* @__PURE__ */ React76.createElement(LodgingEGDSText, {
            overflow: "truncate-2-lines",
            key: "message-".concat(messageIndex),
            spacing: isOptimizedView ? void 0 : "half",
            size: subHeadingSize !== null && subHeadingSize !== void 0 ? subHeadingSize : 300,
            data: message
        });
    })), standardBadges === null || standardBadges === void 0 ? void 0 : standardBadges.map(function(standardBadge, i) {
        return /* @__PURE__ */ React76.createElement(EGDSLayoutFlexItem8, {
            grow: 1,
            alignSelf: "start",
            key: "standardBadge-".concat(i)
        }, /* @__PURE__ */ React76.createElement(LodgingBadge, {
            data: standardBadge
        }));
    }), amenities.length > 0 && /* @__PURE__ */ React76.createElement(EGDSSpacing12, {
        margin: {
            blockstart: isOptimizedView ? "half" : "one"
        }
    }, /* @__PURE__ */ React76.createElement(EGDSLayoutFlex12, {
        wrap: "wrap"
    }, amenities.map(function(amenity, i) {
        return /* @__PURE__ */ React76.createElement(EGDSLayoutFlexItem8, {
            key: "amenity-".concat(i)
        }, /* @__PURE__ */ React76.createElement(LodgingProductAmenity, {
            data: amenity
        }));
    }))), missingFilters && /* @__PURE__ */ React76.createElement(EGDSSpacing12, {
        margin: {
            small: {
                block: "two"
            },
            medium: {
                blockstart: "two"
            }
        }
    }, /* @__PURE__ */ React76.createElement("div", null, /* @__PURE__ */ React76.createElement(LodgingEGDSText, {
        data: missingFilters
    }))));
};
LodgingCardHeadingSection.fragment = fragment54;
LodgingCardHeadingSection.displayName = "LodgingCardHeadingSection";
// src/components/lodging-carousel-container/lodging-carousel-container.tsx
import React114 from "react";
import { gql as gql89 } from "@apollo/client";
import { EGDSPageLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6 } from "@egds/react-core/text";
import { EGDSToast } from "@egds/react-core/toast";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
// src/utils/lodging-carousel-clickstream-util.ts
var decorateWithApplicationProvidedData = function(eventData, clickstreamConfig) {
    return _object_spread_props(_object_spread({}, eventData), {
        experience: {
            page_name: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.PAGE_NAME
        }
    });
};
function createPropertyCarouselPresentedEvent(clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "property_carousel.presented",
            event_type: "Impression",
            event_category: "property_carousel",
            event_version: "1.2.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        },
        product_list: []
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createPropertyCarouselNavSelectedEvent(clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "property_carousel_nav.selected",
            event_type: "Interaction",
            event_category: "property_carousel",
            event_version: "1.2.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        },
        product_list: []
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createPropertyCarouselCardSelectedEvent(item, clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "property_carousel_card.selected",
            event_type: "Interaction",
            event_category: "property_carousel",
            event_version: "1.2.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        },
        product_list: [
            {
                product_id: item.id
            }
        ]
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createRecommendationCarouselCardSelectedEvent(item, position, egrecsResponseId, clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "recommendations_module.selected",
            event_type: "Interaction",
            event_category: "recommendation_module",
            event_version: "1.2.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        },
        recommendation_module: {
            eg_recommendation_response_id: egrecsResponseId,
            recommendations: [
                {
                    recommendation_id: item.id,
                    recommendation_position: position.toString()
                }
            ]
        }
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createRecommendationCarouselPresentedEvent(items, egrecsResponseId, index, clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "recommendations_module.presented",
            event_type: "Impression",
            event_category: "recommendation_module",
            event_version: "1.2.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        },
        recommendation_module: {
            eg_recommendation_response_id: egrecsResponseId,
            recommendations: items.map(function(item) {
                return {
                    recommendation_id: item.id,
                    recommendation_position: index.toString()
                };
            })
        }
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createRecommendationCarouselNavSelectedEvent(clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "recommendations_module_nav.selected",
            event_type: "Interaction",
            event_category: "property_carousel",
            event_version: "1.0.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        }
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createReviewCarouselPresentedEvent(clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "top_rated_module.presented",
            event_type: "Impression",
            event_version: "1.0.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        }
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createReviewCarouselCardSelectedEvent(clickstreamConfig) {
    var eventData = {
        event: {
            event_name: "top_rated_card.selected",
            event_type: "Interaction",
            event_version: "1.0.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        }
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
function createReviewNavSelectedEvent(clickstreamConfig, direction) {
    var eventData = {
        event: {
            event_name: "top_rated_nav.selected",
            event_type: "Interaction",
            event_version: "1.0.0",
            action_location: clickstreamConfig === null || clickstreamConfig === void 0 ? void 0 : clickstreamConfig.ACTION_LOCATION
        },
        additional_context: {
            user_interface: {
                scroll_direction: direction
            }
        }
    };
    return decorateWithApplicationProvidedData(eventData, clickstreamConfig);
}
// src/components/common/carousel/carousel.tsx
import React77 from "react";
import { gql as gql63 } from "@apollo/client";
import { EGDSCarousel } from "@egds/react-core/carousel";
var fragment55 = gql63(_templateObject63(), clientSideAnalyticsFragment);
var Carousel = function(_param) {
    var children = _param.children, _param_peek = _param.peek, peek = _param_peek === void 0 ? true : _param_peek, _param_pageBy = _param.pageBy, pageBy = _param_pageBy === void 0 ? 1 : _param_pageBy, _param_itemsVisible = _param.itemsVisible, itemsVisible = _param_itemsVisible === void 0 ? {
        lg: 3,
        md: 2,
        sm: 1
    } : _param_itemsVisible, nextButtonText = _param.nextButtonText, prevButtonText = _param.prevButtonText, _param_useContainerSizing = _param.useContainerSizing, useContainerSizing = _param_useContainerSizing === void 0 ? true : _param_useContainerSizing, props = _object_without_properties(_param, [
        "children",
        "peek",
        "pageBy",
        "itemsVisible",
        "nextButtonText",
        "prevButtonText",
        "useContainerSizing"
    ]);
    var carouselProps = _object_spread({
        buttonText: {
            nextButton: nextButtonText || "",
            prevButton: prevButtonText || ""
        },
        wrapItems: true,
        itemsMaxHeight: true,
        itemsVisible: itemsVisible,
        pageBy: pageBy,
        peek: peek,
        itemsGap: {
            sm: 12,
            md: 12,
            lg: 12
        },
        useContainerSizing: useContainerSizing
    }, props);
    return /* @__PURE__ */ React77.createElement(EGDSCarousel, _object_spread({}, carouselProps), children);
};
Carousel.displayName = "Carousel";
// src/components/lodging-card/lodging-card.tsx
import React113, { useEffect as useEffect4 } from "react";
import { gql as gql88 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker7 } from "@shared-ui/clickstream-analytics-context";
import { ShoppingActionProvider } from "@shared-ui/retail-shopping-tools-action-providers";
import { useMesoBeaconFrameworkWrapper } from "@shared-ui/retail-sponsored-content-use-beacons-wrapper";
import { useMesoViewabilityWrapper } from "@shared-ui/sponsored-content-meso-viewability-wrapper";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium8, Viewport as Viewport8, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
// src/components/product-card/product-card-footer-section-content.tsx
import React79 from "react";
import { gql as gql65 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex13 } from "@egds/react-core/layout-flex";
// src/components/shopping-link/shopping-link.tsx
import React78 from "react";
import { gql as gql64 } from "@apollo/client";
import { UitkIcon } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
import { ShoppingOverlayMapper, useShoppingActionCallback } from "@shared-ui/retail-shopping-tools-action-providers";
var fragment56 = gql64(_templateObject64());
var ShoppingLink = function(param) {
    var data = param.data, _param_inline = param.inline, inline = _param_inline === void 0 ? true : _param_inline, overlayContent = param.overlayContent, title = param.title, subtitle = param.subtitle, className = param.className, useShoppingActionPackage = param.useShoppingActionPackage, useToolbar = param.useToolbar, _param_align = param.align, align = _param_align === void 0 ? "left" : _param_align;
    var actionId = data.actionId, text = data.text, trailingIcon = data.trailingIcon;
    var productCardActionCallback = useProductCardActionCallback(actionId);
    var shoppingActionCallback = useShoppingActionPackage ? useShoppingActionCallback(actionId) : void 0;
    var triggerRef = React78.useRef(null);
    var sheetToolbar = title ? {
        title: title,
        subtitle: subtitle || null
    } : void 0;
    return /* @__PURE__ */ React78.createElement(React78.Fragment, null, !useShoppingActionPackage && /* @__PURE__ */ React78.createElement(ProductCardActionWrapper, {
        actionId: actionId,
        ref: triggerRef,
        triggerComponent: /* @__PURE__ */ React78.createElement(EGDSLink5, {
            inline: inline,
            align: align
        }, /* @__PURE__ */ React78.createElement("button", {
            type: "button",
            onClick: productCardActionCallback,
            role: "link",
            ref: triggerRef
        }, text, trailingIcon && /* @__PURE__ */ React78.createElement(UitkIcon, {
            name: trailingIcon.id
        })))
    }), useShoppingActionPackage && /* @__PURE__ */ React78.createElement(React78.Fragment, null, /* @__PURE__ */ React78.createElement(EGDSLink5, {
        inline: inline,
        className: className,
        align: align
    }, /* @__PURE__ */ React78.createElement("button", {
        type: "button",
        onClick: shoppingActionCallback,
        role: "link",
        ref: triggerRef
    }, text, trailingIcon && /* @__PURE__ */ React78.createElement(UitkIcon, {
        name: trailingIcon.id
    }))), /* @__PURE__ */ React78.createElement(ShoppingOverlayMapper, {
        actionId: actionId,
        ref: triggerRef,
        sheetToolbar: sheetToolbar,
        useToolbar: useToolbar
    }, overlayContent)));
};
ShoppingLink.fragment = fragment56;
ShoppingLink.displayName = "ShoppingLink";
// src/components/product-card/product-card-footer-section-content.tsx
var fragment57 = gql65(_templateObject65(), EGDSStylizedText.fragment, ShoppingLink.fragment);
var ProductCardFooterSectionContent = function(param) {
    var data = param.data, gridIndex = param.gridIndex, footerSectionContentsLength = param.footerSectionContentsLength;
    if (!data.items) {
        return null;
    }
    var isLeft = gridIndex === 0 && footerSectionContentsLength > 1;
    var justify = isLeft ? "start" : "end";
    var align = isLeft ? "left" : "right";
    return /* @__PURE__ */ React79.createElement(React79.Fragment, null, data.items.map(function(item, i) {
        return /* @__PURE__ */ React79.createElement(EGDSLayoutFlex13, {
            justifyContent: justify,
            key: "product-card-section-content-".concat(i)
        }, item.__typename === "EGDSStylizedText" && /* @__PURE__ */ React79.createElement(EGDSStylizedText, {
            data: item,
            align: align
        }), item.__typename === "ShoppingLink" && /* @__PURE__ */ React79.createElement(ShoppingLink, {
            data: item,
            align: "right",
            inline: false
        }));
    }));
};
ProductCardFooterSectionContent.fragment = fragment57;
ProductCardFooterSectionContent.displayName = "ProductCardFooterSectionContent";
// src/components/lodging-card/__private/lodging-card-content-section.tsx
import React101 from "react";
import { gql as gql85 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex20, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition7 } from "@egds/react-core/layout-position";
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign4 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing19, EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
import { HeadingLevelProvider } from "@shared-ui/heading-level-context";
// src/components/lodging-standard-badge/lodging-standard-badge.tsx
import React80 from "react";
import { gql as gql66 } from "@apollo/client";
import { EGDSBadge as EGDSBadge2, EGDSBadgeLoyalty as EGDSBadgeLoyalty2 } from "@egds/react-core/badge";
import { EGDSIcon as EGDSIcon12, EGDSIconSize as EGDSIconSize12 } from "@egds/react-core/icons";
import { UitkLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark4, EGDSMarkSize as EGDSMarkSize3 } from "@egds/react-core/mark";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
var fragment58 = gql66(_templateObject66());
var LodgingStandardBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, data = param.data, align = param.align;
    if (!data || !data.standardBadge || !data.standardBadge.text && !data.standardBadge.graphic) {
        return null;
    }
    var standardBadge = data.standardBadge, impressionEventAnalytics = data.impressionEventAnalytics;
    var text = standardBadge.text, theme = standardBadge.theme, graphic = standardBadge.graphic, size = standardBadge.size, impressionAnalytics = standardBadge.impressionAnalytics;
    var _ref = impressionEventAnalytics !== null && impressionEventAnalytics !== void 0 ? impressionEventAnalytics : {}, eventReferrerId = _ref.referrerId, eventLinkName = _ref.linkName;
    var _ref1 = impressionAnalytics !== null && impressionAnalytics !== void 0 ? impressionAnalytics : {}, metaImpressionReferrerId = _ref1.referrerId, metaImpressionLinkName = _ref1.linkName;
    var graphics = function() {
        switch(graphic === null || graphic === void 0 ? void 0 : graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React80.createElement(EGDSIcon12, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    size: EGDSIconSize12.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React80.createElement(EGDSMark4, {
                    name: graphic.id,
                    description: graphic.description,
                    size: EGDSMarkSize3.SMALL
                });
            default:
                return null;
        }
    };
    var badgeLoyalty = /* @__PURE__ */ React80.createElement(EGDSBadgeLoyalty2, {
        className: className,
        text: text || void 0,
        theme: theme ? EGDSBadgeLoyaltyThemeMapper[theme] : void 0,
        size: size ? EGDSBadgeSizeMapper[size] : void 0
    }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphics());
    var lodgingBadge = eventReferrerId && eventLinkName ? /* @__PURE__ */ React80.createElement(IntersectionTracker4, {
        referrerId: eventReferrerId,
        linkName: eventLinkName,
        trackOnce: true
    }, badgeLoyalty) : badgeLoyalty;
    var lodgingBadgeWithMetaImpressions = metaImpressionReferrerId && metaImpressionLinkName ? /* @__PURE__ */ React80.createElement(IntersectionTracker4, {
        referrerId: metaImpressionReferrerId,
        linkName: metaImpressionLinkName,
        trackOnce: true
    }, lodgingBadge) : lodgingBadge;
    var egdsBadge = // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ React80.createElement(EGDSBadge2, {
        className: className,
        text: text || void 0,
        theme: theme ? EGDSBadgeThemeMapper[theme] : void 0,
        size: size ? EGDSBadgeSizeMapper[size] : void 0
    }, graphics());
    var badge = metaImpressionReferrerId && metaImpressionLinkName ? /* @__PURE__ */ React80.createElement(IntersectionTracker4, {
        referrerId: metaImpressionReferrerId,
        linkName: metaImpressionLinkName,
        trackOnce: true
    }, /* @__PURE__ */ React80.createElement(UitkLayoutFlex, {
        justifyContent: align || "end"
    }, egdsBadge)) : egdsBadge;
    return theme && EGDSBadgeLoyaltyThemeMapper[theme] ? lodgingBadgeWithMetaImpressions : badge;
};
LodgingStandardBadge.fragment = fragment58;
LodgingStandardBadge.displayName = "LodgingStandardBadge";
// src/components/lodging-card/__private/lodging-card-compare-section.tsx
import React81, { useCallback as useCallback4 } from "react";
import { gql as gql67 } from "@apollo/client";
import { EGDSCheckbox } from "@egds/react-core/checkbox";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition5 } from "@egds/react-core/layout-position";
import { useLodgingCompare as useLodgingCompare3 } from "@shared-ui/retail-compare-providers";
var fragment59 = gql67(_templateObject67(), clientSideAnalyticsFragment);
var LodgingCardCompareSection = function(param) {
    var propertyId = param.propertyId, isAd2 = param.isAd, data = param.data, isOneColumnLayout = param.isOneColumnLayout;
    var compareAction = data.compareAction;
    var _useLodgingCompare3 = _sliced_to_array(useLodgingCompare3(), 2), _useLodgingCompare3_ = _useLodgingCompare3[0], comparePropertyIds = _useLodgingCompare3_.comparePropertyIds, enabled = _useLodgingCompare3_.enabled, maxSelectable = _useLodgingCompare3_.maxSelectable, _useLodgingCompare3_1 = _useLodgingCompare3[1], removeCompareProperty = _useLodgingCompare3_1.removeCompareProperty, addCompareProperty = _useLodgingCompare3_1.addCompareProperty;
    var cardId = isAd2 ? propertyId.concat("-ad") : propertyId;
    var checked = comparePropertyIds.includes(cardId);
    var uniquePropertyIds = _to_consumable_array(new Set(comparePropertyIds.map(function(id2) {
        return id2.split("-")[0];
    })));
    var disabled = uniquePropertyIds.length >= maxSelectable && !checked;
    var checkboxClickTrack = useTrackClientSideAnalytics(checked ? data.compareAction.uncheckedAnalytics : data.compareAction.checkedAnalytics);
    var setCheck = useCallback4(function() {
        checkboxClickTrack();
        if (checked) {
            removeCompareProperty(cardId);
        } else {
            addCompareProperty(cardId);
        }
    }, [
        checked
    ]);
    var id = "lodging-card-compare-checkbox-".concat(propertyId);
    if (!enabled) {
        return null;
    }
    return /* @__PURE__ */ React81.createElement(EGDSLayoutPosition5, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React81.createElement(EGDSLayoutFlexItem10, {
        alignSelf: isOneColumnLayout ? "start" : "end"
    }, /* @__PURE__ */ React81.createElement("div", null, /* @__PURE__ */ React81.createElement(EGDSCheckbox, {
        id: isAd2 ? id.concat("-ad") : id,
        checked: checked,
        onChange: setCheck,
        disabled: disabled,
        a11yLabel: compareAction.label.text
    }, /* @__PURE__ */ React81.createElement(EGDSLayoutPosition5, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            bottom: "zero",
            right: "minus-two"
        }
    }, /* @__PURE__ */ React81.createElement("div", null)), compareAction.label.text))));
};
LodgingCardCompareSection.fragment = fragment59;
LodgingCardCompareSection.displayName = "LodgingCardCompareSection";
var useNotInMap = function() {
    return useProductCardPlacement() !== "Map";
};
var LodgingCardCompareSectionGated = gate({
    predicate: useNotInMap
})(LodgingCardCompareSection, {
    fragment: fragment59
});
// src/components/lodging-card/__private/lodging-card-date-section.tsx
import React82 from "react";
import { gql as gql68 } from "@apollo/client";
var fragment60 = gql68(_templateObject68(), EGDSStylizedText.fragment);
var LodgingCardDateSection = function(param) {
    var data = param.data, _param_align = param.align, align = _param_align === void 0 ? "right" : _param_align;
    var date = data.date, messages = data.messages;
    if (messages) {
        return /* @__PURE__ */ React82.createElement(React82.Fragment, null, messages.map(function(message, index) {
            return /* @__PURE__ */ React82.createElement(LodgingEGDSText, {
                key: index,
                data: message,
                align: align
            });
        }));
    }
    if (date) {
        return /* @__PURE__ */ React82.createElement(LodgingEGDSText, {
            data: date,
            align: align
        });
    }
    return null;
};
LodgingCardDateSection.fragment = fragment60;
LodgingCardDateSection.displayName = "LodgingCardDateSection";
// src/components/lodging-card/__private/lodging-card-marketing-fee-detail.tsx
import React83 from "react";
import { gql as gql69 } from "@apollo/client";
import { EGDSDialog as EGDSDialog3, EGDSDialogContent as EGDSDialogContent3, EGDSDialogFooter as EGDSDialogFooter3 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon13, EGDSIconSize as EGDSIconSize13 } from "@egds/react-core/icons";
import { EGDSMark as EGDSMark5, EGDSMarkSize as EGDSMarkSize4 } from "@egds/react-core/mark";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
var fragment61 = gql69(_templateObject69());
var LodgingCardMarketingFeeDetail = function(param) {
    var id = param.id, data = param.data;
    var _marketingFeeMessageDialog_dialog_footer_buttons_;
    var tierMessage = data.tierMessage, marketingFeeMessageDialog = data.marketingFeeMessageDialog;
    var marketingFeeDialogId = id ? "priceMarketingFeeDialog-".concat(id) : "priceMarketingFeeDialog";
    var _useDialog4 = _sliced_to_array(useDialog4(marketingFeeDialogId, "pwaDialog"), 3), isDialogOpen = _useDialog4[0], dialogActions = _useDialog4[1], DialogComponent = _useDialog4[2];
    var track = useClickTracker15();
    var openDialog = function() {
        track("TAAP.MarketingFee.Details", "Open SRP Commission Information Dialog");
        dialogActions.openDialog();
    };
    if (!marketingFeeMessageDialog || !tierMessage) {
        return null;
    }
    return /* @__PURE__ */ React83.createElement(React83.Fragment, null, /* @__PURE__ */ React83.createElement(EGDSMoreInfoTrigger, {
        onClick: openDialog,
        "data-stid": "marketing-fee-info"
    }, /* @__PURE__ */ React83.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React83.createElement(EGDSSpacing13, {
        padding: {
            inlineend: "two"
        }
    }, tierMessage.egdsMark && /* @__PURE__ */ React83.createElement(EGDSMark5, {
        name: tierMessage.egdsMark.id,
        size: EGDSMarkSize4.SMALL
    })), /* @__PURE__ */ React83.createElement(EGDSText13, {
        overflow: "truncate",
        inline: true
    }, tierMessage.value), /* @__PURE__ */ React83.createElement(EGDSIcon13, {
        name: "info_outline",
        size: EGDSIconSize13.SMALL
    }))), /* @__PURE__ */ React83.createElement(EGDSSheetTransition5, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React83.createElement(DialogComponent, null, /* @__PURE__ */ React83.createElement(EGDSDialog3, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React83.createElement(EGDSDialogContent3, null, marketingFeeMessageDialog.content.map(function(content, index) {
        return /* @__PURE__ */ React83.createElement(EGDSText13, {
            key: "marketing-fee-message-".concat(index)
        }, content);
    }), /* @__PURE__ */ React83.createElement(EGDSDialogFooter3, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_marketingFeeMessageDialog_dialog_footer_buttons_ = marketingFeeMessageDialog.dialog.footer.buttons[0]) === null || _marketingFeeMessageDialog_dialog_footer_buttons_ === void 0 ? void 0 : _marketingFeeMessageDialog_dialog_footer_buttons_.primary) || "",
            type: "tertiary"
        }
    }))))));
};
LodgingCardMarketingFeeDetail.fragment = fragment61;
LodgingCardMarketingFeeDetail.displayName = "LodgingCardMarketingFeeDetail";
// src/components/lodging-card/__private/lodging-card-product-summary-section.tsx
import React99 from "react";
import { gql as gql84 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex19, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
import { useHeadingLevelContext as useHeadingLevelContext2 } from "@shared-ui/heading-level-context";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
// src/components/lodging-card/__private/lodging-card-badged-rating.tsx
import React85 from "react";
import { gql as gql71 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex14, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
// src/components/shopping-actionable-icon/shopping-actionable-icon.tsx
import React84 from "react";
import { gql as gql70 } from "@apollo/client";
import { EGDSIcon as EGDSIcon14, EGDSIconSize as EGDSIconSize14 } from "@egds/react-core/icons";
import { EGDSLayoutPosition as EGDSLayoutPosition6 } from "@egds/react-core/layout-position";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger2 } from "@egds/react-core/more-info-trigger";
var fragment62 = gql70(_templateObject70());
var ShoppingActionableIcon = function(param) {
    var className = param.className, _param_triggerButtonPosition = param.triggerButtonPosition, triggerButtonPosition = _param_triggerButtonPosition === void 0 ? "one" : _param_triggerButtonPosition, data = param.data;
    var actionId = data.actionId, icon = data.icon;
    var productCardActionCallback = useProductCardActionCallback(actionId);
    var triggerRef = React84.useRef(null);
    var _icon_theme;
    return /* @__PURE__ */ React84.createElement(ProductCardActionWrapper, {
        actionId: actionId,
        ref: triggerRef,
        triggerComponent: /* @__PURE__ */ React84.createElement(EGDSMoreInfoTrigger2, {
            onClick: productCardActionCallback,
            size: "small",
            align: "center"
        }, /* @__PURE__ */ React84.createElement(EGDSLayoutPosition6, {
            type: "relative",
            position: {
                top: triggerButtonPosition,
                left: triggerButtonPosition
            },
            cloneElement: true
        }, /* @__PURE__ */ React84.createElement("button", {
            type: "button",
            "data-stid": "shopping-actionable-icon",
            ref: triggerRef
        }, /* @__PURE__ */ React84.createElement(EGDSIcon14, {
            className: className,
            name: icon.id,
            size: icon.size ? EGDSIconSize14[icon.size] : void 0,
            theme: (_icon_theme = icon === null || icon === void 0 ? void 0 : icon.theme) !== null && _icon_theme !== void 0 ? _icon_theme : void 0
        }))))
    });
};
ShoppingActionableIcon.fragment = fragment62;
ShoppingActionableIcon.displayName = "ShoppingActionableIcon";
// src/components/lodging-card/__private/lodging-card-badged-rating.tsx
var fragment63 = gql71(_templateObject71(), SharedUIBadge.fragment, EGDSStylizedText.fragment, LodgingEGDSGraphicText.fragment, ShoppingActionableIcon.fragment);
var ReviewRating = function(param) {
    var part = param.part;
    var phraseParts = part.phraseParts;
    return /* @__PURE__ */ React85.createElement(EGDSLayoutFlex14, {
        alignItems: "center",
        space: "one"
    }, phraseParts.filter(function(element) {
        return element.__typename === "EGDSStylizedText" || element.__typename === "ShoppingActionableIcon";
    }).map(function(phrasePart, index) {
        return phrasePart.__typename === "EGDSStylizedText" ? /* @__PURE__ */ React85.createElement(LodgingEGDSText, {
            inline: true,
            key: "phrase-part-".concat(index),
            data: phrasePart,
            overflow: "truncate-2-lines"
        }) : /* @__PURE__ */ React85.createElement(ShoppingActionableIcon, {
            key: "phrase-part-".concat(index),
            data: phrasePart,
            triggerButtonPosition: "zero"
        });
    }));
};
var LodgingCardBadgedRating = function(param) {
    var data = param.data;
    var badge = data.badge, phrases = data.phrases;
    var _React85_useMemo = React85.useMemo(function() {
        if (phrases) {
            return phrases.reduce(function(acc, phrase) {
                var _phrase_parts, _phrase_parts_;
                if (((_phrase_parts = phrase.parts) === null || _phrase_parts === void 0 ? void 0 : _phrase_parts.length) && ((_phrase_parts_ = phrase.parts[0]) === null || _phrase_parts_ === void 0 ? void 0 : _phrase_parts_.__typename) === "EGDSGraphicText") {
                    var _phrase_parts1 = _sliced_to_array(phrase.parts, 1), topRatedPhrasePart = _phrase_parts1[0];
                    return _object_spread_props(_object_spread({}, acc), {
                        topRatedPhrase: topRatedPhrasePart
                    });
                }
                return _object_spread_props(_object_spread({}, acc), {
                    phrasesWithoutTopRated: _to_consumable_array(acc.phrasesWithoutTopRated).concat([
                        phrase
                    ])
                });
            }, {
                phrasesWithoutTopRated: [],
                topRatedPhrase: void 0
            });
        }
        return {
            phrasesWithoutTopRated: [],
            topRatedPhrase: void 0
        };
    }, [
        phrases
    ]), phrasesWithoutTopRated = _React85_useMemo.phrasesWithoutTopRated, topRatedPhrase = _React85_useMemo.topRatedPhrase;
    return /* @__PURE__ */ React85.createElement("div", null, /* @__PURE__ */ React85.createElement(EGDSLayoutFlex14, {
        alignItems: "center",
        space: "one"
    }, badge.text && badge.badgeTheme && /* @__PURE__ */ React85.createElement(EGDSLayoutFlex14, {
        alignItems: "center"
    }, /* @__PURE__ */ React85.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React85.createElement(SharedUIBadge, {
        data: badge
    }))), /* @__PURE__ */ React85.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React85.createElement(EGDSLayoutFlex14, {
        direction: "column"
    }, phrasesWithoutTopRated.map(function(part, index) {
        return /* @__PURE__ */ React85.createElement(EGDSLayoutFlexItem11, {
            key: "guest-rate-line-".concat(index)
        }, /* @__PURE__ */ React85.createElement(ReviewRating, {
            key: "guest-rate-".concat(index),
            part: part
        }));
    })))), topRatedPhrase ? /* @__PURE__ */ React85.createElement(EGDSSpacing14, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React85.createElement(LodgingEGDSGraphicText, {
        data: topRatedPhrase,
        flexLayout: true,
        flexSpacing: "one",
        textProps: {
            spacing: "half"
        }
    })) : null);
};
LodgingCardBadgedRating.fragment = fragment63;
LodgingCardBadgedRating.displayName = "LodgingCardGuestRatingSection";
// src/components/lodging-card/__private/lodging-card-change-unit-dialog-action.tsx
import React88 from "react";
import { gql as gql74 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent4 } from "@egds/react-core/dialog";
import { EGDSSheet as EGDSSheet3, EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { usePackageOperations as usePackageOperations2 } from "@shared-ui/multi-item-operations-providers";
// src/components/egds/egds-toolbar/egds-dialog-toolbar.tsx
import React86 from "react";
import { gql as gql72 } from "@apollo/client";
import { EGDSToolbar as EGDSToolbar3 } from "@egds/react-core/toolbar";
var fragment64 = gql72(_templateObject72());
var EGDSDialogToolbar = function(param) {
    var data = param.data, toolbarType = param.toolbarType, toolbarAction = param.toolbarAction;
    var _data_closeText;
    return /* @__PURE__ */ React86.createElement(EGDSToolbar3, {
        toolbarTitle: data.title,
        navigationContent: {
            onClick: toolbarAction,
            navType: toolbarType,
            navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
        }
    });
};
EGDSDialogToolbar.fragment = fragment64;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// src/components/lodging-card/__private/lodging-card-more-details-trigger.tsx
import React87 from "react";
import { gql as gql73 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton3 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
var fragment65 = gql73(_templateObject73(), LodgingEGDSIcon.fragment);
var LodgingCardMoreDetailsTrigger = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, accessibilityLabel = _param_data.accessibilityLabel, analytics = _param_data.analytics, icon = _param_data.icon, label = _param_data.label;
    var track = useClickTracker16();
    var onClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
        onClickAction();
    };
    return /* @__PURE__ */ React87.createElement(EGDSSecondaryButton3, {
        onClick: onClick,
        "aria-label": accessibilityLabel,
        domRef: triggerRef
    }, /* @__PURE__ */ React87.createElement(React87.Fragment, null, label, icon && /* @__PURE__ */ React87.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingCardMoreDetailsTrigger.fragment = fragment65;
LodgingCardMoreDetailsTrigger.displayName = "LodgingCardMoreDetailsTrigger";
// src/components/lodging-card/__private/lodging-card-change-unit-dialog-action.tsx
var fragment66 = gql74(_templateObject74(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsTrigger.fragment);
var LodgingCardChangeUnitDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var track = useClickTracker17();
    var triggerRef = React88.useRef(null);
    var _useDialog5 = _sliced_to_array(useDialog5("LodgingCardChangeUnitDialog"), 3), isDialogOpen = _useDialog5[0], lodgingCardChangeUnitDialogActions = _useDialog5[1], LodgingCardChangeUnitDialogComponent = _useDialog5[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardChangeUnitDialogActions.closeDialog();
    };
    var openDialogWithButton = function() {
        if (lodgingCardChangeUnitDialogActions) {
            lodgingCardChangeUnitDialogActions.openDialog();
        }
    };
    var state = usePackageOperations2().state;
    React88.useEffect(function() {
        if (state.selectPackage.status === "IN_PROGRESS") {
            lodgingCardChangeUnitDialogActions.closeDialog();
        }
    }, [
        state.selectPackage.status
    ]);
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement(LodgingCardMoreDetailsTrigger, {
        onClickAction: openDialogWithButton,
        data: trigger,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React88.createElement(EGDSSheetTransition6, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React88.createElement(LodgingCardChangeUnitDialogComponent, null, /* @__PURE__ */ React88.createElement(EGDSSheet3, {
        type: "full",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React88.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React88.createElement(EGDSDialogContent4, null, /* @__PURE__ */ React88.createElement(ChangeUnitContent, null))))));
};
LodgingCardChangeUnitDialogAction.fragment = fragment66;
LodgingCardChangeUnitDialogAction.displayName = "LodgingCardChangeUnitDialogAction";
// src/components/lodging-card/__private/lodging-card-change-unit-sheet-action.tsx
import React89 from "react";
import { gql as gql75 } from "@apollo/client";
import { EGDSSheet as EGDSSheet4, EGDSSheetContent as EGDSSheetContent6, EGDSSheetTransition as EGDSSheetTransition7 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar4 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { usePackageOperations as usePackageOperations3 } from "@shared-ui/multi-item-operations-providers";
import { ViewExtraLarge, ViewLarge as ViewLarge2, ViewMedium as ViewMedium3, Viewport as Viewport3 } from "@shared-ui/viewport-context";
var fragment67 = gql75(_templateObject75(), LodgingCardMoreDetailsTrigger.fragment);
var SheetContent = function() {
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React89.createElement(EGDSSheetContent6, {
        padded: false
    }, /* @__PURE__ */ React89.createElement(EGDSSpacing15, {
        padding: "three"
    }, /* @__PURE__ */ React89.createElement("div", null, /* @__PURE__ */ React89.createElement(ChangeUnitContent, null))));
};
var LodgingCardChangeUnitSheetAction = function(param) {
    var _param_data = param.data, sheet = _param_data.sheet, trigger = _param_data.trigger;
    var track = useClickTracker18();
    var _React89_useState = _sliced_to_array(React89.useState(false), 2), visible = _React89_useState[0], setVisible = _React89_useState[1];
    var toggleSideSheet = function() {
        setVisible(function(prevState) {
            return !prevState;
        });
    };
    var closeButtonAction = function() {
        var _sheet_closeAnalytics = sheet.closeAnalytics, referrerId = _sheet_closeAnalytics.referrerId, linkName = _sheet_closeAnalytics.linkName;
        track(referrerId, linkName);
        setVisible(false);
    };
    var state = usePackageOperations3().state;
    var moreDetailsRef = React89.useRef(null);
    React89.useEffect(function() {
        if (state.selectPackage.status === "SUCCESS" || state.selectPackage.status === "FAILURE") {
            setVisible(false);
        }
    }, [
        state.selectPackage.status
    ]);
    var commonEGDSSheetProps = {
        isVisible: visible,
        type: "side",
        triggerRef: moreDetailsRef
    };
    var renderToolbar = function() {
        var _sheet_closeText;
        return /* @__PURE__ */ React89.createElement(EGDSToolbar4, {
            navigationContent: {
                onClick: closeButtonAction,
                navIconLabel: (_sheet_closeText = sheet.closeText) !== null && _sheet_closeText !== void 0 ? _sheet_closeText : ""
            }
        });
    };
    return /* @__PURE__ */ React89.createElement(React89.Fragment, null, /* @__PURE__ */ React89.createElement(LodgingCardMoreDetailsTrigger, {
        onClickAction: toggleSideSheet,
        data: trigger,
        triggerRef: moreDetailsRef
    }), /* @__PURE__ */ React89.createElement(Viewport3, null, /* @__PURE__ */ React89.createElement(ViewMedium3, null, /* @__PURE__ */ React89.createElement(EGDSSheetTransition7, {
        isVisible: commonEGDSSheetProps.isVisible
    }, /* @__PURE__ */ React89.createElement(EGDSSheet4, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 6
        }
    }), renderToolbar(), /* @__PURE__ */ React89.createElement(SheetContent, null)))), /* @__PURE__ */ React89.createElement(ViewLarge2, null, /* @__PURE__ */ React89.createElement(EGDSSheetTransition7, {
        isVisible: commonEGDSSheetProps.isVisible
    }, /* @__PURE__ */ React89.createElement(EGDSSheet4, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 4
        }
    }), renderToolbar(), /* @__PURE__ */ React89.createElement(SheetContent, null)))), /* @__PURE__ */ React89.createElement(ViewExtraLarge, null, /* @__PURE__ */ React89.createElement(EGDSSheetTransition7, {
        isVisible: commonEGDSSheetProps.isVisible
    }, /* @__PURE__ */ React89.createElement(EGDSSheet4, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 4
        }
    }), renderToolbar(), /* @__PURE__ */ React89.createElement(SheetContent, null))))));
};
LodgingCardChangeUnitSheetAction.fragment = fragment67;
LodgingCardChangeUnitSheetAction.displayName = "LodgingCardChangeUnitSheetAction";
// src/components/lodging-card/__private/lodging-card-property-dialog-action.tsx
import React94 from "react";
import { gql as gql79 } from "@apollo/client";
// src/components/lodging-card/__private/lodging-card-property-details-dialog-action.tsx
import React91 from "react";
import { gql as gql77 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent5 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex15 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet5, EGDSSheetTransition as EGDSSheetTransition8 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
// src/components/lodging-card/__private/lodging-card-more-details-link-trigger.tsx
import React90 from "react";
import { gql as gql76 } from "@apollo/client";
import { EGDSLink as EGDSLink6 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
var fragment68 = gql76(_templateObject76(), LodgingEGDSIcon.fragment);
var LodgingCardMoreDetailsLinkTrigger = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, accessibilityLabel = _param_data.accessibilityLabel, analytics = _param_data.analytics, icon = _param_data.icon, label = _param_data.label;
    var track = useClickTracker19();
    var onClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
        onClickAction();
    };
    return /* @__PURE__ */ React90.createElement(EGDSLink6, {
        onClick: onClick,
        "aria-label": accessibilityLabel
    }, /* @__PURE__ */ React90.createElement("button", {
        type: "button",
        ref: triggerRef
    }, label, icon && /* @__PURE__ */ React90.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingCardMoreDetailsLinkTrigger.fragment = fragment68;
LodgingCardMoreDetailsLinkTrigger.displayName = "LodgingCardMoreDetailsLinkTrigger";
// src/components/lodging-card/__private/lodging-card-property-details-dialog-action.tsx
var fragment69 = gql77(_templateObject77(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsLinkTrigger.fragment);
var LodgingCardPropertyDetailsDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var PropertyDetailsContent = useLodgingCardContentContext().PropertyDetailsContent;
    var track = useClickTracker20();
    var triggerRef = React91.useRef(null);
    var _useDialog6 = _sliced_to_array(useDialog6("LodgingCardPropertyDetailsDialog"), 3), isDialogOpen = _useDialog6[0], lodgingCardPropertyDetailsDialogActions = _useDialog6[1], LodgingCardPropertyDetailsDialogComponent = _useDialog6[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardPropertyDetailsDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React91.createElement(React91.Fragment, null, /* @__PURE__ */ React91.createElement(EGDSLayoutFlex15, null, /* @__PURE__ */ React91.createElement(LodgingCardMoreDetailsLinkTrigger, {
        onClickAction: lodgingCardPropertyDetailsDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React91.createElement(EGDSSheetTransition8, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React91.createElement(LodgingCardPropertyDetailsDialogComponent, null, /* @__PURE__ */ React91.createElement(EGDSSheet5, {
        type: "full",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React91.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React91.createElement(EGDSDialogContent5, null, /* @__PURE__ */ React91.createElement(PropertyDetailsContent, null))))));
};
LodgingCardPropertyDetailsDialogAction.fragment = fragment69;
LodgingCardPropertyDetailsDialogAction.displayName = "LodgingCardPropertyDetailsDialogAction";
// src/components/lodging-card/__private/lodging-card-unit-details-dialog-action.tsx
import React93 from "react";
import { gql as gql78 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex16 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet6, EGDSSheetContent as EGDSSheetContent7, EGDSSheetTransition as EGDSSheetTransition9 } from "@egds/react-core/sheet";
import { EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/dialog-context.tsx
import React92 from "react";
var DialogContext = React92.createContext(false);
// src/components/lodging-card/__private/lodging-card-unit-details-dialog-action.tsx
var fragment70 = gql78(_templateObject78(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsLinkTrigger.fragment);
var LodgingCardUnitDetailsDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var RoomDetailsContent = useLodgingCardContentContext().RoomDetailsContent;
    var track = useClickTracker21();
    var triggerRef = React93.useRef(null);
    var _useDialog7 = _sliced_to_array(useDialog7("LodgingCardPropertyRoomDetailsDialog"), 3), isDialogOpen = _useDialog7[0], lodgingCardPropertyRoomDetailsDialogActions = _useDialog7[1], LodgingCardPropertyRoomDetailsDialogComponent = _useDialog7[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardPropertyRoomDetailsDialogActions.closeDialog();
    };
    var dialogContent = /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React93.createElement("div", null, /* @__PURE__ */ React93.createElement(EGDSSpacingHr3, {
        blockMargin: "unset"
    })), /* @__PURE__ */ React93.createElement(EGDSSheetContent7, {
        padded: false
    }, /* @__PURE__ */ React93.createElement(DialogContext.Provider, {
        value: true
    }, /* @__PURE__ */ React93.createElement(RoomDetailsContent, null))));
    var sheetProps = {
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(EGDSLayoutFlex16, null, /* @__PURE__ */ React93.createElement(LodgingCardMoreDetailsLinkTrigger, {
        onClickAction: lodgingCardPropertyRoomDetailsDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React93.createElement(EGDSSheetTransition9, {
        isVisible: sheetProps.isVisible
    }, /* @__PURE__ */ React93.createElement(EGDSSheetTransition9, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React93.createElement(LodgingCardPropertyRoomDetailsDialogComponent, null, /* @__PURE__ */ React93.createElement(Viewport4, null, /* @__PURE__ */ React93.createElement(ViewSmall3, null, /* @__PURE__ */ React93.createElement(EGDSSheet6, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), dialogContent)), /* @__PURE__ */ React93.createElement(ViewMedium4, null, /* @__PURE__ */ React93.createElement(EGDSSheet6, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered"
    }), dialogContent)))))));
};
LodgingCardUnitDetailsDialogAction.fragment = fragment70;
LodgingCardUnitDetailsDialogAction.displayName = "LodgingCardUnitDetailsDialogAction";
// src/components/lodging-card/__private/lodging-card-property-dialog-action.tsx
var fragment71 = gql79(_templateObject79(), LodgingCardPropertyDetailsDialogAction.fragment, LodgingCardUnitDetailsDialogAction.fragment);
var LodgingCardPropertyDialogAction = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "LodgingCardPropertyDetailsDialog":
            return /* @__PURE__ */ React94.createElement(LodgingCardPropertyDetailsDialogAction, {
                data: data
            });
        case "LodgingCardUnitDetailsDialog":
            return /* @__PURE__ */ React94.createElement(LodgingCardUnitDetailsDialogAction, {
                data: data
            });
        default:
            return null;
    }
};
LodgingCardPropertyDialogAction.fragment = fragment71;
LodgingCardPropertyDialogAction.displayName = "LodgingCardPropertyDialogAction";
// src/components/lodging-card/__private/lodging-card-rating.tsx
import React95 from "react";
import { gql as gql80 } from "@apollo/client";
import { EGDSIcon as EGDSIcon15, EGDSIconSize as EGDSIconSize15 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex17, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
var fragment72 = gql80(_templateObject80(), SharedUIBadge.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSIconRating, ShoppingLink.fragment, ShoppingActionableIcon.fragment);
var getRatingIconPart = function(phraseParts) {
    return phraseParts === null || phraseParts === void 0 ? void 0 : phraseParts.find(function(part) {
        return part.__typename === "EGDSIconRating";
    });
};
var LodgingCardGuestRatingWithIcon = function(param) {
    var accessibilityLabel = param.accessibilityLabel, phraseParts = param.phraseParts;
    var ratingIconPart = getRatingIconPart(phraseParts);
    var RatingTextPartComponent = React95.useMemo(function() {
        return phraseParts.filter(function(phrasePart) {
            return phrasePart !== ratingIconPart;
        }).map(function(phrasePart, index) {
            return phrasePart.__typename === "EGDSStylizedText" ? /* @__PURE__ */ React95.createElement(LodgingEGDSText, {
                inline: true,
                data: phrasePart,
                key: "guest-rate-phrase-part-".concat(index)
            }) : /* @__PURE__ */ React95.createElement(ShoppingActionableIcon, {
                data: phrasePart,
                key: "guest-rate-phrase-part-".concat(index)
            });
        });
    }, [
        phraseParts
    ]);
    var RatingIconPartComponent = React95.useMemo(function() {
        if (!(ratingIconPart === null || ratingIconPart === void 0 ? void 0 : ratingIconPart.icon)) {
            return null;
        }
        var _ratingIconPart_icon = ratingIconPart.icon, token = _ratingIconPart_icon.token, theme = _ratingIconPart_icon.theme, size = _ratingIconPart_icon.size;
        return /* @__PURE__ */ React95.createElement(EGDSIcon15, {
            name: token || "star_outline",
            theme: theme || "default",
            size: size ? EGDSIconSize15[size] : EGDSIconSize15.EXTRA_SMALL
        });
    }, [
        ratingIconPart
    ]);
    return /* @__PURE__ */ React95.createElement(EGDSLayoutFlex17, {
        alignItems: "center",
        space: "one"
    }, RatingIconPartComponent, /* @__PURE__ */ React95.createElement("div", {
        "aria-hidden": !!accessibilityLabel,
        style: {
            display: "inline-block"
        }
    }, RatingTextPartComponent), accessibilityLabel && /* @__PURE__ */ React95.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
var VALID_REVIEW_RATING_PHRASE_PARTS = [
    "EGDSStylizedText",
    "EGDSPlainText",
    "ShoppingLink"
];
var ReviewRating2 = function(param) {
    var part = param.part;
    var accessibilityLabel = part.accessibilityLabel, phraseParts = part.phraseParts;
    return /* @__PURE__ */ React95.createElement(React95.Fragment, null, getRatingIconPart(phraseParts) ? /* @__PURE__ */ React95.createElement(LodgingCardGuestRatingWithIcon, {
        accessibilityLabel: accessibilityLabel,
        phraseParts: phraseParts
    }) : /* @__PURE__ */ React95.createElement(EGDSLayoutFlex17, {
        alignItems: "start",
        wrap: "wrap",
        space: "one"
    }, phraseParts.filter(function(param) {
        var __typename = param.__typename;
        return VALID_REVIEW_RATING_PHRASE_PARTS.includes(__typename);
    }).map(function(phrasePart, index) {
        return /* @__PURE__ */ React95.createElement(EGDSLayoutFlexItem12, {
            key: "phrase-part-".concat(index)
        }, phrasePart.__typename === "EGDSStylizedText" || phrasePart.__typename === "EGDSPlainText" ? /* @__PURE__ */ React95.createElement(LodgingEGDSText, {
            data: phrasePart,
            overflow: "truncate-2-lines"
        }) : /* @__PURE__ */ React95.createElement(ShoppingLink, {
            data: phrasePart
        }));
    })));
};
var LodgingCardRating = function(param) {
    var data = param.data;
    var badge = data.badge, phrases = data.phrases;
    return /* @__PURE__ */ React95.createElement(EGDSLayoutFlex17, {
        alignItems: "center",
        space: "one"
    }, badge && /* @__PURE__ */ React95.createElement(EGDSLayoutFlex17, {
        alignItems: "center"
    }, /* @__PURE__ */ React95.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */ React95.createElement(SharedUIBadge, {
        data: badge
    }))), /* @__PURE__ */ React95.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */ React95.createElement(EGDSLayoutFlex17, {
        direction: "column"
    }, phrases === null || phrases === void 0 ? void 0 : phrases.map(function(part, index) {
        return /* @__PURE__ */ React95.createElement(EGDSLayoutFlexItem12, {
            key: "guest-rate-line-".concat(index)
        }, /* @__PURE__ */ React95.createElement(ReviewRating2, {
            key: "guest-rate-".concat(index),
            part: part
        }));
    }))));
};
LodgingCardRating.fragment = fragment72;
LodgingCardRating.displayName = "LodgingCardGuestRatingSectionV2";
// src/components/lodging-card/__private/lodging-product-description.tsx
import React96 from "react";
import { gql as gql81 } from "@apollo/client";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";
var fragment73 = gql81(_templateObject81());
var LodgingCardPropertyDescriptionSection = function(param) {
    var data = param.data, isReview = param.isReview;
    var heading = data.heading, description = data.description;
    return /* @__PURE__ */ React96.createElement(React96.Fragment, null, heading && /* @__PURE__ */ React96.createElement(EGDSText14, {
        size: 200,
        weight: "bold"
    }, heading.text), description && /* @__PURE__ */ React96.createElement(EGDSText14, {
        size: 200,
        overflow: isReview ? "truncate-4-lines" : void 0
    }, description.text));
};
LodgingCardPropertyDescriptionSection.fragment = fragment73;
LodgingCardPropertyDescriptionSection.displayName = "LodgingCardPropertyDescriptionSection";
// src/components/lodging-card/__private/lodging-product-footer-messages.tsx
import React97 from "react";
import { gql as gql82 } from "@apollo/client";
import { EGDSAvatar } from "@egds/react-core/avatar";
import { EGDSLayoutFlex as EGDSLayoutFlex18 } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark6, EGDSMarkSize as EGDSMarkSize5 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText15 } from "@egds/react-core/text";
import { EGDSUnformattedHtml as EGDSUnformattedHtml2 } from "@egds/react-core/unformatted-html";
var _obj15;
// src/components/lodging-card/__private/uitk-text-theme-mapper.tsx
var EGDSTextThemeMapper = (_obj15 = {}, _define_property(_obj15, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj15, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj15, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj15, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj15, "DEFAULT" /* DEFAULT */ , "default"), _obj15);
// src/components/lodging-card/__private/lodging-product-footer-messages.tsx
var fragment74 = gql82(_templateObject82());
var LodgingProductFooterMessages = function(param) {
    var data = param.data, isReview = param.isReview;
    var _mark_url;
    var style = data.style, text = data.text, mark = data.mark, egdsElementId = data.egdsElementId;
    var hasGraphic = mark && mark.id.length > 0;
    var theme = style ? EGDSTextThemeMapper[style] : void 0;
    var plainTextElement = function(props) {
        return /* @__PURE__ */ React97.createElement("span", null, props.children || null);
    };
    var message = /* @__PURE__ */ React97.createElement(EGDSText15, {
        inline: !!hasGraphic,
        theme: theme
    }, /* @__PURE__ */ React97.createElement(EGDSUnformattedHtml2, {
        plainTextElement: plainTextElement,
        htmlToParse: text
    }));
    var stayedDate = "stayed_date";
    var reviewAuthor = "review_author";
    if (isReview) {
        switch(egdsElementId){
            case stayedDate:
                return /* @__PURE__ */ React97.createElement(EGDSSpacing16, {
                    padding: {
                        blockstart: "one"
                    }
                }, /* @__PURE__ */ React97.createElement(EGDSLayoutFlex18, {
                    wrap: "wrap",
                    direction: "row",
                    alignItems: "center"
                }, /* @__PURE__ */ React97.createElement(EGDSText15, {
                    size: 200
                }, text)));
            case reviewAuthor:
                return /* @__PURE__ */ React97.createElement(EGDSSpacing16, {
                    padding: {
                        blockstart: "four"
                    }
                }, /* @__PURE__ */ React97.createElement(EGDSLayoutFlex18, {
                    wrap: "wrap",
                    direction: "row",
                    alignItems: "center"
                }, /* @__PURE__ */ React97.createElement(EGDSAvatar, {
                    size: "small"
                }), /* @__PURE__ */ React97.createElement(EGDSSpacing16, {
                    padding: {
                        inlinestart: "one"
                    }
                }, /* @__PURE__ */ React97.createElement(EGDSText15, {
                    weight: "bold"
                }, text))));
            default:
                return null;
        }
    }
    return hasGraphic ? /* @__PURE__ */ React97.createElement(EGDSSpacing16, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React97.createElement("div", null, /* @__PURE__ */ React97.createElement(EGDSSpacing16, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React97.createElement(EGDSMark6, {
        name: mark === null || mark === void 0 ? void 0 : mark.id,
        url: mark === null || mark === void 0 ? void 0 : (_mark_url = mark.url) === null || _mark_url === void 0 ? void 0 : _mark_url.value,
        description: mark === null || mark === void 0 ? void 0 : mark.description,
        size: EGDSMarkSize5.SMALL
    })), message)) : message;
};
LodgingProductFooterMessages.fragment = fragment74;
LodgingProductFooterMessages.displayName = "LodgingProductFooterMessages";
// src/components/lodging-card/__private/lodging-product-spannable-footer-messages.tsx
import React98 from "react";
import { gql as gql83 } from "@apollo/client";
import { EGDSMark as EGDSMark7, EGDSMarkSize as EGDSMarkSize6 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText16 } from "@egds/react-core/text";
var fragment75 = gql83(_templateObject83(), EGDSSpannableText.fragment);
var LodgingProductSpannableFooterMessages = function(param) {
    var data = param.data;
    var _graphic_url;
    var style = data.style, text = data.text, graphic = data.graphic, stylizedText = data.stylizedText;
    var hasMark = graphic && graphic.id.length > 0 && graphic.__typename === "Mark";
    var theme = style ? EGDSTextThemeMapper[style] : void 0;
    var hasSpannableData = stylizedText && stylizedText.__typename === "EGDSSpannableText";
    return hasMark && hasSpannableData ? /* @__PURE__ */ React98.createElement(EGDSSpacing17, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React98.createElement("div", null, /* @__PURE__ */ React98.createElement(EGDSSpacing17, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React98.createElement(EGDSMark7, {
        name: graphic.id,
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        description: graphic.description,
        size: EGDSMarkSize6.SMALL
    })), /* @__PURE__ */ React98.createElement(EGDSSpannableText, {
        data: stylizedText
    }))) : /* @__PURE__ */ React98.createElement(EGDSText16, {
        theme: theme
    }, text);
};
LodgingProductSpannableFooterMessages.fragment = fragment75;
LodgingProductSpannableFooterMessages.displayName = "LodgingProductFooterMessages";
// src/components/lodging-card/__private/lodging-card-product-summary-section.tsx
var fragment76 = gql84(_templateObject84(), ShoppingLink.fragment, LodgingEGDSHeading.fragment, LodgingProductAmenity.fragment, LodgingEGDSText.fragment, LodgingCardPropertyDescriptionSection.fragment, LodgingCardChangeUnitDialogAction.fragment, LodgingCardChangeUnitSheetAction.fragment, LodgingCardPropertyDialogAction.fragment, LodgingCardGuestRating.fragment, LodgingCardBadgedRating.fragment, LodgingCardRating.fragment, LodgingProductFooterMessages.fragment, LodgingProductSpannableFooterMessages.fragment);
var LodgingCardProductSummarySection = function(param) {
    var data = param.data, view = param.view, isReview = param.isReview, isOptimizedView = param.isOptimizedView, isOneColumnLayout = param.isOneColumnLayout, isAd2 = param.isAd, isSRPListingCard = param.isSRPListingCard;
    var renderFooterMessage = function renderFooterMessage(footerMessage, footerMessageIndex) {
        switch(footerMessage.__typename){
            case "EGDSTextWithMarkListItem":
                return /* @__PURE__ */ React99.createElement(LodgingProductFooterMessages, {
                    data: footerMessage,
                    key: "message-".concat(footerMessageIndex),
                    isReview: isReview
                });
            case "EarnMessageContainerListItem":
                return /* @__PURE__ */ React99.createElement(LodgingProductSpannableFooterMessages, {
                    data: footerMessage,
                    key: "message-".concat(footerMessageIndex)
                });
            default:
                return null;
        }
    };
    var _footerMessages_listItems;
    var heading = data.heading, messages = data.messages, descriptionSection = data.descriptionSection, amenities = data.amenities, changeActionDialog = data.changeActionDialog, changeActionSheet = data.changeActionSheet, detailsAction = data.detailsAction, guestRatingSection = data.guestRatingSection, guestRatingSectionV2 = data.guestRatingSectionV2, footerMessages = data.footerMessages, detailsLink = data.detailsLink;
    var headingLevel = useHeadingLevelContext2(2).headingLevel;
    var _useExperiment4 = useExperiment4("Split_View_Side_by_side_BEXG_H"), BEXSplitViewExposure = _useExperiment4.exposure;
    var hasDescription = (descriptionSection === null || descriptionSection === void 0 ? void 0 : descriptionSection.heading) || (descriptionSection === null || descriptionSection === void 0 ? void 0 : descriptionSection.description);
    var shouldHideDescription = isAd2 && BEXSplitViewExposure.bucket === 1 && !isSRPListingCard;
    var GuestRating = React99.useMemo(function() {
        var isLodgingCardBadgedRating = guestRatingSection === null || guestRatingSection === void 0 ? void 0 : guestRatingSection.__typename.match("LodgingCardBadgedRating");
        var isLodgingCardRating = guestRatingSectionV2 === null || guestRatingSectionV2 === void 0 ? void 0 : guestRatingSectionV2.__typename.match("LodgingCardRating");
        if (guestRatingSection) {
            if (isLodgingCardBadgedRating) {
                return /* @__PURE__ */ React99.createElement(LodgingCardBadgedRating, {
                    data: guestRatingSection
                });
            }
            return /* @__PURE__ */ React99.createElement(LodgingCardGuestRating, {
                data: guestRatingSection,
                isReview: isReview
            });
        }
        if (guestRatingSectionV2) {
            if (isLodgingCardRating) {
                return /* @__PURE__ */ React99.createElement(LodgingCardRating, {
                    data: guestRatingSectionV2
                });
            }
            return /* @__PURE__ */ React99.createElement(LodgingCardGuestRating, {
                data: guestRatingSectionV2,
                isReview: isReview
            });
        }
        return null;
    }, [
        guestRatingSection,
        guestRatingSectionV2,
        isReview
    ]);
    var isCompactHorizontalCard = isCompactHorizontalView(view);
    var productSummarySpace = function() {
        if (isCompactHorizontalCard) {
            return "one";
        }
        if (isOptimizedView) {
            return "half";
        }
        return "three";
    };
    var headingItem = heading ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React99.createElement(LodgingEGDSHeading, {
        size: 7,
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h3",
        data: heading
    })) : null;
    var messagesItem = messages.length > 0 ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React99.createElement("div", null, messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React99.createElement(LodgingEGDSText, {
            overflow: "truncate-2-lines",
            key: "message-".concat(messageIndex),
            spacing: "half",
            size: 300,
            data: message
        });
    }))) : null;
    var amenitiesItem = amenities.length > 0 ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlex19, {
        wrap: "wrap"
    }, amenities.map(function(amenity, i) {
        return /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, {
            key: "amenity-".concat(i)
        }, /* @__PURE__ */ React99.createElement(LodgingProductAmenity, {
            data: amenity
        }));
    })) : null;
    var guestRatingItem = GuestRating ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, GuestRating) : null;
    var descriptionItem = !isCompactView(view) && hasDescription && !shouldHideDescription ? /* @__PURE__ */ React99.createElement(Viewport5, null, /* @__PURE__ */ React99.createElement(ViewMedium5, null, /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, {
        minWidth: "16x"
    }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(LodgingCardPropertyDescriptionSection, {
        data: descriptionSection,
        isReview: isReview
    }))))) : null;
    var descriptionItemWithReview = isReview && hasDescription ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, {
        minWidth: "16x"
    }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(LodgingCardPropertyDescriptionSection, {
        data: descriptionSection,
        isReview: isReview
    }))) : null;
    var footerMessagesItem = footerMessages && ((_footerMessages_listItems = footerMessages.listItems) === null || _footerMessages_listItems === void 0 ? void 0 : _footerMessages_listItems.length) > 0 ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React99.createElement("div", null, footerMessages.listItems.map(function(footerMessage, footerMessageIndex) {
        return /* @__PURE__ */ React99.createElement("div", {
            key: "footer-message-".concat(footerMessageIndex)
        }, renderFooterMessage(footerMessage, footerMessageIndex));
    }))) : null;
    var detailsActionItem = detailsAction ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React99.createElement(LodgingCardPropertyDialogAction, {
        data: detailsAction
    })) : null;
    var detailsItem = detailsLink ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React99.createElement(EGDSSpacing18, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(ShoppingLink, {
        data: detailsLink,
        inline: false
    })))) : detailsActionItem;
    var changeActionItem = changeActionDialog && changeActionSheet ? /* @__PURE__ */ React99.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React99.createElement(EGDSSpacing18, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(Viewport5, null, /* @__PURE__ */ React99.createElement(ViewSmall4, null, /* @__PURE__ */ React99.createElement(LodgingCardChangeUnitDialogAction, {
        data: changeActionDialog
    })), /* @__PURE__ */ React99.createElement(ViewMedium5, null, /* @__PURE__ */ React99.createElement(LodgingCardChangeUnitSheetAction, {
        data: changeActionSheet
    })))))) : null;
    var hasItemsForSmallCard = headingItem || messagesItem || amenitiesItem || guestRatingItem || descriptionItemWithReview || footerMessagesItem || detailsItem || changeActionItem;
    var hasItemsForMediumCard = hasItemsForSmallCard || descriptionItem;
    var items = /* @__PURE__ */ React99.createElement(EGDSSpacing18, {
        margin: {
            blockstart: isCompactHorizontalCard || isOneColumnLayout ? "half" : void 0
        }
    }, /* @__PURE__ */ React99.createElement(EGDSLayoutFlex19, {
        direction: "column",
        space: productSummarySpace()
    }, headingItem, messagesItem, amenitiesItem, isReview ? guestRatingItem : null, descriptionItem, descriptionItemWithReview, footerMessagesItem, isReview ? null : guestRatingItem, detailsItem, changeActionItem));
    return /* @__PURE__ */ React99.createElement(Viewport5, null, /* @__PURE__ */ React99.createElement(ViewSmall4, null, hasItemsForSmallCard ? items : void 0), /* @__PURE__ */ React99.createElement(ViewMedium5, null, hasItemsForMediumCard ? items : void 0));
};
LodgingCardProductSummarySection.fragment = fragment76;
LodgingCardProductSummarySection.displayName = "LodgingCardProductSummarySection";
// src/components/lodging-card/__private/lodging-mod-sign-in-button.tsx
import React100, { useEffect as useEffect3 } from "react";
import { EGDSButtonSize as EGDSButtonSize3, EGDSPrimaryButton as EGDSPrimaryButton4, EGDSTertiaryButton as EGDSTertiaryButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon16 } from "@egds/react-core/icons";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { IntersectionTracker as IntersectionTracker5, ITrackType as ITrackType5, useClickstreamAnalytics as useClickstreamAnalytics5, useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useInView as useInView2 } from "react-intersection-observer";
var LodgingMODSignInButton = function(props) {
    var _componentAnalytics_impressed, _componentAnalytics_impressed1;
    var data = props.data, isPinnedSRPCta = props.isPinnedSRPCta;
    var action = data.action, analytics = data.analytics, attemptEvents = data.attemptEvents, icon = data.icon, primary = data.primary, successEvents = data.successEvents, adaptexSuccessActionTracking = data.adaptexSuccessActionTracking;
    var _useAdaptExEvents = useAdaptExEvents(adaptexSuccessActionTracking !== null && adaptexSuccessActionTracking !== void 0 ? adaptexSuccessActionTracking : []), propertyListingAdaptExSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var trackClick = useClickTracker22();
    var _useInView2 = useInView2({
        triggerOnce: true,
        threshold: 0.8
    }), ref = _useInView2.ref, inView = _useInView2.inView;
    var track = useClickstreamAnalytics5().track;
    var componentAnalytics = {
        click: action === null || action === void 0 ? void 0 : action.analytics,
        impressed: analytics
    };
    useEffect3(function() {
        if (inView && attemptEvents.length) {
            var attemptEvent = attemptEvents[0];
            var events = attemptEvent === null || attemptEvent === void 0 ? void 0 : attemptEvent.events[0];
            track(ITrackType5.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, attemptEvent), {
                    events: events ? [
                        events
                    ] : []
                }))
            });
        }
    }, [
        attemptEvents,
        inView,
        track
    ]);
    var handleOnClick = function() {
        var _componentAnalytics_click, _componentAnalytics_click1;
        if (((_componentAnalytics_click = componentAnalytics.click) === null || _componentAnalytics_click === void 0 ? void 0 : _componentAnalytics_click.referrerId) && ((_componentAnalytics_click1 = componentAnalytics.click) === null || _componentAnalytics_click1 === void 0 ? void 0 : _componentAnalytics_click1.linkName)) {
            trackClick(componentAnalytics.click.referrerId, componentAnalytics.click.linkName);
        }
        if (successEvents.length) {
            var successEvent = successEvents[0];
            var events = successEvent === null || successEvent === void 0 ? void 0 : successEvent.events[0];
            track(ITrackType5.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, successEvent), {
                    events: events ? [
                        events
                    ] : []
                }))
            });
        }
        if (propertyListingAdaptExSuccessEvents.length) {
            propertyListingAdaptExSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType5.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    };
    var content = /* @__PURE__ */ React100.createElement(EGDSLayoutFlexItem14, {
        alignSelf: "end"
    }, isPinnedSRPCta ? /* @__PURE__ */ React100.createElement(EGDSTertiaryButton3, {
        type: "button",
        domRef: ref,
        onClick: handleOnClick,
        tag: "a",
        href: action === null || action === void 0 ? void 0 : action.resource.value,
        size: EGDSButtonSize3.SMALL
    }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React100.createElement(EGDSIcon16, {
        name: icon.id
    }), primary) : /* @__PURE__ */ React100.createElement(EGDSPrimaryButton4, {
        domRef: ref,
        onClick: handleOnClick,
        type: "button",
        tag: "a",
        href: action === null || action === void 0 ? void 0 : action.resource.value,
        size: EGDSButtonSize3.SMALL
    }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React100.createElement(EGDSIcon16, {
        name: icon.id
    }), primary));
    var MODSignInButtonWithImpressionTracking = ((_componentAnalytics_impressed = componentAnalytics.impressed) === null || _componentAnalytics_impressed === void 0 ? void 0 : _componentAnalytics_impressed.referrerId) && ((_componentAnalytics_impressed1 = componentAnalytics.impressed) === null || _componentAnalytics_impressed1 === void 0 ? void 0 : _componentAnalytics_impressed1.linkName) ? /* @__PURE__ */ React100.createElement(IntersectionTracker5, {
        referrerId: componentAnalytics.impressed.referrerId,
        linkName: componentAnalytics.impressed.linkName,
        trackOnce: true
    }, content) : content;
    return MODSignInButtonWithImpressionTracking;
};
LodgingMODSignInButton.displayName = "LodgingMODSignInButton";
// src/components/lodging-card/__private/lodging-card-content-section.tsx
var fragment77 = gql85(_templateObject85(), AdaptExAnalyticsEventFragment, LodgingCardHeadingSection.fragment, LodgingCardProductSummarySection.fragment, PropertyPriceDocumentNode, LodgingCardMarketingFeeDetail.fragment, LodgingCardCompareSectionGated.fragment, LodgingCardDateSection.fragment, LodgingBadge.fragment, LodgingStandardBadge.fragment, LodgingEGDSText.fragment, AdaptexTrackingFragment);
var LodgingCardContentSection = function(param) {
    var data = param.data, isAd2 = param.isAd, headingSize = param.headingSize, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, headingOverflow = param.headingOverflow, isReview = param.isReview, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView, _param_isOneColumnLayout = param.isOneColumnLayout, isOneColumnLayout = _param_isOneColumnLayout === void 0 ? false : _param_isOneColumnLayout, isSRPListingCard = param.isSRPListingCard, _param_isPinnedSRPCta = param.isPinnedSRPCta, isPinnedSRPCta = _param_isPinnedSRPCta === void 0 ? false : _param_isPinnedSRPCta;
    var _priceSection_priceSummary;
    var headingSection = data.headingSection, priceSection = data.priceSection, callOut = data.callOut, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection, id = data.id;
    var isCompact = isCompactView(view) || isCompactHorizontalView(view);
    var hasRightColumn = callOut || priceSection || dateSection && !isCompact;
    var columns;
    if (!isReview && !isOneColumnLayout) {
        columns = {
            small: [
                "1fr",
                "2fr",
                "2fr"
            ],
            medium: [
                "1fr",
                "2fr",
                "2fr"
            ],
            large: isCompact ? [
                "1fr",
                "2fr",
                "2fr"
            ] : [
                "1fr",
                "max-content",
                "max-content"
            ]
        };
    }
    var isHeadingOnly = !priceSection && !callOut && !summarySections.length && !compareSection && !dateSection;
    var headingDefaultSpacing = isOneColumnLayout ? "one" : "three";
    return /* @__PURE__ */ React101.createElement(React101.Fragment, null, headingSection && /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */ React101.createElement(EGDSSpacing19, {
        padding: {
            blockend: isOptimizedView || isHeadingOnly ? void 0 : headingDefaultSpacing
        }
    }, /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(HeadingLevelProvider, {
        topHeadingLevel: 3
    }, /* @__PURE__ */ React101.createElement(LodgingCardHeadingSection, {
        data: headingSection,
        size: headingSize,
        headingOverflow: headingOverflow,
        isReview: isReview,
        isOptimizedView: isOptimizedView
    }))))), /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, {
        grow: isOneColumnLayout ? 1 : void 0
    }, /* @__PURE__ */ React101.createElement(EGDSLayoutGrid3, {
        space: "one",
        columns: columns
    }, /* @__PURE__ */ React101.createElement(EGDSLayoutGridItem3, {
        colSpan: hasRightColumn && !isOneColumnLayout ? 2 : 3,
        alignSelf: isOneColumnLayout ? "start" : "end"
    }, /* @__PURE__ */ React101.createElement("div", null, summarySections.map(function(summarySection, index) {
        return /* @__PURE__ */ React101.createElement(React101.Fragment, {
            key: "summary-section-".concat(index)
        }, index > 0 && /* @__PURE__ */ React101.createElement(EGDSSpacingHr4, {
            blockMargin: "three"
        }), /* @__PURE__ */ React101.createElement(LodgingCardProductSummarySection, {
            data: summarySection,
            view: view,
            isReview: isReview,
            isOptimizedView: isOptimizedView,
            isOneColumnLayout: isOneColumnLayout,
            isAd: isAd2,
            isSRPListingCard: isSRPListingCard
        }));
    }))), hasRightColumn && /* @__PURE__ */ React101.createElement(EGDSLayoutGridItem3, _object_spread({
        alignSelf: "end"
    }, isOneColumnLayout ? {
        colSpan: 3
    } : {
        colSpan: 1,
        justifySelf: "end"
    }), callOut && /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(LodgingEGDSText, {
        data: callOut,
        align: isOneColumnLayout ? "left" : "right"
    })), !isReview && priceSection && /* @__PURE__ */ React101.createElement(EGDSLayoutFlex20, {
        direction: "column"
    }, /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, {
        alignSelf: isOneColumnLayout ? "start" : "end"
    }, /* @__PURE__ */ React101.createElement(LodgingStandardBadge, {
        data: priceSection.standardBadge,
        propertyId: id,
        align: isOneColumnLayout ? "start" : "end"
    }), " "), /* @__PURE__ */ React101.createElement(PriceSectionPriceSummary, _object_spread({
        priceSummary: priceSection.priceSummary,
        enableInlineLink: enableInlineLink
    }, isOneColumnLayout && {
        align: EGDSPriceLockupAlign4.LEFT,
        flexAlignment: "start",
        flexDirection: "row-reverse"
    })), ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.marketingFeeDetails) && /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, {
        alignSelf: isOneColumnLayout ? "start" : "end"
    }, /* @__PURE__ */ React101.createElement(EGDSSpacing19, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(LodgingCardMarketingFeeDetail, {
        data: priceSection.priceSummary.marketingFeeDetails,
        id: id
    })))), priceSection.button && /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, {
        alignSelf: isOneColumnLayout ? "start" : "end"
    }, /* @__PURE__ */ React101.createElement(EGDSLayoutPosition7, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React101.createElement(EGDSSpacing19, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(LodgingMODSignInButton, {
        data: priceSection.button,
        isPinnedSRPCta: isPinnedSRPCta
    }))))), (dateSection === null || dateSection === void 0 ? void 0 : dateSection.date) && !isCompact && /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, {
        alignSelf: "end"
    }, /* @__PURE__ */ React101.createElement(EGDSSpacing19, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(LodgingCardDateSection, {
        data: dateSection
    })))), compareSection && !((dateSection === null || dateSection === void 0 ? void 0 : dateSection.date) && isCompact) && /* @__PURE__ */ React101.createElement(LodgingCardCompareSectionGated, {
        isAd: isAd2,
        propertyId: id,
        data: compareSection,
        isOneColumnLayout: isOneColumnLayout
    }))), (dateSection === null || dateSection === void 0 ? void 0 : dateSection.date) && isCompact && /* @__PURE__ */ React101.createElement(EGDSLayoutGridItem3, {
        colSpan: 3
    }, /* @__PURE__ */ React101.createElement(EGDSLayoutFlex20, {
        direction: "column"
    }, /* @__PURE__ */ React101.createElement(EGDSLayoutFlexItem15, {
        alignSelf: isOneColumnLayout ? "start" : "end"
    }, /* @__PURE__ */ React101.createElement(EGDSSpacing19, {
        margin: {
            blockstart: isOneColumnLayout ? void 0 : "three"
        }
    }, /* @__PURE__ */ React101.createElement("div", null, /* @__PURE__ */ React101.createElement(LodgingCardDateSection, {
        data: dateSection,
        align: isOneColumnLayout ? "left" : "right"
    })))), compareSection && /* @__PURE__ */ React101.createElement(LodgingCardCompareSectionGated, {
        isAd: isAd2,
        propertyId: id,
        data: compareSection
    }))))));
};
LodgingCardContentSection.fragment = fragment77;
LodgingCardContentSection.displayName = "LodgingCardContentSection";
// src/components/lodging-card/__private/product-card-footer-action.tsx
import React103 from "react";
import { gql as gql87 } from "@apollo/client";
import { UitkButtonSize } from "@egds/react-core/button";
import { ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/components/lodging-card/__private/lodging-card-link-action.tsx
import React102 from "react";
import { gql as gql86 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize4, EGDSPrimaryButton as EGDSPrimaryButton5 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon17 } from "@egds/react-core/icons";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem16 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink7 } from "@egds/react-core/link";
import { IntersectionTracker as IntersectionTracker6, useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
var fragment78 = gql86(_templateObject86());
var LodgingCardLinkAction = function(param) {
    var data = param.data;
    var _data_link;
    var link = data.link;
    var action = link.action, icon = link.icon;
    var analytics = action.analytics, resource = action.resource;
    var track = useClickTracker23();
    if (!link || resource.__typename !== "HttpURI") {
        return null;
    }
    var path = action.useRelativePath ? resource.relativePath : resource.value;
    var analyticsData = analytics ? {
        id: analytics.referrerId,
        description: analytics.linkName,
        callback: function(id, description) {
            return track(id, description, true);
        }
    } : void 0;
    var linkContent = (data === null || data === void 0 ? void 0 : (_data_link = data.link) === null || _data_link === void 0 ? void 0 : _data_link.egdsElementId) === "pinnedSrpCta" ? /* @__PURE__ */ React102.createElement(EGDSLayoutFlexItem16, {
        alignSelf: "end"
    }, /* @__PURE__ */ React102.createElement(EGDSPrimaryButton5, {
        type: "button",
        tag: "a",
        target: UILinkTargetMap3[action.target],
        size: EGDSButtonSize4.SMALL
    }, link.text, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React102.createElement(EGDSIcon17, {
        key: "lodging-card-link-icon-".concat(icon.id),
        name: icon.id
    }))) : /* @__PURE__ */ React102.createElement(EGDSLink7, {
        align: "right",
        analytics: analyticsData
    }, /* @__PURE__ */ React102.createElement("a", {
        href: path,
        target: UILinkTargetMap3[action.target]
    }, link.text, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React102.createElement(EGDSIcon17, {
        key: "lodging-card-link-icon-".concat(icon.id),
        name: icon.id
    })));
    var isSignInFooterLink = !!analytics.linkName.match(/sign in/gi);
    return isSignInFooterLink ? /* @__PURE__ */ React102.createElement(IntersectionTracker6, {
        referrerId: "Impression".concat(analytics.referrerId),
        linkName: analytics.linkName,
        trackOnce: true
    }, linkContent) : linkContent;
};
LodgingCardLinkAction.fragment = fragment78;
LodgingCardLinkAction.displayName = "LodgingCardLinkAction";
// src/components/lodging-card/__private/product-card-footer-action.tsx
var fragment79 = gql87(_templateObject87(), LodgingCardLinkAction.fragment);
var ProductCardFooterAction = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "LodgingCardLinkAction":
            return /* @__PURE__ */ React103.createElement(LodgingCardLinkAction, {
                data: data
            });
        case "ShoppingButton":
            return /* @__PURE__ */ React103.createElement(Viewport6, null, /* @__PURE__ */ React103.createElement(ViewSmall5, null, /* @__PURE__ */ React103.createElement(ShoppingButton, {
                data: data,
                size: UitkButtonSize.SMALL
            })), /* @__PURE__ */ React103.createElement(ViewMedium6, null, /* @__PURE__ */ React103.createElement(ShoppingButton, {
                data: data
            })));
        default:
            return null;
    }
};
ProductCardFooterAction.fragment = fragment79;
ProductCardFooterAction.displayName = "LodgingCardFooterAction";
// src/components/lodging-card/lodging-card-compact.tsx
import React106 from "react";
import { EGDSCardContentSection as EGDSCardContentSection3, EGDSCardFeaturedHeader } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex22, EGDSLayoutFlexItem as EGDSLayoutFlexItem17 } from "@egds/react-core/layout-flex";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
import { Card } from "@egds/react-lodging";
// src/components/product-card/product-card-footer.tsx
import React104 from "react";
import { Link as Link2, useLocation as useLocation3 } from "react-router-dom";
import { EGDSCardContentSection as EGDSCardContentSection2, EGDSCardLink as EGDSCardLink4 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid4 } from "@egds/react-core/layout-grid";
var ProductCardFooterGrid = function(param) {
    var columns = param.columns, children = param.children;
    if (columns === 1) {
        return /* @__PURE__ */ React104.createElement(EGDSLayoutGrid4, {
            columns: columns,
            justifyContent: "end"
        }, children);
    }
    return /* @__PURE__ */ React104.createElement(EGDSLayoutGrid4, {
        columns: [
            "2fr",
            "1fr"
        ]
    }, children);
};
var ProductCardFooter = function(param) {
    var footerSectionContents = param.footerSectionContents, actionId = param.actionId;
    var triggerRef = React104.useRef(null);
    var productCardActionCallback = useProductCardActionCallback(actionId);
    var location = useLocation3();
    if (!footerSectionContents || footerSectionContents.length === 0) {
        return null;
    }
    var hasContent = footerSectionContents.some(function(content2) {
        return (content2 === null || content2 === void 0 ? void 0 : content2.items) && content2.items.length > 0;
    });
    if (!hasContent) {
        return null;
    }
    var content = /* @__PURE__ */ React104.createElement(ProductCardFooterGrid, {
        columns: footerSectionContents.length
    }, footerSectionContents.map(function(footerSectionContent, index) {
        return /* @__PURE__ */ React104.createElement(ProductCardFooterSectionContent, {
            key: index,
            data: footerSectionContent,
            footerSectionContentsLength: footerSectionContents.length,
            gridIndex: index
        });
    }));
    return /* @__PURE__ */ React104.createElement(EGDSCardContentSection2, {
        border: "top",
        className: "uitk-card-content-section-has-link"
    }, actionId && /* @__PURE__ */ React104.createElement(ProductCardActionWrapper, {
        ref: triggerRef,
        actionId: actionId,
        triggerComponent: /* @__PURE__ */ React104.createElement(EGDSCardLink4, null, /* @__PURE__ */ React104.createElement(Link2, {
            rel: "noopener",
            target: "_self",
            onClick: productCardActionCallback,
            ref: triggerRef,
            to: location
        }))
    }), content);
};
ProductCardFooter.displayName = "ProductCardFooter";
// src/components/product-card/product-card-footer-actions.tsx
import React105 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex21 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
var footerActionsMargin = {
    blockstart: "six"
};
var ProductCardFooterActions = function(param) {
    var footerActions = param.footerActions, id = param.id, isPinnedCta = param.isPinnedCta;
    return /* @__PURE__ */ React105.createElement(EGDSSpacing20, {
        margin: footerActionsMargin
    }, /* @__PURE__ */ React105.createElement(EGDSLayoutFlex21, {
        space: "two",
        direction: isPinnedCta ? "column" : "row"
    }, footerActions.map(function(footerAction, footerIndex) {
        return /* @__PURE__ */ React105.createElement(ProductCardFooterAction, {
            data: footerAction,
            key: "footerAction-".concat(id, "-").concat(footerIndex)
        });
    })));
};
ProductCardFooterActions.displayName = "ProductCardFooterActions";
// src/components/lodging-card/lodging-card-compact.tsx
var LodgingCardCompact = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "COMPACT" /* COMPACT */  : _param_view, imageRatio = param.imageRatio, onHoverChanged = param.onHoverChanged, appendAdditionalQueryParamCb = param.appendAdditionalQueryParamCb, headingOverflow = param.headingOverflow, index = param.index, isReview = param.isReview, border = param.border, headingSize = param.headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView, _param_underlineTitleOnHover = param.underlineTitleOnHover, underlineTitleOnHover = _param_underlineTitleOnHover === void 0 ? false : _param_underlineTitleOnHover, isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, _param_isOneColumnLayout = param.isOneColumnLayout, isOneColumnLayout = _param_isOneColumnLayout === void 0 ? false : _param_isOneColumnLayout, fetchPriority = param.fetchPriority, isSRPListingCard = param.isSRPListingCard, lazyLoadImg = param.lazyLoadImg;
    var _data_shoppingJoinListContainer, _data_shoppingJoinListContainer1;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, cardBackgroundTheme = data.cardBackgroundTheme, footerActions = data.footerActions, footer = data.footer, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var routeLink = isRouteAndHoverDifferent && (data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer === void 0 ? void 0 : _data_shoppingJoinListContainer.actions) ? data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer1 = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer1 === void 0 ? void 0 : _data_shoppingJoinListContainer1.actions[0] : null;
    var isPinnedCta = footerActions.some(function(footerElement) {
        var _footerElement_link;
        return footerElement.__typename === "LodgingCardLinkAction" && (footerElement === null || footerElement === void 0 ? void 0 : (_footerElement_link = footerElement.link) === null || _footerElement_link === void 0 ? void 0 : _footerElement_link.egdsElementId) === "pinnedSrpCta";
    });
    var lodgingCardMediaSection = /* @__PURE__ */ React106.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        alternateRouteLink: routeLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        index: index,
        fetchPriority: fetchPriority,
        lazyLoadImg: lazyLoadImg
    });
    var formattedDataAttributes = formatDataAttributes(data.dataAttributes);
    var _getBackgroundCardTheme;
    return /* @__PURE__ */ React106.createElement(EGDSLayoutFlex22, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React106.createElement(EGDSLayoutFlexItem17, {
        grow: 1
    }, /* @__PURE__ */ React106.createElement(Card, _object_spread({
        border: border,
        backgroundTheme: (_getBackgroundCardTheme = getBackgroundCardTheme(cardBackgroundTheme)) !== null && _getBackgroundCardTheme !== void 0 ? _getBackgroundCardTheme : void 0,
        className: className,
        underlineTitleOnHover: underlineTitleOnHover,
        "data-stid": "lodging-card-compact",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        },
        onFocus: function() {
            return onHoverChanged(true);
        },
        onBlur: function() {
            return onHoverChanged(false);
        }
    }, formattedDataAttributes), featuredHeader && /* @__PURE__ */ React106.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            left: "zero",
            top: "zero",
            right: "zero",
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React106.createElement(EGDSCardFeaturedHeader, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    })), /* @__PURE__ */ React106.createElement(EGDSLayoutFlex22, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React106.createElement(EGDSLayoutFlexItem17, {
        grow: 0
    }, /* @__PURE__ */ React106.createElement("div", null, lodgingCardMediaSection)), /* @__PURE__ */ React106.createElement(EGDSLayoutFlexItem17, {
        grow: 1
    }, /* @__PURE__ */ React106.createElement(EGDSCardContentSection3, null, /* @__PURE__ */ React106.createElement(EGDSLayoutFlex22, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React106.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: isAd(mediaSection),
        view: view,
        headingOverflow: headingOverflow,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink,
        isOptimizedView: isOptimizedView,
        isOneColumnLayout: isOneColumnLayout,
        isSRPListingCard: !!isSRPListingCard,
        isPinnedSRPCta: isPinnedCta
    }), footerActions.length > 0 && /* @__PURE__ */ React106.createElement(ProductCardFooterActions, {
        footerActions: footerActions,
        id: id,
        isPinnedCta: isPinnedCta
    }))))), footer && /* @__PURE__ */ React106.createElement(ProductCardFooter, {
        footerSectionContents: footer.contents,
        actionId: footer.actionId
    }), /* @__PURE__ */ React106.createElement(ProductCardLink, {
        data: data,
        isRouteAndHoverDifferent: isRouteAndHoverDifferent,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb
    }))));
};
LodgingCardCompact.displayName = "LodgingCardCompact";
// src/components/lodging-card/lodging-card-compact-horizontal.tsx
import React108 from "react";
import Lazyload from "react-lazy-load";
import { EGDSCardContentSection as EGDSCardContentSection4, EGDSCardFeaturedHeader as EGDSCardFeaturedHeader2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex24 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition9 } from "@egds/react-core/layout-position";
import { Card as Card2 } from "@egds/react-lodging";
// src/components/lodging-card/__private/lodging-card-compact-horizontal-content-section.tsx
import React107 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex23, EGDSLayoutFlexItem as EGDSLayoutFlexItem18 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition8 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing21, EGDSSpacingHr as EGDSSpacingHr5 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
var LodgingCardCompactHorizontalContentSection = function(param) {
    var data = param.data, isAd2 = param.isAd, _param_view = param.view, view = _param_view === void 0 ? "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */  : _param_view, headingOverflow = param.headingOverflow, isReview = param.isReview, showDismissButton = param.showDismissButton, onCardDismiss = param.onCardDismiss, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? {
        heading: 6
    } : _param_headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView, isSRPListingCard = param.isSRPListingCard, _param_isPinnedSRPCta = param.isPinnedSRPCta, isPinnedSRPCta = _param_isPinnedSRPCta === void 0 ? false : _param_isPinnedSRPCta;
    var _priceSection_priceSummary;
    var isBEXGSplitViewExperimentEnabled = useExperiment5("Split_View_Side_by_side_BEXG_H").exposure.bucket === 1;
    var shouldUseOriginalRowStart = isBEXGSplitViewExperimentEnabled && !isSRPListingCard;
    var _obj;
    var rowStartMap = (_obj = {}, _define_property(_obj, ViewSizes.SMALL, void 0), _define_property(_obj, ViewSizes.EXTRA_LARGE, shouldUseOriginalRowStart ? 1 : 2), _obj);
    var rowStart = useViewportMap(rowStartMap);
    var headingSection = data.headingSection, priceSection = data.priceSection, callOut = data.callOut, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection, id = data.id;
    var hasRightColumn = callOut || priceSection;
    return /* @__PURE__ */ React107.createElement(React107.Fragment, null, headingSection && /* @__PURE__ */ React107.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */ React107.createElement(EGDSSpacing21, {
        padding: {
            blockend: isOptimizedView ? void 0 : "three"
        }
    }, /* @__PURE__ */ React107.createElement(LodgingCardHeadingSection, {
        data: headingSection,
        size: headingSize,
        headingOverflow: headingOverflow,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton,
        isOptimizedView: isOptimizedView
    }))), /* @__PURE__ */ React107.createElement(EGDSLayoutFlexItem18, {
        grow: 1
    }, /* @__PURE__ */ React107.createElement(EGDSLayoutGrid5, {
        columns: 1,
        space: isOptimizedView ? "one" : "two"
    }, /* @__PURE__ */ React107.createElement(EGDSLayoutGridItem4, {
        rowStart: rowStart,
        colSpan: hasRightColumn ? 2 : 3,
        alignSelf: "end"
    }, /* @__PURE__ */ React107.createElement("div", null, summarySections.map(function(summarySection, index) {
        return /* @__PURE__ */ React107.createElement(React107.Fragment, {
            key: "summary-section-".concat(index)
        }, index > 0 && /* @__PURE__ */ React107.createElement(EGDSSpacingHr5, {
            blockMargin: "three"
        }), /* @__PURE__ */ React107.createElement(LodgingCardProductSummarySection, {
            data: summarySection,
            view: view,
            isReview: isReview,
            isOptimizedView: isOptimizedView,
            isAd: isAd2,
            isSRPListingCard: isSRPListingCard
        }));
    }))), hasRightColumn && /* @__PURE__ */ React107.createElement(EGDSLayoutGridItem4, {
        rowStart: 2,
        colSpan: 2,
        justifySelf: "end",
        alignSelf: "end"
    }, callOut && /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(LodgingEGDSText, {
        data: callOut,
        align: "right"
    })), priceSection && /* @__PURE__ */ React107.createElement(EGDSLayoutFlex23, {
        direction: "column"
    }, /* @__PURE__ */ React107.createElement(EGDSLayoutFlexItem18, {
        alignSelf: "end"
    }, /* @__PURE__ */ React107.createElement(EGDSLayoutPosition8, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React107.createElement(LodgingStandardBadge, {
        data: priceSection.standardBadge,
        propertyId: id
    }), " ")), /* @__PURE__ */ React107.createElement(PriceSectionPriceSummary, {
        priceSummary: priceSection.priceSummary,
        enableInlineLink: enableInlineLink
    }), ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.marketingFeeDetails) && /* @__PURE__ */ React107.createElement(EGDSLayoutFlexItem18, {
        alignSelf: "end"
    }, /* @__PURE__ */ React107.createElement(EGDSSpacing21, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(LodgingCardMarketingFeeDetail, {
        data: priceSection.priceSummary.marketingFeeDetails,
        id: id
    })))), (priceSection === null || priceSection === void 0 ? void 0 : priceSection.button) && /* @__PURE__ */ React107.createElement(EGDSLayoutPosition8, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React107.createElement(EGDSSpacing21, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(LodgingMODSignInButton, {
        data: priceSection.button,
        isPinnedSRPCta: isPinnedSRPCta
    })))), dateSection && /* @__PURE__ */ React107.createElement(EGDSLayoutFlexItem18, {
        alignSelf: "end"
    }, /* @__PURE__ */ React107.createElement(EGDSSpacing21, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(LodgingCardDateSection, {
        data: dateSection
    })))), compareSection && /* @__PURE__ */ React107.createElement(LodgingCardCompareSectionGated, {
        propertyId: id,
        data: compareSection,
        isAd: isAd2
    }))))));
};
LodgingCardCompactHorizontalContentSection.displayName = "LodgingCardCompactHorizontalContentSection";
// src/components/lodging-card/lodging-card-compact-horizontal.tsx
var LodgingCardCompactHorizontal = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onHoverChanged = param.onHoverChanged, onCardDismiss = param.onCardDismiss, appendAdditionalQueryParamCb = param.appendAdditionalQueryParamCb, showDismissButton = param.showDismissButton, headingOverflow = param.headingOverflow, index = param.index, isReview = param.isReview, border = param.border, headingSize = param.headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView, _param_underlineTitleOnHover = param.underlineTitleOnHover, underlineTitleOnHover = _param_underlineTitleOnHover === void 0 ? false : _param_underlineTitleOnHover, isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, fetchPriority = param.fetchPriority, isSRPListingCard = param.isSRPListingCard;
    var _data_shoppingJoinListContainer, _data_shoppingJoinListContainer1;
    var featuredHeader = data.featuredHeader, cardBackgroundTheme = data.cardBackgroundTheme, summarySections = data.summarySections, compareSection = data.compareSection, footerActions = data.footerActions, footer = data.footer, mediaSection = data.mediaSection, cardLink = data.cardLink, callOut = data.callOut, priceSection = data.priceSection, headingSection = data.headingSection, dateSection = data.dateSection, id = data.id, __typename = data.__typename;
    var lodgingCardCompactHorizontalContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var routeLink = isRouteAndHoverDifferent && (data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer === void 0 ? void 0 : _data_shoppingJoinListContainer.actions) ? data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer1 = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer1 === void 0 ? void 0 : _data_shoppingJoinListContainer1.actions[0] : null;
    var lodgingCardMediaSection = /* @__PURE__ */ React108.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */ React108.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        alternateRouteLink: routeLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        index: index,
        fetchPriority: fetchPriority,
        lazyLoadImg: lazyLoadImg
    }));
    var isPinnedCta = footerActions.some(function(footerElement) {
        var _footerElement_link;
        return footerElement.__typename === "LodgingCardLinkAction" && (footerElement === null || footerElement === void 0 ? void 0 : (_footerElement_link = footerElement.link) === null || _footerElement_link === void 0 ? void 0 : _footerElement_link.egdsElementId) === "pinnedSrpCta";
    });
    var formattedDataAttributes = formatDataAttributes(data.dataAttributes);
    var _getBackgroundCardTheme;
    return /* @__PURE__ */ React108.createElement(Card2, _object_spread({
        border: border,
        backgroundTheme: (_getBackgroundCardTheme = getBackgroundCardTheme(cardBackgroundTheme)) !== null && _getBackgroundCardTheme !== void 0 ? _getBackgroundCardTheme : void 0,
        className: className,
        underlineTitleOnHover: underlineTitleOnHover,
        "data-stid": "lodging-card-compact-horizontal",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        },
        onFocus: function() {
            return onHoverChanged(true);
        },
        onBlur: function() {
            return onHoverChanged(false);
        }
    }, formattedDataAttributes), featuredHeader && /* @__PURE__ */ React108.createElement(EGDSCardFeaturedHeader2, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React108.createElement(EGDSLayoutGrid6, {
        columns: 3
    }, !lazyLoadImg && lodgingCardMediaSection, lazyLoadImg && /* @__PURE__ */ React108.createElement(Lazyload, {
        offset: 100
    }, lodgingCardMediaSection), /* @__PURE__ */ React108.createElement(EGDSLayoutGridItem5, {
        colSpan: 2
    }, /* @__PURE__ */ React108.createElement(EGDSLayoutPosition9, {
        type: "relative"
    }, /* @__PURE__ */ React108.createElement(EGDSCardContentSection4, null, /* @__PURE__ */ React108.createElement(EGDSLayoutFlex24, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React108.createElement(LodgingCardCompactHorizontalContentSection, {
        data: lodgingCardCompactHorizontalContentSectionData,
        isAd: isAd(mediaSection),
        headingOverflow: headingOverflow,
        isReview: isReview,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink,
        isOptimizedView: isOptimizedView,
        isSRPListingCard: !!isSRPListingCard,
        isPinnedSRPCta: isPinnedCta
    }), footerActions.length > 0 && /* @__PURE__ */ React108.createElement(ProductCardFooterActions, {
        footerActions: footerActions,
        id: id,
        isPinnedCta: isPinnedCta
    })))))), footer && /* @__PURE__ */ React108.createElement(ProductCardFooter, {
        footerSectionContents: footer.contents,
        actionId: footer.actionId
    }), /* @__PURE__ */ React108.createElement(ProductCardLink, {
        data: data,
        isRouteAndHoverDifferent: isRouteAndHoverDifferent,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
        isSRPListingCard: !!isSRPListingCard
    }));
};
LodgingCardCompactHorizontal.displayName = "LodgingCardCompactHorizontal";
// src/components/lodging-card/lodging-card-responsive.tsx
import React109 from "react";
import Lazyload2 from "react-lazy-load";
import { EGDSCardContentSection as EGDSCardContentSection5, EGDSCardFeaturedHeader as EGDSCardFeaturedHeader3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex25 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid7, EGDSLayoutGridItem as EGDSLayoutGridItem6 } from "@egds/react-core/layout-grid";
import { Card as Card3 } from "@egds/react-lodging";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium7, Viewport as Viewport7, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
var LodgingCardResponsive = function(props) {
    var _data_shoppingJoinListContainer, _data_shoppingJoinListContainer1;
    var className = props.className, data = props.data, imageRatio = props.imageRatio, lazyLoadImg = props.lazyLoadImg, onHoverChanged = props.onHoverChanged, appendAdditionalQueryParamCb = props.appendAdditionalQueryParamCb, view = props.view, headingOverflow = props.headingOverflow, index = props.index, isReview = props.isReview, border = props.border, headingSize = props.headingSize, isSRPListingCard = props.isSRPListingCard, _props_enableInlineLink = props.enableInlineLink, enableInlineLink = _props_enableInlineLink === void 0 ? false : _props_enableInlineLink, isOptimizedView = props.isOptimizedView, _props_underlineTitleOnHover = props.underlineTitleOnHover, underlineTitleOnHover = _props_underlineTitleOnHover === void 0 ? false : _props_underlineTitleOnHover, isRouteAndHoverDifferent = props.isRouteAndHoverDifferent, fetchPriority = props.fetchPriority;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, cardBackgroundTheme = data.cardBackgroundTheme, footerActions = data.footerActions, footer = data.footer, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var routeLink = isRouteAndHoverDifferent && (data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer === void 0 ? void 0 : _data_shoppingJoinListContainer.actions) ? data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer1 = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer1 === void 0 ? void 0 : _data_shoppingJoinListContainer1.actions[0] : null;
    var lodgingCardMediaSection = /* @__PURE__ */ React109.createElement(EGDSLayoutGridItem6, null, /* @__PURE__ */ React109.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        alternateRouteLink: routeLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        index: index,
        isSRPListingCard: isSRPListingCard,
        fetchPriority: fetchPriority,
        lazyLoadImg: lazyLoadImg
    }));
    var isPinnedCta = footerActions.some(function(footerElement) {
        var _footerElement_link;
        return footerElement.__typename === "LodgingCardLinkAction" && (footerElement === null || footerElement === void 0 ? void 0 : (_footerElement_link = footerElement.link) === null || _footerElement_link === void 0 ? void 0 : _footerElement_link.egdsElementId) === "pinnedSrpCta";
    });
    var _isAd = isAd(mediaSection);
    var formattedDataAttributes = formatDataAttributes(data.dataAttributes);
    var _getBackgroundCardTheme;
    return /* @__PURE__ */ React109.createElement(Viewport7, null, /* @__PURE__ */ React109.createElement(ViewSmall6, null, /* @__PURE__ */ React109.createElement(LodgingCardCompact, _object_spread_props(_object_spread({}, props), {
        isOptimizedView: isOptimizedView
    }))), /* @__PURE__ */ React109.createElement(ViewMedium7, null, /* @__PURE__ */ React109.createElement(Card3, _object_spread({
        border: border,
        backgroundTheme: (_getBackgroundCardTheme = getBackgroundCardTheme(cardBackgroundTheme)) !== null && _getBackgroundCardTheme !== void 0 ? _getBackgroundCardTheme : void 0,
        className: className,
        underlineTitleOnHover: underlineTitleOnHover,
        "data-stid": "lodging-card-responsive",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        },
        onFocus: function() {
            return onHoverChanged(true);
        },
        onBlur: function() {
            return onHoverChanged(false);
        }
    }, formattedDataAttributes), featuredHeader && /* @__PURE__ */ React109.createElement(EGDSCardFeaturedHeader3, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React109.createElement(EGDSLayoutGrid7, {
        columns: {
            medium: 3
        }
    }, lazyLoadImg ? /* @__PURE__ */ React109.createElement(Lazyload2, {
        offset: 100
    }, lodgingCardMediaSection) : lodgingCardMediaSection, /* @__PURE__ */ React109.createElement(EGDSLayoutGridItem6, {
        colSpan: {
            medium: 2
        }
    }, /* @__PURE__ */ React109.createElement(EGDSCardContentSection5, null, /* @__PURE__ */ React109.createElement(Viewport7, null, /* @__PURE__ */ React109.createElement(ViewMedium7, null, /* @__PURE__ */ React109.createElement(EGDSLayoutFlex25, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        style: {
            minHeight: 111
        }
    }, /* @__PURE__ */ React109.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: _isAd,
        view: view || "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ ,
        headingOverflow: headingOverflow,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink,
        isPinnedSRPCta: isPinnedCta
    }), footerActions.length > 0 && /* @__PURE__ */ React109.createElement(ProductCardFooterActions, {
        footerActions: footerActions,
        id: id,
        isPinnedCta: isPinnedCta
    }))), /* @__PURE__ */ React109.createElement(ViewLarge3, null, /* @__PURE__ */ React109.createElement(EGDSLayoutFlex25, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        style: {
            minHeight: 143
        }
    }, /* @__PURE__ */ React109.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: _isAd,
        view: view,
        headingOverflow: headingOverflow,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink,
        isSRPListingCard: !!isSRPListingCard,
        isPinnedSRPCta: isPinnedCta
    }), footerActions.length > 0 && /* @__PURE__ */ React109.createElement(ProductCardFooterActions, {
        footerActions: footerActions,
        id: id,
        isPinnedCta: isPinnedCta
    }))))))), footer && /* @__PURE__ */ React109.createElement(ProductCardFooter, {
        footerSectionContents: footer === null || footer === void 0 ? void 0 : footer.contents,
        actionId: footer.actionId
    }), /* @__PURE__ */ React109.createElement(ProductCardLink, {
        data: data,
        isRouteAndHoverDifferent: isRouteAndHoverDifferent,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb
    }))));
};
LodgingCardResponsive.displayName = "LodgingCardResponsive";
// src/components/lodging-card/lodging-grid-view-card/lodging-grid-view-card.tsx
import React112 from "react";
import { EGDSCardContentSection as EGDSCardContentSection6, EGDSCardFeaturedHeader as EGDSCardFeaturedHeader4 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex26, EGDSLayoutFlexItem as EGDSLayoutFlexItem19 } from "@egds/react-core/layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "@egds/react-core/layout-position";
import { Card as Card4 } from "@egds/react-lodging";
// src/components/lodging-card/lodging-grid-view-card/lodging-grid-view-card-content-section.tsx
import React110 from "react";
// src/components/lodging-card/lodging-grid-view-card/utils.ts
import { EGDSBadgeSize as EGDSBadgeSize3 } from "@egds/react-core/badge";
var getGridViewBadge = function(originalBadge) {
    var _originalBadge_theme;
    if (!originalBadge) {
        return null;
    }
    if ((_originalBadge_theme = originalBadge.theme) === null || _originalBadge_theme === void 0 ? void 0 : _originalBadge_theme.match(/^(family-friendly|vip[a-z-]*)$/)) {
        return null;
    }
    return {
        __typename: "EGDSStandardBadge",
        graphic: null,
        size: EGDSBadgeSize3.SMALL,
        theme: originalBadge.theme,
        text: originalBadge.text
    };
};
var isEGDSStylizedText = function(message) {
    return message.__typename === "EGDSStylizedText";
};
var getGridViewHeadingSection = function(headingSection) {
    var _headingSection_messages, _messages__text, _messages_, _headingSection_standardBadges;
    if (!headingSection) {
        return null;
    }
    var _headingSection_messages_filter;
    var messages = (_headingSection_messages_filter = (_headingSection_messages = headingSection.messages) === null || _headingSection_messages === void 0 ? void 0 : _headingSection_messages.filter(isEGDSStylizedText)) !== null && _headingSection_messages_filter !== void 0 ? _headingSection_messages_filter : [];
    if (messages.length && !((_messages_ = messages[messages.length - 1]) === null || _messages_ === void 0 ? void 0 : (_messages__text = _messages_.text) === null || _messages__text === void 0 ? void 0 : _messages__text.match(/\d/))) {
        messages.pop();
    }
    var _headingSection_standardBadges_map;
    return _object_spread_props(_object_spread({}, headingSection), {
        amenities: [],
        missingFilters: null,
        messages: messages,
        // Multiple units VR badge should be small
        standardBadges: (_headingSection_standardBadges_map = (_headingSection_standardBadges = headingSection.standardBadges) === null || _headingSection_standardBadges === void 0 ? void 0 : _headingSection_standardBadges.map(function(badge) {
            return _object_spread_props(_object_spread({}, badge), {
                size: EGDSBadgeSize3.SMALL
            });
        })) !== null && _headingSection_standardBadges_map !== void 0 ? _headingSection_standardBadges_map : null
    });
};
var nulledOutSummarySection = {
    __typename: "LodgingCardProductSummarySection",
    heading: null,
    messages: [],
    descriptionSection: null,
    amenities: [],
    footerMessages: null,
    guestRatingSection: null,
    guestRatingSectionV2: null,
    detailsAction: null,
    changeActionDialog: null,
    changeActionSheet: null,
    detailsLink: null
};
var shouldDisplayGuestRatingPhrase = function(phrase) {
    var _phrase_phraseParts_filter;
    return ((_phrase_phraseParts_filter = phrase.phraseParts.filter(function(phrasePart) {
        if (phrasePart.__typename === "EGDSStylizedText" && phrasePart.theme === "EMPHASIS" /* EMPHASIS */ ) {
            return false;
        }
        return true;
    })) === null || _phrase_phraseParts_filter === void 0 ? void 0 : _phrase_phraseParts_filter.length) > 0;
};
var getGridViewSummarySection = function(summarySection) {
    var _summarySection_guestRatingSection;
    if (!summarySection.guestRatingSection) {
        return null;
    }
    if (((_summarySection_guestRatingSection = summarySection.guestRatingSection) === null || _summarySection_guestRatingSection === void 0 ? void 0 : _summarySection_guestRatingSection.__typename) === "LodgingCardBadgedRating") {
        var _summarySection_guestRatingSection_phrases_filter, _summarySection_guestRatingSection_phrases;
        var _summarySection_guestRatingSection_phrases_filter_map;
        return _object_spread_props(_object_spread({}, nulledOutSummarySection), {
            guestRatingSection: _object_spread_props(_object_spread({}, summarySection.guestRatingSection), {
                badge: _object_spread_props(_object_spread({}, summarySection.guestRatingSection.badge), {
                    badgeSize: EGDSBadgeSize3.SMALL
                }),
                phrases: (_summarySection_guestRatingSection_phrases_filter_map = (_summarySection_guestRatingSection_phrases = summarySection.guestRatingSection.phrases) === null || _summarySection_guestRatingSection_phrases === void 0 ? void 0 : (_summarySection_guestRatingSection_phrases_filter = _summarySection_guestRatingSection_phrases.filter(shouldDisplayGuestRatingPhrase)) === null || _summarySection_guestRatingSection_phrases_filter === void 0 ? void 0 : _summarySection_guestRatingSection_phrases_filter.map(function(phrase) {
                    return _object_spread_props(_object_spread({}, phrase), {
                        parts: []
                    });
                })) !== null && _summarySection_guestRatingSection_phrases_filter_map !== void 0 ? _summarySection_guestRatingSection_phrases_filter_map : []
            })
        });
    }
    var _summarySection_guestRatingSection1;
    return _object_spread_props(_object_spread({}, nulledOutSummarySection), {
        guestRatingSection: (_summarySection_guestRatingSection1 = summarySection.guestRatingSection) !== null && _summarySection_guestRatingSection1 !== void 0 ? _summarySection_guestRatingSection1 : null
    });
};
var getGridViewStylizedText = function(stylizedText) {
    return stylizedText ? _object_spread_props(_object_spread({}, stylizedText), {
        size: "200"
    }) : null;
};
var getGridViewDateSection = function(dateSection) {
    var _dateSection_messages;
    if (!dateSection) {
        return null;
    }
    var _dateSection_messages_map;
    return {
        __typename: "LodgingCardDateSection",
        date: getGridViewStylizedText(dateSection.date),
        messages: (_dateSection_messages_map = (_dateSection_messages = dateSection.messages) === null || _dateSection_messages === void 0 ? void 0 : _dateSection_messages.map(getGridViewStylizedText)) !== null && _dateSection_messages_map !== void 0 ? _dateSection_messages_map : null
    };
};
var getGridViewCallOut = function(callOut) {
    if ((callOut === null || callOut === void 0 ? void 0 : callOut.__typename) === "EGDSStylizedText") {
        return getGridViewStylizedText(callOut);
    }
    return callOut;
};
var getGridViewPriceSection = function(priceSection) {
    var _priceSection_priceSummary, _priceSection_standardBadge;
    if (!priceSection) {
        return null;
    }
    var _priceSection_priceSummary_displayMessages;
    return {
        __typename: "LodgingCardPriceSection",
        priceSummary: _object_spread_props(_object_spread({}, priceSection === null || priceSection === void 0 ? void 0 : priceSection.priceSummary), {
            __typename: "PropertyPrice",
            options: null,
            priceMessaging: null,
            marketingFeeDetails: null,
            displayMessages: (_priceSection_priceSummary_displayMessages = priceSection === null || priceSection === void 0 ? void 0 : (_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.displayMessages) !== null && _priceSection_priceSummary_displayMessages !== void 0 ? _priceSection_priceSummary_displayMessages : []
        }),
        standardBadge: _object_spread_props(_object_spread({}, priceSection === null || priceSection === void 0 ? void 0 : priceSection.standardBadge), {
            __typename: "LodgingStandardBadge",
            standardBadge: getGridViewBadge(priceSection === null || priceSection === void 0 ? void 0 : (_priceSection_standardBadge = priceSection.standardBadge) === null || _priceSection_standardBadge === void 0 ? void 0 : _priceSection_standardBadge.standardBadge),
            impressionEventAnalytics: null
        }),
        badge: null,
        button: null
    };
};
// src/components/lodging-card/lodging-grid-view-card/lodging-grid-view-card-content-section.tsx
var LodgingGridViewCardContentSection = function(param) {
    var data = param.data, enableInlineLink = param.enableInlineLink, tmp = param.isAd, isAd2 = tmp === void 0 ? false : tmp, isPinnedSRPCta = param.isPinnedSRPCta;
    var lodgingCardContentSectionData = _object_spread_props(_object_spread({}, data), {
        headingSection: getGridViewHeadingSection(data.headingSection),
        summarySections: data.summarySections.map(getGridViewSummarySection).filter(Boolean),
        dateSection: getGridViewDateSection(data.dateSection),
        priceSection: getGridViewPriceSection(data.priceSection),
        callOut: getGridViewCallOut(data.callOut)
    });
    return /* @__PURE__ */ React110.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: isAd2,
        view: "COMPACT" /* COMPACT */ ,
        headingOverflow: "truncate-2-lines",
        headingSize: {
            heading: 7,
            subHeading: 200
        },
        enableInlineLink: enableInlineLink,
        isOneColumnLayout: true,
        isSRPListingCard: true,
        isPinnedSRPCta: isPinnedSRPCta
    });
};
// src/components/lodging-card/lodging-grid-view-card/lodging-grid-view-card-media-section.tsx
import React111 from "react";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType6 } from "@egds/react-core/images";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
var LodgingGridViewCardMediaSection = function(param) {
    var data = param.data, cardLink = param.cardLink, alternateRouteLink = param.alternateRouteLink, propertyId = param.propertyId, index = param.index, fetchPriority = param.fetchPriority;
    var _context_device, _data_gallery_media, _data_gallery, _data_gallery1, _data_badges, _data_badges1, _data_badges2;
    var context = useBexApi4().context;
    var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var _data_gallery_media1;
    var gridViewData = _object_spread_props(_object_spread({}, data), {
        gallery: _object_spread_props(_object_spread({}, data.gallery), {
            media: isMobile && ((_data_gallery = data.gallery) === null || _data_gallery === void 0 ? void 0 : (_data_gallery_media = _data_gallery.media) === null || _data_gallery_media === void 0 ? void 0 : _data_gallery_media[0]) ? [
                data.gallery.media[0]
            ] : (_data_gallery_media1 = (_data_gallery1 = data.gallery) === null || _data_gallery1 === void 0 ? void 0 : _data_gallery1.media) !== null && _data_gallery_media1 !== void 0 ? _data_gallery_media1 : []
        }),
        badges: _object_spread_props(_object_spread({}, data.badges), {
            __typename: "LodgingBadgesGroup",
            primaryBadge: getGridViewBadge((_data_badges = data.badges) === null || _data_badges === void 0 ? void 0 : _data_badges.primaryBadge),
            secondaryBadge: getGridViewBadge((_data_badges1 = data.badges) === null || _data_badges1 === void 0 ? void 0 : _data_badges1.secondaryBadge),
            tertiaryBadge: getGridViewBadge((_data_badges2 = data.badges) === null || _data_badges2 === void 0 ? void 0 : _data_badges2.tertiaryBadge)
        })
    });
    return /* @__PURE__ */ React111.createElement(LodgingCardMediaSection, {
        data: gridViewData,
        cardLink: cardLink,
        alternateRouteLink: alternateRouteLink,
        propertyId: propertyId,
        imageRatio: isMobile ? EGDSFigureAspectRatioType6.R1_1 : EGDSFigureAspectRatioType6.R4_3,
        index: index,
        fetchPriority: fetchPriority
    });
};
// src/components/lodging-card/lodging-grid-view-card/lodging-grid-view-card.tsx
var LodgingGridViewCard = function(param) {
    var data = param.data, className = param.className, onHoverChangedProp = param.onHoverChanged, appendAdditionalQueryParamCbProp = param.appendAdditionalQueryParamCb, index = param.index, border = param.border, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, fetchPriority = param.fetchPriority;
    var _data_shoppingJoinListContainer, _data_shoppingJoinListContainer1;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, cardBackgroundTheme = data.cardBackgroundTheme, footerActions = data.footerActions, footer = data.footer, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var routeLink = isRouteAndHoverDifferent && (data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer === void 0 ? void 0 : _data_shoppingJoinListContainer.actions) ? data === null || data === void 0 ? void 0 : (_data_shoppingJoinListContainer1 = data.shoppingJoinListContainer) === null || _data_shoppingJoinListContainer1 === void 0 ? void 0 : _data_shoppingJoinListContainer1.actions[0] : null;
    var isPinnedCta = footerActions.some(function(footerElement) {
        var _footerElement_link;
        return footerElement.__typename === "LodgingCardLinkAction" && (footerElement === null || footerElement === void 0 ? void 0 : (_footerElement_link = footerElement.link) === null || _footerElement_link === void 0 ? void 0 : _footerElement_link.egdsElementId) === "pinnedSrpCta";
    });
    var onHoverChanged = function(hovered) {
        return onHoverChangedProp === null || onHoverChangedProp === void 0 ? void 0 : onHoverChangedProp(hovered, data);
    };
    var appendAdditionalQueryParamCb = function(url) {
        var _appendAdditionalQueryParamCbProp;
        return (_appendAdditionalQueryParamCbProp = appendAdditionalQueryParamCbProp === null || appendAdditionalQueryParamCbProp === void 0 ? void 0 : appendAdditionalQueryParamCbProp(url, data)) !== null && _appendAdditionalQueryParamCbProp !== void 0 ? _appendAdditionalQueryParamCbProp : "";
    };
    var formattedDataAttributes = formatDataAttributes(data.dataAttributes);
    var _getBackgroundCardTheme;
    return /* @__PURE__ */ React112.createElement(EGDSLayoutFlex26, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React112.createElement(EGDSLayoutFlexItem19, {
        grow: 1
    }, /* @__PURE__ */ React112.createElement(Card4, _object_spread({
        border: border,
        backgroundTheme: (_getBackgroundCardTheme = getBackgroundCardTheme(cardBackgroundTheme)) !== null && _getBackgroundCardTheme !== void 0 ? _getBackgroundCardTheme : void 0,
        className: className,
        "data-stid": "lodging-grid-view-card",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        },
        onFocus: function() {
            return onHoverChanged(true);
        },
        onBlur: function() {
            return onHoverChanged(false);
        }
    }, formattedDataAttributes), featuredHeader && /* @__PURE__ */ React112.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            left: "zero",
            top: "zero",
            right: "zero",
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React112.createElement(EGDSCardFeaturedHeader4, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    })), /* @__PURE__ */ React112.createElement(EGDSLayoutFlex26, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React112.createElement(EGDSLayoutFlexItem19, {
        grow: 0
    }, /* @__PURE__ */ React112.createElement("div", null, /* @__PURE__ */ React112.createElement(LodgingGridViewCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        alternateRouteLink: routeLink,
        propertyId: id,
        index: index,
        fetchPriority: fetchPriority
    }))), /* @__PURE__ */ React112.createElement(EGDSLayoutFlexItem19, {
        grow: 1
    }, /* @__PURE__ */ React112.createElement(EGDSCardContentSection6, null, /* @__PURE__ */ React112.createElement(EGDSLayoutFlex26, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React112.createElement(LodgingGridViewCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: isAd(mediaSection),
        enableInlineLink: enableInlineLink,
        isPinnedSRPCta: isPinnedCta
    }), footerActions.length > 0 && /* @__PURE__ */ React112.createElement(ProductCardFooterActions, {
        footerActions: footerActions,
        id: id,
        isPinnedCta: isPinnedCta
    }))))), footer && /* @__PURE__ */ React112.createElement(ProductCardFooter, {
        footerSectionContents: footer.contents,
        actionId: footer.actionId
    }), /* @__PURE__ */ React112.createElement(ProductCardLink, {
        data: data,
        isRouteAndHoverDifferent: isRouteAndHoverDifferent,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb
    }))));
};
LodgingGridViewCard.displayName = "LodgingGridViewCard";
// src/components/lodging-card/lodging-card.tsx
var fragment80 = gql88(_templateObject88(), AdaptExAnalyticsEventFragment, LodgingCardMediaSection.fragment, LodgingCardHeadingSection.fragment, LodgingCardContentSection.fragment, LodgingCardLink.fragment, ProductCardSheet.fragment, ProductCardSheetListContent.fragment, ProductCardSheetTabularContent.fragment, ProductCardSheetSectionalContent.fragment, ProductCardOverlay.fragment, ProductCardFooterAction.fragment, ProductCardContent.fragment, ProductCardFooterSectionContent.fragment, ShoppingButton.fragment);
var LodgingCardByView = function(view, props) {
    var shouldChangeCardDisplayOnHover = props.shouldChangeCardDisplayOnHover;
    switch(view){
        case "COMPACT" /* COMPACT */ :
            return {
                lodgingCard: /* @__PURE__ */ React113.createElement(LodgingCardCompact, _object_spread({}, props)),
                trackerClassName: "uitk-card-roundcorner-all uitk-card-has-primary-theme"
            };
        case "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ :
            return {
                lodgingCard: /* @__PURE__ */ React113.createElement(LodgingCardCompactHorizontal, _object_spread({}, props))
            };
        case "GRID" /* GRID */ :
            return {
                lodgingCard: /* @__PURE__ */ React113.createElement(LodgingGridViewCard, _object_spread({}, props))
            };
        default:
            return {
                lodgingCard: /* @__PURE__ */ React113.createElement(Viewport8, null, /* @__PURE__ */ React113.createElement(ViewLarge4, null, /* @__PURE__ */ React113.createElement(LodgingCardResponsive, _object_spread({
                    underlineTitleOnHover: shouldChangeCardDisplayOnHover
                }, props))), /* @__PURE__ */ React113.createElement(ViewMedium8, null, /* @__PURE__ */ React113.createElement(LodgingCardResponsive, _object_spread({}, props))), /* @__PURE__ */ React113.createElement(ViewSmall7, null, /* @__PURE__ */ React113.createElement(LodgingCardResponsive, _object_spread({}, props))))
            };
    }
};
var LodgingCard = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClickCallback = param.onClickCallback, onHoverChanged = param.onHoverChanged, onCardDismiss = param.onCardDismiss, appendAdditionalQueryParamCb = param.appendAdditionalQueryParamCb, showDismissButton = param.showDismissButton, headingOverflow = param.headingOverflow, index = param.index, _param_fireCardImpression = param.fireCardImpression, fireCardImpression = _param_fireCardImpression === void 0 ? true : _param_fireCardImpression, isReview = param.isReview, _param_border = param.border, border = _param_border === void 0 ? false : _param_border, headingSize = param.headingSize, _param_isSRPListingCard = param.isSRPListingCard, isSRPListingCard = _param_isSRPListingCard === void 0 ? false : _param_isSRPListingCard, _param_fireImpressionByViewability = param.fireImpressionByViewability, fireImpressionByViewability = _param_fireImpressionByViewability === void 0 ? false : _param_fireImpressionByViewability, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isFirstModIndex = param.isFirstModIndex, _param_shouldChangeCardDisplayOnHover = param.shouldChangeCardDisplayOnHover, shouldChangeCardDisplayOnHover = _param_shouldChangeCardDisplayOnHover === void 0 ? false : _param_shouldChangeCardDisplayOnHover, _param_isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, isRouteAndHoverDifferent = _param_isRouteAndHoverDifferent === void 0 ? false : _param_isRouteAndHoverDifferent, _param_isOneColumnLayout = param.isOneColumnLayout, isOneColumnLayout = _param_isOneColumnLayout === void 0 ? false : _param_isOneColumnLayout, fetchPriority = param.fetchPriority, placement = param.placement, onClickScrollToView = param.onClickScrollToView;
    var _context_device, _data_renderAnalytics;
    var context = useBexApi5().context;
    var impressionAnalytics = data.impressionAnalytics;
    var _ref = impressionAnalytics !== null && impressionAnalytics !== void 0 ? impressionAnalytics : {}, url = _ref.url, referrerId = _ref.referrerId, linkName = _ref.linkName, uisPrimeMessages = _ref.uisPrimeMessages;
    var additionalUisPrimeMicroMessages2 = parseLodgingCardImpressionSchema(uisPrimeMessages);
    var shouldUseViewability = url && fireImpressionByViewability;
    var componentRef = useMesoViewabilityWrapper({
        viewabilityBeacon: url
    }).componentRef;
    var shoppingInvokeFunctionCallBack2 = useShoppingInvokeFunctionCallBack();
    var isOptimizedView = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var MOD_AND_DRR_TRACKING = {
        referrerId: "ModAvailableStackedWithDRR.propertyRankonSRPnumber_",
        linkName: "first MOD & DRR stacked property impression"
    };
    var onHoverChangedWithId = React113.useCallback(function(hovered) {
        onHoverChanged === null || onHoverChanged === void 0 ? void 0 : onHoverChanged(hovered, data);
    }, [
        onHoverChanged
    ]);
    var appendAdditionalQueryParamCbWithLodgingCard = React113.useCallback(function(link) {
        return (appendAdditionalQueryParamCb === null || appendAdditionalQueryParamCb === void 0 ? void 0 : appendAdditionalQueryParamCb(link, data)) || link;
    }, []);
    useMesoBeaconFrameworkWrapper((_data_renderAnalytics = data.renderAnalytics) === null || _data_renderAnalytics === void 0 ? void 0 : _data_renderAnalytics.urls);
    useEffect4(function() {
        if (url && fireCardImpression && !fireImpressionByViewability) {
            fetch(url).then(function(response) {
                return response;
            });
        }
    }, [
        impressionAnalytics
    ]);
    var props = {
        className: className,
        data: data,
        index: index,
        lazyLoadImg: lazyLoadImg,
        imageRatio: imageRatio,
        onCardDismiss: onCardDismiss,
        onHoverChanged: onHoverChangedWithId,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCbWithLodgingCard,
        showDismissButton: showDismissButton,
        headingOverflow: headingOverflow,
        isReview: isReview,
        border: border,
        headingSize: headingSize,
        isSRPListingCard: isSRPListingCard,
        enableInlineLink: enableInlineLink,
        isOptimizedView: isOptimizedView,
        isRouteAndHoverDifferent: isRouteAndHoverDifferent,
        isOneColumnLayout: isOneColumnLayout,
        fetchPriority: fetchPriority,
        shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover
    };
    var lodgingCardWrapper = LodgingCardByView(view, props);
    var lodgingCardComponent = function() {
        return referrerId && linkName ? /* @__PURE__ */ React113.createElement(IntersectionTracker7, {
            className: lodgingCardWrapper.trackerClassName,
            referrerId: referrerId,
            linkName: linkName,
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages2
        }, lodgingCardWrapper.lodgingCard) : lodgingCardWrapper.lodgingCard;
    };
    var lodgingCardComponentWithModDRRTracking = function() {
        return isFirstModIndex ? /* @__PURE__ */ React113.createElement(IntersectionTracker7, {
            referrerId: MOD_AND_DRR_TRACKING.referrerId + index,
            linkName: MOD_AND_DRR_TRACKING.linkName,
            trackOnce: true
        }, lodgingCardComponent()) : lodgingCardComponent();
    };
    return /* @__PURE__ */ React113.createElement(ShoppingActionProvider, {
        id: data.id,
        shoppingJoinListContainer: data.shoppingJoinListContainer
    }, /* @__PURE__ */ React113.createElement(ProductCardProvider, {
        data: data,
        onClickCallback: onClickCallback,
        shoppingInvokeFunctionCallBack: shoppingInvokeFunctionCallBack2,
        placement: placement,
        onClickScrollToView: onClickScrollToView
    }, shouldUseViewability ? /* @__PURE__ */ React113.createElement("div", {
        ref: componentRef
    }, lodgingCardComponentWithModDRRTracking()) : lodgingCardComponentWithModDRRTracking()));
};
LodgingCard.fragment = fragment80;
LodgingCard.displayName = "LodgingCard";
// src/components/product-card-carousel/product-card-carousel-invoke-function-reducer.ts
var productShoppingInvokeFunctionReducer = function(state, action) {
    switch(action.type){
        case 0 /* SHOW_LOADING_STATE */ :
            return _object_spread_props(_object_spread({}, state), {
                toastData: {
                    disabled: true,
                    loading: true,
                    message: null,
                    actionId: null,
                    typeOfOperation: ""
                }
            });
        case 1 /* SHOW_ADD_VEHICLE_TOAST_MESSAGE */ :
            var _action_payload, _action_payload1;
            return _object_spread_props(_object_spread({}, state), {
                toastData: {
                    loading: false,
                    disabled: true,
                    message: ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.message) || null,
                    actionId: ((_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.actionId) || null,
                    typeOfOperation: "ADD"
                }
            });
        case 2 /* SHOW_REMOVE_VEHICLE_TOAST_MESSAGE */ :
            var _action_payload2;
            return _object_spread_props(_object_spread({}, state), {
                toastData: {
                    loading: false,
                    disabled: true,
                    message: ((_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : _action_payload2.message) || null,
                    actionId: null,
                    typeOfOperation: "REMOVE"
                }
            });
        case 4 /* DISMISS_TOAST_ADD_VEHICLE_MESSAGE */ :
            var _state_toastData;
            return _object_spread_props(_object_spread({}, state), {
                toastData: {
                    message: null,
                    loading: false,
                    disabled: false,
                    actionId: ((_state_toastData = state.toastData) === null || _state_toastData === void 0 ? void 0 : _state_toastData.actionId) || null,
                    typeOfOperation: "ADD"
                }
            });
        case 5 /* DISMISS_TOAST_REMOVE_VEHICLE_MESSAGE */ :
            return _object_spread_props(_object_spread({}, state), {
                toastData: {
                    message: null,
                    loading: false,
                    disabled: false,
                    actionId: null,
                    typeOfOperation: "REMOVE"
                }
            });
        case 3 /* DISMISS_LOADING_STATE */ :
            return _object_spread_props(_object_spread({}, state), {
                toastData: {
                    message: null,
                    loading: false,
                    disabled: false,
                    actionId: null,
                    typeOfOperation: ""
                }
            });
        default:
            return _object_spread({}, state);
    }
};
// src/components/lodging-carousel-container/lodging-carousel-container.tsx
var fragment81 = gql89(_templateObject89(), LodgingCard.fragment);
var LodgingCarouselContainer = function(param) {
    var data = param.data, _param_peek = param.peek, peek = _param_peek === void 0 ? true : _param_peek, _param_pageBy = param.pageBy, pageBy = _param_pageBy === void 0 ? 1 : _param_pageBy, itemsVisible = param.itemsVisible, aspectRatio = param.aspectRatio, _param_headingOverflow = param.headingOverflow, headingOverflow = _param_headingOverflow === void 0 ? "truncate" : _param_headingOverflow, clickstreamConfig = param.clickstreamConfig, _param_isRecommendationModule = param.isRecommendationModule, isRecommendationModule = _param_isRecommendationModule === void 0 ? false : _param_isRecommendationModule, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 4 : _param_headingSize, _param_tag = param.tag, tag = _param_tag === void 0 ? "h3" : _param_tag, carouselName = param.carouselName, margin = param.margin, navigationIconId = param.navigationIconId, _param_fireCardsImpression = param.fireCardsImpression, fireCardsImpression = _param_fireCardsImpression === void 0 ? true : _param_fireCardsImpression, itemViewedCallback = param.itemViewedCallback, isReview = param.isReview, analytics = param.analytics, _param_withCardBorder = param.withCardBorder, withCardBorder = _param_withCardBorder === void 0 ? false : _param_withCardBorder, cardHeadingSize = param.cardHeadingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, fireNextPrevNavEvent = param.fireNextPrevNavEvent, onClickCallback = param.onClickCallback, _param_isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, isRouteAndHoverDifferent = _param_isRouteAndHoverDifferent === void 0 ? false : _param_isRouteAndHoverDifferent, toastMessageVerticalOffset = param.toastMessageVerticalOffset, _param_useContainerSizing = param.useContainerSizing, useContainerSizing = _param_useContainerSizing === void 0 ? true : _param_useContainerSizing, onHoverChanged = param.onHoverChanged;
    var _data_impressionAnalytics, _carousel_nextButton_icon, _carousel_nextButton, _carousel_previousButton_icon, _carousel_previousButton;
    var items = data.items, heading = data.heading, carousel = data.carousel, seoRichContentMetaData = data.seoRichContentMetaData;
    var track = useEgClickstream2();
    var mounting = React114.useRef(0);
    var _data_impressionAnalytics_referrerId;
    var egRecsResponseId = (_data_impressionAnalytics_referrerId = data === null || data === void 0 ? void 0 : (_data_impressionAnalytics = data.impressionAnalytics) === null || _data_impressionAnalytics === void 0 ? void 0 : _data_impressionAnalytics.referrerId) !== null && _data_impressionAnalytics_referrerId !== void 0 ? _data_impressionAnalytics_referrerId : "";
    var _React114_useState = _sliced_to_array(React114.useState(0), 2), prevIndex = _React114_useState[0], setIndex = _React114_useState[1];
    var toastData = useProductShoppingInvokeFunctionToastData();
    var dispatch = useProductShoppingInvokeFunctionDispatch();
    React114.useEffect(function() {
        if (isReview) {
            track(createReviewCarouselPresentedEvent(clickstreamConfig));
        } else {
            track(createPropertyCarouselPresentedEvent(clickstreamConfig));
        }
    }, []);
    var trackRecommendationCarouselPresentedEvent = function(index) {
        track(createRecommendationCarouselPresentedEvent([
            items[index]
        ], egRecsResponseId, index, clickstreamConfig));
    };
    var onItemViewedCallback = function(index) {
        if (isRecommendationModule) {
            trackRecommendationCarouselPresentedEvent(index);
        } else if (itemViewedCallback) {
            itemViewedCallback(index);
        }
    };
    var onCarouselNavSelected = function(index) {
        if (fireNextPrevNavEvent && prevIndex !== index) {
            fireNextPrevNavEvent(prevIndex > index ? "left" : "right");
        }
        setIndex(index);
        if (isReview) {
            var direction = prevIndex > index ? "left" : "right";
            track(createReviewNavSelectedEvent(clickstreamConfig, direction));
        } else if (isRecommendationModule) {
            track(createRecommendationCarouselNavSelectedEvent(clickstreamConfig));
        } else {
            track(createPropertyCarouselNavSelectedEvent(clickstreamConfig));
        }
    };
    var onIndexChange = function(index) {
        if (mounting.current >= 1) {
            onCarouselNavSelected(index);
        } else {
            mounting.current += 1;
        }
    };
    var carouselProps = {
        nextButtonText: carousel === null || carousel === void 0 ? void 0 : (_carousel_nextButton = carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : (_carousel_nextButton_icon = _carousel_nextButton.icon) === null || _carousel_nextButton_icon === void 0 ? void 0 : _carousel_nextButton_icon.description,
        prevButtonText: carousel === null || carousel === void 0 ? void 0 : (_carousel_previousButton = carousel.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : (_carousel_previousButton_icon = _carousel_previousButton.icon) === null || _carousel_previousButton_icon === void 0 ? void 0 : _carousel_previousButton_icon.description,
        pageBy: pageBy,
        peek: peek,
        navigationIconId: navigationIconId,
        itemsVisible: itemsVisible,
        carouselName: carouselName,
        onIndexChange: onIndexChange,
        analytics: analytics,
        useContainerSizing: useContainerSizing
    };
    if (!items.length || !carousel) {
        return null;
    }
    var lodgingCardSelected = function(item, index) {
        if (isReview) {
            track(createReviewCarouselCardSelectedEvent(clickstreamConfig));
        } else if (isRecommendationModule) {
            track(createRecommendationCarouselCardSelectedEvent(item, index, egRecsResponseId, clickstreamConfig));
        } else {
            track(createPropertyCarouselCardSelectedEvent(item, clickstreamConfig));
        }
        onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback(item.id);
    };
    var onDismissToastType = (toastData === null || toastData === void 0 ? void 0 : toastData.typeOfOperation) === "ADD" ? 4 /* DISMISS_TOAST_ADD_VEHICLE_MESSAGE */  : 5 /* DISMISS_TOAST_REMOVE_VEHICLE_MESSAGE */ ;
    return /* @__PURE__ */ React114.createElement(React114.Fragment, null, /* @__PURE__ */ React114.createElement(EGDSPageLoader, {
        visible: toastData === null || toastData === void 0 ? void 0 : toastData.loading
    }), (toastData === null || toastData === void 0 ? void 0 : toastData.message) && /* @__PURE__ */ React114.createElement(EGDSToast, {
        show: Boolean(toastData.message),
        verticalOffset: toastMessageVerticalOffset,
        onDismiss: function() {
            return dispatch({
                type: onDismissToastType,
                payload: {
                    message: null
                }
            });
        }
    }, toastData.message), heading.__typename === "EGDSStylizedText" && /* @__PURE__ */ React114.createElement(EGDSHeading6, {
        size: headingSize,
        tag: tag
    }, heading.text), /* @__PURE__ */ React114.createElement(EGDSSpacing22, {
        margin: margin
    }, /* @__PURE__ */ React114.createElement(Carousel, _object_spread_props(_object_spread({}, carouselProps), {
        itemViewedCallback: onItemViewedCallback
    }), items.map(function(item, index) {
        return /* @__PURE__ */ React114.createElement(LodgingCard, {
            key: index,
            data: item,
            view: "COMPACT" /* COMPACT */ ,
            imageRatio: aspectRatio,
            headingOverflow: headingOverflow,
            onClickCallback: function() {
                return lodgingCardSelected(item, index);
            },
            fireCardImpression: fireCardsImpression,
            isReview: isReview,
            border: true,
            headingSize: cardHeadingSize,
            enableInlineLink: enableInlineLink,
            isRouteAndHoverDifferent: isRouteAndHoverDifferent,
            onHoverChanged: onHoverChanged
        });
    }))), seoRichContentMetaData && /* @__PURE__ */ React114.createElement("script", {
        "data-stid": "lodging-carousel-structured-data",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: seoRichContentMetaData
        }
    }));
};
LodgingCarouselContainer.displayName = "LodgingCarouselContainer";
LodgingCarouselContainer.fragment = fragment81;
// src/components/lodging-carousel-skeleton/lodging-carousel-skeleton.tsx
import React116 from "react";
import { EGDSCarousel as EGDSCarousel2 } from "@egds/react-core/carousel";
import { EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing24 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge5, ViewMedium as ViewMedium9, Viewport as Viewport9, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
// src/components/lodging-card-skeleton/lodging-card-skeleton.tsx
import React115 from "react";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection7 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure6, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType7 } from "@egds/react-core/images";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
var LodgingCardImageSkeleton = function(param) {
    var aspectRatio = param.aspectRatio;
    return /* @__PURE__ */ React115.createElement(EGDSSpacing23, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React115.createElement(EGDSFigure6, {
        ratio: aspectRatio
    }, /* @__PURE__ */ React115.createElement(EGDSBlockSkeleton, null)));
};
LodgingCardImageSkeleton.displayName = "LodgingCardImageSkeleton";
var LodgingCardTextSkeleton = function() {
    return /* @__PURE__ */ React115.createElement(React115.Fragment, null, /* @__PURE__ */ React115.createElement(EGDSSpacing23, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React115.createElement(EGDSLineSkeleton, {
        animation: true,
        type: "primary"
    })), /* @__PURE__ */ React115.createElement(EGDSSpacing23, {
        margin: {
            blockstart: "three",
            blockend: "twelve",
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React115.createElement(EGDSLineSkeleton, {
        animation: true,
        type: "secondary"
    })));
};
LodgingCardTextSkeleton.displayName = "LodgingCardTextSkeleton";
var LodgingCardContentSkeleton = function() {
    return /* @__PURE__ */ React115.createElement(EGDSCardContentSection7, {
        padded: false
    }, /* @__PURE__ */ React115.createElement(LodgingCardTextSkeleton, null));
};
LodgingCardContentSkeleton.displayName = "LodgingCardContentSkeleton";
var LodgingCardPlaceholder = function() {
    return /* @__PURE__ */ React115.createElement(EGDSCard2, null, /* @__PURE__ */ React115.createElement(LodgingCardImageSkeleton, {
        aspectRatio: EGDSFigureAspectRatioType7.R4_3
    }), /* @__PURE__ */ React115.createElement(LodgingCardContentSkeleton, null));
};
LodgingCardPlaceholder.displayName = "LodgingCardPlaceholder";
// src/components/lodging-carousel-skeleton/lodging-carousel-skeleton.tsx
var LodgingCarouselPlaceholderView = function(param) {
    var itemsVisible = param.itemsVisible, elements = param.elements;
    var carouselProps = {
        buttonText: {
            nextButton: "",
            prevButton: ""
        },
        pageBy: 1,
        peek: true,
        itemsVisible: itemsVisible
    };
    return /* @__PURE__ */ React116.createElement(React116.Fragment, null, /* @__PURE__ */ React116.createElement(EGDSSpacing24, {
        margin: {
            inlineend: "six"
        }
    }, /* @__PURE__ */ React116.createElement(EGDSHeading7, {
        size: 4
    }, /* @__PURE__ */ React116.createElement(EGDSLineSkeleton2, {
        animation: true,
        type: "primary"
    }))), /* @__PURE__ */ React116.createElement(EGDSSpacing24, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React116.createElement(EGDSCarousel2, _object_spread({}, carouselProps), _to_consumable_array(Array(elements)).map(function(_, i) {
        return /* @__PURE__ */ React116.createElement(React116.Fragment, {
            key: i
        }, /* @__PURE__ */ React116.createElement(LodgingCardPlaceholder, null));
    }))));
};
var LodgingCarouselPlaceholder = function(param) {
    var _param_itemsVisible = param.itemsVisible, itemsVisible = _param_itemsVisible === void 0 ? {
        lg: 4,
        md: 2,
        sm: 1
    } : _param_itemsVisible;
    return /* @__PURE__ */ React116.createElement(Viewport9, null, /* @__PURE__ */ React116.createElement(ViewSmall8, null, /* @__PURE__ */ React116.createElement(LodgingCarouselPlaceholderView, {
        itemsVisible: itemsVisible,
        elements: itemsVisible.sm
    })), /* @__PURE__ */ React116.createElement(ViewMedium9, null, /* @__PURE__ */ React116.createElement(LodgingCarouselPlaceholderView, {
        itemsVisible: itemsVisible,
        elements: itemsVisible.md
    })), /* @__PURE__ */ React116.createElement(ViewLarge5, null, /* @__PURE__ */ React116.createElement(LodgingCarouselPlaceholderView, {
        itemsVisible: itemsVisible,
        elements: itemsVisible.lg
    })));
};
// src/components/product-card-carousel/product-card-carousel-provider.tsx
import React117, { useMemo as useMemo4, useReducer } from "react";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
import { useSessionOperations } from "@shared-ui/multi-item-operations-providers";
// src/components/product-card-carousel/product-card-carousel-utils.tsx
import { SystemEvent as SystemEvent3, SystemEventLevel as SystemEventLevel3 } from "@shared-ui/logger-context";
var STORE_EVENTS2 = {
    ADD_VEHICLE_TO_PACKAGE_FAILURE: new SystemEvent3(SystemEventLevel3.ERROR, "ADD_VEHICLE_TO_PACKAGE_FAILURE"),
    REMOVE_VEHICLE_FROM_PACKAGE_FAILURE: new SystemEvent3(SystemEventLevel3.ERROR, "REMOVE_VEHICLE_FROM_PACKAGE_FAILURE")
};
var shoppingInvokeFunctionCallBack = function(context, sessionOperation, misId, loggerEvents, dispatch, actionId, name, keyValueParams) {
    switch(name){
        case "addToTrip":
            addProductGT(sessionOperation.addProduct, context, misId, loggerEvents, dispatch, actionId, keyValueParams);
            break;
        case "removeFromTrip":
            removeProductGT(sessionOperation.removeProduct, context, misId, loggerEvents, dispatch, keyValueParams);
            break;
        default:
            break;
    }
};
var getValueFromKeyValuePairs = function(keyValueParams, key) {
    var _keyValueParams_filter_;
    return keyValueParams ? (_keyValueParams_filter_ = keyValueParams.filter(function(rec) {
        return rec.key === key;
    })[0]) === null || _keyValueParams_filter_ === void 0 ? void 0 : _keyValueParams_filter_.value : null;
};
var addProductGT = function() {
    var _ref = _async_to_generator(function(addProduct, context, misId, loggerEvents, dispatch, actionId, keyValueParams) {
        var response, _response_data_multiItemShopping_addProducts, _response_data_multiItemShopping, _response_data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch({
                        type: 0 /* SHOW_LOADING_STATE */ ,
                        payload: {
                            message: null
                        }
                    });
                    return [
                        4,
                        addProduct({
                            context: context,
                            activities: null,
                            multiItemSessionId: misId,
                            groundTransfers: [
                                {
                                    offerToken: getValueFromKeyValuePairs(keyValueParams, "offerToken")
                                }
                            ]
                        }, "GT_ADD")
                    ];
                case 1:
                    response = _state.sent();
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        ;
                        if (response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_multiItemShopping = _response_data.multiItemShopping) === null || _response_data_multiItemShopping === void 0 ? void 0 : (_response_data_multiItemShopping_addProducts = _response_data_multiItemShopping.addProducts) === null || _response_data_multiItemShopping_addProducts === void 0 ? void 0 : _response_data_multiItemShopping_addProducts.message) {
                            dispatch({
                                type: 1 /* SHOW_ADD_VEHICLE_TOAST_MESSAGE */ ,
                                payload: {
                                    message: response.data.multiItemShopping.addProducts.message,
                                    actionId: actionId
                                }
                            });
                        }
                    } else {
                        dispatch({
                            type: 3 /* DISMISS_LOADING_STATE */ ,
                            payload: {
                                message: null
                            }
                        });
                        loggerEvents.ADD_VEHICLE_TO_PACKAGE_FAILURE.log({});
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function addProductGT(addProduct, context, misId, loggerEvents, dispatch, actionId, keyValueParams) {
        return _ref.apply(this, arguments);
    };
}();
var removeProductGT = function() {
    var _ref = _async_to_generator(function(removeProduct, context, misId, loggerEvents, dispatch, keyValueParams) {
        var response, _response_data_multiItemShopping_removeProducts, _response_data_multiItemShopping, _response_data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch({
                        type: 0 /* SHOW_LOADING_STATE */ ,
                        payload: {
                            message: null
                        }
                    });
                    return [
                        4,
                        removeProduct({
                            context: context,
                            activities: null,
                            multiItemSessionId: misId,
                            groundTransfers: [
                                {
                                    offerToken: getValueFromKeyValuePairs(keyValueParams, "offerToken")
                                }
                            ]
                        }, "GT_REMOVE")
                    ];
                case 1:
                    response = _state.sent();
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        ;
                        if (response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_multiItemShopping = _response_data.multiItemShopping) === null || _response_data_multiItemShopping === void 0 ? void 0 : (_response_data_multiItemShopping_removeProducts = _response_data_multiItemShopping.removeProducts) === null || _response_data_multiItemShopping_removeProducts === void 0 ? void 0 : _response_data_multiItemShopping_removeProducts.message) {
                            dispatch({
                                type: 2 /* SHOW_REMOVE_VEHICLE_TOAST_MESSAGE */ ,
                                payload: {
                                    message: response.data.multiItemShopping.removeProducts.message
                                }
                            });
                        }
                    } else {
                        dispatch({
                            type: 3 /* DISMISS_LOADING_STATE */ ,
                            payload: {
                                message: null
                            }
                        });
                        loggerEvents.REMOVE_VEHICLE_FROM_PACKAGE_FAILURE.log({});
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function removeProductGT(removeProduct, context, misId, loggerEvents, dispatch, keyValueParams) {
        return _ref.apply(this, arguments);
    };
}();
// src/components/product-card-carousel/product-card-carousel-provider.tsx
var ProductShoppingInvokeFunctionProvider = function(param) {
    var children = param.children;
    var sessionOperation = useSessionOperations();
    var misId = useMultiItemSessionId();
    var loggerEvents = useLoggerEvents3(STORE_EVENTS2);
    var context = useBexApi6().context;
    var initialState = {
        toastData: {
            message: null,
            loading: false,
            disabled: false,
            actionId: null,
            typeOfOperation: ""
        },
        shoppingInvokeFunctionCallBack: function(actionId, callbackName, keyValueParams) {
            return shoppingInvokeFunctionCallBack(context, sessionOperation, misId, loggerEvents, dispatch, actionId, callbackName, keyValueParams);
        }
    };
    var _useReducer = _sliced_to_array(useReducer(productShoppingInvokeFunctionReducer, initialState), 2), productShoppingInvokeFunctionData = _useReducer[0], dispatch = _useReducer[1];
    var value = useMemo4(function() {
        return {
            productShoppingInvokeFunctionData: productShoppingInvokeFunctionData,
            dispatch: dispatch
        };
    }, [
        productShoppingInvokeFunctionData,
        dispatch
    ]);
    return /* @__PURE__ */ React117.createElement(ProductShoppingInvokeFunctionContext.Provider, {
        value: value
    }, children);
};
// src/components/property-content-section-group/cleanliness.tsx
import React144 from "react";
import { gql as gql113 } from "@apollo/client";
// src/components/property-content-section-group/property-content-section-group.tsx
import React143 from "react";
import { gql as gql112 } from "@apollo/client";
import { EGDSCard as EGDSCard6, EGDSCardContentSection as EGDSCardContentSection9 } from "@egds/react-core/cards";
import { ViewLarge as ViewLarge7, Viewport as Viewport14, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
// src/components/property-content-section-group/property-content.tsx
import React128, { useMemo as useMemo5 } from "react";
import Lazyload4 from "react-lazy-load";
import { gql as gql99 } from "@apollo/client";
import { EGDSExpandoPeek as EGDSExpandoPeek2 } from "@egds/react-core/expando";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType10, UitkFigure, UitkFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid8, EGDSLayoutGridItem as EGDSLayoutGridItem7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing28 } from "@egds/react-core/spacing";
import { UitkVideo } from "@egds/react-core/video";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment as useExperiment7 } from "@shared-ui/experiment-context";
import { useRefContext } from "@shared-ui/ref-context";
// src/components/lodging-gallery-carousel/lodging-gallery-carousel-spaces.tsx
import React118, { useEffect as useEffect5 } from "react";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSCarouselPaginationDots, UitkCarousel as EGDSCarousel3 } from "@egds/react-core/carousel";
import { EGDSFigure as EGDSFigure7, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType8, EGDSImage as EGDSImage5, EGDSImageLink as EGDSImageLink3, EGDSQueuedImage } from "@egds/react-core/images";
import { EGDSLayoutPosition as EGDSLayoutPosition10 } from "@egds/react-core/layout-position";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { IntersectionTracker as IntersectionTracker8, ITrackType as ITrackType6, useClickstreamAnalytics as useClickstreamAnalytics6, useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { useInView as useInView3 } from "react-intersection-observer";
var LodgingGalleryCarouselSpaces = function(param) {
    var data = param.data, carouselId = param.carouselId, cardLink = param.cardLink, propertyId = param.propertyId, _param_alternateRouteLink = param.alternateRouteLink, alternateRouteLink = _param_alternateRouteLink === void 0 ? null : _param_alternateRouteLink, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? EGDSFigureAspectRatioType8.R21_9 : _param_imageRatio, propertySortIndex = param.propertySortIndex, fetchPriority = param.fetchPriority;
    var _carouselRef_current, _carouselRef_current1;
    var media = data.media, accessibilityHeadingText = data.accessibilityHeadingText, navClickAnalytics = data.navClickAnalytics, intersectionAnalytics = data.intersectionAnalytics, adaptExAnalyticsAttemptEvents = data.adaptExAnalyticsAttemptEvents, carouselScrimType = data.carouselScrimType;
    var track = useClickTracker24();
    var carouselRef = React118.useRef(null);
    var _useClickstreamAnalytics6 = useClickstreamAnalytics6(), clickStreamTrack = _useClickstreamAnalytics6.track;
    var _useInView3 = useInView3({
        triggerOnce: true,
        threshold: 0.8
    }), ref = _useInView3.ref, inView = _useInView3.inView;
    var _React118_useState = _sliced_to_array(React118.useState(0), 2), currentMediaIndex = _React118_useState[0], setCurrentMediaIndex = _React118_useState[1];
    var clickActionId = useClickActionId();
    var productCardClickAction = useProductCardAction(clickActionId);
    var onImageClickWithoutTracking = useLodgingCardImageClickCallback(cardLink, alternateRouteLink);
    React118.useEffect(function() {
        setCurrentMediaIndex(0);
    }, [
        carouselId
    ]);
    useEffect5(function() {
        if (inView && (adaptExAnalyticsAttemptEvents === null || adaptExAnalyticsAttemptEvents === void 0 ? void 0 : adaptExAnalyticsAttemptEvents.length)) {
            adaptExAnalyticsAttemptEvents.forEach(function(adaptExEvent) {
                clickStreamTrack(ITrackType6.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        adaptExAnalyticsAttemptEvents,
        inView,
        clickStreamTrack
    ]);
    var onImageClick = function() {
        var _media_currentMediaIndex;
        onImageClickWithoutTracking();
        if ((productCardClickAction === null || productCardClickAction === void 0 ? void 0 : productCardClickAction.__typename) === "ShoppingNavigateToOverlay" || !cardLink) {
            return;
        }
        if (alternateRouteLink === null || alternateRouteLink === void 0 ? void 0 : alternateRouteLink.analytics) {
            sendProductSchemaTracking(alternateRouteLink.analytics, track);
        } else if (cardLink.resource.__typename === "HttpURI" && cardLink.analytics) {
            sendProductSchemaTracking(cardLink.analytics, track);
        }
        var currentMedia = (_media_currentMediaIndex = media[currentMediaIndex]) === null || _media_currentMediaIndex === void 0 ? void 0 : _media_currentMediaIndex.media;
        if ((currentMedia === null || currentMedia === void 0 ? void 0 : currentMedia.__typename) === "Image" && currentMedia.thumbnailClickAnalytics) {
            track(currentMedia.thumbnailClickAnalytics.referrerId, currentMedia.thumbnailClickAnalytics.linkName, true);
        }
    };
    var navButtonAnalytics = navClickAnalytics ? {
        id: navClickAnalytics.referrerId,
        description: navClickAnalytics.linkName,
        callback: function(id, description) {
            return track(id, description, true);
        }
    } : void 0;
    var carouselImages = media.map(function(mediaItem, index) {
        var additionalProps = {
            "data-testid": "egds-carousel-item-image",
            fetchPriority: fetchPriority,
            lazyloading: "off"
        };
        if (mediaItem.media.__typename === "Image") {
            var _mediaItem_media, _mediaItem_media1, _mediaItem_media2, _mediaItem_media3;
            var _mediaItem_media_description, _mediaItem_media_description1, _mediaItem_media_description2;
            return /* @__PURE__ */ React118.createElement(EGDSFigure7, {
                key: mediaItem.id,
                ratio: imageRatio
            }, index === 0 ? /* @__PURE__ */ React118.createElement(EGDSImage5, {
                additionalProps: additionalProps,
                placeholderImage: true,
                alt: (_mediaItem_media_description = (_mediaItem_media = mediaItem.media) === null || _mediaItem_media === void 0 ? void 0 : _mediaItem_media.description) !== null && _mediaItem_media_description !== void 0 ? _mediaItem_media_description : "",
                src: (_mediaItem_media1 = mediaItem.media) === null || _mediaItem_media1 === void 0 ? void 0 : _mediaItem_media1.url
            }) : /* @__PURE__ */ React118.createElement(EGDSQueuedImage, {
                lazyLoading: "lazy",
                "data-testid": "egds-carousel-item-queued-image",
                placeholderImage: true,
                alt: (_mediaItem_media_description1 = (_mediaItem_media2 = mediaItem.media) === null || _mediaItem_media2 === void 0 ? void 0 : _mediaItem_media2.description) !== null && _mediaItem_media_description1 !== void 0 ? _mediaItem_media_description1 : "",
                src: (_mediaItem_media3 = mediaItem.media) === null || _mediaItem_media3 === void 0 ? void 0 : _mediaItem_media3.url
            }), /* @__PURE__ */ React118.createElement(EGDSImageLink3, null, /* @__PURE__ */ React118.createElement("button", {
                type: "button",
                onClick: onImageClick,
                "data-testid": "uitk-gallery-item-current-trigger"
            }, (_mediaItem_media_description2 = mediaItem.media.description) !== null && _mediaItem_media_description2 !== void 0 ? _mediaItem_media_description2 : "")));
        }
        return null;
    });
    var _data_nextButtonText, _data_previousButtonText;
    var carouselButtonText = {
        nextButton: (_data_nextButtonText = data.nextButtonText) !== null && _data_nextButtonText !== void 0 ? _data_nextButtonText : "",
        prevButton: (_data_previousButtonText = data.previousButtonText) !== null && _data_previousButtonText !== void 0 ? _data_previousButtonText : ""
    };
    var carouselNavigationIconId = {
        next: "next-button-".concat(carouselId),
        prev: "prev-button-".concat(carouselId)
    };
    var carousel = media.length > 0 ? /* @__PURE__ */ React118.createElement(EGDSCard3, null, /* @__PURE__ */ React118.createElement(EGDSCarousel3, {
        analytics: navButtonAnalytics,
        buttonText: carouselButtonText,
        carouselHeaderText: accessibilityHeadingText,
        carouselName: carouselId,
        itemsMaxHeight: true,
        itemsVisible: {
            sm: 1,
            md: 1,
            lg: 1
        },
        navigationIconId: carouselNavigationIconId,
        onIndexChange: setCurrentMediaIndex,
        pagingInset: true,
        wrapItems: true,
        pagingOverlay: true,
        peek: false,
        carouselRef: carouselRef,
        domRef: ref
    }, carouselImages), carouselScrimType === "INSET_PAGINATION_DOT" /* INSET_PAGINATION_DOT */  ? /* @__PURE__ */ React118.createElement(EGDSScrim, {
        type: EGDSScrimType.BOTTOM
    }, ((_carouselRef_current = carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : _carouselRef_current.changeIndex) && /* @__PURE__ */ React118.createElement(EGDSCarouselPaginationDots, {
        activeIndex: currentMediaIndex,
        inset: true,
        itemCount: carouselImages.length,
        changeIndex: carouselRef.current.changeIndex
    })) : /* @__PURE__ */ React118.createElement(React118.Fragment, null, ((_carouselRef_current1 = carouselRef.current) === null || _carouselRef_current1 === void 0 ? void 0 : _carouselRef_current1.changeIndex) && /* @__PURE__ */ React118.createElement(EGDSCarouselPaginationDots, {
        activeIndex: currentMediaIndex,
        itemCount: carouselImages.length,
        changeIndex: carouselRef.current.changeIndex
    }))) : null;
    return /* @__PURE__ */ React118.createElement(React118.Fragment, null, media.length === 0 ? /* @__PURE__ */ React118.createElement(EGDSLayoutPosition10, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React118.createElement(EGDSFigure7, {
        imageFit: "cover",
        ratio: imageRatio
    }, /* @__PURE__ */ React118.createElement(EGDSImage5, {
        placeholderImage: true,
        alt: ""
    }))) : /* @__PURE__ */ React118.createElement(EGDSLayoutPosition10, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, intersectionAnalytics ? /* @__PURE__ */ React118.createElement(IntersectionTracker8, {
        cloneElement: true,
        tag: "span",
        referrerId: intersectionAnalytics.referrerId,
        linkName: intersectionAnalytics.linkName
    }, carousel) : carousel));
};
LodgingGalleryCarouselSpaces.displayName = "LodgingGalleryCarouselSpaces";
// src/components/lodging-link-message.tsx
import React119 from "react";
import { gql as gql90 } from "@apollo/client";
import { EGDSIcon as EGDSIcon18, EGDSIconSize as EGDSIconSize16 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink8 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
var __LodgingLinkMessageFragment = gql90(_templateObject90());
var LodgingLinkMessage = function(param) {
    var data = param.data;
    var link = data.link, value = data.value, icon = data.icon;
    var _ref = icon || {}, iconId = _ref.id, iconDescription = _ref.description;
    var uri = link.uri, clientSideAnalytics = link.clientSideAnalytics;
    var track = useClickTracker25();
    var href = uri.value;
    var handleClick = function() {
        var _ref = clientSideAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React119.createElement(React119.Fragment, null, href && /* @__PURE__ */ React119.createElement(EGDSLink8, {
        onClickCapture: handleClick,
        "data-stid": "lodging-link-message"
    }, /* @__PURE__ */ React119.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer"
    }, value, iconId && /* @__PURE__ */ React119.createElement(EGDSSpacing25, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React119.createElement(EGDSIcon18, {
        "data-stid": "lodging-link-message-icon",
        name: iconId,
        size: EGDSIconSize16.SMALL,
        title: iconDescription
    })))));
};
LodgingLinkMessage.displayName = "LodgingLinkMessage";
LodgingLinkMessage.fragment = __LodgingLinkMessageFragment;
var lodging_link_message_default = LodgingLinkMessage;
// src/components/property-image/property-image.tsx
import React120 from "react";
import { gql as gql91 } from "@apollo/client";
import { EGDSFigure as EGDSFigure8, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType9, EGDSImage as EGDSImage6, EGDSImageLink as EGDSImageLink4 } from "@egds/react-core/images";
import { IntersectionTracker as IntersectionTracker9, useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
// src/components/property-image/utils/additional-uis-prime-micro-messages-utils.ts
function additionalUisPrimeMicroMessages(galleryPosition, algoMediaGuid, galleryMaxPosition, imageId, productId, galleryName, galleryCategory) {
    var _messages_;
    var timestamp = Date.now().toString();
    var messages = [
        {
            schemaName: "allHotelProducts",
            messageContent: {
                hotelProducts: [
                    _object_spread({
                        imageGalleryAlgorithm: {
                            name: "heroaesthetics.v20190411-hsc.v20190223"
                        },
                        algoMediaGuid: algoMediaGuid
                    }, productId ? {
                        productId: Number(productId)
                    } : {}, imageId ? {
                        imageId: Number(imageId)
                    } : {})
                ]
            }
        },
        {
            schemaName: "imageTracking",
            messageContent: {
                galleryName: galleryName,
                galleryType: "GALLERY_TYPE_SINGLE",
                galleryMaxPosition: galleryMaxPosition,
                galleryPosition: galleryPosition,
                repeatedGalleryIndex: null,
                imageGalleryMetaTagList: [
                    {
                        imageGalleryMetaTagValue: timestamp,
                        imageGalleryMetaTagType: "DEVICE_TIME_STAMP"
                    }
                ]
            }
        }
    ];
    if (galleryCategory && ((_messages_ = messages[1]) === null || _messages_ === void 0 ? void 0 : _messages_.messageContent.imageGalleryMetaTagList)) {
        messages[1].messageContent.imageGalleryMetaTagList.push({
            imageGalleryMetaTagValue: galleryCategory,
            imageGalleryMetaTagType: "GALLERY_FILTER"
        });
    }
    return messages;
}
// src/components/property-image/property-image.tsx
var __PropertyImageFragment = gql91(_templateObject91());
var PropertyImage = function(props) {
    var data = props.data, onClick = props.onClick, index = props.index, className = props.className, fetchPriority = props.fetchPriority, galleryLength = props.galleryLength, propertyId = props.propertyId, roundcorner = props.roundcorner, attributes = _object_without_properties(props, [
        "data",
        "onClick",
        "index",
        "className",
        "fetchPriority",
        "galleryLength",
        "propertyId",
        "roundcorner"
    ]);
    var alt = data.alt, image = data.image, lowResImage = data.lowResImage, trackingId = data.trackingId, imageId = data.imageId;
    var track = useClickTracker26();
    var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
    var handleClick = React120.useCallback(function() {
        if (thumbnailClickAnalytics) {
            track(thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.referrerId, thumbnailClickAnalytics === null || thumbnailClickAnalytics === void 0 ? void 0 : thumbnailClickAnalytics.linkName);
        }
        if (onClick) {
            onClick(index);
        }
    }, [
        onClick,
        index
    ]);
    var galleryImage = /* @__PURE__ */ React120.createElement(React120.Fragment, null, /* @__PURE__ */ React120.createElement(EGDSImage6, {
        alt: alt || image.description,
        placeholderImage: true,
        src: lowResImage ? lowResImage.url : image.url,
        additionalProps: {
            fetchPriority: fetchPriority
        }
    }), onClick && /* @__PURE__ */ React120.createElement(EGDSImageLink4, null, /* @__PURE__ */ React120.createElement("button", {
        onClick: handleClick,
        type: "button"
    }, /* @__PURE__ */ React120.createElement("span", {
        className: "is-visually-hidden"
    }, image.description))));
    var messages = propertyId && additionalUisPrimeMicroMessages(index, trackingId, galleryLength, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ );
    return /* @__PURE__ */ React120.createElement(EGDSFigure8, _object_spread_props(_object_spread({}, attributes), {
        className: className,
        ratio: EGDSFigureAspectRatioType9.R16_9,
        roundcorner: roundcorner
    }), /* @__PURE__ */ React120.createElement(IntersectionTracker9, {
        trackOnce: true,
        referrerId: "HOT.HIS.MosaicTileImageImpression.".concat(index),
        linkName: "Mosaic Tile Image Impression",
        additionalUisPrimeMicroMessages: messages
    }, galleryImage));
};
PropertyImage.displayName = "PropertyImage";
PropertyImage.fragment = __PropertyImageFragment;
// src/components/property-content-section-group/__private__/property-content-item-graphics.tsx
import React122 from "react";
import { gql as gql93 } from "@apollo/client";
// src/components/common/lodging-graphic.tsx
import React121 from "react";
import { gql as gql92 } from "@apollo/client";
var __LodgingGraphicFragment = gql92(_templateObject92(), Icon.fragment, Mark.fragment, Illustration.fragment, SharedUIBadge.fragment);
var LodgingGraphic = function(param) {
    var markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React121.createElement(Icon, {
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React121.createElement(Mark, {
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React121.createElement(Illustration, {
                data: data
            });
        case "EGDSStandardBadge":
            return /* @__PURE__ */ React121.createElement(SharedUIBadge, {
                data: data
            });
        default:
            return null;
    }
};
LodgingGraphic.displayName = "LodgingGraphic";
LodgingGraphic.fragment = __LodgingGraphicFragment;
// src/components/property-content-section-group/__private__/property-content-item-graphics.tsx
var fragment82 = gql93(_templateObject93(), UiGraphic.fragment, LodgingGraphic.fragment);
var PropertyContentItemGraphics = function(param) {
    var data = param.data;
    var graphics = data.graphics, graphicsV2 = data.graphicsV2;
    if (!graphics || graphics.length === 0) {
        return null;
    }
    if (graphicsV2 && graphicsV2.length !== 0) {
        return /* @__PURE__ */ React122.createElement(React122.Fragment, null, graphicsV2.map(function(graphic, index) {
            return /* @__PURE__ */ React122.createElement(LodgingGraphic, {
                key: index,
                data: graphic
            });
        }));
    }
    return /* @__PURE__ */ React122.createElement(React122.Fragment, null, graphics.map(function(graphic, index) {
        return /* @__PURE__ */ React122.createElement(UiGraphic, {
            key: index,
            data: graphic
        });
    }));
};
PropertyContentItemGraphics.displayName = "PropertyContentItemGraphics";
PropertyContentItemGraphics.fragment = fragment82;
// src/components/property-content-section-group/__private__/property-content-item-images.tsx
import React123 from "react";
import Lazyload3 from "react-lazy-load";
import { gql as gql94 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex27, EGDSLayoutFlexItem as EGDSLayoutFlexItem20 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
var fragment83 = gql94(_templateObject94());
var PropertyContentItemImages = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var contents = data.contents;
    var structuredData = props.structuredData;
    if (!contents || contents.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React123.createElement(EGDSSpacing26, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React123.createElement("div", {
        "data-stid": "content-image"
    }, /* @__PURE__ */ React123.createElement(EGDSLayoutFlex27, {
        space: "half",
        wrap: "wrap"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React123.createElement(EGDSLayoutFlexItem20, {
            key: index
        }, /* @__PURE__ */ React123.createElement(Lazyload3, {
            height: 64
        }, /* @__PURE__ */ React123.createElement(React123.Fragment, null, /* @__PURE__ */ React123.createElement("img", {
            src: content.image.url,
            alt: content.image.description || "",
            height: "100%"
        }), structuredData && /* @__PURE__ */ React123.createElement("meta", {
            itemProp: structuredData.itemprop,
            content: content.image.description
        }))));
    }))));
};
PropertyContentItemImages.displayName = "PropertyContentItemImages";
PropertyContentItemImages.fragment = fragment83;
// src/components/property-content-section-group/__private__/property-content-item-markup.tsx
import React124 from "react";
import { gql as gql95 } from "@apollo/client";
import { EGDSText as EGDSText17 } from "@egds/react-core/text";
import { EGDSUnformattedHtml as EGDSUnformattedHtml3 } from "@egds/react-core/unformatted-html";
var fragment84 = gql95(_templateObject95());
var PropertyContentItemMarkup = function(param) {
    var data = param.data;
    var text = data.content.text;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React124.createElement(EGDSText17, {
        size: 300,
        spacing: "two",
        overflow: "wrap"
    }, /* @__PURE__ */ React124.createElement("div", {
        "data-stid": "content-markup"
    }, /* @__PURE__ */ React124.createElement(EGDSUnformattedHtml3, {
        htmlToParse: text
    })));
};
PropertyContentItemMarkup.displayName = "PropertyContentItemMarkup";
PropertyContentItemMarkup.fragment = fragment84;
// src/components/property-content-section-group/__private__/property-content-item-text.tsx
import React125 from "react";
import { gql as gql96 } from "@apollo/client";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSIcon as EGDSIcon19 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex28, EGDSLayoutFlexItem as EGDSLayoutFlexItem21 } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark8 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing27 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText18 } from "@egds/react-core/text";
import { useExperiment as useExperiment6 } from "@shared-ui/experiment-context";
var fragment85 = gql96(_templateObject96());
var PropertyContentItemText = function(param) {
    var data = param.data;
    var expando = data.expando, content = data.content;
    var _ref = expando || {}, expandedLabel = _ref.expandedLabel, collapsedLabel = _ref.collapsedLabel;
    var primary = content.primary, secondary = content.secondary;
    var value = primary.value, subtexts = primary.subtexts;
    var _React125_useState = _sliced_to_array(React125.useState(false), 2), isVisible = _React125_useState[0], setIsVisible = _React125_useState[1];
    var _useExperiment6 = useExperiment6("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment6.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    var handleClick = React125.useCallback(function() {
        setIsVisible(function(prev) {
            return !prev;
        });
    }, [
        setIsVisible
    ]);
    var Content = React125.useMemo(function() {
        var _primary_icon, _primary_egdsMark;
        return /* @__PURE__ */ React125.createElement(React125.Fragment, null, /* @__PURE__ */ React125.createElement(EGDSLayoutFlex28, {
            alignItems: "center"
        }, ((_primary_icon = primary.icon) === null || _primary_icon === void 0 ? void 0 : _primary_icon.iconId) && /* @__PURE__ */ React125.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */ React125.createElement(EGDSSpacing27, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React125.createElement(EGDSIcon19, {
            name: primary.icon.iconId
        }))), ((_primary_egdsMark = primary.egdsMark) === null || _primary_egdsMark === void 0 ? void 0 : _primary_egdsMark.url) && /* @__PURE__ */ React125.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */ React125.createElement(EGDSSpacing27, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React125.createElement(EGDSMark8, {
            url: primary.egdsMark.url.value,
            description: primary.egdsMark.description
        }))), /* @__PURE__ */ React125.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */ React125.createElement(EGDSSpacing27, {
            padding: {
                blockstart: isTopOfPDPRedesignVariant ? "two" : void 0
            }
        }, /* @__PURE__ */ React125.createElement(EGDSText18, {
            theme: "standard",
            size: 300,
            weight: (primary === null || primary === void 0 ? void 0 : primary.state) === "STRONG" ? "bold" : "regular"
        }, value, subtexts && subtexts.length > 0 && /* @__PURE__ */ React125.createElement(React125.Fragment, null, subtexts.map(function(subtext, index) {
            return /* @__PURE__ */ React125.createElement(EGDSText18, {
                key: index,
                theme: "standard",
                size: 200,
                weight: (primary === null || primary === void 0 ? void 0 : primary.state) === "STRONG" ? "bold" : "regular"
            }, subtext);
        })))))), (secondary === null || secondary === void 0 ? void 0 : secondary.value) && /* @__PURE__ */ React125.createElement(EGDSText18, {
            spacing: "two",
            theme: "standard",
            size: 300
        }, secondary.value));
    }, [
        primary,
        secondary,
        value,
        subtexts
    ]);
    if (!expando) {
        return Content;
    }
    return /* @__PURE__ */ React125.createElement(EGDSExpandoPeek, {
        isVisible: isVisible,
        handleClick: handleClick,
        lines: 4,
        expandLabel: collapsedLabel,
        collapseLabel: expandedLabel
    }, Content);
};
PropertyContentItemText.displayName = "PropertyContentItemText";
PropertyContentItemText.fragment = fragment85;
// src/components/property-content-section-group/__private__/property-content-item-texts.tsx
import React126 from "react";
import { gql as gql97 } from "@apollo/client";
import { EGDSText as EGDSText19 } from "@egds/react-core/text";
var fragment86 = gql97(_templateObject97());
var PropertyContentItemTexts = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var contents = data.contents;
    var structuredData = props.structuredData;
    return /* @__PURE__ */ React126.createElement(React126.Fragment, null, contents === null || contents === void 0 ? void 0 : contents.map(function(param, index) {
        var primary = param.primary;
        return primary.value && /* @__PURE__ */ React126.createElement(React126.Fragment, {
            key: "PropertyContentItemTexts-".concat(index)
        }, /* @__PURE__ */ React126.createElement(EGDSText19, {
            theme: "standard",
            spacing: "two",
            size: 300
        }, primary.value), structuredData && /* @__PURE__ */ React126.createElement("meta", {
            itemProp: structuredData.itemprop,
            content: primary.value
        }));
    }));
};
PropertyContentItemTexts.displayName = "PropertyContentItemTexts";
PropertyContentItemTexts.fragment = fragment86;
// src/components/property-content-section-group/property-content-section-detailed-dialog-context.tsx
import { createContext as createContext2, useContext as useContext2 } from "react";
var PropertyContentSectionDetailedDialogContext = createContext2({
    dialogElement: null,
    actionId: null,
    idReference: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIdReference: function() {}
});
var usePropertyContentSectionDetailedDialogContext = function() {
    var context = useContext2(PropertyContentSectionDetailedDialogContext);
    return context;
};
// src/components/property-content-section-group/property-section-header.tsx
import React127 from "react";
import { gql as gql98 } from "@apollo/client";
import { EGDSAvatar as EGDSAvatar2 } from "@egds/react-core/avatar";
import { EGDSIcon as EGDSIcon20 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex29, EGDSLayoutFlexItem as EGDSLayoutFlexItem22 } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark9, EGDSMarkSize as EGDSMarkSize7 } from "@egds/react-core/mark";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText20 } from "@egds/react-core/text";
var fragment87 = gql98(_templateObject98());
var SectionHeader = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var text = data.text, subText = data.subText, icon = data.icon, mark = data.mark, headerImage = data.headerImage;
    var singleLineHeader = props.singleLineHeader;
    var _ref = mark !== null && mark !== void 0 ? mark : {}, id = _ref.id, description = _ref.description, url = _ref.url;
    var RenderedSubtext = React127.useMemo(function() {
        return /* @__PURE__ */ React127.createElement(EGDSText20, {
            inline: singleLineHeader,
            size: 400,
            spacing: "two"
        }, subText);
    }, [
        singleLineHeader,
        subText
    ]);
    if (!text && !mark) {
        return null;
    }
    return /* @__PURE__ */ React127.createElement(EGDSLayoutFlex29, {
        space: "six"
    }, icon && /* @__PURE__ */ React127.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */ React127.createElement("div", null, /* @__PURE__ */ React127.createElement(EGDSIcon20, {
        name: icon.iconId,
        description: icon.description
    }))), mark && /* @__PURE__ */ React127.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */ React127.createElement(React127.Fragment, null, id && /* @__PURE__ */ React127.createElement("div", null, /* @__PURE__ */ React127.createElement(EGDSMark9, {
        name: id,
        size: EGDSMarkSize7.MEDIUM,
        description: description
    })), !id && (url === null || url === void 0 ? void 0 : url.value) && /* @__PURE__ */ React127.createElement(EGDSMark9, {
        url: url.value,
        size: EGDSMarkSize7.MEDIUM,
        description: description
    }))), /* @__PURE__ */ React127.createElement(EGDSLayoutFlexItem22, {
        maxWidth: "full_width",
        grow: 1
    }, /* @__PURE__ */ React127.createElement("div", null, /* @__PURE__ */ React127.createElement(EGDSHeading8, _object_spread_props(_object_spread({}, props), {
        tabIndex: -1
    }), text, subText && singleLineHeader && /* @__PURE__ */ React127.createElement(React127.Fragment, null, " ", RenderedSubtext)), subText && !singleLineHeader && RenderedSubtext)), headerImage && /* @__PURE__ */ React127.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */ React127.createElement(EGDSAvatar2, {
        border: false,
        image: {
            alt: headerImage.description,
            src: headerImage.url
        },
        size: "extra_large"
    })));
};
SectionHeader.displayName = "SectionHeader";
SectionHeader.fragment = fragment87;
// src/components/property-content-section-group/property-content.tsx
var fragment88 = gql99(_templateObject99(), lodging_link_message_default.fragment, PropertyContentItemGraphics.fragment, PropertyContentItemImages.fragment, PropertyContentItemMarkup.fragment, PropertyContentItemText.fragment, PropertyContentItemTexts.fragment, PropertyImage.fragment, LodgingGalleryCarousel.fragment, SectionHeader.fragment);
var PropertyContent = function(param) {
    var data = param.data, smallerHeader = param.smallerHeader, isExpandoSection = param.isExpandoSection, whitespace = param.whitespace;
    var createExpandoAnalytics = function createExpandoAnalytics(referrerId, linkName) {
        if (referrerId && linkName) {
            return {
                id: referrerId,
                description: linkName,
                callback: useClickTrackerCallback
            };
        }
    };
    var _expandButton_analytics, _collapseButton_analytics, _expandButton_analytics1, _collapseButton_analytics1;
    var clickTracker = useClickTracker27();
    var header = data.header, items = data.items, expando = data.expando, maxColumns = data.maxColumns, structuredData = data.structuredData, expandoPeek = data.expandoPeek, leadingGraphic = data.leadingGraphic, propertyContentRef = data.propertyContentRef;
    var _ref = expando || {}, expandButton = _ref.expandButton, collapseButton = _ref.collapseButton;
    var _ref1 = expandoPeek || {}, expandAnalytics = _ref1.expandAnalytics, collapseAnalytics = _ref1.collapseAnalytics;
    var _React128_useState = _sliced_to_array(React128.useState(false), 2), isVisible = _React128_useState[0], setIsVisible = _React128_useState[1];
    var registerTarget = useRefContext().registerTarget;
    var detailedDialogContent = usePropertyContentSectionDetailedDialogContext();
    var setIdReference = detailedDialogContent.setIdReference, actionId = detailedDialogContent.actionId;
    var _useDialog8 = _sliced_to_array(useDialog8("property-content-section-detailed-dialog-".concat(actionId), "PropertyContentSectionDetailedDialog"), 2), dialogActions = _useDialog8[1];
    var expandoReferrerId = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics = expandButton.analytics) === null || _expandButton_analytics === void 0 ? void 0 : _expandButton_analytics.referrerId : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics = collapseButton.analytics) === null || _collapseButton_analytics === void 0 ? void 0 : _collapseButton_analytics.referrerId;
    var expandoLinkName = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics1 = expandButton.analytics) === null || _expandButton_analytics1 === void 0 ? void 0 : _expandButton_analytics1.linkName : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics1 = collapseButton.analytics) === null || _collapseButton_analytics1 === void 0 ? void 0 : _collapseButton_analytics1.linkName;
    var expandoPeekReferrerId = !isVisible ? expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.referrerId : collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.referrerId;
    var expandoPeekLinkName = !isVisible ? expandAnalytics === null || expandAnalytics === void 0 ? void 0 : expandAnalytics.linkName : collapseAnalytics === null || collapseAnalytics === void 0 ? void 0 : collapseAnalytics.linkName;
    var _useExperiment7_exposure = useExperiment7("Remove_About_the_Property_Web").exposure, isTopOfPDPRedesignVariant = _useExperiment7_exposure.bucket;
    var handleClick = React128.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var useClickTrackerCallback = React128.useCallback(function(referrerId, linkName) {
        clickTracker(referrerId, linkName);
    }, [
        clickTracker
    ]);
    var expandoAnalytics = createExpandoAnalytics(expandoReferrerId, expandoLinkName);
    var expandoPeekAnalytics = createExpandoAnalytics(expandoPeekReferrerId, expandoPeekLinkName);
    var handleSetRef = React128.useCallback(function() {
        if ((leadingGraphic === null || leadingGraphic === void 0 ? void 0 : leadingGraphic.__typename) === "PropertyImage") {
            var onClickAction = leadingGraphic.onClickAction;
            var refToScroll = onClickAction === null || onClickAction === void 0 ? void 0 : onClickAction.scrollPageToRef;
            if (refToScroll) {
                setIdReference === null || setIdReference === void 0 ? void 0 : setIdReference(refToScroll);
            }
            dialogActions.openDialog();
        }
    }, [
        setIdReference,
        dialogActions,
        leadingGraphic
    ]);
    var leadingGraphicComponent = useMemo5(function() {
        switch(leadingGraphic === null || leadingGraphic === void 0 ? void 0 : leadingGraphic.__typename){
            case "PropertyImage":
                return /* @__PURE__ */ React128.createElement(EGDSSpacing28, {
                    padding: {
                        blockend: "two"
                    }
                }, /* @__PURE__ */ React128.createElement(PropertyImage, {
                    data: leadingGraphic,
                    index: 0,
                    galleryLength: 1,
                    onClick: handleSetRef
                }));
            case "LodgingGalleryCarousel":
                return /* @__PURE__ */ React128.createElement(EGDSSpacing28, {
                    padding: {
                        blockend: "two"
                    }
                }, /* @__PURE__ */ React128.createElement(LodgingGalleryCarouselSpaces, {
                    data: leadingGraphic,
                    carouselId: "lodging-card-gallery-carousel",
                    fetchPriority: "low",
                    imageRatio: EGDSFigureAspectRatioType10.R16_9
                }));
            default:
                return null;
        }
    }, [
        handleSetRef,
        leadingGraphic
    ]);
    if (items.length === 0) {
        return null;
    }
    var getPropertyContentItemComponent = function(contentItem) {
        switch(contentItem.__typename){
            case "PropertyContentItemMarkup":
                return /* @__PURE__ */ React128.createElement(PropertyContentItemMarkup, {
                    data: contentItem
                });
            case "PropertyContentItemTexts":
                return /* @__PURE__ */ React128.createElement(PropertyContentItemTexts, {
                    data: contentItem,
                    structuredData: structuredData
                });
            case "PropertyContentItemText":
                return /* @__PURE__ */ React128.createElement(PropertyContentItemText, {
                    data: contentItem
                });
            case "PropertyContentItemImages":
                return /* @__PURE__ */ React128.createElement(PropertyContentItemImages, {
                    data: contentItem,
                    structuredData: structuredData
                });
            case "PropertyContentItemGraphics":
                return /* @__PURE__ */ React128.createElement(PropertyContentItemGraphics, {
                    data: contentItem
                });
            case "LodgingLinkMessage":
                return /* @__PURE__ */ React128.createElement(lodging_link_message_default, {
                    data: contentItem
                });
            default:
                return null;
        }
    };
    var propertyContentItems = items.map(function(item, index) {
        var propertyContentItemComponent = getPropertyContentItemComponent(item);
        return propertyContentItemComponent && /* @__PURE__ */ React128.createElement(EGDSLayoutGridItem7, {
            key: index
        }, /* @__PURE__ */ React128.createElement("div", null, propertyContentItemComponent));
    });
    var contentRef = function() {
        if (leadingGraphic && leadingGraphic.__typename === "LodgingGalleryCarousel" && propertyContentRef) {
            return registerTarget(propertyContentRef);
        }
        return null;
    };
    var hasItems = propertyContentItems && (propertyContentItems === null || propertyContentItems === void 0 ? void 0 : propertyContentItems.length) > 0;
    return /* @__PURE__ */ React128.createElement(EGDSLayoutGridItem7, {
        colSpan: 1
    }, /* @__PURE__ */ React128.createElement("div", {
        "data-stid": "content-item",
        itemProp: structuredData === null || structuredData === void 0 ? void 0 : structuredData.itemprop,
        ref: contentRef()
    }, leadingGraphic && leadingGraphic.__typename !== "Video" && /* @__PURE__ */ React128.createElement(EGDSSpacing28, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React128.createElement(UitkFigure, {
        ratio: EGDSFigureAspectRatioType10.R16_9,
        additionalProps: {
            style: {
                borderRadius: "8px"
            }
        }
    }, /* @__PURE__ */ React128.createElement(Lazyload4, null, leadingGraphicComponent))), leadingGraphic && leadingGraphic.__typename === "Video" && /* @__PURE__ */ React128.createElement(Lazyload4, null, !isTopOfPDPRedesignVariant && /* @__PURE__ */ React128.createElement(Experiment, {
        name: "Add_PDP_YouTube_Videos"
    }, /* @__PURE__ */ React128.createElement(ExperimentControl, null), /* @__PURE__ */ React128.createElement(ExperimentVariant, {
        bucket: 1
    }, /* @__PURE__ */ React128.createElement(EGDSSpacing28, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React128.createElement(EGDSLayoutGridItem7, {
        colSpan: {
            medium: 1,
            large: 1
        },
        rowSpan: {
            medium: 1,
            large: 1
        }
    }, /* @__PURE__ */ React128.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React128.createElement(UitkVideo, {
        src: leadingGraphic.url.value,
        alt: leadingGraphic.description
    }))))))), header && /* @__PURE__ */ React128.createElement(SectionHeader, {
        tag: smallerHeader ? "h4" : "h3",
        size: smallerHeader ? 6 : 5,
        data: header
    }), hasItems && /* @__PURE__ */ React128.createElement(EGDSSpacing28, {
        padding: {
            inlinestart: (header === null || header === void 0 ? void 0 : header.icon) ? "twelve" : void 0,
            blockstart: "two"
        }
    }, isExpandoSection ? /* @__PURE__ */ React128.createElement(EGDSLayoutGrid8, {
        space: "two",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems) : /* @__PURE__ */ React128.createElement(React128.Fragment, null, !expando && !expandoPeek && /* @__PURE__ */ React128.createElement(EGDSLayoutGrid8, {
        space: "two",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems), !expandoPeek && expando && /* @__PURE__ */ React128.createElement(EGDSExpandoPeek2, {
        handleClick: handleClick,
        items: 2,
        isVisible: isVisible,
        expandLabel: expando.expandButton.text,
        collapseLabel: expando.collapseButton.text,
        analytics: expandoAnalytics
    }, /* @__PURE__ */ React128.createElement(EGDSLayoutGrid8, {
        space: "two",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems)), expandoPeek && /* @__PURE__ */ React128.createElement(EGDSExpandoPeek2, _object_spread_props(_object_spread({
        handleClick: handleClick
    }, expandoPeek.items && {
        items: expandoPeek.items
    }, expandoPeek.lines && {
        lines: expandoPeek.lines
    }), {
        isVisible: isVisible,
        expandLabel: expandoPeek.expandedLabel,
        collapseLabel: expandoPeek.collapsedLabel,
        analytics: expandoPeekAnalytics,
        whitespace: whitespace
    }), /* @__PURE__ */ React128.createElement(EGDSLayoutGrid8, {
        space: "two",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems))))));
};
PropertyContent.displayName = "PropertyContent";
PropertyContent.fragment = fragment88;
// src/components/property-content-section-group/property-content-section.tsx
import React142 from "react";
import { gql as gql111 } from "@apollo/client";
import { EGDSCard as EGDSCard5, EGDSCardContentSection as EGDSCardContentSection8 } from "@egds/react-core/cards";
import { EGDSExpandoList, EGDSExpandoListItem, EGDSExpandoPeek as EGDSExpandoPeek3 } from "@egds/react-core/expando";
import { EGDSLayoutGrid as EGDSLayoutGrid14, EGDSLayoutGridItem as EGDSLayoutGridItem10 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing38, EGDSSpacingHr as EGDSSpacingHr6 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker12, useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment10 } from "@shared-ui/experiment-context";
import { RefTarget } from "@shared-ui/ref-context";
// src/components/property-content-section-group/property-content-section-action.tsx
import React138 from "react";
import { gql as gql107 } from "@apollo/client";
// src/components/property-content-section-group/property-content-section-detailed-dialog.tsx
import React129, { useEffect as useEffect6 } from "react";
import { gql as gql100 } from "@apollo/client";
import { EGDSLink as EGDSLink9 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet7, EGDSSheetContent as EGDSSheetContent8, EGDSSheetTransition as EGDSSheetTransition10 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing29 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar5 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { useRefContext as useRefContext2 } from "@shared-ui/ref-context";
import { ViewMedium as ViewMedium10, Viewport as Viewport10, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
var fragment89 = gql100(_templateObject100());
var PropertyContentSectionDetailedDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var dialog = data.dialog, trigger = data.trigger;
    var dialogData = (dialog === null || dialog === void 0 ? void 0 : dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var linkRef = React129.useRef(null);
    var clickTracker = useClickTracker28();
    var _useDialog9 = _sliced_to_array(useDialog9("property-content-section-detailed-dialog-".concat(actionId), "PropertyContentSectionDetailedDialog"), 3), isDialogOpen = _useDialog9[0], dialogActions = _useDialog9[1], DialogComponent = _useDialog9[2];
    var detailedDialogContent = usePropertyContentSectionDetailedDialogContext();
    var setIdReference = detailedDialogContent.setIdReference, idReference = detailedDialogContent.idReference;
    var idRef = idReference || "";
    var closeDialog = React129.useCallback(function() {
        dialogActions.closeDialog();
        if (dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics) {
            clickTracker(dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics.referrerId, dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        clickTracker,
        dialogData === null || dialogData === void 0 ? void 0 : dialogData.closeAnalytics
    ]);
    var getTargets = useRefContext2().getTargets;
    var _getTargets = getTargets([
        idRef
    ]), targetRef = _getTargets[idRef];
    useEffect6(function() {
        if (isDialogOpen && targetRef && targetRef.current && targetRef.current.focus) {
            var _targetRef_current, _targetRef_current1;
            targetRef === null || targetRef === void 0 ? void 0 : (_targetRef_current = targetRef.current) === null || _targetRef_current === void 0 ? void 0 : _targetRef_current.focus();
            targetRef === null || targetRef === void 0 ? void 0 : (_targetRef_current1 = targetRef.current) === null || _targetRef_current1 === void 0 ? void 0 : _targetRef_current1.scrollIntoView({
                behavior: "auto"
            });
        }
    }, [
        isDialogOpen,
        targetRef === null || targetRef === void 0 ? void 0 : targetRef.current,
        trigger.analytics
    ]);
    useEffect6(function() {
        if (isDialogOpen) {
            clickTracker(trigger.analytics.referrerId, trigger.analytics.linkName);
        }
    }, [
        isDialogOpen
    ]);
    var openDialog = React129.useCallback(function() {
        setIdReference === null || setIdReference === void 0 ? void 0 : setIdReference(null);
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    if (!dialogData) {
        return null;
    }
    var dialogContent = function(sheetType) {
        var _dialogData_toolbar_closeText;
        return /* @__PURE__ */ React129.createElement(EGDSSheet7, {
            type: sheetType,
            key: "property-content-section-detailed-dialog",
            returnFocusOnClose: true,
            isVisible: true,
            triggerRef: linkRef,
            ariaLabel: (_dialogData_toolbar_closeText = dialogData.toolbar.closeText) !== null && _dialogData_toolbar_closeText !== void 0 ? _dialogData_toolbar_closeText : void 0
        }, /* @__PURE__ */ React129.createElement(EGDSToolbar5, {
            toolbarTitle: dialogData.toolbar.title,
            key: "EGDSToolbar",
            navigationContent: {
                onClick: closeDialog,
                navType: "close",
                navButtonLabel: void 0
            }
        }), /* @__PURE__ */ React129.createElement(EGDSSheetContent8, null, detailedDialogContent.dialogElement));
    };
    return /* @__PURE__ */ React129.createElement(React129.Fragment, null, /* @__PURE__ */ React129.createElement(EGDSSheetTransition10, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React129.createElement(DialogComponent, null, /* @__PURE__ */ React129.createElement(Viewport10, null, /* @__PURE__ */ React129.createElement(ViewSmall9, null, dialogContent("full")), /* @__PURE__ */ React129.createElement(ViewMedium10, null, dialogContent("centered"))))), /* @__PURE__ */ React129.createElement(EGDSSpacing29, null, /* @__PURE__ */ React129.createElement(EGDSLink9, {
        onClick: openDialog
    }, /* @__PURE__ */ React129.createElement("button", {
        ref: linkRef,
        type: "button"
    }, trigger.message))));
};
PropertyContentSectionDetailedDialog.displayName = "PropertyContentSectionDetailedDialog";
PropertyContentSectionDetailedDialog.fragment = fragment89;
// src/components/property-content-section-group/property-content-section-dialog.tsx
import React131 from "react";
import { gql as gql101 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent6 } from "@egds/react-core/dialog";
import { EGDSLink as EGDSLink11 } from "@egds/react-core/link";
import { EGDSSheet as EGDSSheet8, EGDSSheetTransition as EGDSSheetTransition11 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar6 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
// src/components/property-content-section-group/property-content-section-action-item.tsx
import React130 from "react";
import { EGDSLink as EGDSLink10 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing30 } from "@egds/react-core/spacing";
import { EGDSParagraph as EGDSParagraph2, EGDSText as EGDSText21 } from "@egds/react-core/text";
var PropertyContentSectionActionItem = function(param) {
    var contentItem = param.contentItem, key = param.key;
    switch(contentItem.__typename){
        case "EGDSParagraph":
            return /* @__PURE__ */ React130.createElement(EGDSSpacing30, {
                key: key,
                padding: {
                    blockend: "three"
                }
            }, /* @__PURE__ */ React130.createElement(EGDSParagraph2, null, " ", contentItem.text, " "));
        case "EGDSPlainText":
            return /* @__PURE__ */ React130.createElement(EGDSText21, {
                key: key,
                inline: true
            }, contentItem.text);
        case "EGDSInlineLink":
            {
                var _contentItem_action;
                var resource = (_contentItem_action = contentItem.action) === null || _contentItem_action === void 0 ? void 0 : _contentItem_action.resource;
                return /* @__PURE__ */ React130.createElement(EGDSLink10, {
                    key: key,
                    inline: true
                }, /* @__PURE__ */ React130.createElement("a", {
                    href: resource.value
                }, contentItem.text));
            }
        default:
            return null;
    }
};
PropertyContentSectionActionItem.displayName = "PropertyContentSectionActionItem";
// src/components/property-content-section-group/property-content-section-dialog.tsx
var fragment90 = gql101(_templateObject101());
var PropertyContentSectionDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var _dialogContent_toolbar;
    var _useDialog10 = _sliced_to_array(useDialog10("property-content-section-dialog-".concat(actionId), "PropertyContentSectionDialog"), 3), isDialogOpen = _useDialog10[0], dialogActions = _useDialog10[1], DialogComponent = _useDialog10[2];
    var content = data.content, dialog = data.dialog, trigger = data.trigger;
    var contents = content.contents;
    var dialogContent = (dialog === null || dialog === void 0 ? void 0 : dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var clickTracker = useClickTracker29();
    var closeDialog = React131.useCallback(function() {
        dialogActions.closeDialog();
        if (dialog.closeAnalytics) {
            clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        dialog.closeAnalytics,
        clickTracker
    ]);
    var openDialog = React131.useCallback(function() {
        dialogActions.openDialog();
        clickTracker(trigger.analytics.referrerId, trigger.analytics.linkName);
    }, [
        dialogActions,
        trigger.analytics,
        clickTracker
    ]);
    return /* @__PURE__ */ React131.createElement(React131.Fragment, null, /* @__PURE__ */ React131.createElement(EGDSSheetTransition11, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React131.createElement(DialogComponent, null, /* @__PURE__ */ React131.createElement(EGDSSheet8, {
        type: "centered",
        isVisible: isDialogOpen,
        triggerRef: null,
        returnFocusOnClose: true,
        key: "property-content-section-dialog"
    }, /* @__PURE__ */ React131.createElement(EGDSToolbar6, {
        toolbarTitle: dialogContent === null || dialogContent === void 0 ? void 0 : (_dialogContent_toolbar = dialogContent.toolbar) === null || _dialogContent_toolbar === void 0 ? void 0 : _dialogContent_toolbar.title,
        key: "EGDSToolbar",
        navigationContent: {
            onClick: closeDialog,
            navType: "close"
        }
    }), /* @__PURE__ */ React131.createElement(EGDSDialogContent6, null, contents.map(function(contentItem, index) {
        return /* @__PURE__ */ React131.createElement(PropertyContentSectionActionItem, {
            contentItem: contentItem,
            key: index
        });
    }))))), /* @__PURE__ */ React131.createElement(EGDSLink11, {
        inline: true
    }, /* @__PURE__ */ React131.createElement("button", {
        type: "button",
        onClick: openDialog
    }, trigger.message)));
};
PropertyContentSectionDialog.displayName = "PropertyContentSectionDialog";
PropertyContentSectionDialog.fragment = fragment90;
// src/components/property-content-section-group/property-content-section-list-type-dialog.tsx
import React137 from "react";
import { gql as gql106 } from "@apollo/client";
import { EGDSIcon as EGDSIcon24 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink12 } from "@egds/react-core/link";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSheet as EGDSSheet10, EGDSSheetContent as EGDSSheetContent10, EGDSSheetTransition as EGDSSheetTransition14 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing36 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar7 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog13 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium12, Viewport as Viewport13, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
// src/utils/property-info-content.ts
var CONTENT_TYPE = /* @__PURE__ */ function(CONTENT_TYPE2) {
    CONTENT_TYPE2["AMENITIES_DIALOG"] = "AmenitiesDialog";
    CONTENT_TYPE2["SUSTAINABILITY_DIALOG"] = "SustainabilityDialog";
    return CONTENT_TYPE2;
}(CONTENT_TYPE || {});
// src/components/property-info-content/property-info-content-header.tsx
import React132 from "react";
import { gql as gql102 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing31 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9, EGDSText as EGDSText22 } from "@egds/react-core/text";
var __PropertyInfoContentHeader = gql102(_templateObject102());
var PropertyInfoContentHeader = function(param) {
    var data = param.data, headingSize = param.headingSize, headingPadding = param.headingPadding, headingTag = param.headingTag;
    var text = data.text, subText = data.subText;
    var size = headingSize || 5;
    var padding = headingPadding !== null && headingPadding !== void 0 ? headingPadding : {
        blockend: "three"
    };
    var tag = headingTag || "h3";
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React132.createElement(EGDSSpacing31, {
        padding: padding
    }, /* @__PURE__ */ React132.createElement(EGDSHeading9, {
        tag: tag,
        size: size,
        tabIndex: -1
    }, text), subText && /* @__PURE__ */ React132.createElement(EGDSSpacing31, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React132.createElement(EGDSText22, {
        spacing: "two"
    }, subText)));
};
PropertyInfoContentHeader.displayName = "PropertyInfoContentHeader";
PropertyInfoContentHeader.fragment = __PropertyInfoContentHeader;
// src/components/property-info-content/property-info-content-items.tsx
import React135 from "react";
import { gql as gql104 } from "@apollo/client";
import { EGDSIcon as EGDSIcon22 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex31 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid10 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList2, EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing34 } from "@egds/react-core/spacing";
// src/components/property-info-content/amenity-review-summary.tsx
import React134 from "react";
import { gql as gql103 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize5, EGDSTertiaryButton as EGDSTertiaryButton4 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon21, EGDSIconSize as EGDSIconSize17 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex30, EGDSLayoutFlexItem as EGDSLayoutFlexItem23 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid9, EGDSLayoutGridItem as EGDSLayoutGridItem8 } from "@egds/react-core/layout-grid";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger3 } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet9, EGDSSheetCloseButton, EGDSSheetContent as EGDSSheetContent9, EGDSSheetTransition as EGDSSheetTransition12 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing33 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10, EGDSText as EGDSText24 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker10, useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
import { ViewMedium as ViewMedium11, Viewport as Viewport11, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
// src/components/property-info-content/property-info-content-text.tsx
import React133 from "react";
import { EGDSSpacing as EGDSSpacing32 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText23 } from "@egds/react-core/text";
var PropertyInfoContentText = function(param) {
    var infoContent = param.infoContent;
    var text = infoContent.text, state = infoContent.state, moreInfo = infoContent.moreInfo, accessibilityLabel = infoContent.accessibilityLabel;
    return /* @__PURE__ */ React133.createElement(React133.Fragment, null, state === "DISABLED" ? /* @__PURE__ */ React133.createElement("s", {
        "aria-hidden": true
    }, /* @__PURE__ */ React133.createElement(EGDSText23, {
        size: 300,
        inline: true
    }, text)) : /* @__PURE__ */ React133.createElement(EGDSText23, {
        size: 300,
        inline: true
    }, text), accessibilityLabel && /* @__PURE__ */ React133.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), moreInfo && /* @__PURE__ */ React133.createElement(EGDSSpacing32, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React133.createElement(EGDSText23, {
        size: 200,
        inline: true
    }, moreInfo)));
};
PropertyInfoContentText.displayName = "PropertyInfoContentText";
// src/components/property-info-content/amenity-review-summary.tsx
var __AmenityReviewSummary = gql103(_templateObject103());
var AmenityReviewSummary = function(props) {
    var infoContent = props.infoContent, data = props.data;
    var icon = data.icon, reviewSummaryHighlight = data.reviewSummaryHighlight, clickAnalytics = data.clickAnalytics, impressionAnalytics = data.impressionAnalytics;
    var headerInfo = reviewSummaryHighlight === null || reviewSummaryHighlight === void 0 ? void 0 : reviewSummaryHighlight.header;
    var summaryInfo = reviewSummaryHighlight === null || reviewSummaryHighlight === void 0 ? void 0 : reviewSummaryHighlight.content;
    var formatText = useLocalization().formatText;
    var dialogButtonText = formatText("property-amenity-review-summary.dialog.ok.label");
    var triggerRef = React134.useRef(null);
    var _useDialog11 = _sliced_to_array(useDialog11("amenity-review-summary-dialog-".concat(infoContent === null || infoContent === void 0 ? void 0 : infoContent.text.replace(/\s/g, "-"))), 3), isDialogOpen = _useDialog11[0], dialogActions = _useDialog11[1], DialogComponent = _useDialog11[2];
    var _React134_useState = _sliced_to_array(React134.useState(false), 2), visible = _React134_useState[0], setVisible = _React134_useState[1];
    var trackClick = useClickTracker30();
    var trackClickAnalytics = function() {
        if (clickAnalytics) {
            trackClick(clickAnalytics.referrerId, clickAnalytics.linkName);
        }
    };
    var toggleVisibility = function() {
        setVisible(!visible);
        if (!visible) {
            trackClickAnalytics();
        }
    };
    var openDialog = function() {
        dialogActions.openDialog();
        trackClickAnalytics();
    };
    var closeDialog = function() {
        dialogActions.closeDialog();
    };
    var moreInfoTriggerRender = function(onClickHandler) {
        return /* @__PURE__ */ React134.createElement(EGDSMoreInfoTrigger3, null, /* @__PURE__ */ React134.createElement("button", {
            type: "button",
            ref: triggerRef,
            onClick: onClickHandler
        }, /* @__PURE__ */ React134.createElement(PropertyInfoContentText, {
            infoContent: infoContent
        }), icon && /* @__PURE__ */ React134.createElement(EGDSIcon21, {
            name: icon.iconId,
            size: EGDSIconSize17.MEDIUM
        })));
    };
    var amenityReviewSummarySheetContentRender = /* @__PURE__ */ React134.createElement(React134.Fragment, null, /* @__PURE__ */ React134.createElement(EGDSLayoutFlexItem23, null, /* @__PURE__ */ React134.createElement(EGDSLayoutGrid9, {
        space: "two",
        justifyContent: "center",
        alignItems: "center",
        columns: [
            "min-content",
            "auto"
        ]
    }, headerInfo && headerInfo.graphic.__typename === "Icon" && /* @__PURE__ */ React134.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */ React134.createElement("div", null, /* @__PURE__ */ React134.createElement(EGDSIcon21, {
        name: headerInfo.graphic.id,
        size: EGDSIconSize17.MEDIUM,
        spotlight: {
            theme: "info",
            background: true
        }
    }))), headerInfo && /* @__PURE__ */ React134.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */ React134.createElement(EGDSHeading10, {
        tag: "h6",
        size: 6
    }, headerInfo.text)))), (summaryInfo === null || summaryInfo === void 0 ? void 0 : summaryInfo.length) && /* @__PURE__ */ React134.createElement(EGDSLayoutFlexItem23, null, /* @__PURE__ */ React134.createElement(EGDSSpacing33, {
        margin: {
            blockstart: "two"
        }
    }, summaryInfo.map(function(contentText, index) {
        return /* @__PURE__ */ React134.createElement(EGDSText24, {
            size: 300,
            key: "".concat(contentText, "-").concat(index)
        }, contentText);
    }))));
    var amenityReviewSummaryRender = /* @__PURE__ */ React134.createElement(Viewport11, null, /* @__PURE__ */ React134.createElement(ViewSmall10, null, /* @__PURE__ */ React134.createElement(React134.Fragment, null, moreInfoTriggerRender(openDialog), /* @__PURE__ */ React134.createElement(EGDSSheetTransition12, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React134.createElement(DialogComponent, null, /* @__PURE__ */ React134.createElement(EGDSSheet9, {
        isVisible: isDialogOpen,
        type: "centered",
        centeredSheetSize: "small",
        returnFocusOnClose: true,
        liveAnnounceString: "Centered Sheet has opened",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React134.createElement(EGDSSheetContent9, null, /* @__PURE__ */ React134.createElement(EGDSLayoutFlex30, {
        direction: "column"
    }, amenityReviewSummarySheetContentRender, /* @__PURE__ */ React134.createElement(EGDSLayoutFlexItem23, null, /* @__PURE__ */ React134.createElement(EGDSSpacing33, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React134.createElement(EGDSTertiaryButton4, {
        size: EGDSButtonSize5.MEDIUM,
        onClick: closeDialog
    }, dialogButtonText)))))))))), /* @__PURE__ */ React134.createElement(ViewMedium11, null, /* @__PURE__ */ React134.createElement(React134.Fragment, null, moreInfoTriggerRender(toggleVisibility), /* @__PURE__ */ React134.createElement(EGDSCard4, {
        overflow: false
    }, /* @__PURE__ */ React134.createElement(EGDSSheetTransition12, {
        isVisible: visible
    }, /* @__PURE__ */ React134.createElement(EGDSSheet9, {
        autoFocus: false,
        autoPosition: true,
        position: {
            inline: "leading",
            block: "leading"
        },
        applyBlockStartMargin: true,
        width: 360,
        isVisible: visible,
        liveAnnounceString: "Popover Sheet has opened",
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: toggleVisibility
    }, /* @__PURE__ */ React134.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */ React134.createElement(EGDSTertiaryButton4, {
        type: "button",
        onClick: toggleVisibility
    }, /* @__PURE__ */ React134.createElement(EGDSIcon21, {
        name: "close",
        size: EGDSIconSize17.MEDIUM,
        title: "Close Sheet",
        id: "sheet-close-button"
    }))), /* @__PURE__ */ React134.createElement(EGDSSheetContent9, {
        padded: false
    }, /* @__PURE__ */ React134.createElement(EGDSSpacing33, {
        padding: {
            block: "six",
            inlinestart: "six",
            inlineend: "unset"
        }
    }, /* @__PURE__ */ React134.createElement(EGDSLayoutFlex30, {
        direction: "column"
    }, amenityReviewSummarySheetContentRender)))))))));
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React134.createElement(React134.Fragment, null, (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) && (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) ? /* @__PURE__ */ React134.createElement(IntersectionTracker10, {
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, amenityReviewSummaryRender) : amenityReviewSummaryRender);
};
AmenityReviewSummary.displayName = "AmenityReviewSummary";
AmenityReviewSummary.fragment = __AmenityReviewSummary;
// src/components/property-info-content/property-info-content-items.tsx
var __PropertyInfoContentItem = gql104(_templateObject104(), AmenityReviewSummary.fragment);
var PropertyInfoContentItem = function(param) {
    var className = param.className, iconSize = param.iconSize, data = param.data;
    var icon = data.icon, text = data.text, state = data.state, moreInfo = data.moreInfo, accessibilityLabel = data.accessibilityLabel, highlights = data.highlights;
    var infoContent = {
        text: text,
        state: state,
        moreInfo: moreInfo,
        accessibilityLabel: accessibilityLabel
    };
    var iconTheme = moreInfo ? "positive" : "default";
    var propertyInfoContentIcon = /* @__PURE__ */ React135.createElement(React135.Fragment, null, icon && /* @__PURE__ */ React135.createElement(EGDSSpacing34, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React135.createElement(EGDSIcon22, {
        name: icon.iconId.toLocaleLowerCase(),
        description: icon.description,
        theme: iconTheme,
        size: iconSize
    })));
    return /* @__PURE__ */ React135.createElement(React135.Fragment, null, text && /* @__PURE__ */ React135.createElement(EGDSListItem2, {
        key: "amenity-".concat(text),
        className: className
    }, /* @__PURE__ */ React135.createElement(EGDSLayoutFlex31, null, propertyInfoContentIcon, highlights ? /* @__PURE__ */ React135.createElement(AmenityReviewSummary, {
        infoContent: infoContent,
        data: highlights
    }) : /* @__PURE__ */ React135.createElement(PropertyInfoContentText, {
        infoContent: infoContent
    }))));
};
PropertyInfoContentItem.displayName = "PropertyInfoContentItem";
PropertyInfoContentItem.fragment = __PropertyInfoContentItem;
var __PropertyInfoContentItems = gql104(_templateObject105(), PropertyInfoContentItem.fragment);
var PropertyInfoContentItems = function(param) {
    var columns = param.columns, rows = param.rows, data = param.data, space = param.space, prefix = param.prefix, subset = param.subset, autoflow = param.autoflow, iconSize = param.iconSize;
    var _contentItems_;
    var items = data.items;
    var contentItems = subset && subset > 0 ? items.slice(0, subset) : items;
    var numberOfRows = rows !== null && rows !== void 0 ? rows : contentItems && Math.ceil(contentItems.length / columns);
    var bullet = contentItems.length > 0 && ((_contentItems_ = contentItems[0]) === null || _contentItems_ === void 0 ? void 0 : _contentItems_.icon) ? "icon-alternate" : "default";
    return /* @__PURE__ */ React135.createElement(EGDSList2, {
        spacing: false,
        bullet: bullet,
        size: 2,
        type: "unordered"
    }, /* @__PURE__ */ React135.createElement(EGDSLayoutGrid10, {
        columns: columns,
        space: space,
        autoFlow: autoflow,
        rows: numberOfRows
    }, contentItems.map(function(item, idx) {
        return /* @__PURE__ */ React135.createElement(PropertyInfoContentItem, {
            key: "".concat(prefix, "-item-").concat(idx),
            data: item,
            iconSize: iconSize
        });
    })));
};
PropertyInfoContentItems.displayName = "PropertyInfoContentItems";
PropertyInfoContentItems.fragment = __PropertyInfoContentItems;
// src/components/property-info-content/property-info-content.tsx
import React136, { useEffect as useEffect7 } from "react";
import { gql as gql105 } from "@apollo/client";
import { EGDSDialog as EGDSDialog4, EGDSDialogContent as EGDSDialogContent7, EGDSDialogFooter as EGDSDialogFooter4 } from "@egds/react-core/dialog";
import { EGDSIcon as EGDSIcon23, UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex32, UitkLayoutFlex as UitkLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid11 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList3, EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
import { EGDSSheetTransition as EGDSSheetTransition13 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing35 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading11 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker11, ITrackType as ITrackType7, useClickstreamAnalytics as useClickstreamAnalytics7, useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog12 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment8 } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge6, Viewport as Viewport12, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
import { useInView as useInView4 } from "react-intersection-observer";
var __PropertyInfoContent = gql105(_templateObject106(), PropertyInfoContentHeader.fragment, PropertyInfoContentItems.fragment, PropertyInfoContentItem.fragment, AdaptExAnalyticsEventFragment);
var PropertyInfoContent = function(param) {
    var data = param.data, small = param.small, large = param.large, headingSize = param.headingSize, headingTag = param.headingTag;
    var _header_icon;
    var header = data.header, icon = data.icon, iconAnalytics = data.iconAnalytics, adaptExAttemptEvents = data.adaptExAttemptEvents;
    var dialogKey = React136.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var dialogId = "location-highlights-".concat(dialogKey);
    var _useDialog12 = _sliced_to_array(useDialog12(dialogId), 3), isDialogOpen = _useDialog12[0], dialogActions = _useDialog12[1], DialogComponent = _useDialog12[2];
    var _useExperiment8_exposure = useExperiment8("PDP_MODULARISED_LOCATION_SECTION").exposure, isAmenitiesModularised = _useExperiment8_exposure.bucket;
    var trackIconAnalytics = useClickTracker31();
    var track = useClickstreamAnalytics7().track;
    var _useInView4 = useInView4({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView4.ref, inView = _useInView4.inView;
    useEffect7(function() {
        if (inView && (adaptExAttemptEvents === null || adaptExAttemptEvents === void 0 ? void 0 : adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                track(ITrackType7.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExAttemptEvent)
                });
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track
    ]);
    var _header_subText, _header_icon_description;
    var dialog = /* @__PURE__ */ React136.createElement(EGDSSheetTransition13, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React136.createElement(DialogComponent, null, /* @__PURE__ */ React136.createElement(EGDSDialog4, {
        returnFocusOnClose: true,
        dialogShow: isDialogOpen
    }, /* @__PURE__ */ React136.createElement(EGDSDialogContent7, null, (_header_subText = header === null || header === void 0 ? void 0 : header.subText) !== null && _header_subText !== void 0 ? _header_subText : "", /* @__PURE__ */ React136.createElement(EGDSDialogFooter4, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_header_icon_description = header === null || header === void 0 ? void 0 : (_header_icon = header.icon) === null || _header_icon === void 0 ? void 0 : _header_icon.description) !== null && _header_icon_description !== void 0 ? _header_icon_description : "",
            type: "tertiary"
        }
    })))));
    var handleClick = React136.useCallback(function() {
        dialogActions.openDialog();
        if (iconAnalytics) {
            trackIconAnalytics(iconAnalytics.referrerId, iconAnalytics.linkName, true);
        }
    }, [
        dialogActions,
        trackIconAnalytics,
        iconAnalytics
    ]);
    return /* @__PURE__ */ React136.createElement(React136.Fragment, null, /* @__PURE__ */ React136.createElement(EGDSLayoutFlex32, {
        direction: "column",
        domRef: ref
    }, /* @__PURE__ */ React136.createElement(EGDSLayoutFlex32, {
        alignItems: "start"
    }, header && /* @__PURE__ */ React136.createElement(PropertyInfoContentHeader, {
        data: header,
        headingSize: headingSize || 6,
        headingTag: headingTag || void 0
    }), icon && /* @__PURE__ */ React136.createElement("button", {
        type: "button",
        onClick: handleClick,
        "aria-label": "property-info-content_icon"
    }, /* @__PURE__ */ React136.createElement(EGDSSpacing35, {
        padding: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React136.createElement(EGDSIcon23, {
        name: icon.id
    })))), /* @__PURE__ */ React136.createElement(Viewport12, null, /* @__PURE__ */ React136.createElement(ViewSmall11, null, /* @__PURE__ */ React136.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, small), {
        data: data,
        iconSize: UitkIconSize2.SMALL
    }))), /* @__PURE__ */ React136.createElement(ViewLarge6, null, /* @__PURE__ */ React136.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, large), {
        data: data,
        iconSize: UitkIconSize2.SMALL
    }))))), dialog);
};
PropertyInfoContent.displayName = "PropertyInfoContent";
PropertyInfoContent.fragment = __PropertyInfoContent;
var PropertyInfoContentList = function(param) {
    var data = param.data, prefix = param.prefix, contentType = param.contentType, headingSize = param.headingSize, listItemPadding = param.listItemPadding, className = param.className;
    var header = data.header, items = data.items, impressionAnalytics = data.impressionAnalytics, icon = data.icon;
    var _ref = impressionAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var checkNestedListSection = function() {
        return items === null || items === void 0 ? void 0 : items.some(function(element) {
            var _element_subItems;
            var _element_subItems_listItems;
            var listItems = (_element_subItems_listItems = element === null || element === void 0 ? void 0 : (_element_subItems = element.subItems) === null || _element_subItems === void 0 ? void 0 : _element_subItems.listItems) !== null && _element_subItems_listItems !== void 0 ? _element_subItems_listItems : [];
            return listItems.length > 0;
        });
    };
    var isNestedListSection = checkNestedListSection();
    var columns = isNestedListSection && contentType === "AmenitiesDialog" /* AMENITIES_DIALOG */  ? 2 : 1;
    var renderListWithSubItems = function(item, idx) {
        var _item_subItems;
        var _item_subItems_listItems;
        var listItems = (_item_subItems_listItems = item === null || item === void 0 ? void 0 : (_item_subItems = item.subItems) === null || _item_subItems === void 0 ? void 0 : _item_subItems.listItems) !== null && _item_subItems_listItems !== void 0 ? _item_subItems_listItems : [];
        return /* @__PURE__ */ React136.createElement(EGDSSpacing35, {
            padding: {
                blockend: "one"
            }
        }, /* @__PURE__ */ React136.createElement("div", {
            key: "".concat(prefix, "-item-").concat(idx)
        }, /* @__PURE__ */ React136.createElement(EGDSSpacing35, {
            padding: listItemPadding
        }, /* @__PURE__ */ React136.createElement(EGDSHeading11, {
            tag: "h4",
            size: headingSize
        }, item.text)), listItems.length > 0 && listItems.map(function(listItem, index) {
            return /* @__PURE__ */ React136.createElement(EGDSSpacing35, {
                padding: {
                    blockend: "two"
                },
                key: "".concat(prefix, "-list-item-").concat(index)
            }, /* @__PURE__ */ React136.createElement("div", null, /* @__PURE__ */ React136.createElement(EGDSListItem3, null, listItem.text)));
        })));
    };
    var renderListWithoutSubItems = function(item, idx) {
        return /* @__PURE__ */ React136.createElement(EGDSSpacing35, {
            padding: listItemPadding
        }, /* @__PURE__ */ React136.createElement("div", null, /* @__PURE__ */ React136.createElement(EGDSListItem3, {
            key: "".concat(prefix, "-item-").concat(idx)
        }, item.text)));
    };
    var renderHeader = function() {
        return /* @__PURE__ */ React136.createElement(UitkLayoutFlex2, {
            space: "two",
            alignItems: "start"
        }, icon && /* @__PURE__ */ React136.createElement(UitkIcon2, {
            id: icon.id,
            name: icon.id,
            description: icon.description,
            size: UitkIconSize2.SMALL,
            theme: "primary"
        }), header && /* @__PURE__ */ React136.createElement(PropertyInfoContentHeader, {
            data: header,
            headingSize: 7,
            headingPadding: {
                blockend: "two"
            }
        }));
    };
    var layoutComponent = /* @__PURE__ */ React136.createElement(React136.Fragment, null, renderHeader(), items && items.length > 0 && /* @__PURE__ */ React136.createElement(EGDSList3, {
        bullet: "no-bullet",
        spacing: false,
        className: className
    }, /* @__PURE__ */ React136.createElement(EGDSLayoutGrid11, {
        columns: columns
    }, isNestedListSection ? items.map(function(item, idx) {
        return renderListWithSubItems(item, idx);
    }) : items.map(function(item, idx) {
        return renderListWithoutSubItems(item, idx);
    }))));
    if (referrerId && linkName) {
        return /* @__PURE__ */ React136.createElement(IntersectionTracker11, {
            trackOnce: true,
            referrerId: referrerId,
            linkName: linkName
        }, layoutComponent);
    }
    return layoutComponent;
};
PropertyInfoContentList.displayName = "PropertyInfoContentList";
PropertyInfoContentList.fragment = __PropertyInfoContent;
// src/components/property-content-section-group/property-content-section-list-type-dialog.tsx
var fragment91 = gql106(_templateObject107(), PropertyInfoContent.fragment);
var PropertyContentSectionListTypeDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var _useDialog13 = _sliced_to_array(useDialog13("property-content-section-list-type-dialog-".concat(actionId), "PropertyContentSectionListTypeDialog"), 3), isDialogOpen = _useDialog13[0], dialogActions = _useDialog13[1], DialogComponent = _useDialog13[2];
    var dialogData = data.dialogData, dialog = data.dialog, trigger = data.trigger;
    var triggerIcon = trigger.icon;
    var dialogContent = (dialog === null || dialog === void 0 ? void 0 : dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var clickTracker = useClickTracker32();
    var closeDialog = React137.useCallback(function() {
        dialogActions.closeDialog();
        var closeAnalytics = dialog.closeAnalytics;
        if (closeAnalytics) {
            clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        dialog.closeAnalytics,
        clickTracker
    ]);
    var openDialog = React137.useCallback(function() {
        dialogActions.openDialog();
        var analytics = trigger.analytics;
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        dialogActions,
        trigger.analytics,
        clickTracker
    ]);
    if (!(dialogData === null || dialogData === void 0 ? void 0 : dialogData.length)) {
        return null;
    }
    var dialogSheet = function(sheetType) {
        var _dialogContent_toolbar;
        return /* @__PURE__ */ React137.createElement(EGDSSheet10, {
            type: sheetType,
            key: "property-content-section-list-type-dialog",
            returnFocusOnClose: true,
            isVisible: true,
            triggerRef: null
        }, /* @__PURE__ */ React137.createElement(EGDSToolbar7, {
            toolbarTitle: dialogContent === null || dialogContent === void 0 ? void 0 : (_dialogContent_toolbar = dialogContent.toolbar) === null || _dialogContent_toolbar === void 0 ? void 0 : _dialogContent_toolbar.title,
            key: "EGDSToolbar",
            navigationContent: {
                onClick: closeDialog,
                navType: "close"
            }
        }), /* @__PURE__ */ React137.createElement(EGDSSheetContent10, {
            padded: true
        }, /* @__PURE__ */ React137.createElement(EGDSScrollable, {
            direction: "vertical"
        }, dialogData.map(function(section, idx) {
            return /* @__PURE__ */ React137.createElement(EGDSSpacing36, {
                key: "property-content-section-list-type-dialog-content-".concat(idx),
                padding: {
                    blockend: "four"
                }
            }, /* @__PURE__ */ React137.createElement("div", null, /* @__PURE__ */ React137.createElement(PropertyInfoContentList, {
                data: section,
                prefix: "property-content-section-list-type-dialog-content",
                contentType: "SustainabilityDialog" /* SUSTAINABILITY_DIALOG */ 
            })));
        }))));
    };
    return /* @__PURE__ */ React137.createElement(React137.Fragment, null, trigger.message && /* @__PURE__ */ React137.createElement(EGDSLink12, null, /* @__PURE__ */ React137.createElement("button", {
        type: "button",
        onClick: openDialog
    }, trigger.message, (triggerIcon === null || triggerIcon === void 0 ? void 0 : triggerIcon.id) && /* @__PURE__ */ React137.createElement(EGDSIcon24, {
        id: triggerIcon.id,
        name: triggerIcon.id,
        title: triggerIcon.description
    }))), /* @__PURE__ */ React137.createElement(EGDSSheetTransition14, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React137.createElement(DialogComponent, null, /* @__PURE__ */ React137.createElement(Viewport13, null, /* @__PURE__ */ React137.createElement(ViewSmall12, null, dialogSheet("full")), /* @__PURE__ */ React137.createElement(ViewMedium12, null, dialogSheet("centered"))))));
};
PropertyContentSectionListTypeDialog.displayName = "PropertyContentSectionListTypeDialog";
PropertyContentSectionListTypeDialog.fragment = fragment91;
// src/components/property-content-section-group/property-content-section-action.tsx
var fragment92 = gql107(_templateObject108(), PropertyContentSectionDialog.fragment, PropertyContentSectionDetailedDialog.fragment, PropertyContentSectionListTypeDialog.fragment, lodging_link_message_default.fragment);
var PropertyContentSectionAction = function(param) {
    var data = param.data, actionId = param.actionId;
    var __typename = data.__typename;
    if (__typename !== "PropertyContentSectionDetailedDialog" && __typename !== "PropertyContentSectionDialog" && __typename !== "PropertyContentSectionListTypeDialog" && __typename !== "LodgingLinkMessage") {
        return null;
    }
    switch(__typename){
        case "PropertyContentSectionDialog":
            return /* @__PURE__ */ React138.createElement(PropertyContentSectionDialog, {
                data: data,
                actionId: actionId
            });
        case "PropertyContentSectionDetailedDialog":
            return /* @__PURE__ */ React138.createElement(PropertyContentSectionDetailedDialog, {
                data: data,
                actionId: actionId
            });
        case "PropertyContentSectionListTypeDialog":
            return /* @__PURE__ */ React138.createElement(PropertyContentSectionListTypeDialog, {
                data: data,
                actionId: actionId
            });
        case "LodgingLinkMessage":
            return /* @__PURE__ */ React138.createElement(lodging_link_message_default, {
                data: data
            });
        default:
            return null;
    }
};
PropertyContentSectionAction.displayName = "PropertyContentSectionAction";
PropertyContentSectionAction.fragment = fragment92;
// src/components/property-content-section-group/property-content-sub-section.tsx
import React141 from "react";
import { gql as gql110 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid13, EGDSLayoutGridItem as EGDSLayoutGridItem9 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing37 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment9 } from "@shared-ui/experiment-context";
// src/components/property-content-section-group/property-content-element-group.tsx
import React140 from "react";
import { gql as gql109 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid12 } from "@egds/react-core/layout-grid";
import { useViewportMap as useViewportMap2, ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
// src/components/property-content-section-group/property-content-item-card.tsx
import React139 from "react";
import { gql as gql108 } from "@apollo/client";
var fragment93 = gql108(_templateObject109(), EGDSStandardMessagingCard.fragment);
var PropertyContentItemCard = function(props) {
    var data = props.data;
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React139.createElement(EGDSStandardMessagingCard, {
        data: data
    });
};
PropertyContentItemCard.displayName = "PropertyContentItemCard";
PropertyContentItemCard.fragment = fragment93;
// src/components/property-content-section-group/property-content-element-group.tsx
var fragment94 = gql109(_templateObject110(), EGDSStandardMessagingCard.fragment);
var PropertyContentElementGroup = function(param) {
    var data = param.data, smallerHeader = param.smallerHeader, isExpandoSection = param.isExpandoSection, whitespace = param.whitespace;
    var elements = data.elements, _data_maxColumns = data.maxColumns, maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
    var _obj;
    var isSmallView = useViewportMap2((_obj = {}, _define_property(_obj, ViewSizes2.SMALL, true), _define_property(_obj, ViewSizes2.MEDIUM, false), _define_property(_obj, ViewSizes2.LARGE, false), _obj));
    var renderedElements = elements.map(function(element, indexElement) {
        switch(element.__typename){
            case "PropertyContent":
                return /* @__PURE__ */ React140.createElement(PropertyContent, {
                    key: indexElement,
                    data: element,
                    smallerHeader: smallerHeader,
                    isExpandoSection: isExpandoSection,
                    whitespace: whitespace
                });
            case "EGDSStandardMessagingCard":
                return /* @__PURE__ */ React140.createElement(PropertyContentItemCard, {
                    key: indexElement,
                    data: element
                });
            default:
                return null;
        }
    });
    var hasImages = elements.some(function(elemt) {
        var _elemt_leadingGraphic, _elemt_leadingGraphic1;
        return elemt.__typename === "PropertyContent" && (((_elemt_leadingGraphic = elemt.leadingGraphic) === null || _elemt_leadingGraphic === void 0 ? void 0 : _elemt_leadingGraphic.__typename) === "PropertyImage" || ((_elemt_leadingGraphic1 = elemt.leadingGraphic) === null || _elemt_leadingGraphic1 === void 0 ? void 0 : _elemt_leadingGraphic1.__typename) === "LodgingGalleryCarousel");
    });
    if (maxColumns === 1 && !hasImages) {
        return /* @__PURE__ */ React140.createElement(React140.Fragment, null, renderedElements);
    }
    var getNumColumns = function() {
        if (hasImages && !isSmallView) {
            if (elements.length > maxColumns && maxColumns > 3) {
                return maxColumns;
            }
            return 3;
        }
        if (hasImages && isSmallView) {
            return 1;
        }
        return Math.min(Math.max(1, elements.length), maxColumns);
    };
    return /* @__PURE__ */ React140.createElement(EGDSLayoutGrid12, {
        space: "three",
        columns: getNumColumns()
    }, renderedElements);
};
PropertyContentElementGroup.displayName = "PropertyContentElementGroup";
PropertyContentElementGroup.fragment = fragment94;
// src/components/property-content-section-group/property-content-sub-section.tsx
var fragment95 = gql110(_templateObject111(), PropertyContentElementGroup.fragment, PropertyContentSectionAction.fragment);
var PropertyContentSubSection = function(param) {
    var data = param.data, isExpandoSection = param.isExpandoSection, whitespace = param.whitespace, isFirstSection = param.isFirstSection, isInDialog = param.isInDialog, isFullyCollapsible = param.isFullyCollapsible;
    var header = data.header, elementsV2 = data.elementsV2, actions = data.actions, _data_maxColumns = data.maxColumns, maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
    var _useExperiment9 = useExperiment9("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment9.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    var subSectionContent = /* @__PURE__ */ React141.createElement(React141.Fragment, null, elementsV2.map(function(elementV2, i) {
        return /* @__PURE__ */ React141.createElement(PropertyContentElementGroup, {
            data: elementV2,
            smallerHeader: Boolean(header || isFirstSection && isInDialog || isTopOfPDPRedesignVariant),
            isExpandoSection: isExpandoSection,
            key: i,
            whitespace: whitespace
        });
    }));
    var actionContent = actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
        return /* @__PURE__ */ React141.createElement(PropertyContentSectionAction, {
            data: action,
            key: index,
            actionId: ""
        });
    });
    return /* @__PURE__ */ React141.createElement(React141.Fragment, null, header && /* @__PURE__ */ React141.createElement(SectionHeader, {
        tag: "h3",
        size: 5,
        singleLineHeader: true,
        data: header
    }), /* @__PURE__ */ React141.createElement(EGDSSpacing37, {
        padding: isFullyCollapsible ? void 0 : {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React141.createElement(EGDSLayoutGrid13, {
        space: "three",
        columns: {
            medium: 1,
            large: maxColumns
        }
    }, subSectionContent, actionContent && /* @__PURE__ */ React141.createElement(EGDSLayoutGridItem9, null, /* @__PURE__ */ React141.createElement("div", null, actionContent)))));
};
PropertyContentSubSection.displayName = "PropertyContentSubSection";
PropertyContentSubSection.fragment = fragment95;
// src/components/property-content-section-group/property-content-section.tsx
var fragment96 = gql111(_templateObject112(), SectionHeader.fragment, PropertyContentSubSection.fragment, PropertyContentSectionAction.fragment);
var PropertyContentSection = function(param) {
    var data = param.data, _param_columns = param.columns, columns = _param_columns === void 0 ? 3 : _param_columns, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, _param_isInDialog = param.isInDialog, isInDialog = _param_isInDialog === void 0 ? false : _param_isInDialog, _param_isFirstSection = param.isFirstSection, isFirstSection = _param_isFirstSection === void 0 ? false : _param_isFirstSection, _param_isLastSection = param.isLastSection, isLastSection = _param_isLastSection === void 0 ? false : _param_isLastSection, _param_isCardComponent = param.isCardComponent, isCardComponent = _param_isCardComponent === void 0 ? true : _param_isCardComponent, isExpandoSection = param.isExpandoSection, _param_displayThreshold = param.displayThreshold, displayThreshold = _param_displayThreshold === void 0 ? 1 : _param_displayThreshold, actionId = param.actionId, _param_whitespace = param.whitespace, whitespace = _param_whitespace === void 0 ? true : _param_whitespace, disableSectionSeparator = param.disableSectionSeparator, _param_showBorder = param.showBorder, showBorder = _param_showBorder === void 0 ? false : _param_showBorder;
    var _context_device, _expandButton_analytics, _collapseButton_analytics, _expandButton_analytics1, _collapseButton_analytics1;
    var context = useBexApi7().context;
    var isMobile = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var subSectionName = data.sectionName, header = data.header, bodySubSections = data.bodySubSections, sectionAction = data.action, impressionAnalytics = data.impressionAnalytics, expando = data.expando;
    var border = !isLastSection ? "bottom" : void 0;
    var _ref = impressionAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var headerRowSpanMultiColumn = sectionAction ? bodySubSections.length + 1 : bodySubSections.length;
    var headerRowSpanLg = columns === 1 ? 1 : headerRowSpanMultiColumn;
    var _ref1 = expando || {}, expandButton = _ref1.expandButton, collapseButton = _ref1.collapseButton, items = _ref1.items;
    var _React142_useState = _sliced_to_array(React142.useState(false), 2), isVisible = _React142_useState[0], setIsVisible = _React142_useState[1];
    var expandoReferrerId = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics = expandButton.analytics) === null || _expandButton_analytics === void 0 ? void 0 : _expandButton_analytics.referrerId : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics = collapseButton.analytics) === null || _collapseButton_analytics === void 0 ? void 0 : _collapseButton_analytics.referrerId;
    var expandoLinkName = !isVisible ? expandButton === null || expandButton === void 0 ? void 0 : (_expandButton_analytics1 = expandButton.analytics) === null || _expandButton_analytics1 === void 0 ? void 0 : _expandButton_analytics1.linkName : collapseButton === null || collapseButton === void 0 ? void 0 : (_collapseButton_analytics1 = collapseButton.analytics) === null || _collapseButton_analytics1 === void 0 ? void 0 : _collapseButton_analytics1.linkName;
    var track = useClickTracker33();
    var expandoPeekAnalysis = {
        id: expandoReferrerId !== null && expandoReferrerId !== void 0 ? expandoReferrerId : "",
        description: expandoLinkName !== null && expandoLinkName !== void 0 ? expandoLinkName : "",
        callback: function(refererId, lnkName) {
            track(refererId, lnkName);
        }
    };
    var _useExperiment10 = useExperiment10("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment10.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    var getThresholdValue = function() {
        if (items && items < 0) {
            return displayThreshold;
        }
        if (items && items > 0 && isMobile) {
            return items;
        }
        return 0;
    };
    var headingTag = isFirstSection ? "h2" : "h3";
    var headingSize = isFirstSection ? 5 : 7;
    var isDatelessPDPExpando = isExpandoSection && bodySubSections.length > 1 && expando;
    var isDatedPDPExpando = bodySubSections.length > 1 && expando && items && items > 0;
    var isFullyCollapsible = expando && (items === 0 || displayThreshold === 0) && bodySubSections.length >= 1;
    var layoutComponent = /* @__PURE__ */ React142.createElement(EGDSLayoutGrid14, {
        space: isInDialog ? "one" : "six",
        columns: {
            medium: 1,
            large: columns
        }
    }, showHeader && /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
        colSpan: {
            medium: 1,
            large: 1
        },
        rowSpan: {
            medium: 1,
            large: headerRowSpanLg
        }
    }, header && /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(SectionHeader, {
        tag: isInDialog ? headingTag : "h2",
        size: isInDialog ? headingSize : 4,
        data: header
    }))), bodySubSections.map(function(bodySubSection, i) {
        return /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
            colSpan: {
                medium: 1,
                large: columns === 1 ? 1 : Math.max(columns - 1, 1)
            },
            key: i
        }, /* @__PURE__ */ React142.createElement("div", null, isInDialog && i !== 0 && /* @__PURE__ */ React142.createElement(EGDSSpacing38, {
            padding: {
                blockend: "two",
                blockstart: "one"
            }
        }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(EGDSSpacingHr6, null))), /* @__PURE__ */ React142.createElement(PropertyContentSubSection, {
            data: bodySubSection,
            whitespace: whitespace,
            isFirstSection: isFirstSection,
            isInDialog: isInDialog
        })));
    }), sectionAction && /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
        colSpan: {
            medium: 1,
            large: columns === 1 ? 1 : Math.max(columns - 1, 1)
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(PropertyContentSectionAction, {
        data: sectionAction,
        actionId: actionId
    }))));
    var title = showHeader && header && /* @__PURE__ */ React142.createElement(SectionHeader, {
        tag: "h2",
        size: 4,
        data: header
    });
    var body = /* @__PURE__ */ React142.createElement(EGDSSpacing38, {
        margin: {
            small: {
                blockstart: "six"
            },
            large: {
                blockstart: "unset"
            }
        }
    }, /* @__PURE__ */ React142.createElement(EGDSLayoutGrid14, {
        space: "six",
        columns: {
            medium: 1,
            large: columns
        }
    }, bodySubSections.map(function(bodySubSection, i) {
        return /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
            colStart: {
                medium: 1,
                large: 2
            },
            colEnd: {
                medium: 2,
                large: columns + 1
            },
            key: i
        }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(PropertyContentSubSection, {
            data: bodySubSection,
            whitespace: whitespace,
            isFullyCollapsible: true
        })));
    }), sectionAction && /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
        colStart: {
            medium: 1,
            large: 2
        },
        colEnd: {
            medium: 2,
            large: columns + 1
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(PropertyContentSectionAction, {
        data: sectionAction,
        actionId: actionId
    })))));
    var fullyCollapsible = /* @__PURE__ */ React142.createElement(EGDSExpandoList, null, /* @__PURE__ */ React142.createElement(EGDSExpandoListItem, {
        isVisible: isVisible,
        onToggle: function() {
            if (expandoReferrerId && expandoLinkName) {
                track(expandoReferrerId, expandoLinkName);
            }
            setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        triggerPosition: "trailing",
        expandoTitle: title,
        expandoDescription: body
    }));
    var _expandButton_accessibilityLabel, _collapseButton_accessibilityLabel;
    var expandoComponent = /* @__PURE__ */ React142.createElement(EGDSLayoutGrid14, {
        space: "six",
        columns: {
            medium: 1,
            large: columns
        }
    }, showHeader && /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
        colSpan: {
            medium: 1,
            large: 1
        },
        rowSpan: {
            medium: 1,
            large: 1
        }
    }, header && /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(SectionHeader, {
        tag: "h2",
        size: 4,
        data: header
    }))), bodySubSections || sectionAction ? /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
        colSpan: {
            medium: 1,
            large: columns === 1 ? 1 : Math.max(columns - 1, 1)
        }
    }, /* @__PURE__ */ React142.createElement(EGDSExpandoPeek3, {
        analytics: expandoPeekAnalysis,
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        expandLabel: expandButton === null || expandButton === void 0 ? void 0 : expandButton.text,
        collapseLabel: collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.text,
        expandA11yLabel: (_expandButton_accessibilityLabel = expandButton === null || expandButton === void 0 ? void 0 : expandButton.accessibilityLabel) !== null && _expandButton_accessibilityLabel !== void 0 ? _expandButton_accessibilityLabel : "",
        collapseA11yLabel: (_collapseButton_accessibilityLabel = collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.accessibilityLabel) !== null && _collapseButton_accessibilityLabel !== void 0 ? _collapseButton_accessibilityLabel : "",
        items: getThresholdValue(),
        hideScrim: !(items && items > 0),
        whitespace: !(items && items > 0)
    }, bodySubSections.map(function(bodySubSection, i) {
        return /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
            colSpan: {
                medium: 1,
                large: columns === 1 ? 1 : Math.max(columns - 1, 1)
            },
            key: i
        }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(PropertyContentSubSection, {
            data: bodySubSection,
            isExpandoSection: isExpandoSection,
            whitespace: whitespace
        })));
    }), sectionAction && /* @__PURE__ */ React142.createElement(EGDSLayoutGridItem10, {
        colSpan: {
            medium: 1,
            large: columns === 1 ? 1 : Math.max(columns - 1, 1)
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(PropertyContentSectionAction, {
        data: sectionAction,
        actionId: actionId
    }))))) : null);
    var layoutSectionComponent = isDatelessPDPExpando || isDatedPDPExpando ? expandoComponent : layoutComponent;
    var layoutSection = isFullyCollapsible && title ? fullyCollapsible : layoutSectionComponent;
    var layoutGridComponent = referrerId && linkName ? /* @__PURE__ */ React142.createElement(IntersectionTracker12, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, layoutSection) : layoutSection;
    var borderSectionBlockEndmargin = isFullyCollapsible ? "two" : "six";
    var layoutGridComponentWithBorder = /* @__PURE__ */ React142.createElement(EGDSSpacing38, {
        margin: {
            blockend: isLastSection ? "unset" : borderSectionBlockEndmargin
        }
    }, /* @__PURE__ */ React142.createElement("div", null, /* @__PURE__ */ React142.createElement(EGDSCard5, {
        border: true
    }, /* @__PURE__ */ React142.createElement(EGDSSpacing38, {
        padding: {
            inline: "six",
            block: "three"
        }
    }, layoutGridComponent))));
    var firstSectionPadding = disableSectionSeparator ? void 0 : "three";
    var blockStartPadding = disableSectionSeparator ? "three" : "six";
    var lastSectionPadding = isTopOfPDPRedesignVariant ? "two" : "three";
    return isCardComponent ? /* @__PURE__ */ React142.createElement(EGDSCardContentSection8, {
        border: disableSectionSeparator ? void 0 : border,
        padded: false
    }, /* @__PURE__ */ React142.createElement(RefTarget, {
        name: subSectionName,
        tabIndex: -1
    }, showBorder ? layoutGridComponentWithBorder : /* @__PURE__ */ React142.createElement(EGDSSpacing38, {
        padding: {
            small: {
                inline: "unset"
            },
            medium: {
                inline: "unset"
            },
            large: {
                inline: isInDialog ? "unset" : "three"
            },
            extra_large: {
                inline: isInDialog ? "unset" : "three"
            },
            blockend: isLastSection ? lastSectionPadding : "six",
            blockstart: isFirstSection ? firstSectionPadding : blockStartPadding
        }
    }, layoutGridComponent))) : /* @__PURE__ */ React142.createElement("div", null, layoutGridComponent);
};
PropertyContentSection.displayName = "PropertyContentSection";
PropertyContentSection.fragment = fragment96;
// src/components/property-content-section-group/property-content-section-group.tsx
var fragment97 = gql112(_templateObject113(), SectionHeader.fragment, PropertyContent.fragment, PropertyContentSection.fragment, PropertyContentSectionAction.fragment, PropertyContentSubSection.fragment);
var PropertyContentSectionGroup = function(param) {
    var data = param.data, _param_columns = param.columns, columns = _param_columns === void 0 ? 3 : _param_columns, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, _param_isCardComponent = param.isCardComponent, isCardComponent = _param_isCardComponent === void 0 ? true : _param_isCardComponent, _param_actionId = param.actionId, actionId = _param_actionId === void 0 ? "id" : _param_actionId, isExpandoSection = param.isExpandoSection, _param_displayThreshold = param.displayThreshold, displayThreshold = _param_displayThreshold === void 0 ? 1 : _param_displayThreshold, _param_whitespace = param.whitespace, whitespace = _param_whitespace === void 0 ? true : _param_whitespace, isTopOfPDPRedesignVariant = param.isTopOfPDPRedesignVariant, _param_disableSectionSeparator = param.disableSectionSeparator, disableSectionSeparator = _param_disableSectionSeparator === void 0 ? false : _param_disableSectionSeparator, _param_showBorder = param.showBorder, showBorder = _param_showBorder === void 0 ? false : _param_showBorder;
    var sections = data.sections, action = data.action;
    if (!sections || sections.length === 0) {
        return null;
    }
    var sectionContent = sections.map(function(section, index) {
        return /* @__PURE__ */ React143.createElement(PropertyContentSection, {
            data: section,
            columns: isTopOfPDPRedesignVariant ? 1 : columns,
            showHeader: showHeader,
            isFirstSection: index === 0,
            isLastSection: index === sections.length - 1,
            key: "section-".concat(index),
            actionId: "".concat(actionId, "-section-").concat(index),
            isCardComponent: isCardComponent,
            isExpandoSection: isExpandoSection,
            displayThreshold: displayThreshold,
            whitespace: whitespace,
            isInDialog: isTopOfPDPRedesignVariant,
            disableSectionSeparator: disableSectionSeparator,
            showBorder: showBorder
        });
    });
    return isCardComponent ? /* @__PURE__ */ React143.createElement(EGDSCard6, null, /* @__PURE__ */ React143.createElement(EGDSCardContentSection9, {
        padded: isTopOfPDPRedesignVariant || showBorder ? false : void 0
    }, /* @__PURE__ */ React143.createElement(Viewport14, null, /* @__PURE__ */ React143.createElement(ViewSmall13, null, /* @__PURE__ */ React143.createElement("section", null, /* @__PURE__ */ React143.createElement(EGDSCard6, null, sectionContent, " "))), /* @__PURE__ */ React143.createElement(ViewLarge7, null, /* @__PURE__ */ React143.createElement("section", null, sectionContent))), action && /* @__PURE__ */ React143.createElement(PropertyContentSectionAction, {
        data: action,
        actionId: actionId
    }))) : /* @__PURE__ */ React143.createElement("div", null, sectionContent);
};
PropertyContentSectionGroup.displayName = "PropertyContentSectionGroup";
PropertyContentSectionGroup.fragment = fragment97;
// src/components/property-content-section-group/cleanliness.tsx
var __CleanlinessFragment = gql113(_templateObject114(), PropertyContentSectionGroup.fragment);
var Cleanliness = function(props) {
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data.propertyContentSectionGroups.cleanliness;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React144.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
Cleanliness.fragment = __CleanlinessFragment;
Cleanliness.displayName = "Cleanliness";
// src/components/property-content-section-group/policies.tsx
import React145 from "react";
import { gql as gql114 } from "@apollo/client";
var __PoliciesFragment = gql114(_templateObject115(), PropertyContentSectionGroup.fragment);
var Policies = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.policies;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React145.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
Policies.displayName = "Policies";
Policies.fragment = __PoliciesFragment;
// src/components/property-content-section-group/special-features.tsx
import React146 from "react";
import { gql as gql115 } from "@apollo/client";
var __SpecialFeaturesFragment = gql115(_templateObject116(), PropertyContentSectionGroup.fragment);
var SpecialFeatures = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.specialFeatures;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React146.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
SpecialFeatures.displayName = "SpecialFeatures";
SpecialFeatures.fragment = __SpecialFeaturesFragment;
// src/components/property-content-section-group/important-info.tsx
import React147 from "react";
import { gql as gql116 } from "@apollo/client";
var __ImportantInfoFragment = gql116(_templateObject117(), PropertyContentSectionGroup.fragment);
var ImportantInfo = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.importantInfo;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React147.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
ImportantInfo.displayName = "ImportantInfo";
ImportantInfo.fragment = __ImportantInfoFragment;
// src/components/property-content-section-group/about-this-property.tsx
import React148 from "react";
import { gql as gql117 } from "@apollo/client";
import { useExperiment as useExperiment11 } from "@shared-ui/experiment-context";
var __AboutThisPropertyFragment = gql117(_templateObject118(), PropertyContentSectionGroup.fragment);
var AboutThisProperty = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisProperty;
    var _useExperiment11 = useExperiment11("Remove_About_the_Property_Web"), topOfPDPRedesignExposure = _useExperiment11.exposure;
    var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React148.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: content,
        whitespace: false,
        columns: contentProps.columns
    }, contentProps), {
        isTopOfPDPRedesignVariant: isTopOfPDPRedesignVariant
    }));
};
AboutThisProperty.fragment = __AboutThisPropertyFragment;
AboutThisProperty.displayName = "AboutThisProperty";
// src/components/property-content-section-group/host-profile.tsx
import React149 from "react";
import { gql as gql118 } from "@apollo/client";
var __HostProfileFragment = gql118(_templateObject119(), PropertyContentSectionGroup.fragment);
var HostProfile = function(props) {
    var _data_propertyContentSectionGroups;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data === null || data === void 0 ? void 0 : (_data_propertyContentSectionGroups = data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisHost;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React149.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
HostProfile.fragment = __HostProfileFragment;
HostProfile.displayName = "HostProfile";
// src/components/property-content-section-group/property-detailed-amenities.tsx
import React150, { useMemo as useMemo6 } from "react";
import { gql as gql119 } from "@apollo/client";
var DetailedAmenitiesFragment = gql119(_templateObject120(), PropertyContentSectionGroup.fragment);
var DetailedAmenities = function(props) {
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var amenitiesSummary = data.amenitiesSummary, detailedAmenitiesContent = data.detailedAmenitiesContent;
    var detailedDialogContent = useMemo6(function() {
        var _detailedAmenitiesContent_amenities;
        var amenitiesSections = detailedAmenitiesContent === null || detailedAmenitiesContent === void 0 ? void 0 : (_detailedAmenitiesContent_amenities = detailedAmenitiesContent.amenities) === null || _detailedAmenitiesContent_amenities === void 0 ? void 0 : _detailedAmenitiesContent_amenities.sections;
        var dialogElement = (amenitiesSections === null || amenitiesSections === void 0 ? void 0 : amenitiesSections.length) ? /* @__PURE__ */ React150.createElement(React150.Fragment, null, amenitiesSections.map(function(section, index) /* @__PURE__ */ {
            var _amenitiesSections_length;
            return React150.createElement(PropertyContentSection, {
                data: section,
                columns: 1,
                key: "detailed-section-".concat(index),
                actionId: "amenities",
                isInDialog: true,
                disableSectionSeparator: index === ((_amenitiesSections_length = amenitiesSections === null || amenitiesSections === void 0 ? void 0 : amenitiesSections.length) !== null && _amenitiesSections_length !== void 0 ? _amenitiesSections_length : 0) - 1
            });
        })) : null;
        return {
            dialogElement: dialogElement
        };
    }, [
        detailedAmenitiesContent
    ]);
    if (!(amenitiesSummary === null || amenitiesSummary === void 0 ? void 0 : amenitiesSummary.amenities)) {
        return null;
    }
    var amenities = amenitiesSummary.amenities;
    return /* @__PURE__ */ React150.createElement(PropertyContentSectionDetailedDialogContext.Provider, {
        value: detailedDialogContent
    }, /* @__PURE__ */ React150.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: amenities
    }, contentProps), {
        actionId: "amenities"
    })));
};
DetailedAmenities.displayName = "DetailedAmenities";
DetailedAmenities.fragment = DetailedAmenitiesFragment;
// src/components/lodging-jumplink/lodging-jumplink.tsx
import React151 from "react";
import { gql as gql120 } from "@apollo/client";
import { EGDSIcon as EGDSIcon25 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink13 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing39 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker34 } from "@shared-ui/clickstream-analytics-context";
import { useRefTargetScroll as useRefTargetScroll2 } from "@shared-ui/ref-context";
var __LodgingJumpLinkFragment = gql120(_templateObject121());
var scrollOffsets = [
    {
        sectionName: "wizard",
        offsetMultiplier: 2
    },
    {
        sectionName: "navigation"
    }
];
var LodgingJumpLink = function(param) {
    var data = param.data, trackingDetails = param.trackingDetails;
    var linkText = data.localizedName, icon = data.icon, sectionName = data.sectionName, accessibilityLabel = data.accessibilityLabel;
    var iconId = (icon === null || icon === void 0 ? void 0 : icon.iconId) || "";
    var scrollTo = useRefTargetScroll2().scrollTo;
    var track = useClickTracker34();
    var handleClick = React151.useCallback(function(e) {
        e.preventDefault();
        if (trackingDetails) {
            track(trackingDetails === null || trackingDetails === void 0 ? void 0 : trackingDetails.id, trackingDetails === null || trackingDetails === void 0 ? void 0 : trackingDetails.description, true);
        }
        if (sectionName) {
            scrollTo(sectionName, scrollOffsets);
        }
    }, [
        trackingDetails,
        track,
        scrollTo,
        sectionName
    ]);
    return /* @__PURE__ */ React151.createElement(EGDSSpacing39, {
        padding: {
            blockstart: "three",
            blockend: "unset"
        }
    }, /* @__PURE__ */ React151.createElement(EGDSLink13, {
        align: "left",
        onClick: handleClick
    }, /* @__PURE__ */ React151.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React151.createElement("span", {
        "aria-hidden": accessibilityLabel !== null
    }, linkText), accessibilityLabel && /* @__PURE__ */ React151.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React151.createElement(EGDSIcon25, {
        name: iconId
    }))));
};
LodgingJumpLink.displayName = "LodgingJumpLink";
LodgingJumpLink.fragment = __LodgingJumpLinkFragment;
// src/components/lodging-egds-switch/lodging-egds-switch.tsx
import React152 from "react";
import { gql as gql121 } from "@apollo/client";
import { EGDSSwitch } from "@egds/react-core/switch";
import { useClickTracker as useClickTracker35 } from "@shared-ui/clickstream-analytics-context";
var __Fragment = gql121(_templateObject122());
var LodgingEGDSSwitch = function(_param) {
    var data = _param.data, checked = _param.checked, handleToggle = _param.handleToggle, props = _object_without_properties(_param, [
        "data",
        "checked",
        "handleToggle"
    ]);
    var initialCheck = data.checked, checkedAnalytics = data.checkedAnalytics, checkedLabel = data.checkedLabel, enabled = data.enabled, uncheckedAnalytics = data.uncheckedAnalytics, uncheckedLabel = data.uncheckedLabel;
    var _React152_useState = _sliced_to_array(React152.useState(checked !== null && checked !== void 0 ? checked : initialCheck), 2), isChecked = _React152_useState[0], setIsChecked = _React152_useState[1];
    React152.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : initialCheck);
    }, [
        checked,
        initialCheck
    ]);
    var track = useClickTracker35();
    var handleChange = React152.useCallback(function(event) {
        var _event_currentTarget = event.currentTarget, wasChecked = _event_currentTarget.checked;
        setIsChecked(wasChecked);
        if (checkedAnalytics && !wasChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && wasChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        handleToggle === null || handleToggle === void 0 ? void 0 : handleToggle(wasChecked);
    }, [
        checkedAnalytics,
        handleToggle,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React152.createElement(EGDSSwitch, _object_spread({
        id: isChecked ? checkedLabel : uncheckedLabel,
        disabled: !enabled,
        checked: isChecked,
        label: isChecked ? checkedLabel : uncheckedLabel,
        onChange: handleChange
    }, props));
};
LodgingEGDSSwitch.displayName = "EGDSSwitch";
LodgingEGDSSwitch.fragment = __Fragment;
// src/components/egds/egds-spannable-list/egds-spannable-list.tsx
import React154 from "react";
import { gql as gql123 } from "@apollo/client";
import { EGDSList as EGDSList4, EGDSListItem as EGDSListItem4 } from "@egds/react-core/list";
// src/components/egds/egds-spannable-list/egds-spannable-list-item.tsx
import React153 from "react";
import { gql as gql122 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex33, EGDSLayoutFlexItem as EGDSLayoutFlexItem24 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing40 } from "@egds/react-core/spacing";
var fragment98 = gql122(_templateObject123(), UiGraphic.fragment, EGDSSpannableText.fragment);
var EGDSSpannableListItem = function(param) {
    var data = param.data, handleInlineLinkClick = param.handleInlineLinkClick, triggerRef = param.triggerRef, trackingPrefix = param.trackingPrefix;
    var graphic = data.graphic, subText = data.subText, text = data.text;
    return /* @__PURE__ */ React153.createElement(EGDSLayoutFlex33, null, /* @__PURE__ */ React153.createElement(EGDSLayoutFlexItem24, {
        alignSelf: "center"
    }, graphic && /* @__PURE__ */ React153.createElement(EGDSSpacing40, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React153.createElement("div", null, /* @__PURE__ */ React153.createElement(UiGraphic, {
        data: graphic
    })))), /* @__PURE__ */ React153.createElement(EGDSLayoutFlexItem24, {
        alignSelf: "center"
    }, /* @__PURE__ */ React153.createElement("div", null, /* @__PURE__ */ React153.createElement(EGDSSpannableText, {
        data: text,
        handleInlineLinkClick: handleInlineLinkClick,
        triggerRef: triggerRef,
        trackingPrefix: trackingPrefix
    }), subText)));
};
EGDSSpannableListItem.displayName = "EGDSSpannableListItem";
EGDSSpannableListItem.fragment = fragment98;
// src/components/egds/egds-spannable-list/egds-spannable-list.tsx
var fragment99 = gql123(_templateObject124(), EGDSSpannableListItem.fragment);
var bulletListTypeMapping = function(listType) {
    switch(listType){
        case "BULLET":
            return "default";
        case "ICON":
            return "icon-standard";
        case "NO_BULLET":
            return "no-bullet";
        case "NUMBER":
            return "tiered-numbered";
        default:
            return void 0;
    }
};
var EGDSSpannableList = function(param) {
    var data = param.data, handleInlineLinkClick = param.handleInlineLinkClick, triggerRef = param.triggerRef, trackingPrefix = param.trackingPrefix;
    if (!data) {
        return null;
    }
    var listType = data.listType, items = data.items;
    if (items.length === 0) {
        return null;
    }
    var bullet = bulletListTypeMapping(listType);
    return /* @__PURE__ */ React154.createElement(EGDSList4, {
        bullet: bullet,
        spacing: false
    }, items.map(function(item, key) {
        return /* @__PURE__ */ React154.createElement(EGDSListItem4, {
            key: key
        }, /* @__PURE__ */ React154.createElement(EGDSSpannableListItem, {
            data: item,
            handleInlineLinkClick: handleInlineLinkClick,
            triggerRef: triggerRef,
            trackingPrefix: trackingPrefix
        }));
    }));
};
EGDSSpannableList.displayName = "EGDSSpannableList";
EGDSSpannableList.fragment = fragment99;
// src/components/property-review-summary/property-reviews-breakdown.tsx
import React161 from "react";
import { gql as gql130 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex37, EGDSLayoutFlexItem as EGDSLayoutFlexItem27 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink16 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing45 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading13, EGDSText as EGDSText28 } from "@egds/react-core/text";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
// src/components/property-review-summary/utils/structured-data.ts
var getStructuredDataProps = function(itemProp, required) {
    if (!required) {
        return null;
    }
    var baseProps = {
        itemProp: itemProp
    };
    if (itemProp === "aggregateRating") {
        baseProps = _object_spread_props(_object_spread({}, baseProps), {
            itemScope: true,
            itemType: "http://schema.org/AggregateRating"
        });
    }
    return baseProps;
};
// src/components/lodging-enriched-message/lodging-enriched-message.tsx
import React155 from "react";
import { gql as gql124 } from "@apollo/client";
import { EGDSIcon as EGDSIcon26, EGDSIconSize as EGDSIconSize18 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex34 } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark10, EGDSMarkSize as EGDSMarkSize8 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing41 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText25 } from "@egds/react-core/text";
import { EGDSUnformattedHtml as EGDSUnformattedHtml4 } from "@egds/react-core/unformatted-html";
var fragment100 = gql124(_templateObject125());
var highlightedMessagesThemeToEGDSTextTheme = {
    AGGRESSIVE: "negative",
    HIGHLIGHT: "positive",
    LOYALTY: "loyalty"
};
var highlightedMessagesThemeToEGDSTextWeight = {
    STRONG: "bold"
};
var LodgingEnrichedMessage = function(param) {
    var data = param.data, markSize = param.markSize, textSize = param.textSize;
    var _egdsMark_url;
    var subText = data.subText, value = data.value, theme = data.theme, icon = data.icon, mark = data.mark, egdsMark = data.egdsMark, state = data.state, accessibilityLabel = data.accessibilityLabel;
    if (!value) {
        return null;
    }
    var plainTextElement = function(props) {
        return /* @__PURE__ */ React155.createElement("span", null, /* @__PURE__ */ React155.createElement(EGDSText25, {
            size: textSize,
            weight: stateTheme && highlightedMessagesThemeToEGDSTextWeight[stateTheme] || void 0,
            theme: stateTheme && highlightedMessagesThemeToEGDSTextTheme[stateTheme] || void 0,
            "aria-hidden": accessibilityLabel !== null
        }, props.children));
    };
    var stateTheme = state || theme;
    return /* @__PURE__ */ React155.createElement("div", null, /* @__PURE__ */ React155.createElement(EGDSLayoutFlex34, {
        alignItems: "center"
    }, mark && !egdsMark && /* @__PURE__ */ React155.createElement(EGDSSpacing41, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React155.createElement(EGDSMark10, {
        name: mark.id,
        size: markSize
    })), icon && /* @__PURE__ */ React155.createElement(EGDSSpacing41, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React155.createElement(EGDSIcon26, {
        name: icon.id,
        size: icon.size ? EGDSIconSize18[icon.size] : EGDSIconSize18.MEDIUM,
        theme: icon.theme || "default"
    })), egdsMark && /* @__PURE__ */ React155.createElement(EGDSSpacing41, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React155.createElement(EGDSMark10, {
        url: (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value,
        size: markSize !== null && markSize !== void 0 ? markSize : EGDSMarkSize8.MEDIUM
    })), accessibilityLabel && /* @__PURE__ */ React155.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React155.createElement("div", null, /* @__PURE__ */ React155.createElement(EGDSUnformattedHtml4, {
        htmlToParse: value,
        plainTextElement: plainTextElement
    }))), subText && /* @__PURE__ */ React155.createElement(EGDSText25, {
        size: 200,
        theme: "standard"
    }, subText));
};
LodgingEnrichedMessage.fragment = fragment100;
LodgingEnrichedMessage.displayName = "LodgingEnrichedMessage";
// src/components/property-review-summary/__private/__fragments/rating-counts.tsx
import React156 from "react";
import { gql as gql125 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex35, EGDSLayoutFlexItem as EGDSLayoutFlexItem25 } from "@egds/react-core/layout-flex";
import { EGDSProgressBar } from "@egds/react-core/progress-bar";
import { EGDSSpacing as EGDSSpacing42 } from "@egds/react-core/spacing";
var fragment101 = gql125(_templateObject126());
var RatingCounts = function(param) {
    var data = param.data;
    var ratingCounts = data.ratingCounts;
    if (!ratingCounts || ratingCounts.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React156.createElement(EGDSSpacing42, {
        margin: {
            blockstart: "two",
            blockend: "four"
        }
    }, /* @__PURE__ */ React156.createElement(EGDSLayoutFlex35, {
        space: "two",
        direction: "column"
    }, ratingCounts.map(function(ratingCount) {
        return /* @__PURE__ */ React156.createElement(EGDSLayoutFlexItem25, {
            minWidth: "full_width",
            key: "rating-".concat(ratingCount.rating)
        }, /* @__PURE__ */ React156.createElement(EGDSProgressBar, {
            accessibilityLabel: (ratingCount === null || ratingCount === void 0 ? void 0 : ratingCount.accessibilityLabel) || "",
            percent: ratingCount.percent,
            progressDescription: ratingCount.count.formatted,
            title: ratingCount.description
        }));
    })));
};
RatingCounts.displayName = "RatingCounts";
RatingCounts.fragment = fragment101;
// src/components/property-review-summary/__private/__fragments/summary-details.tsx
import React157 from "react";
import { gql as gql126 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex36, EGDSLayoutFlexItem as EGDSLayoutFlexItem26 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing43 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading12, EGDSText as EGDSText26 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker36 } from "@shared-ui/clickstream-analytics-context";
var fragment102 = gql126(_templateObject127());
var SummaryDetails = function(param) {
    var data = param.data;
    var _reviewSummaryDetails_;
    var reviewSummaryDetails = data.reviewSummaryDetails;
    var track = useClickTracker36();
    React157.useEffect(function() {
        var _reviewSummaryDetails_;
        var cleanlinessRate = reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value;
        if (cleanlinessRate) {
            track("HOT.HIS.cleanliness.".concat(cleanlinessRate), "Property cleanliness score");
        }
    }, [
        reviewSummaryDetails === null || reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value
    ]);
    if (!reviewSummaryDetails || reviewSummaryDetails.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React157.createElement(EGDSLayoutFlex36, {
        wrap: "wrap"
    }, reviewSummaryDetails.map(function(reviewSummaryDetailItem) {
        var formattedRatingOutOfMaxA11y = reviewSummaryDetailItem.formattedRatingOutOfMaxA11y, label = reviewSummaryDetailItem.label;
        var _formattedRatingOutOfMaxA11y_accessibilityLabel;
        return /* @__PURE__ */ React157.createElement(EGDSLayoutFlexItem26, {
            minWidth: "half_width",
            key: "category-".concat(label)
        }, /* @__PURE__ */ React157.createElement(EGDSSpacing43, {
            margin: {
                block: "three"
            }
        }, /* @__PURE__ */ React157.createElement(EGDSLayoutFlex36, {
            direction: "column"
        }, /* @__PURE__ */ React157.createElement(EGDSHeading12, {
            "aria-label": (_formattedRatingOutOfMaxA11y_accessibilityLabel = formattedRatingOutOfMaxA11y.accessibilityLabel) !== null && _formattedRatingOutOfMaxA11y_accessibilityLabel !== void 0 ? _formattedRatingOutOfMaxA11y_accessibilityLabel : void 0,
            tag: "h3",
            size: 5
        }, formattedRatingOutOfMaxA11y.value), /* @__PURE__ */ React157.createElement(EGDSText26, {
            size: 300
        }, label))));
    }));
};
SummaryDetails.displayName = "SummaryDetails";
SummaryDetails.fragment = fragment102;
// src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
import React159 from "react";
import { gql as gql128 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent8 } from "@egds/react-core/dialog";
import { EGDSSheet as EGDSSheet11, EGDSSheetTransition as EGDSSheetTransition15 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker38 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog14 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium13, Viewport as Viewport15, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
// src/components/lodging-dialog-trigger-message/lodging-dialog-trigger-message.tsx
import React158 from "react";
import { gql as gql127 } from "@apollo/client";
import { EGDSLink as EGDSLink14 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker37 } from "@shared-ui/clickstream-analytics-context";
var fragment103 = gql127(_templateObject128(), LodgingEGDSIcon.fragment);
var LodgingDialogTriggerMessage = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, value = _param_data.value, accessibilityLabel = _param_data.accessibilityLabel, icon = _param_data.icon, clientSideAnalytics = _param_data.clientSideAnalytics;
    var track = useClickTracker37();
    var onClick = function() {
        if (clientSideAnalytics) {
            track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
        onClickAction();
    };
    return /* @__PURE__ */ React158.createElement(EGDSLink14, null, /* @__PURE__ */ React158.createElement("button", {
        type: "button",
        ref: triggerRef,
        "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0,
        onClick: onClick
    }, value, icon && /* @__PURE__ */ React158.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingDialogTriggerMessage.fragment = fragment103;
LodgingDialogTriggerMessage.displayName = "LodgingDialogTriggerMessage";
// src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
var fragment104 = gql128(_templateObject129(), LodgingDialogTriggerMessage.fragment, EGDSDialogToolbar.fragment);
var PropertyFilteredReviewsDialog = function(param) {
    var _param_data = param.data, ratingPercentage = _param_data.ratingPercentage, trigger = _param_data.trigger;
    var PropertyFilteredReviewsDialogContent = usePropertyFilteredReviewsDialogContext().PropertyFilteredReviewsDialogContent;
    var _useDialog14 = _sliced_to_array(useDialog14("PropertyDetailsReviewsBreakdownDialog", "pwaDialogNested"), 3), isVisible = _useDialog14[0], _useDialog14_ = _useDialog14[1], openDialog = _useDialog14_.openDialog, closeDialog = _useDialog14_.closeDialog, ReviewsDialog = _useDialog14[2];
    var track = useClickTracker38();
    var linkRef = React159.useRef(null);
    var memoizedCloseDialog = React159.useCallback(function() {
        if (ratingPercentage.closeAnalytics) {
            var closeAnalytics = ratingPercentage.closeAnalytics;
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        closeDialog();
    }, [
        closeDialog,
        ratingPercentage,
        track
    ]);
    var sheet = function(sheetType, dialogHeight) {
        return /* @__PURE__ */ React159.createElement(EGDSSheet11, {
            type: sheetType,
            height: dialogHeight,
            isVisible: isVisible,
            triggerRef: linkRef,
            returnFocusOnClose: true
        }, /* @__PURE__ */ React159.createElement(EGDSDialogToolbar, {
            toolbarType: "close",
            toolbarAction: memoizedCloseDialog,
            data: ratingPercentage.toolbar
        }), /* @__PURE__ */ React159.createElement(EGDSDialogContent8, null, /* @__PURE__ */ React159.createElement(PropertyFilteredReviewsDialogContent, null)));
    };
    return /* @__PURE__ */ React159.createElement(React159.Fragment, null, /* @__PURE__ */ React159.createElement(LodgingDialogTriggerMessage, {
        onClickAction: openDialog,
        data: trigger,
        triggerRef: linkRef
    }), /* @__PURE__ */ React159.createElement(EGDSSheetTransition15, {
        isVisible: isVisible
    }, /* @__PURE__ */ React159.createElement(ReviewsDialog, null, /* @__PURE__ */ React159.createElement(Viewport15, null, /* @__PURE__ */ React159.createElement(ViewSmall14, null, sheet("full")), /* @__PURE__ */ React159.createElement(ViewMedium13, null, sheet("centered", 1200))))));
};
PropertyFilteredReviewsDialog.displayName = "PropertyFilteredReviewsDialog";
PropertyFilteredReviewsDialog.fragment = fragment104;
// src/components/property-review-summary/review-disclaimer.tsx
import React160 from "react";
import { gql as gql129 } from "@apollo/client";
import { EGDSExpandoPeek as EGDSExpandoPeek4 } from "@egds/react-core/expando";
import { EGDSIcon as EGDSIcon27, EGDSIconSize as EGDSIconSize19 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink15 } from "@egds/react-core/link";
import { EGDSMenu, EGDSMenuContainer, EGDSMenuTrigger, PositionType } from "@egds/react-core/menu";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger4 } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet12, EGDSSheetContent as EGDSSheetContent11, EGDSSheetTransition as EGDSSheetTransition16 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing44 } from "@egds/react-core/spacing";
import { EGDSParagraph as EGDSParagraph3, EGDSText as EGDSText27 } from "@egds/react-core/text";
import { EGDSToolbar as EGDSToolbar8 } from "@egds/react-core/toolbar";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker39 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog15 } from "@shared-ui/dialog-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
var fragment105 = gql129(_templateObject130());
var ReviewDisclaimer = function(param) {
    var reviewPage = param.reviewPage, data = param.data;
    var _React160_useState = _sliced_to_array(React160.useState(false), 2), showMenu = _React160_useState[0], setShowMenu = _React160_useState[1];
    var reviewDisclaimer = data.reviewDisclaimer, reviewDisclaimerHeading = data.reviewDisclaimerHeading, reviewDisclaimerValues = data.reviewDisclaimerValues, reviewDisclaimerAccessibilityLabel = data.reviewDisclaimerAccessibilityLabel, reviewDisclaimerLabel = data.reviewDisclaimerLabel, reviewDisclaimerUrl = data.reviewDisclaimerUrl, reviewDisclaimerAnalytics = data.reviewDisclaimerAnalytics, strategy = data.strategy;
    var _React160_useState1 = _sliced_to_array(React160.useState(false), 2), isVisible = _React160_useState1[0], setIsVisible = _React160_useState1[1];
    var dialogPostFix = useDialogId();
    var _useDialog15 = _sliced_to_array(useDialog15("centered-sheet-necessary-dialog-layer-".concat(dialogPostFix)), 3), isDialogOpen = _useDialog15[0], dialogActions = _useDialog15[1], DialogComponent = _useDialog15[2];
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var context = useBexApi8().context;
    var isTabletOrBigger = viewSize === 0 ? context.device.type === "DESKTOP" || context.device.type === "MOBILE_TABLET" : viewSize > defaultViewSizes.SMALL;
    var sheetSize = isTabletOrBigger ? "small" : "medium";
    var openDialog = function() {
        dialogActions.openDialog();
    };
    var handleToolbarCloseAction = function() {
        dialogActions.closeDialog();
    };
    var clickTracker = useClickTracker39();
    if (!reviewDisclaimer || reviewDisclaimer.length === 0) {
        return null;
    }
    var handleReviewDisclaimerLabelClick = function() {
        if (!showMenu && reviewDisclaimerAnalytics && reviewPage) {
            clickTracker(reviewDisclaimerAnalytics.referrerId, reviewDisclaimerAnalytics.linkName);
        }
        setShowMenu(!showMenu);
    };
    var renderReviewDisclaimerVrbexGeneric = function() {
        return (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(EGDSSpacing44, {
            padding: {
                blockstart: "four",
                blockend: "two"
            }
        }, /* @__PURE__ */ React160.createElement(EGDSText27, {
            weight: "regular",
            size: 200
        }, reviewDisclaimer)), /* @__PURE__ */ React160.createElement(EGDSSpacing44, {
            padding: {
                blockend: "four"
            }
        }, reviewDisclaimerUrl && /* @__PURE__ */ React160.createElement(EGDSLink15, null, /* @__PURE__ */ React160.createElement("a", {
            href: reviewDisclaimerUrl.link.url,
            target: "_blank",
            rel: "noreferrer noopener"
        }, reviewDisclaimerUrl.value, /* @__PURE__ */ React160.createElement("span", {
            className: "is-visually-hidden"
        }, reviewDisclaimerUrl.accessibilityLabel)))));
    };
    var reviewsDisclaimerView = (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel;
    var ThirdPartyReviewDisclaimer = reviewsDisclaimerView && /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(EGDSText27, null, /* @__PURE__ */ React160.createElement(EGDSSpacing44, null, /* @__PURE__ */ React160.createElement(EGDSMoreInfoTrigger4, {
        onClick: openDialog,
        size: "medium",
        weight: "regular"
    }, /* @__PURE__ */ React160.createElement(EGDSText27, {
        size: 300
    }, reviewDisclaimerLabel, /* @__PURE__ */ React160.createElement(EGDSIcon27, {
        name: "info_outline"
    }))))), /* @__PURE__ */ React160.createElement(EGDSSheetTransition16, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React160.createElement(DialogComponent, null, /* @__PURE__ */ React160.createElement(EGDSSheet12, {
        isVisible: isDialogOpen,
        type: "centered",
        centeredSheetSize: sheetSize,
        triggerRef: null
    }, /* @__PURE__ */ React160.createElement(EGDSToolbar8, {
        navigationContent: {
            onClick: handleToolbarCloseAction,
            navIconLabel: "close toolbar",
            navType: "close"
        }
    }), /* @__PURE__ */ React160.createElement(EGDSSheetContent11, null, /* @__PURE__ */ React160.createElement(EGDSText27, {
        weight: "bold",
        size: 400
    }, reviewDisclaimerHeading), /* @__PURE__ */ React160.createElement(EGDSSpacing44, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React160.createElement(EGDSExpandoPeek4, {
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        items: 1
    }, reviewDisclaimerValues === null || reviewDisclaimerValues === void 0 ? void 0 : reviewDisclaimerValues.map(function(value, key) {
        return /* @__PURE__ */ React160.createElement(EGDSParagraph3, {
            key: key
        }, value.text);
    }))))))));
    var ReviewDisclaimerComponent = /* @__PURE__ */ React160.createElement(EGDSMenu, {
        isOpen: showMenu,
        onTriggerClick: handleReviewDisclaimerLabelClick
    }, /* @__PURE__ */ React160.createElement(EGDSMenuTrigger, null, /* @__PURE__ */ React160.createElement(EGDSLink15, null, /* @__PURE__ */ React160.createElement("button", {
        type: "button",
        "aria-label": reviewDisclaimerAccessibilityLabel !== null && reviewDisclaimerAccessibilityLabel !== void 0 ? reviewDisclaimerAccessibilityLabel : void 0
    }, reviewDisclaimerLabel, /* @__PURE__ */ React160.createElement(EGDSSpacing44, {
        padding: {
            inline: "one",
            block: "half"
        }
    }, /* @__PURE__ */ React160.createElement(EGDSIcon27, {
        name: "info_outline",
        size: EGDSIconSize19.SMALL
    }))))), /* @__PURE__ */ React160.createElement(EGDSMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT,
        width: 300
    }, /* @__PURE__ */ React160.createElement(EGDSSpacing44, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React160.createElement(EGDSParagraph3, {
        size: 1
    }, reviewDisclaimer, reviewDisclaimerUrl && /* @__PURE__ */ React160.createElement(EGDSLink15, null, /* @__PURE__ */ React160.createElement("a", {
        href: reviewDisclaimerUrl.link.url,
        target: "_blank",
        rel: "noreferrer noopener"
    }, reviewDisclaimerUrl.value, /* @__PURE__ */ React160.createElement("span", {
        className: "is-visually-hidden"
    }, reviewDisclaimerUrl.accessibilityLabel)))))));
    return /* @__PURE__ */ React160.createElement(React160.Fragment, null, reviewsDisclaimerView && /* @__PURE__ */ React160.createElement(Experiment2, {
        name: "External_reviews_display_SRP_and_PDP"
    }, /* @__PURE__ */ React160.createElement(ExperimentControl2, null, ReviewDisclaimerComponent), /* @__PURE__ */ React160.createElement(ExperimentVariant2, {
        bucket: 1
    }, strategy === "EXTERNAL_REVIEWS" /* EXTERNAL_REVIEWS */  ? ThirdPartyReviewDisclaimer : ReviewDisclaimerComponent)), /* @__PURE__ */ React160.createElement(Experiment2, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React160.createElement(ExperimentControl2, null), /* @__PURE__ */ React160.createElement(ExperimentVariant2, {
        bucket: 1
    }, renderReviewDisclaimerVrbexGeneric())));
};
ReviewDisclaimer.displayName = "ReviewDisclaimer";
ReviewDisclaimer.fragment = fragment105;
// src/components/property-review-summary/property-reviews-breakdown.tsx
var fragment106 = gql130(_templateObject131(), ReviewDisclaimer.fragment, SummaryDetails.fragment, RatingCounts.fragment, PropertyFilteredReviewsDialog.fragment, LodgingEnrichedMessage.fragment);
var PropertyReviewsBreakdown = function(param) {
    var data = param.data, onClickLink = param.onClickLink, _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating, reviewPage = param.reviewPage;
    var averageOverallRatingValue = data.averageOverallRatingValue, averageOverallRatingSection = data.averageOverallRatingSection, superlative = data.superlative, propertyReviewCountDetails = data.propertyReviewCountDetails, reviewDisclaimer = data.reviewDisclaimer, totalCount = data.totalCount, seeAllAction = data.seeAllAction, reviewDisclaimerLabel = data.reviewDisclaimerLabel, strategy = data.strategy;
    var ratingValueProps = getStructuredDataProps("ratingValue", withAggregateRating);
    var aggregateRatingValueProps = getStructuredDataProps("aggregateRating", withAggregateRating);
    var reviewCountValueProps = getStructuredDataProps("reviewCount", withAggregateRating);
    var renderPropertyReviewBreakdownVrbexGeneric = function() {
        return totalCount.raw !== 0 && (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React161.createElement(EGDSLayoutFlexItem27, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React161.createElement(ReviewDisclaimer, {
            data: data,
            reviewPage: reviewPage
        }));
    };
    var reviewsDisclaimerView = (reviewDisclaimer === null || reviewDisclaimer === void 0 ? void 0 : reviewDisclaimer.length) && reviewDisclaimerLabel;
    var ThirdPartyReviewsBreakdown = /* @__PURE__ */ React161.createElement("div", _object_spread({}, aggregateRatingValueProps), totalCount.raw !== 0 && /* @__PURE__ */ React161.createElement(EGDSLayoutFlex37, {
        space: "three",
        alignItems: "center"
    }, /* @__PURE__ */ React161.createElement(EGDSText28, {
        weight: "regular",
        size: 900
    }, /* @__PURE__ */ React161.createElement("span", _object_spread({}, ratingValueProps), averageOverallRatingValue === null || averageOverallRatingValue === void 0 ? void 0 : averageOverallRatingValue.formatted)), /* @__PURE__ */ React161.createElement(EGDSSpacing45, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React161.createElement(EGDSLayoutFlex37, {
        direction: "column"
    }, /* @__PURE__ */ React161.createElement(EGDSHeading13, {
        tag: "h3",
        size: 6
    }, superlative), /* @__PURE__ */ React161.createElement(EGDSLayoutFlex37, null, seeAllAction && /* @__PURE__ */ React161.createElement(EGDSSpacing45, {
        padding: {
            block: "two"
        }
    }, seeAllAction ? /* @__PURE__ */ React161.createElement(PropertyFilteredReviewsDialog, {
        data: seeAllAction
    }) : /* @__PURE__ */ React161.createElement(EGDSLink16, {
        onClick: onClickLink,
        size: "medium"
    }, /* @__PURE__ */ React161.createElement("button", _object_spread({
        type: "button"
    }, reviewCountValueProps), propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription)))), reviewsDisclaimerView && /* @__PURE__ */ React161.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */ React161.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }))))));
    var RenderPropertyReviewsBreakdown = /* @__PURE__ */ React161.createElement("div", _object_spread({}, aggregateRatingValueProps), totalCount.raw !== 0 && /* @__PURE__ */ React161.createElement(EGDSLayoutFlex37, {
        space: "three"
    }, /* @__PURE__ */ React161.createElement("span", _object_spread({}, ratingValueProps), averageOverallRatingSection && /* @__PURE__ */ React161.createElement(LodgingEnrichedMessage, {
        data: averageOverallRatingSection,
        textSize: 900
    })), /* @__PURE__ */ React161.createElement(EGDSSpacing45, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React161.createElement(EGDSLayoutFlex37, {
        direction: "column"
    }, /* @__PURE__ */ React161.createElement(EGDSHeading13, {
        tag: "h3",
        size: 6
    }, superlative), /* @__PURE__ */ React161.createElement(EGDSLayoutFlex37, null, /* @__PURE__ */ React161.createElement(EGDSSpacing45, {
        padding: {
            block: "two"
        }
    }, seeAllAction ? /* @__PURE__ */ React161.createElement(PropertyFilteredReviewsDialog, {
        data: seeAllAction
    }) : /* @__PURE__ */ React161.createElement(EGDSLink16, {
        onClick: onClickLink,
        size: "medium"
    }, /* @__PURE__ */ React161.createElement("button", _object_spread({
        type: "button"
    }, reviewCountValueProps), propertyReviewCountDetails === null || propertyReviewCountDetails === void 0 ? void 0 : propertyReviewCountDetails.shortDescription)))), reviewsDisclaimerView && /* @__PURE__ */ React161.createElement(EGDSLayoutFlexItem27, null, /* @__PURE__ */ React161.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }))))), /* @__PURE__ */ React161.createElement(Experiment3, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React161.createElement(ExperimentControl3, null), /* @__PURE__ */ React161.createElement(ExperimentVariant3, {
        bucket: 1
    }, renderPropertyReviewBreakdownVrbexGeneric())), /* @__PURE__ */ React161.createElement(RatingCounts, {
        data: data
    }), /* @__PURE__ */ React161.createElement(SummaryDetails, {
        data: data
    }));
    return /* @__PURE__ */ React161.createElement(Experiment3, {
        name: "External_reviews_display_SRP_and_PDP"
    }, /* @__PURE__ */ React161.createElement(ExperimentControl3, null, RenderPropertyReviewsBreakdown), /* @__PURE__ */ React161.createElement(ExperimentVariant3, {
        bucket: 1
    }, strategy === "EXTERNAL_REVIEWS" /* EXTERNAL_REVIEWS */  ? ThirdPartyReviewsBreakdown : RenderPropertyReviewsBreakdown));
};
PropertyReviewsBreakdown.displayName = "PropertyReviewsBreakdownFragment";
PropertyReviewsBreakdown.fragment = fragment106;
// src/components/map-trigger/map-trigger.tsx
import React166 from "react";
import { gql as gql131 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition17 } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker40 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog16 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge8, ViewMedium as ViewMedium14, Viewport as Viewport16, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
// src/components/map-trigger/floating-wrap.tsx
import React164 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition11 } from "@egds/react-core/layout-position";
import { useExperiment as useExperiment12 } from "@shared-ui/experiment-context";
import { useLodgingCompare as useLodgingCompare4 } from "@shared-ui/retail-compare-providers";
// src/components/map-trigger/utils/map-trigger-utils.ts
var openMapDialog = function(clientSideAnalytics, trackClick, dialogActions) {
    if (clientSideAnalytics) {
        trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    }
    dialogActions.openDialog({
        closeAllDialogs: true
    });
};
var handlePlayPauseAnalytics = function(clientSideAnalytics, trackClick) {
    if (clientSideAnalytics) {
        trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    }
};
// src/components/map-trigger/floating-map-button.tsx
import React162 from "react";
import { EGDSFloatingButton as EGDSFloatingButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon28 } from "@egds/react-core/icons";
var FloatingMapButton = function(param) {
    var openMapDialog2 = param.openMapDialog, className = param.className, triggerRef = param.triggerRef, icon = param.icon, label = param.label;
    return /* @__PURE__ */ React162.createElement(EGDSFloatingButton2, {
        "data-stid": "map-trigger-floating-button",
        onClick: openMapDialog2,
        className: className,
        domRef: triggerRef
    }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React162.createElement(EGDSIcon28, {
        name: icon === null || icon === void 0 ? void 0 : icon.id
    }), label);
};
// src/components/map-trigger/secondary-map-button.tsx
import React163 from "react";
import { EGDSSecondaryButton as EGDSSecondaryButton4 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon29 } from "@egds/react-core/icons";
var SecondaryMapButton = function(param) {
    var openMapDialog2 = param.openMapDialog, className = param.className, triggerRef = param.triggerRef, icon = param.icon, label = param.label, isFullWidth = param.isFullWidth, _param_style = param.style, style = _param_style === void 0 ? void 0 : _param_style;
    return /* @__PURE__ */ React163.createElement(EGDSSecondaryButton4, {
        "data-stid": "map-trigger-secondary-button",
        onClick: openMapDialog2,
        isFullWidth: isFullWidth,
        className: className,
        domRef: triggerRef,
        style: style
    }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React163.createElement(EGDSIcon29, {
        name: icon === null || icon === void 0 ? void 0 : icon.id
    }), label);
};
// src/components/map-trigger/floating-wrap.tsx
var bottomMargin = 24;
var bottomMarginWhenOffset = 16;
var FloatingWrap = function(param) {
    var trackClick = param.trackClick, dialogActions = param.dialogActions, className = param.className, triggerRef = param.triggerRef, dialogView = param.dialogView, icon = param.icon, labels = param.labels, label = param.label, clientSideAnalytics = param.clientSideAnalytics;
    var inlineLinkLabel = labels === null || labels === void 0 ? void 0 : labels.find(function(labelElement) {
        return labelElement.__typename === "EGDSInlineLink";
    });
    var _inlineLinkLabel_text;
    var resolvedLabel = (_inlineLinkLabel_text = inlineLinkLabel === null || inlineLinkLabel === void 0 ? void 0 : inlineLinkLabel.text) !== null && _inlineLinkLabel_text !== void 0 ? _inlineLinkLabel_text : label;
    var _inlineLinkLabel_action_analytics;
    var analytics = (_inlineLinkLabel_action_analytics = inlineLinkLabel === null || inlineLinkLabel === void 0 ? void 0 : inlineLinkLabel.action.analytics) !== null && _inlineLinkLabel_action_analytics !== void 0 ? _inlineLinkLabel_action_analytics : clientSideAnalytics;
    var openMapDialogWrapper = function() {
        return openMapDialog(analytics, trackClick, dialogActions);
    };
    var _useExperiment12_exposure = useExperiment12("Introduce_Quick_Sort_and_Filters_at_top_of_SRP_mweb", true).exposure, sortAndFilterSrpMwebBucket = _useExperiment12_exposure.bucket;
    var _useExperiment12_exposure1 = useExperiment12("Vrbex_Mweb_MapButtonUI", false).exposure, vrbexMwebMapButtonUiBucket = _useExperiment12_exposure1.bucket;
    var _useLodgingCompare4 = _sliced_to_array(useLodgingCompare4(), 1), _useLodgingCompare4_ = _useLodgingCompare4[0], bottomOffset = _useLodgingCompare4_.bottomSheetHeight;
    var button = dialogView === "FILTER_BAR" && (sortAndFilterSrpMwebBucket === 1 || vrbexMwebMapButtonUiBucket === 1) ? /* @__PURE__ */ React164.createElement(FloatingMapButton, {
        openMapDialog: openMapDialogWrapper,
        className: className,
        triggerRef: triggerRef,
        icon: icon,
        label: resolvedLabel
    }) : /* @__PURE__ */ React164.createElement(SecondaryMapButton, {
        openMapDialog: openMapDialogWrapper,
        className: className,
        triggerRef: triggerRef,
        icon: icon,
        label: resolvedLabel,
        isFullWidth: false
    });
    return dialogView === "FILTER_BAR" ? /* @__PURE__ */ React164.createElement(EGDSLayoutPosition11, {
        type: "fixed",
        position: {
            left: "center",
            zindex: "layer4"
        },
        cloneElement: true,
        style: {
            insetBlockEnd: bottomOffset ? bottomOffset + bottomMarginWhenOffset : bottomMargin
        }
    }, button) : button;
};
// src/components/map-trigger/interfaces.ts
var Alignment = /* @__PURE__ */ function(Alignment2) {
    Alignment2["Left"] = "left";
    Alignment2["Right"] = "right";
    Alignment2["Center"] = "center";
    return Alignment2;
}(Alignment || {});
// src/components/map-trigger/map-preview.tsx
import React165, { useState as useState3 } from "react";
import { EGDSCard as EGDSCard7, EGDSCardContentSection as EGDSCardContentSection10 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure9, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType11, EGDSImage as EGDSImage7, EGDSImageLink as EGDSImageLink5 } from "@egds/react-core/images";
import { EGDSLayoutPosition as EGDSLayoutPosition12 } from "@egds/react-core/layout-position";
import { EGDSLink as EGDSLink17 } from "@egds/react-core/link";
import { EGDSText as EGDSText29 } from "@egds/react-core/text";
import { VideoPlayer } from "@egds/react-property-experience";
import { Experiment as Experiment4, ExperimentControl as ExperimentControl4, ExperimentVariant as ExperimentVariant4, useExperiment as useExperiment13 } from "@shared-ui/experiment-context";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
var HEIGHT_OF_QUICK_FILTERS = 60;
var MapPreview = function(param) {
    var address = param.address, className = param.className, clientSideAnalytics = param.clientSideAnalytics, dialogActions = param.dialogActions, dialogView = param.dialogView, image = param.image, labels = param.labels, labelsAlignment = param.labelsAlignment, linkRef = param.linkRef, setClickedRef = param.setClickedRef, staticTrigger = param.staticTrigger, trackClick = param.trackClick, triggerRef = param.triggerRef, label = param.label, video = param.video;
    var _useExperiment13 = useExperiment13("PDP_3D_AERIAL_VIEW_LOCATION_MODULE", false), isShowingAerialVideo = _useExperiment13.exposure;
    var _ref = video || {}, videoUrl = _ref.url, thumbnail = _ref.thumbnail, thumbnailClickAnalytics = _ref.thumbnailClickAnalytics, playPauseAnalytics = _ref.playPauseAnalytics, description = _ref.description;
    var _useState3 = _sliced_to_array(useState3(!!videoUrl), 2), showAerialMap = _useState3[0], setShowAerialMap = _useState3[1];
    var handleError = function() {
        setShowAerialMap(false);
    };
    var handleVideoAnalytics = React165.useCallback(function(analytics) {
        return handlePlayPauseAnalytics(analytics, trackClick);
    }, []);
    var mapPreviewContent = React165.useCallback(function() {
        if (!image) {
            return null;
        }
        var renderImage = /* @__PURE__ */ React165.createElement(React165.Fragment, null, (image === null || image === void 0 ? void 0 : image.url) ? /* @__PURE__ */ React165.createElement(EGDSImage7, {
            alt: image === null || image === void 0 ? void 0 : image.description,
            src: image === null || image === void 0 ? void 0 : image.url,
            "aria-hidden": "true"
        }) : /* @__PURE__ */ React165.createElement(EGDSImage7, {
            placeholderImage: true,
            "aria-hidden": "true"
        }), !staticTrigger && /* @__PURE__ */ React165.createElement(EGDSImageLink5, null, /* @__PURE__ */ React165.createElement("button", {
            "data-stid": "map-trigger-image",
            type: "button",
            onClick: function() {
                setClickedRef(triggerRef);
                openMapDialogWrapper(image === null || image === void 0 ? void 0 : image.thumbnailClickAnalytics);
            },
            ref: triggerRef
        }, image === null || image === void 0 ? void 0 : image.description)));
        var renderVideo = /* @__PURE__ */ React165.createElement(React165.Fragment, null, videoUrl && /* @__PURE__ */ React165.createElement(VideoPlayer, {
            thumbnail: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.value,
            src: videoUrl.value,
            onError: handleError,
            autoplay: true,
            loop: true,
            showDefaultControls: false,
            controlButtonSize: UitkButtonSize2.LARGE,
            autoplayInView: true,
            onPlay: function() {
                return handleVideoAnalytics(playPauseAnalytics);
            },
            onPause: function() {
                return handleVideoAnalytics(playPauseAnalytics);
            },
            showLoader: false,
            showScrim: true
        }), /* @__PURE__ */ React165.createElement(EGDSImageLink5, null, /* @__PURE__ */ React165.createElement("button", {
            "data-stid": "map-trigger-video",
            type: "button",
            onClick: function() {
                setClickedRef(triggerRef);
                openMapDialogWrapper(thumbnailClickAnalytics);
            },
            ref: triggerRef
        }, description)));
        var openMapDialogWrapper = function(analytics) {
            return openMapDialog(analytics, trackClick, dialogActions);
        };
        return /* @__PURE__ */ React165.createElement(EGDSCard7, {
            border: true,
            className: className
        }, /* @__PURE__ */ React165.createElement(EGDSFigure9, {
            ratio: EGDSFigureAspectRatioType11.R21_9,
            roundcorner: [
                "startstart",
                "startend"
            ],
            "aria-hidden": "true"
        }, isShowingAerialVideo.bucket && showAerialMap ? renderVideo : renderImage), (labels === null || labels === void 0 ? void 0 : labels.length) > 0 ? /* @__PURE__ */ React165.createElement(EGDSCardContentSection10, null, labels.map(function(dynamicLabel, index) {
            var _dynamicLabel_action;
            if (!(dynamicLabel === null || dynamicLabel === void 0 ? void 0 : dynamicLabel.text)) {
                return null;
            }
            if (!staticTrigger && (dynamicLabel === null || dynamicLabel === void 0 ? void 0 : (_dynamicLabel_action = dynamicLabel.action) === null || _dynamicLabel_action === void 0 ? void 0 : _dynamicLabel_action.analytics)) {
                return /* @__PURE__ */ React165.createElement(EGDSLink17, {
                    key: index,
                    align: labelsAlignment,
                    domRef: linkRef
                }, /* @__PURE__ */ React165.createElement("button", {
                    "data-stid": "map-trigger-link",
                    type: "button",
                    className: "uitk-button",
                    onClick: function() {
                        var _dynamicLabel_action;
                        setClickedRef(linkRef);
                        openMapDialogWrapper(dynamicLabel === null || dynamicLabel === void 0 ? void 0 : (_dynamicLabel_action = dynamicLabel.action) === null || _dynamicLabel_action === void 0 ? void 0 : _dynamicLabel_action.analytics);
                    }
                }, dynamicLabel.text));
            }
            return /* @__PURE__ */ React165.createElement(React165.Fragment, null, address ? /* @__PURE__ */ React165.createElement(EGDSText29, {
                "data-stid": "content-hotel-address",
                key: index,
                align: labelsAlignment
            }, /* @__PURE__ */ React165.createElement("div", {
                itemProp: "address",
                itemScope: true,
                itemType: "http://schema.org/PostalAddress"
            }, /* @__PURE__ */ React165.createElement("meta", {
                itemProp: "name",
                content: address === null || address === void 0 ? void 0 : address.city
            }), /* @__PURE__ */ React165.createElement("meta", {
                itemProp: "addressRegion",
                content: address === null || address === void 0 ? void 0 : address.province
            }), /* @__PURE__ */ React165.createElement("meta", {
                itemProp: "streetAddress",
                content: address === null || address === void 0 ? void 0 : address.streetAddress
            }), /* @__PURE__ */ React165.createElement("meta", {
                itemProp: "addressCountry",
                content: address === null || address === void 0 ? void 0 : address.countryCode
            })), dynamicLabel.text) : /* @__PURE__ */ React165.createElement(EGDSText29, {
                key: index,
                align: labelsAlignment
            }, dynamicLabel.text));
        })) : /* @__PURE__ */ React165.createElement(EGDSCardContentSection10, null, staticTrigger ? /* @__PURE__ */ React165.createElement(EGDSText29, {
            align: "center"
        }, /* @__PURE__ */ React165.createElement("span", null, label)) : /* @__PURE__ */ React165.createElement(EGDSLink17, {
            align: "center",
            domRef: linkRef
        }, /* @__PURE__ */ React165.createElement("button", {
            type: "button",
            className: "uitk-button",
            onClick: function() {
                setClickedRef(linkRef);
                openMapDialogWrapper(clientSideAnalytics);
            }
        }, label))));
    }, [
        image,
        labels
    ]);
    return /* @__PURE__ */ React165.createElement(Experiment4, {
        name: "Introduce_Quick_Sort_and_Filters_at_top_of_SRP_web"
    }, /* @__PURE__ */ React165.createElement(ExperimentControl4, null, mapPreviewContent()), /* @__PURE__ */ React165.createElement(ExperimentVariant4, {
        bucket: 1
    }, dialogView === "FILTER_BAR" ? /* @__PURE__ */ React165.createElement(EGDSLayoutPosition12, {
        type: "sticky",
        position: {
            top: HEIGHT_OF_QUICK_FILTERS
        }
    }, mapPreviewContent()) : /* @__PURE__ */ React165.createElement(React165.Fragment, null, mapPreviewContent())));
};
MapPreview.displayName = "MapPreview";
// src/components/map-trigger/map-trigger.tsx
var __MapTriggerFragment = gql131(_templateObject132());
var defaultCloseMapDialogPropBuilder = function(onClose) {
    return {
        onClose: onClose
    };
};
var fullscreenOptionsCloseMapDialogPropBuilder = function(onClose, isDialogOpen, triggerRef) {
    return {
        fullscreenOptions: {
            onClose: onClose,
            isDialogOpen: isDialogOpen,
            triggerRef: triggerRef
        }
    };
};
var MapTrigger = function(props) {
    var mapTriggerRef = React166.useRef(null);
    var linkRef = React166.useRef(null);
    var address = props.address, children = props.children, className = props.className, _props_closeMapDialogPropBuilder = props.closeMapDialogPropBuilder, closeMapDialogPropBuilder = _props_closeMapDialogPropBuilder === void 0 ? defaultCloseMapDialogPropBuilder : _props_closeMapDialogPropBuilder, data = props.data, _props_dialogId = props.dialogId, dialogId = _props_dialogId === void 0 ? "map" : _props_dialogId, _props_dialogQueryKey = props.dialogQueryKey, dialogQueryKey = _props_dialogQueryKey === void 0 ? "pwaOverlay" : _props_dialogQueryKey, dialogView = props.dialogView, _props_labelsAlignment = props.labelsAlignment, labelsAlignment = _props_labelsAlignment === void 0 ? "left" /* Left */  : _props_labelsAlignment, _props_staticTrigger = props.staticTrigger, staticTrigger = _props_staticTrigger === void 0 ? false : _props_staticTrigger, _props_triggerRef = props.triggerRef, triggerRef = _props_triggerRef === void 0 ? mapTriggerRef : _props_triggerRef, _props_useMapPreview = props.useMapPreview, useMapPreview = _props_useMapPreview === void 0 ? false : _props_useMapPreview, video = props.video;
    var trackClick = useClickTracker40();
    var _useDialog16 = _sliced_to_array(useDialog16(dialogId, dialogQueryKey), 3), isDialogOpen = _useDialog16[0], dialogActions = _useDialog16[1], DialogComponent = _useDialog16[2];
    var _React166_useState = _sliced_to_array(React166.useState(null), 2), clickedRef = _React166_useState[0], setClickedRef = _React166_useState[1];
    if (!data) {
        return null;
    }
    var smallImage = data.small, mediumImage = data.medium, largeImage = data.large, labels = data.labels, icon = data.icon, label = data.label, clientSideAnalytics = data.clientSideAnalytics;
    var closeProps = closeMapDialogPropBuilder(dialogActions.closeDialog, isDialogOpen, clickedRef);
    var generateTriggerView = function(image, isMapPreview) {
        var commonProps = {
            className: className,
            dialogActions: dialogActions,
            dialogView: dialogView,
            labels: labels,
            staticTrigger: staticTrigger,
            trackClick: trackClick,
            triggerRef: triggerRef,
            label: label,
            clientSideAnalytics: clientSideAnalytics
        };
        if (isMapPreview) {
            return /* @__PURE__ */ React166.createElement(MapPreview, _object_spread_props(_object_spread({}, commonProps), {
                address: address,
                image: image,
                labelsAlignment: labelsAlignment,
                video: video,
                linkRef: linkRef,
                setClickedRef: setClickedRef
            }));
        }
        return /* @__PURE__ */ React166.createElement(FloatingWrap, _object_spread_props(_object_spread({}, commonProps), {
            icon: icon
        }));
    };
    var renderChildren = function() {
        if (Array.isArray(children)) {
            return children.map(function(child) {
                return React166.cloneElement(child, closeProps);
            });
        }
        return React166.cloneElement(children, closeProps);
    };
    return /* @__PURE__ */ React166.createElement(React166.Fragment, null, /* @__PURE__ */ React166.createElement(Viewport16, null, /* @__PURE__ */ React166.createElement(ViewSmall15, null, generateTriggerView(smallImage, useMapPreview)), /* @__PURE__ */ React166.createElement(ViewMedium14, null, generateTriggerView(mediumImage, useMapPreview)), /* @__PURE__ */ React166.createElement(ViewLarge8, null, generateTriggerView(largeImage, true))), isDialogOpen && /* @__PURE__ */ React166.createElement(EGDSSheetTransition17, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React166.createElement(DialogComponent, null, renderChildren())));
};
MapTrigger.displayName = "MapTrigger";
MapTrigger.fragment = __MapTriggerFragment;
// src/utils/find-react-child-by-type.ts
import React167 from "react";
var findReactChildByType = function(children, type) {
    return React167.Children.toArray(children).find(function(child) {
        return React167.isValidElement(child) && child.type === type;
    });
};
// src/components/lodging-egds-checkbox/lodging-egds-checkbox.tsx
import React169 from "react";
import { gql as gql133 } from "@apollo/client";
// src/components/lodging-egds-checkbox/lodging-egds-basic-checkbox.tsx
import React168 from "react";
import { gql as gql132 } from "@apollo/client";
import { EGDSCheckbox as EGDSCheckbox2 } from "@egds/react-core/checkbox";
import { useClickTracker as useClickTracker41 } from "@shared-ui/clickstream-analytics-context";
var __Fragment2 = gql132(_templateObject133());
var LodgingEGDSBasicCheckBox = function(_param) {
    var data = _param.data, checked = _param.checked, onChange = _param.onChange, props = _object_without_properties(_param, [
        "data",
        "checked",
        "onChange"
    ]);
    var egdsElementId = data.egdsElementId, description = data.description, enabled = data.enabled, name = data.name, label = data.label, checkedAnalytics = data.checkedAnalytics, uncheckedAnalytics = data.uncheckedAnalytics, state = data.state;
    var _React168_useState = _sliced_to_array(React168.useState(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ ), 2), isChecked = _React168_useState[0], setIsChecked = _React168_useState[1];
    React168.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ );
    }, [
        checked,
        state
    ]);
    var track = useClickTracker41();
    var handleChange = React168.useCallback(function(event) {
        setIsChecked(event.currentTarget.checked);
        if (checkedAnalytics && !isChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && isChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }, [
        checkedAnalytics,
        isChecked,
        onChange,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React168.createElement(EGDSCheckbox2, _object_spread({
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : void 0,
        checked: isChecked,
        description: description !== null && description !== void 0 ? description : void 0,
        disabled: !enabled,
        name: name !== null && name !== void 0 ? name : void 0,
        onChange: handleChange
    }, props), label === null || label === void 0 ? void 0 : label.text);
};
LodgingEGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
LodgingEGDSBasicCheckBox.fragment = __Fragment2;
// src/components/lodging-egds-checkbox/lodging-egds-checkbox.tsx
var __Fragment3 = gql133(_templateObject134(), LodgingEGDSBasicCheckBox.fragment);
var LodgingEGDSCheckbox = function(param) {
    var data = param.data, onChange = param.onChange, checked = param.checked, tabIndex = param.tabIndex;
    switch(data.__typename){
        case "EGDSBasicCheckBox":
            return /* @__PURE__ */ React169.createElement(LodgingEGDSBasicCheckBox, _object_spread({
                onChange: onChange,
                checked: checked,
                data: data
            }, {
                tabIndex: tabIndex
            }));
        default:
            return null;
    }
};
LodgingEGDSCheckbox.displayName = "EGDSCheckBox";
LodgingEGDSCheckbox.fragment = __Fragment3;
// src/components/property-overfiltered-card/property-overfiltered-card.tsx
import React170 from "react";
import { gql as gql134 } from "@apollo/client";
import { EGDSHeading as EGDSHeading14, EGDSText as EGDSText30 } from "@egds/react-core/text";
import { EGDSToast as EGDSToast2 } from "@egds/react-core/toast";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment14 } from "@shared-ui/experiment-context";
var fragment107 = gql134(_templateObject135());
var PropertyOverfilteredCard = function(param) {
    var data = param.data, isPropertySelected = param.isPropertySelected;
    var _ref = data.content || {}, heading = _ref.heading, message = _ref.message, impressionTracking = _ref.impressionTracking;
    var context = useBexApi9().context;
    var _useExperiment14_exposure = useExperiment14("Vrbex_Overfiltering_Message").exposure, vrboOverfilteringBucket = _useExperiment14_exposure.bucket;
    var _useExperiment14_exposure1 = useExperiment14("vrbex_fuzzy_search_manual_override_search_api").exposure, vrboFuzzyOverrideBucket = _useExperiment14_exposure1.bucket;
    if (!data.content) {
        return null;
    }
    var isVrboOverfilteringEnabled = vrboOverfilteringBucket === 1 || vrboFuzzyOverrideBucket === 1;
    if (isVrboOverfilteringEnabled && impressionTracking) {
        var _context_device;
        var isVisible = !isPropertySelected;
        var isDesktop = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "DESKTOP" /* DESKTOP */ ;
        if (isDesktop) {
            return null;
        }
        return /* @__PURE__ */ React170.createElement(IntersectionTracker13, {
            referrerId: impressionTracking.referrerId,
            linkName: impressionTracking.linkName
        }, /* @__PURE__ */ React170.createElement(EGDSToast2, {
            autoHide: false,
            show: isVisible
        }, heading && /* @__PURE__ */ React170.createElement(EGDSHeading14, {
            tag: "h3",
            className: "uitk-text-light-theme uitk-type-regular"
        }, heading), message && /* @__PURE__ */ React170.createElement(EGDSHeading14, {
            tag: "h3",
            className: "uitk-text-light-theme uitk-type-regular"
        }, message)));
    }
    return /* @__PURE__ */ React170.createElement(EGDSToast2, {
        autoHide: false,
        show: true
    }, heading && /* @__PURE__ */ React170.createElement(EGDSText30, {
        theme: "light"
    }, heading), message && /* @__PURE__ */ React170.createElement(EGDSText30, {
        theme: "light"
    }, message));
};
PropertyOverfilteredCard.displayName = "PropertyOverfilteredCard";
PropertyOverfilteredCard.fragment = fragment107;
// src/components/common/carousel/shopping-carousel.tsx
import React171 from "react";
import { gql as gql135 } from "@apollo/client";
var fragment108 = gql135(_templateObject136());
var getCarouselItems = function(itemsVisible) {
    return itemsVisible ? {
        xl: Math.min(itemsVisible, 7),
        lg: Math.min(itemsVisible, 6),
        md: Math.min(itemsVisible - 2, 3),
        sm: 2
    } : void 0;
};
var ShoppingCarousel = function(_param) {
    var children = _param.children, carousel = _param.data, props = _object_without_properties(_param, [
        "children",
        "data"
    ]);
    var itemsVisibleProp = carousel.itemsVisible, nextButton = carousel.nextButton, previousButton = carousel.previousButton;
    var itemsVisible = React171.useMemo(function() {
        return getCarouselItems(itemsVisibleProp);
    }, [
        itemsVisibleProp
    ]);
    var carouselProps = _object_spread({
        nextButtonText: (nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibilityLabel) || "",
        prevButtonText: (previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibilityLabel) || "",
        itemsVisible: itemsVisible
    }, props);
    return /* @__PURE__ */ React171.createElement(Carousel, _object_spread({}, carouselProps), children);
};
ShoppingCarousel.fragment = fragment108;
ShoppingCarousel.displayName = "EGDSCarousel";
// src/components/shopping-selectable-image-card/shopping-selectable-image-card.tsx
import React172 from "react";
import { gql as gql136 } from "@apollo/client";
import { EGDSCard as EGDSCard8 } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType12, EGDSImageLink as EGDSImageLink6 } from "@egds/react-core/images";
import { EGDSLayoutPosition as EGDSLayoutPosition13 } from "@egds/react-core/layout-position";
import { EGDSScrim as EGDSScrim2, EGDSScrimType as EGDSScrimType2 } from "@egds/react-core/scrim";
var fragment109 = gql136(_templateObject137(), EGDSStylizedText.fragment, LodgingEGDSImage.fragment);
var ShoppingSelectableImageCard = function(param) {
    var data = param.data, index = param.index, _param_lazyLoad = param.lazyLoad, lazyLoad = _param_lazyLoad === void 0 ? false : _param_lazyLoad, selected = param.selected, fetchPriority = param.fetchPriority, onImageCardClick = param.onImageCardClick;
    var _data_title, _data_title1;
    var handleClick = React172.useCallback(function() {
        var imageCard = _object_spread_props(_object_spread({}, data), {
            state: selected ? "UNSELECTED" /* UNSELECTED */  : "SELECTED" /* SELECTED */ 
        });
        onImageCardClick(imageCard, index);
    }, [
        data,
        index,
        selected,
        onImageCardClick
    ]);
    var hasTitle = ((_data_title = data.title) === null || _data_title === void 0 ? void 0 : _data_title.__typename) === "EGDSStylizedText";
    var accessibilityLabel = hasTitle && ((_data_title1 = data.title) === null || _data_title1 === void 0 ? void 0 : _data_title1.accessibility);
    return /* @__PURE__ */ React172.createElement(EGDSCard8, {
        "data-stid": "shopping-selectable-image-card-".concat(index),
        selected: selected
    }, /* @__PURE__ */ React172.createElement(EGDSImageLink6, null, /* @__PURE__ */ React172.createElement("button", {
        type: "button",
        onClick: handleClick
    }, accessibilityLabel && /* @__PURE__ */ React172.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel))), /* @__PURE__ */ React172.createElement(LodgingEGDSImage, {
        data: data.image,
        ratio: EGDSFigureAspectRatioType12.R1_1,
        lazyLoad: lazyLoad ? "lazy" : "off",
        fetchPriority: fetchPriority
    }), hasTitle && /* @__PURE__ */ React172.createElement(EGDSScrim2, {
        type: EGDSScrimType2.BOTTOM,
        "aria-hidden": true
    }, /* @__PURE__ */ React172.createElement(EGDSLayoutPosition13, {
        position: {
            left: "three",
            bottom: "three"
        }
    }, /* @__PURE__ */ React172.createElement(EGDSStylizedText, {
        data: data.title,
        theme: "light",
        overflow: "truncate-4-lines",
        wordBreak: true
    }))));
};
ShoppingSelectableImageCard.fragment = fragment109;
ShoppingSelectableImageCard.displayName = "ShoppingSelectableImageCard";
// src/components/common/client-side-analytics/intersection-tracker.tsx
import React173 from "react";
import { IntersectionTracker as IntersectionTracker14 } from "@shared-ui/clickstream-analytics-context";
var IntersectionTrackerWrapper = function(_param) {
    var children = _param.children, linkName = _param.linkName, referrerId = _param.referrerId, intersectionOptions = _param.intersectionOptions, rest = _object_without_properties(_param, [
        "children",
        "linkName",
        "referrerId",
        "intersectionOptions"
    ]);
    var trackerProps = _object_spread({
        intersectionOptions: intersectionOptions || {
            threshold: 0.5
        }
    }, rest);
    return referrerId && linkName ? /* @__PURE__ */ React173.createElement(IntersectionTracker14, _object_spread({
        linkName: linkName,
        referrerId: referrerId
    }, trackerProps), children) : /* @__PURE__ */ React173.createElement(React173.Fragment, null, " ", children, " ");
};
// src/components/lodging-more-info-trigger/lodging-more-info-trigger.tsx
import React174 from "react";
import { gql as gql137 } from "@apollo/client";
import { EGDSIcon as EGDSIcon30, EGDSIconSize as EGDSIconSize20 } from "@egds/react-core/icons";
import { EGDSLayoutPosition as EGDSLayoutPosition14 } from "@egds/react-core/layout-position";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger5 } from "@egds/react-core/more-info-trigger";
import { EGDSSpacing as EGDSSpacing46 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText31 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker42 } from "@shared-ui/clickstream-analytics-context";
import { useViewportMap as useViewportMap3, ViewSizes as ViewSizes3 } from "@shared-ui/viewport-context";
var fragment110 = gql137(_templateObject138());
var viewPortAlignments = {
    center: {
        type: "relative",
        position: {
            bottom: "one",
            left: "center"
        },
        cloneElement: true
    },
    left: {}
};
var _obj16;
var viewportLayoutPositionPropsMap = (_obj16 = {}, _define_property(_obj16, ViewSizes3.SMALL, viewPortAlignments.center), _define_property(_obj16, ViewSizes3.LARGE, viewPortAlignments.left), _obj16);
var LodgingMoreInfoTrigger = function(param) {
    var data = param.data, _param_fontWeight = param.fontWeight, fontWeight = _param_fontWeight === void 0 ? "bold" : _param_fontWeight, fontSize = param.fontSize, align = param.align;
    var _data_action, _data_action1, _data_action2, _data_action3;
    var clickTracker = useClickTracker42();
    var viewportBasedLayoutProps = useViewportMap3(viewportLayoutPositionPropsMap);
    var layoutPositionProps = align ? viewPortAlignments[align] : viewportBasedLayoutProps;
    if (!data.action || ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.resource.__typename) !== "HttpURI") {
        return null;
    }
    var path = data.action.useRelativePath ? (_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : _data_action1.resource.relativePath : data.action.resource.value;
    var triggerAnalytics = {
        id: ((_data_action2 = data.action) === null || _data_action2 === void 0 ? void 0 : _data_action2.analytics.referrerId) || "",
        description: ((_data_action3 = data.action) === null || _data_action3 === void 0 ? void 0 : _data_action3.analytics.linkName) || "",
        callback: function(id, desc) {
            return clickTracker(id, desc);
        }
    };
    return /* @__PURE__ */ React174.createElement(EGDSLayoutPosition14, _object_spread({}, layoutPositionProps), /* @__PURE__ */ React174.createElement(EGDSMoreInfoTrigger5, {
        size: "small",
        analytics: triggerAnalytics
    }, /* @__PURE__ */ React174.createElement("a", {
        href: path,
        target: "_blank",
        rel: "noopener"
    }, /* @__PURE__ */ React174.createElement(EGDSText31, {
        size: fontSize,
        weight: fontWeight
    }, data.text, data.action.accessibility && /* @__PURE__ */ React174.createElement("span", {
        className: "is-visually-hidden"
    }, data.action.accessibility), data.icon && /* @__PURE__ */ React174.createElement(EGDSSpacing46, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React174.createElement(EGDSIcon30, {
        id: data.icon.id || "info_outline",
        name: data.icon.id || "info_outline",
        description: data.icon.description || "",
        title: data.icon.title || "",
        "data-stid": "uitk-icon",
        size: EGDSIconSize20.SMALL
    }))))));
};
LodgingMoreInfoTrigger.fragment = fragment110;
LodgingMoreInfoTrigger.displayName = "LodgingMoreInfoTrigger";
// src/components/lodging-search-filter-pills/lodging-search-filter-pills.tsx
import React176 from "react";
import { gql as gql139 } from "@apollo/client";
import { EGDSPillContainer } from "@egds/react-core/pill";
// src/components/lodging-egds-removable-pill/lodging-egds-removable-pill.tsx
import React175 from "react";
import { gql as gql138 } from "@apollo/client";
import { EGDSRemovablePill } from "@egds/react-core/pill";
import { useClickTracker as useClickTracker43 } from "@shared-ui/clickstream-analytics-context";
var fragment111 = gql138(_templateObject139());
var LodgingEGDSRemovablePill = function(param) {
    var data = param.data, onClick = param.onClick, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var name = data.name, value = data.value, primary = data.primary, accessibility = data.accessibility, remove = data.remove, removeAnalytics = data.removeAnalytics;
    var clickTracker = useClickTracker43();
    var handleChange = function() {
        if (removeAnalytics) {
            var linkName = removeAnalytics.linkName, referrerId = removeAnalytics.referrerId;
            clickTracker(referrerId, linkName);
        }
        if (name && value) {
            var removablePill = {
                name: name,
                value: value
            };
            onClick === null || onClick === void 0 ? void 0 : onClick(removablePill);
        }
    };
    return /* @__PURE__ */ React175.createElement(EGDSRemovablePill, {
        id: "".concat(name, "-").concat(value),
        onClick: handleChange,
        value: value !== null && value !== void 0 ? value : "",
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        disabled: disabled,
        icon: (remove === null || remove === void 0 ? void 0 : remove.__typename) === "Icon" && remove.id ? remove.id : ""
    }, primary);
};
LodgingEGDSRemovablePill.fragment = fragment111;
LodgingEGDSRemovablePill.displayName = "LodgingEGDSRemovablePill";
// src/components/lodging-search-filter-pills/lodging-search-filter-pills.tsx
var __SearchFilterPillsFragment = gql139(_templateObject140(), LodgingEGDSRemovablePill.fragment);
var SearchFilterPills = function(param) {
    var data = param.data, onFilterPillRemoval = param.onFilterPillRemoval, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    if (!data || !data.filterPills) {
        return null;
    }
    var pills = data.filterPills.map(function(pill, index) {
        var _pill_filter;
        if (pill.__typename !== "BasicShoppingAppliedFilter" || ((_pill_filter = pill.filter) === null || _pill_filter === void 0 ? void 0 : _pill_filter.__typename) !== "EGDSBasicRemovablePill") {
            return null;
        }
        return /* @__PURE__ */ React176.createElement(LodgingEGDSRemovablePill, {
            key: "filterPill".concat(index),
            data: pill.filter,
            onClick: function() {
                return onFilterPillRemoval === null || onFilterPillRemoval === void 0 ? void 0 : onFilterPillRemoval(pill);
            },
            disabled: disabled
        });
    });
    return /* @__PURE__ */ React176.createElement(EGDSPillContainer, {
        wrap: true,
        align: "center"
    }, pills);
};
SearchFilterPills.displayName = "SearchFilterPills";
SearchFilterPills.fragment = __SearchFilterPillsFragment;
// src/components/lodging-message-card/message-result.tsx
import React178 from "react";
import { gql as gql141 } from "@apollo/client";
import { EGDSCard as EGDSCard9 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex38, EGDSLayoutFlexItem as EGDSLayoutFlexItem29 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink18 } from "@egds/react-core/link";
import { EGDSList as EGDSList5, EGDSListItem as EGDSListItem5 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing48 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading15, EGDSText as EGDSText32 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker44 } from "@shared-ui/clickstream-analytics-context";
// src/components/lodging-message-card/messaging-result-title-media.tsx
import React177 from "react";
import { gql as gql140 } from "@apollo/client";
import { EGDSIcon as EGDSIcon31, EGDSIconSize as EGDSIconSize21 } from "@egds/react-core/icons";
import { EGDSIllustrations as EGDSIllustrations2 } from "@egds/react-core/illustrations";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem28 } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark11, EGDSMarkSize as EGDSMarkSize9 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing47 } from "@egds/react-core/spacing";
var fragment112 = gql140(_templateObject141());
var MessagingResultTitleMedia = function(param) {
    var data = param.data;
    var _egdsMark_url, _illustration_assetUri;
    var egdsMark = data.egdsMark, icon = data.icon, illustration = data.illustration;
    if (!egdsMark && !icon && !illustration) {
        return null;
    }
    var graphic = egdsMark;
    var spotLight = (icon === null || icon === void 0 ? void 0 : icon.spotLight) ? icon.spotLight.toLowerCase() : void 0;
    var _egdsMark_url_value, _illustration_description, _illustration_assetUri_value;
    return /* @__PURE__ */ React177.createElement(React177.Fragment, null, graphic && /* @__PURE__ */ React177.createElement(EGDSMark11, {
        id: graphic.id,
        name: graphic.id,
        size: EGDSMarkSize9.MEDIUM_LARGE,
        description: graphic.description,
        url: (_egdsMark_url_value = egdsMark === null || egdsMark === void 0 ? void 0 : (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value) !== null && _egdsMark_url_value !== void 0 ? _egdsMark_url_value : ""
    }), icon && /* @__PURE__ */ React177.createElement(EGDSIcon31, {
        id: icon.id,
        title: icon.id,
        name: icon.id,
        size: EGDSIconSize21.MEDIUM,
        description: icon.description,
        spotlight: spotLight
    }), illustration && /* @__PURE__ */ React177.createElement(EGDSLayoutFlexItem28, {
        maxWidth: "18x"
    }, /* @__PURE__ */ React177.createElement(EGDSSpacing47, {
        padding: {
            block: "half"
        }
    }, /* @__PURE__ */ React177.createElement(EGDSIllustrations2, {
        alt: (_illustration_description = illustration.description) !== null && _illustration_description !== void 0 ? _illustration_description : "",
        url: (_illustration_assetUri_value = (_illustration_assetUri = illustration.assetUri) === null || _illustration_assetUri === void 0 ? void 0 : _illustration_assetUri.value) !== null && _illustration_assetUri_value !== void 0 ? _illustration_assetUri_value : ""
    }))));
};
MessagingResultTitleMedia.fragment = fragment112;
MessagingResultTitleMedia.displayName = "MessagingResultTitleMedia";
// src/components/lodging-message-card/message-result.tsx
var fragment113 = gql141(_templateObject142(), MessagingResultTitleMedia.fragment);
var getAnalytics = function(linkName, referrerId, trackClick) {
    if (linkName && referrerId) {
        return {
            id: referrerId,
            callback: function() {
                return trackClick(referrerId, linkName);
            }
        };
    }
    return void 0;
};
var getMessageGraphic = function(title, subtitle) {
    if (title && (title.icon || title.egdsMark || title.illustration)) {
        return title;
    }
    if (subtitle && (subtitle.icon || subtitle.egdsMark)) {
        return subtitle;
    }
    return void 0;
};
var getLinkTarget = function(action) {
    switch(action){
        case "EXTERNAL_LINK":
            return {
                target: "_blank"
            };
        default:
            return {};
    }
};
var MessageResult = function(param) {
    var className = param.className, data = param.data, primaryActionClickHandler = param.primaryActionClickHandler, secondaryActionClickHandler = param.secondaryActionClickHandler, liveAnnounceLevel = param.liveAnnounceLevel;
    var _primary_analytics, _secondary_analytics, _primary_analytics1, _secondary_analytics1, _primary_actionDetails;
    var title = data.title, subtitle = data.subtitle, action = data.action, footerText = data.footerText;
    var _ref = action || {}, primary = _ref.primary, secondary = _ref.secondary;
    var _primary_analytics_referrerId;
    var primaryReferrerId = (_primary_analytics_referrerId = primary === null || primary === void 0 ? void 0 : (_primary_analytics = primary.analytics) === null || _primary_analytics === void 0 ? void 0 : _primary_analytics.referrerId) !== null && _primary_analytics_referrerId !== void 0 ? _primary_analytics_referrerId : primary === null || primary === void 0 ? void 0 : primary.referrerId;
    var _secondary_analytics_referrerId;
    var secondaryReferrerId = (_secondary_analytics_referrerId = secondary === null || secondary === void 0 ? void 0 : (_secondary_analytics = secondary.analytics) === null || _secondary_analytics === void 0 ? void 0 : _secondary_analytics.referrerId) !== null && _secondary_analytics_referrerId !== void 0 ? _secondary_analytics_referrerId : secondary === null || secondary === void 0 ? void 0 : secondary.referrerId;
    var _primary_analytics_linkName;
    var primaryLinkName = (_primary_analytics_linkName = primary === null || primary === void 0 ? void 0 : (_primary_analytics1 = primary.analytics) === null || _primary_analytics1 === void 0 ? void 0 : _primary_analytics1.linkName) !== null && _primary_analytics_linkName !== void 0 ? _primary_analytics_linkName : primary === null || primary === void 0 ? void 0 : primary.text;
    var _secondary_analytics_linkName;
    var secondaryLinkName = (_secondary_analytics_linkName = secondary === null || secondary === void 0 ? void 0 : (_secondary_analytics1 = secondary.analytics) === null || _secondary_analytics1 === void 0 ? void 0 : _secondary_analytics1.linkName) !== null && _secondary_analytics_linkName !== void 0 ? _secondary_analytics_linkName : secondary === null || secondary === void 0 ? void 0 : secondary.text;
    var trackClick = useClickTracker44();
    if (!title && !subtitle) {
        return null;
    }
    var messageGraphic = getMessageGraphic(title, subtitle);
    var primaryLinkTargetAttributes = getLinkTarget(primary === null || primary === void 0 ? void 0 : (_primary_actionDetails = primary.actionDetails) === null || _primary_actionDetails === void 0 ? void 0 : _primary_actionDetails.action);
    return /* @__PURE__ */ React178.createElement(EGDSCard9, {
        padded: true,
        className: className
    }, /* @__PURE__ */ React178.createElement(EGDSLayoutFlex38, {
        alignItems: "center",
        "aria-live": liveAnnounceLevel,
        "data-stid": "lodging-message-card-message-result"
    }, messageGraphic && /* @__PURE__ */ React178.createElement(EGDSLayoutFlexItem29, null, /* @__PURE__ */ React178.createElement(EGDSSpacing48, {
        margin: {
            inlinestart: "half"
        }
    }, /* @__PURE__ */ React178.createElement("div", null, /* @__PURE__ */ React178.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    })))), /* @__PURE__ */ React178.createElement(EGDSSpacing48, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React178.createElement(EGDSLayoutFlexItem29, null, /* @__PURE__ */ React178.createElement("div", null, /* @__PURE__ */ React178.createElement(EGDSHeading15, {
        tag: "h3",
        size: 7
    }, title === null || title === void 0 ? void 0 : title.text), /* @__PURE__ */ React178.createElement(EGDSText32, {
        size: 300
    }, subtitle === null || subtitle === void 0 ? void 0 : subtitle.text), (primary || secondary) && /* @__PURE__ */ React178.createElement(EGDSList5, {
        bullet: "no-bullet",
        orientation: "inline",
        size: 2,
        spacing: true,
        type: "unordered"
    }, (primary === null || primary === void 0 ? void 0 : primary.linkUrl) && /* @__PURE__ */ React178.createElement(EGDSListItem5, null, /* @__PURE__ */ React178.createElement(EGDSLink18, {
        analytics: getAnalytics(primaryLinkName, primaryReferrerId, trackClick)
    }, /* @__PURE__ */ React178.createElement("a", _object_spread({
        href: primary.linkUrl
    }, primaryLinkTargetAttributes), primary.text))), (primary === null || primary === void 0 ? void 0 : primary.actionDetails) && (primary === null || primary === void 0 ? void 0 : primary.text) && primaryActionClickHandler && /* @__PURE__ */ React178.createElement(EGDSListItem5, null, /* @__PURE__ */ React178.createElement(EGDSText32, {
        align: "left"
    }, /* @__PURE__ */ React178.createElement(EGDSLink18, {
        onClick: primaryActionClickHandler,
        analytics: getAnalytics(primaryLinkName, primaryReferrerId, trackClick),
        inline: true
    }, /* @__PURE__ */ React178.createElement("button", {
        type: "button"
    }, primary.text)))), (secondary === null || secondary === void 0 ? void 0 : secondary.linkUrl) && /* @__PURE__ */ React178.createElement(EGDSListItem5, null, /* @__PURE__ */ React178.createElement(EGDSLink18, {
        analytics: getAnalytics(secondaryLinkName, secondaryReferrerId, trackClick)
    }, /* @__PURE__ */ React178.createElement("a", {
        href: secondary.linkUrl
    }, secondary.text))), (secondary === null || secondary === void 0 ? void 0 : secondary.actionDetails) && (secondary === null || secondary === void 0 ? void 0 : secondary.text) && /* @__PURE__ */ React178.createElement(EGDSListItem5, null, /* @__PURE__ */ React178.createElement(EGDSText32, {
        align: "left"
    }, /* @__PURE__ */ React178.createElement(EGDSLink18, {
        onClick: secondaryActionClickHandler,
        analytics: getAnalytics(secondaryLinkName, secondaryReferrerId, trackClick),
        inline: true
    }, /* @__PURE__ */ React178.createElement("button", {
        type: "button"
    }, secondary.text))))), footerText && /* @__PURE__ */ React178.createElement(EGDSText32, {
        align: "left",
        size: 100,
        spacing: "two"
    }, footerText))))));
};
MessageResult.fragment = fragment113;
MessageResult.displayName = "MessageResult";
// src/components/lodging-heading/lodging-heading.tsx
import React179 from "react";
import { gql as gql142 } from "@apollo/client";
import { EGDSHeading as EGDSHeading16 } from "@egds/react-core/text";
var fragment114 = gql142(_templateObject143());
var LodgingHeading = function(param) {
    var tag = param.tag, size = param.size, className = param.className, data = param.data;
    var value = data.value;
    return /* @__PURE__ */ React179.createElement(EGDSHeading16, {
        tag: tag,
        size: size,
        className: className
    }, value);
};
LodgingHeading.fragment = fragment114;
LodgingHeading.displayName = "LodgingHeading";
// src/components/lodging-intent-card/lodging-intent-card.tsx
import React181 from "react";
import { gql as gql144 } from "@apollo/client";
import { EGDSCard as EGDSCard10, EGDSCardContentSection as EGDSCardContentSection11 } from "@egds/react-core/cards";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType13 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid15, EGDSLayoutGridItem as EGDSLayoutGridItem11 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing50 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading17, EGDSText as EGDSText33 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker15 } from "@shared-ui/clickstream-analytics-context";
// src/components/lodging-intent-card/__private/lodging-intent-button.tsx
import React180 from "react";
import { gql as gql143 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton6 } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing49 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker45 } from "@shared-ui/clickstream-analytics-context";
var fragment115 = gql143(_templateObject144());
var LodgingIntentButton = function(param) {
    var data = param.data, onClickButton = param.onClickButton;
    var track = useClickTracker45();
    var onClickCapture = function() {
        var _data_action;
        if ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.analytics) {
            track(data.action.analytics.referrerId, data.action.analytics.linkName);
        }
    };
    return /* @__PURE__ */ React180.createElement(EGDSSpacing49, {
        margin: {
            small: {
                blockstart: "three",
                blockend: "four"
            },
            medium: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React180.createElement(EGDSPrimaryButton6, {
        type: "button",
        onClickCapture: onClickCapture,
        onClick: onClickButton
    }, data.primary));
};
LodgingIntentButton.fragment = fragment115;
LodgingIntentButton.displayName = "LodgingIntentButton";
// src/components/lodging-intent-card/lodging-intent-card.tsx
var fragment116 = gql144(_templateObject145(), LodgingMediaItem.fragment, LodgingIntentButton.fragment);
var LodgingIntentCard = function(param) {
    var data = param.data, onClickButton = param.onClickButton;
    var headingTitle = data.headingTitle, cardMessage = data.cardMessage, gallery = data.gallery, primaryButton = data.primaryButton, impressionAnalyticsTracking = data.impressionAnalyticsTracking;
    return /* @__PURE__ */ React181.createElement(IntersectionTracker15, {
        referrerId: impressionAnalyticsTracking.referrerId,
        linkName: impressionAnalyticsTracking.event
    }, /* @__PURE__ */ React181.createElement(EGDSCard10, null, /* @__PURE__ */ React181.createElement(EGDSLayoutGrid15, {
        columns: {
            medium: 2,
            large: 12
        }
    }, /* @__PURE__ */ React181.createElement(EGDSLayoutGridItem11, {
        colSpan: {
            medium: 1,
            large: 7
        },
        rowStart: {
            small: 2,
            medium: 1
        }
    }, /* @__PURE__ */ React181.createElement(EGDSSpacing50, {
        padding: {
            medium: {
                block: "two",
                inline: "four"
            }
        },
        margin: {
            medium: "three"
        }
    }, /* @__PURE__ */ React181.createElement(EGDSCardContentSection11, null, headingTitle && /* @__PURE__ */ React181.createElement(EGDSHeading17, {
        size: 5
    }, headingTitle), cardMessage && /* @__PURE__ */ React181.createElement(EGDSSpacing50, {
        margin: {
            large: {
                inlineend: "six"
            }
        }
    }, /* @__PURE__ */ React181.createElement(EGDSText33, {
        size: 300,
        spacing: "two"
    }, cardMessage)), primaryButton && /* @__PURE__ */ React181.createElement(LodgingIntentButton, {
        onClickButton: onClickButton,
        data: primaryButton
    })))), gallery.media[0] && /* @__PURE__ */ React181.createElement(EGDSLayoutGridItem11, {
        colSpan: {
            medium: 1,
            large: 5
        }
    }, gallery.media.length && /* @__PURE__ */ React181.createElement(LodgingMediaItem, {
        ratio: EGDSFigureAspectRatioType13.R21_9,
        data: gallery.media[0]
    })))));
};
LodgingIntentCard.displayName = "LodgingIntentCard";
LodgingIntentCard.fragment = fragment116;
// src/components/lodging-sparkle-banner/lodging-sparkle-banner.tsx
import React182 from "react";
import { gql as gql145 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize6, EGDSPrimaryButton as EGDSPrimaryButton7 } from "@egds/react-core/button";
import { EGDSCardBrandTheme, EGDSCardContentSection as EGDSCardContentSection12 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex39, EGDSLayoutFlexItem as EGDSLayoutFlexItem30 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid16, EGDSLayoutGridItem as EGDSLayoutGridItem12 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing51 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading18, EGDSText as EGDSText34 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium15, Viewport as Viewport17, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
var fragment117 = gql145(_templateObject146(), MessagingResultTitleMedia.fragment);
var getMessageGraphic2 = function(title) {
    return (title === null || title === void 0 ? void 0 : title.egdsMark) || (title === null || title === void 0 ? void 0 : title.illustration) ? title : void 0;
};
var SparkleBanner = function(param) {
    var className = param.className, data = param.data, liveAnnounceLevel = param.liveAnnounceLevel, bannerToAddMargin = param.bannerToAddMargin;
    var action = data.action, title = data.title, type = data.type;
    var primary = (action || {}).primary;
    var bannerTheme;
    var buttonTheme;
    var buttonTextColor = type === "BRANDED_THEME_ACCENT" ? "loyalty" : "inverse";
    if (type === "BRANDED_THEME_ACCENT") {
        bannerTheme = "accent";
        buttonTheme = true;
    } else {
        bannerTheme = "dark";
        buttonTheme = false;
    }
    var messageGraphic = getMessageGraphic2(title);
    var shouldAddMargin = bannerToAddMargin === "sparklePDP";
    return /* @__PURE__ */ React182.createElement("div", {
        "data-stid": "lodging-sparkle-banner-message-result-".concat(bannerTheme),
        role: "presentation"
    }, /* @__PURE__ */ React182.createElement(EGDSSpacing51, {
        margin: shouldAddMargin ? {
            small: "three",
            medium: "unset",
            large: "unset"
        } : "unset"
    }, /* @__PURE__ */ React182.createElement(EGDSCardBrandTheme, {
        brandTheme: bannerTheme,
        className: className,
        "aria-live": liveAnnounceLevel
    }, /* @__PURE__ */ React182.createElement(EGDSSpacing51, {
        padding: {
            inlinestart: "three",
            inlineend: "three",
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React182.createElement(EGDSLayoutGrid16, {
        alignItems: "center",
        autoColumns: [
            "minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"
        ],
        columns: [
            "0fr",
            "1fr",
            "max-content"
        ],
        display: "grid"
    }, /* @__PURE__ */ React182.createElement(EGDSLayoutGridItem12, {
        alignSelf: "start"
    }, /* @__PURE__ */ React182.createElement(EGDSCardContentSection12, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, messageGraphic && /* @__PURE__ */ React182.createElement(EGDSSpacing51, {
        margin: shouldAddMargin ? {
            inlinestart: "half"
        } : "unset"
    }, /* @__PURE__ */ React182.createElement("div", null, /* @__PURE__ */ React182.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    }))))), /* @__PURE__ */ React182.createElement(EGDSLayoutFlex39, {
        wrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React182.createElement(EGDSLayoutFlexItem30, {
        grow: 1,
        maxWidth: "180x",
        alignSelf: "center"
    }, /* @__PURE__ */ React182.createElement(EGDSCardContentSection12, {
        padded: true
    }, /* @__PURE__ */ React182.createElement(Viewport17, null, /* @__PURE__ */ React182.createElement(ViewSmall16, null, /* @__PURE__ */ React182.createElement(EGDSHeading18, {
        size: 7
    }, title === null || title === void 0 ? void 0 : title.text)), /* @__PURE__ */ React182.createElement(ViewMedium15, null, /* @__PURE__ */ React182.createElement(EGDSSpacing51, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React182.createElement(EGDSHeading18, {
        size: 6
    }, title === null || title === void 0 ? void 0 : title.text)))))), /* @__PURE__ */ React182.createElement(EGDSLayoutGrid16, null, (primary === null || primary === void 0 ? void 0 : primary.linkUrl) && /* @__PURE__ */ React182.createElement(EGDSLayoutFlexItem30, {
        alignSelf: "center"
    }, /* @__PURE__ */ React182.createElement(EGDSCardContentSection12, null, /* @__PURE__ */ React182.createElement(EGDSSpacing51, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React182.createElement(EGDSPrimaryButton7, {
        href: primary === null || primary === void 0 ? void 0 : primary.linkUrl,
        inverse: buttonTheme,
        size: EGDSButtonSize6.SMALL
    }, /* @__PURE__ */ React182.createElement(EGDSText34, {
        theme: buttonTextColor
    }, primary.text))))))))))));
};
SparkleBanner.fragment = fragment117;
SparkleBanner.displayName = "SparkleBanner";
// src/components/lodging-header/lodging-header.tsx
import React183 from "react";
import { gql as gql146 } from "@apollo/client";
import { EGDSHeading as EGDSHeading19, EGDSText as EGDSText35 } from "@egds/react-core/text";
var fragment118 = gql146(_templateObject147());
var LodgingHeader = function(param) {
    var _param_tag = param.tag, tag = _param_tag === void 0 ? "h4" : _param_tag, _param_size = param.size, size = _param_size === void 0 ? 7 : _param_size, _param_accessibilityTag = param.accessibilityTag, accessibilityTag = _param_accessibilityTag === void 0 ? tag : _param_accessibilityTag, data = param.data;
    var text = data.text, label = data.label, subText = data.subText, accessibilityLabel = data.accessibilityLabel;
    return /* @__PURE__ */ React183.createElement(React183.Fragment, null, subText && /* @__PURE__ */ React183.createElement(EGDSText35, {
        size: 200,
        theme: "standard"
    }, subText), text && /* @__PURE__ */ React183.createElement(EGDSHeading19, {
        tag: tag,
        size: size,
        overflow: "truncate-2-lines"
    }, text), accessibilityLabel && /* @__PURE__ */ React183.createElement(EGDSHeading19, {
        tag: accessibilityTag,
        className: "is-visually-hidden"
    }, accessibilityLabel), label && /* @__PURE__ */ React183.createElement(EGDSText35, {
        size: 200,
        theme: "standard"
    }, label));
};
LodgingHeader.fragment = fragment118;
LodgingHeader.displayName = "LodgingHeaderFragment";
// src/components/lodging-detailed-timeline/lodging-detailed-timeline.tsx
import React189 from "react";
import { gql as gql152 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing54 } from "@egds/react-core/spacing";
import { EGDSTab as EGDSTab2, EGDSTabs as EGDSTabs2, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading20 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker46 } from "@shared-ui/clickstream-analytics-context";
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy.tsx
import React188 from "react";
import { gql as gql151 } from "@apollo/client";
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-messages.tsx
import React186 from "react";
import { gql as gql149 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid17, EGDSLayoutGridItem as EGDSLayoutGridItem13 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing52 } from "@egds/react-core/spacing";
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-primary-info.tsx
import React184 from "react";
import { gql as gql147 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex40 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText36 } from "@egds/react-core/text";
var __LodgingCancellationPolicyPrimaryInfoFragment = gql147(_templateObject148());
var LodgingCancellationPolicyPrimaryInfo = function(param) {
    var data = param.data;
    var heading = data.heading, subheading = data.subheading;
    return /* @__PURE__ */ React184.createElement(EGDSLayoutFlex40, {
        direction: "column"
    }, /* @__PURE__ */ React184.createElement(EGDSText36, {
        size: 200,
        weight: "medium",
        theme: "emphasis"
    }, heading.text), /* @__PURE__ */ React184.createElement(EGDSText36, {
        size: 400,
        weight: "medium",
        theme: "emphasis"
    }, subheading.text));
};
LodgingCancellationPolicyPrimaryInfo.displayName = "LodgingCancellationPolicyPrimaryInfo";
LodgingCancellationPolicyPrimaryInfo.fragment = __LodgingCancellationPolicyPrimaryInfoFragment;
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-secondary-info.tsx
import React185 from "react";
import { gql as gql148 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex41 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText37 } from "@egds/react-core/text";
var __LodgingCancellationPolicySecondaryInfoFragment = gql148(_templateObject149());
var LodgingCancellationPolicySecondaryInfo = function(param) {
    var data = param.data;
    var title = data.title, message = data.message;
    return /* @__PURE__ */ React185.createElement(EGDSLayoutFlex41, {
        direction: "column"
    }, (title === null || title === void 0 ? void 0 : title.text) && // emphasis is being deprecated and will be removed. Use weight="bold" if you need boldness
    /* @__PURE__ */ React185.createElement(EGDSText37, {
        size: 400,
        weight: "medium",
        theme: "emphasis"
    }, title.text), /* @__PURE__ */ React185.createElement(EGDSText37, {
        size: 200,
        theme: "standard",
        weight: "regular",
        spacing: "one"
    }, message));
};
LodgingCancellationPolicySecondaryInfo.displayName = "LodgingCancellationPolicySecondaryInfo";
LodgingCancellationPolicySecondaryInfo.fragment = __LodgingCancellationPolicySecondaryInfoFragment;
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-messages.tsx
var Separator = function(param) {
    var index = param.index, messageSectionLength = param.messageSectionLength;
    if (index === messageSectionLength - 1) {
        return null;
    }
    return /* @__PURE__ */ React186.createElement(EGDSLayoutGridItem13, {
        colSpan: "all"
    }, /* @__PURE__ */ React186.createElement(EGDSSpacing52, {
        border: [
            "blockend"
        ],
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React186.createElement("div", null)));
};
Separator.displayName = "Separator";
var __LodgingCancellationPolicyMessagesFragment = gql149(_templateObject150(), LodgingCancellationPolicyPrimaryInfo.fragment, LodgingCancellationPolicySecondaryInfo.fragment);
var LodgingCancellationPolicyMessages = function(param) {
    var data = param.data;
    var messageSections = data.messageSections;
    return /* @__PURE__ */ React186.createElement(EGDSSpacing52, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React186.createElement(EGDSLayoutGrid17, {
        columns: [
            "24x",
            "1fr"
        ],
        space: {
            column: "four"
        }
    }, messageSections.map(function(messageSection, index) {
        return /* @__PURE__ */ React186.createElement(React186.Fragment, {
            key: index
        }, /* @__PURE__ */ React186.createElement(EGDSLayoutGridItem13, {
            colStart: 1
        }, /* @__PURE__ */ React186.createElement(EGDSSpacing52, null, /* @__PURE__ */ React186.createElement(LodgingCancellationPolicyPrimaryInfo, {
            data: messageSection.primaryInfo
        }))), /* @__PURE__ */ React186.createElement(EGDSLayoutGridItem13, {
            colStart: 2
        }, /* @__PURE__ */ React186.createElement(EGDSSpacing52, null, /* @__PURE__ */ React186.createElement(LodgingCancellationPolicySecondaryInfo, {
            data: messageSection.secondaryInfo
        }))), /* @__PURE__ */ React186.createElement(Separator, {
            index: index,
            messageSectionLength: messageSections.length
        }));
    })));
};
LodgingCancellationPolicyMessages.displayName = "LodgingCancellationPolicyMessages";
LodgingCancellationPolicyMessages.fragment = __LodgingCancellationPolicyMessagesFragment;
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy-step-indicator.tsx
import React187 from "react";
import { gql as gql150 } from "@apollo/client";
import { EGDSCard as EGDSCard11, EGDSCardContentSection as EGDSCardContentSection13 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex42 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing53 } from "@egds/react-core/spacing";
import { StepIndicator } from "@egds/react-lodging";
import { ViewMedium as ViewMedium16, Viewport as Viewport18, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
var LodgingCancellationPolicyStepIndicatorFragment = gql150(_templateObject151());
var LodgingCancellationPolicyStepIndicator = function(param) {
    var data = param.data;
    var steppers = data.steppers;
    if (steppers.length === 0) {
        return null;
    }
    var steps = steppers.map(function(step) {
        var _step_track_text, _step_track, _step_track_text1, _step_track1;
        var _step_track_text_accessibility;
        return {
            label: step.text.text,
            trackLabelText: step === null || step === void 0 ? void 0 : (_step_track = step.track) === null || _step_track === void 0 ? void 0 : (_step_track_text = _step_track.text) === null || _step_track_text === void 0 ? void 0 : _step_track_text.text,
            trackLabelA11y: (_step_track_text_accessibility = step === null || step === void 0 ? void 0 : (_step_track1 = step.track) === null || _step_track1 === void 0 ? void 0 : (_step_track_text1 = _step_track1.text) === null || _step_track_text1 === void 0 ? void 0 : _step_track_text1.accessibility) !== null && _step_track_text_accessibility !== void 0 ? _step_track_text_accessibility : void 0
        };
    });
    var activeStepIndex = steppers.findIndex(function(step) {
        return step.state === "CURRENT" /* CURRENT */ ;
    }) + 1;
    return /* @__PURE__ */ React187.createElement("section", {
        "aria-label": data.accessibilityLabel
    }, /* @__PURE__ */ React187.createElement(EGDSCard11, {
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React187.createElement(EGDSSpacing53, {
        margin: {
            block: "three"
        },
        padding: {
            block: "six"
        }
    }, /* @__PURE__ */ React187.createElement(EGDSCardContentSection13, null, /* @__PURE__ */ React187.createElement(Viewport18, null, /* @__PURE__ */ React187.createElement(ViewSmall17, null, /* @__PURE__ */ React187.createElement(EGDSLayoutFlex42, {
        justifyContent: "center"
    }, /* @__PURE__ */ React187.createElement(StepIndicator, {
        steps: steps,
        activeStep: activeStepIndex,
        direction: "vertical"
    }))), /* @__PURE__ */ React187.createElement(ViewMedium16, null, /* @__PURE__ */ React187.createElement(StepIndicator, {
        steps: steps,
        activeStep: activeStepIndex,
        direction: "horizontal"
    })))))));
};
LodgingCancellationPolicyStepIndicator.displayName = "LodgingCancellationPolicyStepIndicator";
LodgingCancellationPolicyStepIndicator.fragment = LodgingCancellationPolicyStepIndicatorFragment;
// src/components/lodging-detailed-timeline/__private/lodging-cancellation-policy.tsx
var __LodgingCancellationPolicyFragment = gql151(_templateObject152(), LodgingCancellationPolicyMessages.fragment, LodgingCancellationPolicyStepIndicator.fragment);
var LodgingCancellationPolicy = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React188.createElement(React188.Fragment, null, /* @__PURE__ */ React188.createElement(LodgingCancellationPolicyStepIndicator, {
        data: data.stepIndicator
    }), /* @__PURE__ */ React188.createElement(LodgingCancellationPolicyMessages, {
        data: data
    }));
};
LodgingCancellationPolicy.displayName = "LodgingCancellationPolicy";
LodgingCancellationPolicy.fragment = __LodgingCancellationPolicyFragment;
// src/components/lodging-detailed-timeline/lodging-detailed-timeline.tsx
var __LodgingDetailedTimelineFragment = gql152(_templateObject153(), LodgingCancellationPolicy.fragment);
var LodgingDetailedTimeline = function(param) {
    var data = param.data;
    var policies = data.policies, title = data.title;
    var _React189_useState = _sliced_to_array(React189.useState(0), 2), activeTab = _React189_useState[0], setTabSelection = _React189_useState[1];
    var clickTracker = useClickTracker46();
    var trackTabClickAnalytics = React189.useCallback(function(analytics) {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        clickTracker
    ]);
    var handleTabChange = function(tabIndex) {
        var _policies_tabIndex;
        setTabSelection(tabIndex);
        trackTabClickAnalytics((_policies_tabIndex = policies[tabIndex]) === null || _policies_tabIndex === void 0 ? void 0 : _policies_tabIndex.policyClientSideAnalytics);
    };
    if (policies.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React189.createElement(React189.Fragment, null, (title === null || title === void 0 ? void 0 : title.text) && /* @__PURE__ */ React189.createElement(EGDSHeading20, {
        tag: "h3",
        size: 3
    }, title.text), /* @__PURE__ */ React189.createElement(EGDSSpacing54, {
        margin: {
            block: "three"
        }
    }, policies.length > 1 ? /* @__PURE__ */ React189.createElement(EGDSTabs2, {
        selectedTab: activeTab,
        onTabSelect: handleTabChange,
        tabsType: EGDSTabsType.NATURAL,
        withBorder: false
    }, policies.map(function(policy, index) {
        var _policy_title;
        return policy.title && /* @__PURE__ */ React189.createElement(EGDSTab2, {
            key: "tab-key-".concat(index),
            targetURI: "#",
            name: policy === null || policy === void 0 ? void 0 : (_policy_title = policy.title) === null || _policy_title === void 0 ? void 0 : _policy_title.text,
            id: "tab-id-".concat(index)
        }, /* @__PURE__ */ React189.createElement(LodgingCancellationPolicy, {
            data: policy,
            key: "LodgingCancellationPolicy-".concat(index)
        }));
    })) : policies[0] && /* @__PURE__ */ React189.createElement(LodgingCancellationPolicy, {
        data: policies[0],
        key: "LodgingCancellationPolicy-0"
    })));
};
LodgingDetailedTimeline.displayName = "LodgingDetailedTimeline";
LodgingDetailedTimeline.fragment = __LodgingDetailedTimelineFragment;
// src/components/lodging-micro-card/lodging-micro-card.tsx
import React191 from "react";
import { gql as gql154 } from "@apollo/client";
import { UitkCard } from "@egds/react-core/cards";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "@egds/react-core/images";
import { UitkLayoutGrid, UitkLayoutGridItem } from "@egds/react-core/layout-grid";
import { UitkSpacing as UitkSpacing2 } from "@egds/react-core/spacing";
import { UitkHeading } from "@egds/react-core/text";
// src/components/lodging-micro-card/lodging-micro-card-text.tsx
import React190 from "react";
import { gql as gql153 } from "@apollo/client";
var fragment119 = gql153(_templateObject154(), LodgingEGDSGraphicText.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment);
var LodgingMicroCardText = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React190.createElement(EGDSPlainText, {
                size: 300,
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React190.createElement(EGDSStylizedText, {
                size: 300,
                data: data
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React190.createElement(LodgingEGDSGraphicText, {
                customTextSize: 300,
                data: data
            });
        default:
            return null;
    }
};
LodgingMicroCardText.fragment = fragment119;
LodgingMicroCardText.displayName = "LodgingMicroCardText";
// src/components/lodging-micro-card/lodging-micro-card.tsx
var fragment120 = gql154(_templateObject155(), LodgingMicroCardText.fragment);
var LodgingMicroCard = function(param) {
    var data = param.data;
    var image = data.image, contents = data.contents, heading = data.heading;
    return /* @__PURE__ */ React191.createElement(UitkCard, {
        border: true
    }, /* @__PURE__ */ React191.createElement(UitkLayoutGrid, {
        columns: 3
    }, /* @__PURE__ */ React191.createElement(UitkLayoutGridItem, {
        colSpan: 1
    }, /* @__PURE__ */ React191.createElement(UitkFigure2, {
        ratio: UitkFigureAspectRatioType2.R3_2
    }, /* @__PURE__ */ React191.createElement(UitkImage, {
        placeholderImage: true,
        src: image === null || image === void 0 ? void 0 : image.url,
        alt: image === null || image === void 0 ? void 0 : image.description
    }))), /* @__PURE__ */ React191.createElement(UitkLayoutGridItem, {
        colSpan: 2
    }, /* @__PURE__ */ React191.createElement(UitkSpacing2, {
        margin: {
            inline: "four",
            blockstart: "four",
            blockend: "two"
        }
    }, /* @__PURE__ */ React191.createElement("div", null, /* @__PURE__ */ React191.createElement(UitkSpacing2, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React191.createElement(UitkHeading, {
        tag: "h3"
    }, heading)), contents.map(function(content, index) {
        return /* @__PURE__ */ React191.createElement(UitkSpacing2, {
            key: "lodging-micro-card-text-".concat(index),
            margin: {
                blockend: "two"
            }
        }, /* @__PURE__ */ React191.createElement("div", null, /* @__PURE__ */ React191.createElement(LodgingMicroCardText, {
            data: content
        })));
    }))))));
};
LodgingMicroCard.fragment = fragment120;
LodgingMicroCard.displayName = "LodgingMicroCard";
// src/components/lodging-change-loader/lodging-change-loader.tsx
import React192 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid18 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition15 } from "@egds/react-core/layout-position";
import { EGDSLoader } from "@egds/react-core/loader";
var componentPosition = {
    position: {
        top: "center",
        left: "center"
    }
};
var gridRowSpacing = [
    "120x"
];
var LodgingChangeLoader = function() {
    return /* @__PURE__ */ React192.createElement(EGDSLayoutGrid18, {
        rows: gridRowSpacing,
        justifyItems: "center"
    }, /* @__PURE__ */ React192.createElement("div", {
        "data-stid": "lodging-change-loader"
    }, /* @__PURE__ */ React192.createElement(EGDSLayoutPosition15, {
        type: "relative",
        position: componentPosition.position,
        display: "block"
    }, /* @__PURE__ */ React192.createElement(EGDSLoader, null))));
};
// src/components/egds/egds-expando-card/egds-expando-card.tsx
import React193 from "react";
import { gql as gql155 } from "@apollo/client";
import { EGDSCard as EGDSCard12 } from "@egds/react-core/cards";
import { EGDSExpandoList as EGDSExpandoList2, EGDSExpandoListItem as EGDSExpandoListItem2 } from "@egds/react-core/expando";
import { EGDSSpacing as EGDSSpacing55 } from "@egds/react-core/spacing";
import { EGDSSubheading, EGDSText as EGDSText38 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker47 } from "@shared-ui/clickstream-analytics-context";
var expandoCardFragment = gql155(_templateObject156());
var EGDSExpandoCard = function(param) {
    var children = param.children, data = param.data, expandoTitleMoreInfoTrigger = param.expandoTitleMoreInfoTrigger, className = param.className, padding = param.padding, titleSize = param.titleSize, titleWeight = param.titleWeight, isIndented = param.isIndented, id = param.id, hasBorder = param.hasBorder;
    var expandAnalytics = data.expandAnalytics, expandedLabel = data.expandedLabel, collapseAnalytics = data.collapseAnalytics, collapsedLabel = data.collapsedLabel, expanded = data.expanded, subtitle = data.subtitle;
    var clickTracker = useClickTracker47();
    var _React193_useState = _sliced_to_array(React193.useState(expanded), 2), isVisible = _React193_useState[0], setIsVisible = _React193_useState[1];
    var _React193_useState1 = _sliced_to_array(React193.useState(expanded ? expandedLabel : collapsedLabel), 2), label = _React193_useState1[0], setLabel = _React193_useState1[1];
    var analytics;
    if (collapseAnalytics && expandAnalytics) {
        analytics = {
            id: isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId,
            description: isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName,
            callback: function(referrerId, linkName) {
                clickTracker(referrerId, linkName);
            }
        };
    }
    var onToggle = React193.useCallback(function() {
        if (isVisible) {
            setLabel(collapsedLabel);
        } else {
            setLabel(expandedLabel);
        }
        setIsVisible(!isVisible);
    }, [
        isVisible,
        collapsedLabel,
        expandedLabel
    ]);
    return /* @__PURE__ */ React193.createElement(EGDSCard12, {
        border: hasBorder
    }, /* @__PURE__ */ React193.createElement(EGDSSpacing55, {
        padding: padding || "six"
    }, /* @__PURE__ */ React193.createElement(EGDSExpandoList2, null, /* @__PURE__ */ React193.createElement(EGDSExpandoListItem2, {
        "data-stid": "".concat(id, "-list-item"),
        analytics: analytics,
        className: className,
        isVisible: isVisible,
        onToggle: onToggle,
        isIndented: isIndented,
        expandoTitle: /* @__PURE__ */ React193.createElement(React193.Fragment, null, /* @__PURE__ */ React193.createElement(EGDSText38, {
            size: titleSize,
            weight: titleWeight
        }, label, expandoTitleMoreInfoTrigger), subtitle && /* @__PURE__ */ React193.createElement(EGDSSpacing55, {
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React193.createElement(EGDSSubheading, {
            tag: "h2"
        }, /* @__PURE__ */ React193.createElement(EGDSText38, {
            size: 200
        }, subtitle)))),
        expandoDescription: children,
        triggerPosition: "trailing"
    }))));
};
EGDSExpandoCard.fragment = expandoCardFragment;
EGDSExpandoCard.displayName = "EGDSExpandoCard";
// src/components/egds/egds-dialog/egds-dialog.tsx
import React195 from "react";
import { gql as gql157 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition18 } from "@egds/react-core/sheet";
import { useDialog as useDialog17 } from "@shared-ui/dialog-context";
// src/components/egds/egds-dialog/egds-action-dialog.tsx
import React194 from "react";
import { gql as gql156 } from "@apollo/client";
import { EGDSDialog as EGDSDialog5, EGDSDialogContent as EGDSDialogContent9, EGDSDialogFooter as EGDSDialogFooter5 } from "@egds/react-core/dialog";
import { EGDSHeading as EGDSHeading21, EGDSParagraph as EGDSParagraph4 } from "@egds/react-core/text";
import { useClickstreamAnalytics as useClickstreamAnalytics8 } from "@shared-ui/clickstream-analytics-context";
var fragment121 = gql156(_templateObject157());
var EGDSActionDialog = function(param) {
    var data = param.data, actionsCallback = param.actionsCallback, closeDialog = param.closeDialog, content = param.content, title = param.title;
    var clickstreamAnalytics = useClickstreamAnalytics8();
    var _obj;
    var EGDSParagraphSizeMap2 = (_obj = {}, _define_property(_obj, "P1" /* P1 */ , 1), _define_property(_obj, "P2" /* P2 */ , 2), _define_property(_obj, "P3" /* P3 */ , 3), _obj);
    var _data_footer = data.footer, __typename = _data_footer.__typename, buttons = _data_footer.buttons;
    var handleLinkButtonClick = function(url) {
        window.location.replace(url);
    };
    var handleDialogTriggerClick = function(action) {
        trackAnalyticsList(clickstreamAnalytics, action === null || action === void 0 ? void 0 : action.analytics);
        if (actionsCallback) {
            actionsCallback(action);
        } else {
            closeDialog();
        }
    };
    var handleActionButtonClick = function(analytics) {
        trackAnalyticsList(clickstreamAnalytics, analytics);
        closeDialog();
    };
    var _buttons_map = _sliced_to_array(buttons.map(function(currentButton) {
        if (currentButton.__typename === "UITertiaryButton") {
            var _currentButton_action;
            var primary2 = currentButton.primary;
            var tertiaryBtn = {
                text: primary2,
                type: "tertiary",
                onClick: function() {
                    return handleDialogTriggerClick(currentButton);
                }
            };
            if ((currentButton === null || currentButton === void 0 ? void 0 : (_currentButton_action = currentButton.action) === null || _currentButton_action === void 0 ? void 0 : _currentButton_action.__typename) === "UILinkAction") {
                var _currentButton_action1;
                var url = currentButton === null || currentButton === void 0 ? void 0 : (_currentButton_action1 = currentButton.action) === null || _currentButton_action1 === void 0 ? void 0 : _currentButton_action1.resource.value;
                tertiaryBtn.onClick = function() {
                    return handleLinkButtonClick(url);
                };
            }
            return tertiaryBtn;
        }
        var primary = currentButton.primary;
        return {
            text: primary,
            type: "primary",
            onClick: function() {
                var _currentButton_action;
                return handleActionButtonClick((_currentButton_action = currentButton.action) === null || _currentButton_action === void 0 ? void 0 : _currentButton_action.analytics);
            }
        };
    }), 3), buttonOne = _buttons_map[0], buttonTwo = _buttons_map[1], buttonThree = _buttons_map[2];
    return /* @__PURE__ */ React194.createElement(EGDSDialog5, {
        dialogShow: true,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React194.createElement(EGDSDialogContent9, null, /* @__PURE__ */ React194.createElement(EGDSHeading21, {
        size: 5,
        key: "dialogHeading"
    }, title), /* @__PURE__ */ React194.createElement(EGDSParagraph4, {
        key: "dialogParagraph",
        size: EGDSParagraphSizeMap2[content.style]
    }, content.text), /* @__PURE__ */ React194.createElement(EGDSDialogFooter5, {
        stacked: __typename === "EGDSStackedDialogFooter",
        buttonOne: buttonOne,
        buttonTwo: buttonTwo,
        buttonThree: buttonThree
    })));
};
EGDSActionDialog.fragment = fragment121;
EGDSActionDialog.displayName = "EGDSActionDialog";
// src/components/egds/egds-dialog/egds-dialog.tsx
var fragment122 = gql157(_templateObject158(), EGDSActionDialog.fragment);
var SharedUIDialog = function(param) {
    var data = param.data, title = param.title, dialogId = param.dialogId, dialogContent = param.dialogContent, handleActionsCallback = param.handleActionsCallback;
    var _useDialog17 = _sliced_to_array(useDialog17(dialogId), 3), isDialogOpen = _useDialog17[0], dialogActions = _useDialog17[1], DialogComponent = _useDialog17[2];
    var closeDialog = function() {
        dialogActions.closeDialog();
    };
    if (!dialogContent) {
        return null;
    }
    return /* @__PURE__ */ React195.createElement("div", {
        "data-stid": dialogId
    }, /* @__PURE__ */ React195.createElement(EGDSSheetTransition18, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React195.createElement(DialogComponent, null, /* @__PURE__ */ React195.createElement(EGDSActionDialog, {
        data: data,
        content: dialogContent,
        closeDialog: closeDialog,
        title: title,
        actionsCallback: handleActionsCallback
    }))));
};
SharedUIDialog.fragment = fragment122;
SharedUIDialog.displayName = "EGDSDialog";
// src/components/egds/egds-text/egds-paragraph.tsx
import React196 from "react";
import { gql as gql158 } from "@apollo/client";
import { EGDSParagraph as EGDSParagraph5 } from "@egds/react-core/text";
var fragment123 = gql158(_templateObject159());
var _obj17;
var EGDSParagraphSizeMap = (_obj17 = {}, _define_property(_obj17, "P1" /* P1 */ , 1), _define_property(_obj17, "P2" /* P2 */ , 2), _define_property(_obj17, "P3" /* P3 */ , 3), _obj17);
var SharedUIParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React196.createElement(EGDSParagraph5, {
        size: EGDSParagraphSizeMap[data.style]
    }, data.text);
};
SharedUIParagraph.fragment = fragment123;
SharedUIParagraph.displayName = "EGDSParagraph";
// src/components/egds/egds-standard-message/egds-standard-message.tsx
import React197 from "react";
import { gql as gql159 } from "@apollo/client";
import { EGDSCard as EGDSCard13, EGDSCardBackgroundThemes as EGDSCardBackgroundThemes2, EGDSCardContentSection as EGDSCardContentSection14 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex43, EGDSLayoutFlexItem as EGDSLayoutFlexItem31 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing56, EGDSSpacingHr as EGDSSpacingHr7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading22, EGDSText as EGDSText39 } from "@egds/react-core/text";
var fragment124 = gql159(_templateObject160(), UiGraphic.fragment, EGDSStandardLink.fragment);
var EGDSStandardMessage = function(param) {
    var data = param.data;
    var _ref = data || {}, heading = _ref.heading, graphic = _ref.graphic, message = _ref.message;
    if (!heading && !graphic) {
        return null;
    }
    return /* @__PURE__ */ React197.createElement(EGDSCard13, {
        backgroundTheme: EGDSCardBackgroundThemes2.PRIMARY
    }, /* @__PURE__ */ React197.createElement(EGDSCardContentSection14, {
        padded: false
    }, /* @__PURE__ */ React197.createElement(EGDSLayoutFlex43, {
        alignItems: "center",
        space: "four"
    }, graphic && /* @__PURE__ */ React197.createElement(EGDSLayoutFlexItem31, null, /* @__PURE__ */ React197.createElement(EGDSSpacing56, {
        padding: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React197.createElement("div", null, /* @__PURE__ */ React197.createElement(UiGraphic, {
        data: graphic
    })))), /* @__PURE__ */ React197.createElement(EGDSLayoutFlexItem31, null, /* @__PURE__ */ React197.createElement(EGDSCardContentSection14, {
        padded: false
    }, heading && /* @__PURE__ */ React197.createElement(EGDSHeading22, {
        tag: "h2",
        size: 7
    }, heading), message && /* @__PURE__ */ React197.createElement(EGDSText39, {
        spacing: "two"
    }, message)))), /* @__PURE__ */ React197.createElement(EGDSSpacingHr7, {
        blockMargin: "three"
    })));
};
EGDSStandardMessage.displayName = "EGDSStandardMessage";
EGDSStandardMessage.fragment = fragment124;
// src/components/egds/egds-checkbox/egds-basic-checkbox.tsx
import React198 from "react";
import { gql as gql160 } from "@apollo/client";
import { EGDSCheckbox as EGDSCheckbox3 } from "@egds/react-core/checkbox";
var fragment125 = gql160(_templateObject161());
var EGDSBasicCheckBox = function(param) {
    var data = param.data, handleCheckboxChange = param.handleCheckboxChange, isChecked = param.isChecked;
    if (!data) {
        return null;
    }
    var label = data.label, enabled = data.enabled;
    return /* @__PURE__ */ React198.createElement(EGDSCheckbox3, {
        id: label.text,
        checked: isChecked,
        disabled: !enabled,
        onChange: handleCheckboxChange
    }, label.text);
};
EGDSBasicCheckBox.fragment = fragment125;
EGDSBasicCheckBox.displayName = "EGDSBasicCheckbox";
// src/components/egds/egds-select/egds-traveler-child-age-select.tsx
import React200 from "react";
import { gql as gql162 } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
// src/components/egds/egds-option/egds-basic-option.tsx
import React199 from "react";
import { gql as gql161 } from "@apollo/client";
var fragment126 = gql161(_templateObject162());
var EGDSBasicOption = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var label = data.label, selected = data.selected, value = data.value;
    return /* @__PURE__ */ React199.createElement("option", {
        key: value,
        id: value,
        value: value,
        "aria-selected": selected !== null && selected !== void 0 ? selected : void 0
    }, label);
};
EGDSBasicOption.fragment = fragment126;
EGDSBasicOption.displayName = "EGDSOption";
// src/components/egds/egds-select/egds-traveler-child-age-select.tsx
var fragment127 = gql162(_templateObject163(), EGDSBasicOption.fragment);
var EGDSTravelerChildAgeSelect = function(param) {
    var data = param.data, name = param.name, customValue = param.customValue, childIndex = param.childIndex, onSelect = param.onSelect;
    if (!data) {
        return null;
    }
    var disabled = data.disabled, label = data.label, options = data.options, value = data.value;
    return /* @__PURE__ */ React200.createElement(EGDSSelect, {
        id: name,
        name: name,
        disabled: disabled,
        value: customValue || (value === null || value === void 0 ? void 0 : value.toString()) || 0,
        label: label,
        onChange: function(e) {
            return onSelect(e, childIndex);
        }
    }, options.map(function(option, index) {
        return /* @__PURE__ */ React200.createElement(EGDSBasicOption, {
            key: "option-".concat(index),
            data: option
        });
    }));
};
EGDSTravelerChildAgeSelect.fragment = fragment127;
EGDSTravelerChildAgeSelect.displayName = "EGDSSelect";
// src/components/egds/egds-step-input/egds-traveler-step-input.tsx
import React201 from "react";
import { gql as gql163 } from "@apollo/client";
import { EGDSStepInput } from "@egds/react-core/step-input";
var fragment128 = gql163(_templateObject164());
var EGDSTravelerStepInput = function(param) {
    var data = param.data, onChange = param.onChange, value = param.value, customMax = param.customMax, customMin = param.customMin, travelerType = param.travelerType;
    if (!data) {
        return null;
    }
    var increaseText = data.increaseText, decreaseText = data.decreaseText, key = data.key, label = data.label, min = data.min, max = data.max, step = data.step, subLabel = data.subLabel;
    var defaultProps = EGDSStepInput.defaultProps;
    if (customMin !== void 0 && customMax !== void 0 && customMin > customMax) {
        return null;
    }
    var stepMin = customMin !== void 0 ? customMin : min !== null && min !== void 0 ? min : defaultProps.max;
    var stepMax = customMax !== void 0 ? customMax : max !== null && max !== void 0 ? max : defaultProps.min;
    if (stepMax === 0) {
        stepMin = value;
    }
    return /* @__PURE__ */ React201.createElement(EGDSStepInput, {
        label: label,
        key: key,
        incrementText: increaseText !== null && increaseText !== void 0 ? increaseText : "+",
        decrementText: decreaseText !== null && decreaseText !== void 0 ? decreaseText : "-",
        incrementId: "step-".concat(label, "-increase"),
        decrementId: "step-".concat(label, "-decrease"),
        min: stepMin,
        max: stepMax,
        value: value,
        onChange: function(e) {
            return onChange(e, travelerType);
        },
        id: "step-".concat(label, "-").concat(travelerType),
        description: subLabel || void 0,
        step: step
    });
};
EGDSTravelerStepInput.fragment = fragment128;
EGDSTravelerStepInput.displayName = "EGDSStepInput";
// src/components/lodging-unit-card/lodging-unit-card.tsx
import React202 from "react";
import { gql as gql164 } from "@apollo/client";
import { EGDSCard as EGDSCard14, EGDSCardContentSection as EGDSCardContentSection15, EGDSCardLink as EGDSCardLink5 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure10, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType14, EGDSImage as EGDSImage8 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex44, EGDSLayoutFlexItem as EGDSLayoutFlexItem32 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading23, EGDSText as EGDSText40 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker48 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog18 } from "@shared-ui/dialog-context";
var fragment129 = gql164(_templateObject165());
var LodgingUnitCard = function(param) {
    var data = param.data, _param_aspectRatio = param.aspectRatio, aspectRatio = _param_aspectRatio === void 0 ? EGDSFigureAspectRatioType14.R16_9 : _param_aspectRatio, dialogProps = param.dialogProps;
    var trackClick = useClickTracker48();
    var _dialogProps_id;
    var _useDialog18 = _sliced_to_array(useDialog18((_dialogProps_id = dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.id) !== null && _dialogProps_id !== void 0 ? _dialogProps_id : "", dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.dialogQueryKey), 2), dialogActions = _useDialog18[1];
    var onClickCaptureCallback = React202.useCallback(function() {
        var _data_trigger;
        if (data === null || data === void 0 ? void 0 : (_data_trigger = data.trigger) === null || _data_trigger === void 0 ? void 0 : _data_trigger.clientSideAnalytics) {
            trackClick(data.trigger.clientSideAnalytics.referrerId, data.trigger.clientSideAnalytics.linkName);
        }
        dialogActions.openDialog();
    }, [
        data,
        trackClick,
        dialogActions
    ]);
    if (!data) {
        return null;
    }
    var image = data.image, header = data.header, trigger = data.trigger;
    return /* @__PURE__ */ React202.createElement(EGDSCard14, {
        border: true
    }, /* @__PURE__ */ React202.createElement(EGDSLayoutFlex44, {
        direction: "column"
    }, /* @__PURE__ */ React202.createElement(EGDSFigure10, {
        ratio: aspectRatio
    }, /* @__PURE__ */ React202.createElement(EGDSImage8, {
        alt: image === null || image === void 0 ? void 0 : image.description,
        src: image === null || image === void 0 ? void 0 : image.url,
        placeholderImage: true
    })), /* @__PURE__ */ React202.createElement(EGDSLayoutFlexItem32, {
        grow: 1
    }, /* @__PURE__ */ React202.createElement(EGDSCardContentSection15, {
        padded: true
    }, /* @__PURE__ */ React202.createElement(EGDSLayoutFlex44, {
        direction: "column",
        justifyContent: "space-between",
        blockSize: "full_size"
    }, /* @__PURE__ */ React202.createElement(EGDSLayoutFlexItem32, null, /* @__PURE__ */ React202.createElement(EGDSHeading23, {
        overflow: "truncate-2-lines",
        size: 7
    }, header === null || header === void 0 ? void 0 : header.text)), /* @__PURE__ */ React202.createElement(EGDSLayoutFlexItem32, {
        alignSelf: "stretch"
    }, /* @__PURE__ */ React202.createElement("div", null, (trigger === null || trigger === void 0 ? void 0 : trigger.theme) === "AGGRESSIVE" /* AGGRESSIVE */  ? /* @__PURE__ */ React202.createElement(EGDSText40, {
        weight: "bold",
        size: 200,
        theme: highlightedMessagesThemeToEGDSTextTheme[trigger === null || trigger === void 0 ? void 0 : trigger.theme],
        spacing: "two"
    }, trigger === null || trigger === void 0 ? void 0 : trigger.value) : /* @__PURE__ */ React202.createElement(EGDSText40, {
        weight: "bold",
        size: 400,
        spacing: "two",
        overflow: "wrap"
    }, trigger === null || trigger === void 0 ? void 0 : trigger.value), /* @__PURE__ */ React202.createElement(EGDSText40, {
        size: 100,
        overflow: "wrap",
        weight: "regular"
    }, trigger === null || trigger === void 0 ? void 0 : trigger.secondaryValue)))))), /* @__PURE__ */ React202.createElement(EGDSCardLink5, null, /* @__PURE__ */ React202.createElement("button", {
        type: "button",
        onClick: onClickCaptureCallback
    }, trigger === null || trigger === void 0 ? void 0 : trigger.accessibilityLabel))));
};
LodgingUnitCard.displayName = "LodgingUnitCard";
LodgingUnitCard.fragment = fragment129;
// src/components/theme-card-wrapper/theme-card-wrapper.tsx
import React203 from "react";
import { EGDSSpacing as EGDSSpacing57 } from "@egds/react-core/spacing";
import { Card as Card5 } from "@egds/react-lodging";
var ThemeCardWrapper = function(param) {
    var children = param.children, theme = param.theme, isSquareCard = param.isSquareCard, spacingOptions = param.spacingOptions;
    return theme ? /* @__PURE__ */ React203.createElement(Card5, {
        "data-stid": "theme-card-wrapper",
        className: "theme-card-wrapper",
        backgroundTheme: theme,
        removeRoundedCorner: isSquareCard
    }, /* @__PURE__ */ React203.createElement(EGDSSpacing57, _object_spread({}, spacingOptions), /* @__PURE__ */ React203.createElement("div", null, children))) : /* @__PURE__ */ React203.createElement(React203.Fragment, null, children);
};
ThemeCardWrapper.displayName = "ThemeCardWrapper";
// src/components/shopping-range-indicator-card/shopping-range-indicator-card.tsx
import React205 from "react";
import { gql as gql166 } from "@apollo/client";
import { EGDSCard as EGDSCard15, EGDSCardContentSection as EGDSCardContentSection16 } from "@egds/react-core/cards";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { UitkSpacing as UitkSpacing3 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText41 } from "@egds/react-core/text";
import { EGDSLocalRangeIndicator } from "@egds/react-lodging";
// src/components/shopping-range-indicator-card/shopping-range-indicator-card-disclaimer.tsx
import React204 from "react";
import { gql as gql165 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton8, UitkTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon32, UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "@egds/react-core/icons";
import { EGDSLayoutPosition as EGDSLayoutPosition16 } from "@egds/react-core/layout-position";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger6 } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet13, EGDSSheetContent as EGDSSheetContent12, EGDSSheetTransition as EGDSSheetTransition19, UitkSheetCloseButton } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing58 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading24, EGDSParagraph as EGDSParagraph6 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker49 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog19 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium17, Viewport as Viewport19, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
var fragment130 = gql165(_templateObject166());
var ShoppingRangeIndicatorCardDisclaimer = function(param) {
    var data = param.data;
    var _trigger_icon;
    var title = data.title, content = data.content, primaryUIButton = data.primaryUIButton, trigger = data.trigger, toolbar = data.toolbar;
    var _useDialog19 = _sliced_to_array(useDialog19("shopping-range-indicator-disclaimer-dialog"), 3), isDialogOpen = _useDialog19[0], dialogActions = _useDialog19[1], DialogComponent = _useDialog19[2];
    var trackClick = useClickTracker49();
    var triggerRef = React204.useRef(null);
    var openDialog = React204.useCallback(function() {
        dialogActions.openDialog();
        var _trigger_clientSideAnalytics;
        var _ref = (_trigger_clientSideAnalytics = trigger.clientSideAnalytics) !== null && _trigger_clientSideAnalytics !== void 0 ? _trigger_clientSideAnalytics : {}, linkName = _ref.linkName, referrerId = _ref.referrerId;
        if (linkName && referrerId) {
            trackClick(referrerId, linkName);
        }
    }, [
        dialogActions,
        trackClick,
        trigger.clientSideAnalytics
    ]);
    var closeDialog = React204.useCallback(function() {
        dialogActions.closeDialog();
        var _primaryUIButton_analytics;
        var _ref = (_primaryUIButton_analytics = primaryUIButton === null || primaryUIButton === void 0 ? void 0 : primaryUIButton.analytics) !== null && _primaryUIButton_analytics !== void 0 ? _primaryUIButton_analytics : {}, linkName = _ref.linkName, referrerId = _ref.referrerId;
        if (linkName && referrerId) {
            trackClick(referrerId, linkName);
        }
    }, [
        dialogActions,
        trackClick,
        primaryUIButton === null || primaryUIButton === void 0 ? void 0 : primaryUIButton.analytics
    ]);
    if (!((_trigger_icon = trigger.icon) === null || _trigger_icon === void 0 ? void 0 : _trigger_icon.id)) {
        return null;
    }
    var _trigger_icon_title;
    return /* @__PURE__ */ React204.createElement(React204.Fragment, null, /* @__PURE__ */ React204.createElement(EGDSLayoutPosition16, {
        type: "relative",
        cloneElement: true,
        position: {
            bottom: "half"
        }
    }, /* @__PURE__ */ React204.createElement(EGDSSpacing58, {
        margin: {
            inlinestart: "half"
        }
    }, /* @__PURE__ */ React204.createElement(EGDSMoreInfoTrigger6, {
        onClick: openDialog,
        size: "small"
    }, /* @__PURE__ */ React204.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React204.createElement("span", null, /* @__PURE__ */ React204.createElement(EGDSIcon32, {
        name: trigger.icon.id,
        id: trigger.icon.id,
        title: (_trigger_icon_title = trigger.icon.title) !== null && _trigger_icon_title !== void 0 ? _trigger_icon_title : void 0,
        size: UitkIconSize3.EXTRA_SMALL
    })))))), /* @__PURE__ */ React204.createElement(EGDSSheetTransition19, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React204.createElement(DialogComponent, null, /* @__PURE__ */ React204.createElement(Viewport19, null, /* @__PURE__ */ React204.createElement(ViewSmall18, null, /* @__PURE__ */ React204.createElement(EGDSSheet13, {
        type: "bottom",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        hasModal: true
    }, (toolbar === null || toolbar === void 0 ? void 0 : toolbar.icon) && /* @__PURE__ */ React204.createElement(UitkSheetCloseButton, {
        alignment: "top"
    }, /* @__PURE__ */ React204.createElement(UitkTertiaryButton, {
        type: "button",
        onClick: closeDialog
    }, /* @__PURE__ */ React204.createElement(UitkIcon3, {
        name: toolbar.icon.id,
        size: UitkIconSize3.MEDIUM,
        title: toolbar.icon.description,
        id: toolbar.icon.id
    }))), /* @__PURE__ */ React204.createElement(EGDSSheetContent12, {
        padded: false
    }, /* @__PURE__ */ React204.createElement(EGDSSpacing58, {
        padding: {
            blockend: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React204.createElement("div", null, /* @__PURE__ */ React204.createElement(EGDSHeading24, {
        size: 5
    }, title), content.map(function(paragraph, index) {
        return /* @__PURE__ */ React204.createElement(EGDSParagraph6, {
            key: index
        }, paragraph);
    }), primaryUIButton && /* @__PURE__ */ React204.createElement(EGDSSpacing58, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React204.createElement(EGDSPrimaryButton8, {
        isFullWidth: true,
        onClick: closeDialog
    }, primaryUIButton.primary))))))), /* @__PURE__ */ React204.createElement(ViewMedium17, null, /* @__PURE__ */ React204.createElement(EGDSSheet13, {
        type: "centered",
        centeredSheetSize: "small",
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    }, /* @__PURE__ */ React204.createElement(EGDSSheetContent12, null, /* @__PURE__ */ React204.createElement(EGDSHeading24, {
        size: 5
    }, title), content.map(function(paragraph, index) {
        return /* @__PURE__ */ React204.createElement(EGDSParagraph6, {
            key: index
        }, paragraph);
    }), primaryUIButton && /* @__PURE__ */ React204.createElement(EGDSSpacing58, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React204.createElement(EGDSPrimaryButton8, {
        onClick: closeDialog
    }, primaryUIButton.primary)))))))));
};
ShoppingRangeIndicatorCardDisclaimer.displayName = "ShoppingRangeIndicatorCardDisclaimer";
ShoppingRangeIndicatorCardDisclaimer.fragment = fragment130;
// src/components/shopping-range-indicator-card/shopping-range-indicator-card.tsx
var fragment131 = gql166(_templateObject167(), ShoppingRangeIndicatorCardDisclaimer.fragment);
var ShoppingRangeIndicatorCard = function(param) {
    var data = param.data;
    var rangeIndicator = data.rangeIndicator, message = data.message, disclaimer = data.disclaimer;
    var accessibility = rangeIndicator.accessibility;
    var milestones = rangeIndicator.milestones;
    var segments = rangeIndicator.segments;
    return /* @__PURE__ */ React205.createElement(EGDSCard15, null, /* @__PURE__ */ React205.createElement(UitkSpacing3, {
        padding: "four"
    }, /* @__PURE__ */ React205.createElement(EGDSCardContentSection16, {
        padded: false
    }, /* @__PURE__ */ React205.createElement(UitkLayoutGrid2, {
        columns: message ? {
            small: 1,
            medium: 2
        } : void 0,
        space: "six"
    }, /* @__PURE__ */ React205.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React205.createElement(UitkSpacing3, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React205.createElement(EGDSLocalRangeIndicator, {
        accessibility: accessibility,
        segments: segments,
        milestones: milestones
    }))), message && /* @__PURE__ */ React205.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React205.createElement(EGDSText41, {
        size: 200
    }, message, disclaimer && /* @__PURE__ */ React205.createElement(ShoppingRangeIndicatorCardDisclaimer, {
        data: disclaimer
    })))))));
};
ShoppingRangeIndicatorCard.displayName = "ShoppingRangeIndicatorCard";
ShoppingRangeIndicatorCard.fragment = fragment131;
export { AboutThisProperty, ActionDetailsType, AdaptExAnalyticsEventFragment, AdaptExEventsProvider, AgencyBusinessModel, AirportLocationType, Alignment, AlterMode, AmenityCategory, AmenityReviewSummary, AspectRatio, AuthenticationState, BACKGROUND_CARD_THEME_DICTIONARY, BadgeIcon, BusinessModelType, CONTENT_TYPE, CarouselScrimType, ChronoUnit, CleaningAndSafetyPractice, Cleanliness, ClosedPeriodBounding, CommissionTier, CompressionLevel, DatePeriodUnit, DealType, DetailedAmenities, DeviceType, DialogContext, DirectFeedbackSheetType, DistanceUnit, EGDSActionDialog, EGDSBadgeLoyaltyThemeMapper, EGDSBadgeLoyaltyThemePerksMessageMapper, EGDSBadgeSizeMapper, EGDSBadgeThemeMapper, EGDSBasicCheckBox, EGDSCardBackgroundTheme, EGDSCardThemes, EGDSCheckBoxState, EGDSDecorativeText, EGDSDialogToolbar, EGDSExpandoCard, EGDSHeadingStyle, EGDSIconPosition, EGDSLinkSize, EGDSMapFeatureType, EGDSMapInitialViewport, EGDSMapMarkerStatus, EGDSMapProvider, EGDSParagraphStyle, EGDSPhotosphereCameraMovement, EGDSPlainText, EGDSSheetType, EGDSSheetTypeViewSize, EGDSSpannableList, EGDSSpannableText, EGDSSpannableTextContent, EGDSStandardLink, EGDSStandardMessage, EGDSStandardMessagingCard, EGDSStylizedText, EGDSTextListItemStyle, EGDSTextListSize, EGDSTextListType, EGDSThemeProviderColor, EGDSTravelerChildAgeSelect, EGDSTravelerStepInput, EGDSTypeaheadRenderType, EGReferrerEventType, ExpandoTriggerPosition, FeeType, FilterPlacement, FlexibleSearchTripDurationType, FlightsAdvancedFilterType, FlightsCabinClass, FlightsTripType, GeoType, GroundTransfersDirection, GroundTransfersTravelerDetailsType, HostProfile, Icon, IconSize, IconSpotLight, IconTheme, Illustration, ImportantInfo, InsurTechPagePlacementType, IntersectionTrackerWrapper, InventoryType, LOYALTY_GLOBAL_EXTRA_HIGH_TIER, LOYALTY_GLOBAL_HIGH_TIER, LOYALTY_GLOBAL_LOW_TIER, LOYALTY_GLOBAL_MIDDLE_TIER, LineOfBusinessDomain, Listings, LiveAnnouncePoliteness, LodgingBadge, LodgingCard, LodgingCardCompact, LodgingCardContentContext, LodgingCardGuestRating, LodgingCardHeadingSection, LodgingCardMediaSection, LodgingCardRating, LodgingCardView, LodgingCarouselContainer, LodgingCarouselPlaceholder, LodgingCarouselPlaceholderView, LodgingChangeLoader, LodgingCrossSellProductType, LodgingDetailedTimeline, LodgingDialogTriggerMessage, LodgingEGDSBasicLocalizedText, LodgingEGDSButton, LodgingEGDSCardinalLocalizedText, LodgingEGDSCheckbox, LodgingEGDSFloatingActionButton, LodgingEGDSFloatingButton, LodgingEGDSGraphicText, LodgingEGDSHeading, LodgingEGDSIcon, LodgingEGDSImage, LodgingEGDSInlineLink, LodgingEGDSLocalizedTextTemplate, LodgingEGDSParagraph, LodgingEGDSRating, LodgingEGDSSheet, LodgingEGDSSwitch, LodgingEGDSText, LodgingEnrichedMessage, LodgingFormMethod, LodgingHeader, LodgingHeading, LodgingInputType, LodgingIntentCard, LodgingJumpLink, LodgingMessageTheme, LodgingMicroCard, LodgingMoreInfoTrigger, LodgingPriceSummary, LodgingStepperState, LodgingTrackPosition, LodgingTripsSaveItemAdapter, LodgingUnitCard, MapIconType, MapToolbarActionsType, MapTrigger, Mark, MarkerType, MarkupTextType, MealPlanFilterAmenity, MessageResult, MessageType, OfferAttributeType, Orientation, PackageType, PageLocation, PaymentType, PluralCategory, Points, Policies, PriceHeaderDialog, PriceSectionPriceSummary, PricingSchemeType, PrivacyTrackingState, ProductShoppingInvokeFunctionProvider, PropertyAmenityCategoryType, PropertyAmenityType, PropertyCancellationPolicyType, PropertyContent, PropertyContentElementGroup, PropertyContentItemCard, PropertyContentSection, PropertyContentSectionAction, PropertyContentSectionActionItem, PropertyContentSectionDetailedDialog, PropertyContentSectionDetailedDialogContext, PropertyContentSectionDialog, PropertyContentSectionGroup, PropertyContentSectionListTypeDialog, PropertyContentSectionRef, PropertyContentSubSection, PropertyFilterAccessibility, PropertyFilterAmenity, PropertyFilteredReviewsDialogContext, PropertyImage, PropertyInfoContent, PropertyInfoContentHeader, PropertyInfoContentItem, PropertyInfoContentItems, PropertyInfoContentList, PropertyInfoContentText, PropertyInfoOptions, PropertyOverfilteredCard, PropertyPaymentFlags, PropertyPaymentModel, PropertyPaymentType, PropertyPriceDocumentNode, PropertyReviewsBreakdown, PropertySearchOptions, PropertySectionRef, PropertySort, PropertyStyle, RangeIndicatorSegmentStyle, RangeIndicatorSegmentTheme, RateDiscountType, RatingCounts, RegionType, ReviewDisclaimer, ReviewInteractionType, ReviewSource, SearchFilterPills, SectionHeader, SharedUIBadge, SharedUIDialog, SharedUIParagraph, ShoppingButton, ShoppingButtonType, ShoppingCarousel, ShoppingFunctionType, ShoppingLink, ShoppingPathType, ShoppingRangeIndicatorCard, ShoppingSelectableCardState, ShoppingSelectableImageCard, ShoppingTabsNavType, ShoppingTriggerType, SortAndFilterBasicFilterPayloadType, SortAndFilterSignalCondition, SortAndFiltersViewType, SourceType, SparkleBanner, SpecialFeatures, SponsoredContentLocationResolver, SponsoredContentProductType, StayType, StrikeOutType, StructureType, SummaryDetails, TextTheme, TextWeight, Theme, ThemeCardWrapper, TravelerDetailsType, TravelerType, UILinkTarget, UILinkTargetMap, UiGraphic, __AboutThisPropertyFragment, __CleanlinessFragment, __MapTriggerFragment, __PropertyInfoContent, __PropertyInfoContentItem, __PropertyInfoContentItems, __SearchFilterPillsFragment, adaptToAdaptExSuccessEventSchema, buildEGDSPriceLockupProps, clientSideAnalyticsFragment, consolidateAdaptExEvents, consolidateOnclick, createAdaptExMicroMessage, defaultCloseMapDialogPropBuilder, errorBoundary, findReactChildByType, formatDataAttributes, fragment109 as fragment, fullscreenOptionsCloseMapDialogPropBuilder, gate, gated, getBackgroundCardTheme, getLinkTarget, getLodgingUILinkActionPath, getLodgingUILinkActionTarget, getStructuredDataProps, highlightedMessagesThemeToEGDSTextTheme, isAd, isCompactHorizontalView, isCompactView, lightweightAdaptExMicroMessage, linkSizeMapper, fragment43 as lodgingUILinkActionFragment, microMessageToFragment, parseLodgingCardImpressionSchema, safeBuildMicroMessage, sendProductSchemaTracking, sizeMap, trackAnalyticsList, useAdaptExEvents, useDialogId, useInterpolateBasicLocalizedText, useInterpolateCardinalLocalizedText, useLodgingCardImageClickCallback, usePropertyContentSectionDetailedDialogContext, usePropertyFilteredReviewsDialogContext, useTrackClientSideAnalytics }; // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map